webpackJsonp([1],{

/***/ "+EsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Gh5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+O1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "picture-input",
    attrs: {
      "id": "picture-input"
    }
  }, [(!_vm.supportsUpload) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.strings.upload)
    }
  }) : (_vm.supportsPreview) ? _c('div', [_c('div', {
    staticClass: "preview-container",
    style: ({
      maxWidth: _vm.previewWidth + 'px',
      height: _vm.previewHeight + 'px',
      borderRadius: _vm.radius + '%'
    })
  }, [_c('canvas', {
    ref: "previewCanvas",
    staticClass: "picture-preview",
    class: _vm.computedClasses,
    style: ({
      height: _vm.previewHeight + 'px',
      zIndex: _vm.zIndex + 1
    }),
    on: {
      "drag": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "dragover": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "dragstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onDragStart($event)
      },
      "dragenter": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onDragStart($event)
      },
      "dragend": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onDragStop($event)
      },
      "dragleave": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onDragStop($event)
      },
      "drop": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onFileDrop($event)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }), _vm._v(" "), (!_vm.imageSelected && !_vm.plain) ? _c('div', {
    staticClass: "picture-inner",
    style: ({
      top: -_vm.previewHeight + 'px',
      marginBottom: -_vm.previewHeight + 'px',
      fontSize: _vm.fontSize,
      borderRadius: _vm.radius + '%',
      zIndex: _vm.zIndex + 2
    })
  }, [(_vm.supportsDragAndDrop) ? _c('span', {
    staticClass: "picture-inner-text",
    domProps: {
      "innerHTML": _vm._s(_vm.strings.drag)
    }
  }) : _c('span', {
    staticClass: "picture-inner-text",
    domProps: {
      "innerHTML": _vm._s(_vm.strings.tap)
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.imageSelected && !_vm.hideChangeButton) ? _c('button', {
    class: _vm.buttonClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.strings.change))]) : _vm._e(), _vm._v(" "), (_vm.imageSelected && _vm.removable) ? _c('button', {
    class: _vm.removeButtonClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.strings.remove))]) : _vm._e(), _vm._v(" "), (_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height) ? _c('button', {
    class: _vm.aspectButtonClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.rotateImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.strings.aspect))]) : _vm._e()]) : _c('div', [(!_vm.imageSelected) ? _c('button', {
    class: _vm.buttonClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.strings.select))]) : _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.strings.selected)
    }
  }), _vm._v(" "), (!_vm.hideChangeButton) ? _c('button', {
    class: _vm.buttonClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.strings.change))]) : _vm._e(), _vm._v(" "), (_vm.removable) ? _c('button', {
    class: _vm.removeButtonClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.strings.remove))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "name": _vm.name,
      "id": _vm.id,
      "accept": _vm.accept
    },
    on: {
      "change": _vm.onFileChange
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+P32":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+fIq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "+zfG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/6OH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/9U9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ES+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/eNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recommendation_vue__ = __webpack_require__("QBt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_976deb48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_recommendation_vue__ = __webpack_require__("mOXy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recommendation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_976deb48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_recommendation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/qkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_headerLogin_vue__ = __webpack_require__("3656");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_bannerSearch_vue__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__playlistCards__ = __webpack_require__("aLMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_footerArea__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_newVideoCards__ = __webpack_require__("q9mY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlist',
  components: {
    headerArea: __WEBPACK_IMPORTED_MODULE_3__components_common_headerLogin_vue__["a" /* default */],
    bannerSearch: __WEBPACK_IMPORTED_MODULE_4__components_home_bannerSearch_vue__["a" /* default */],
    playlistCards: __WEBPACK_IMPORTED_MODULE_5__playlistCards__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_7__components_home_libraryCards__["a" /* default */],
    newVideoCards: __WEBPACK_IMPORTED_MODULE_8__components_home_newVideoCards__["a" /* default */],
    footerArea: __WEBPACK_IMPORTED_MODULE_6__components_common_footerArea__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      showPlayListCards: false,
      profileId: this.$store.getters.getProfileDetails.profileId,
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    };
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('resetPlayListDetailsPaginationDetails');
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */] === 'MAHADEMY') {
      this.$router.push('/home');
    } else {
      this.fetchPlayList();
      this.GetAllocatedVideosDetails();
      this.$store.dispatch('resetPlayListDetailsPaginationDetails');
      __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$emit('showNav', true);
    }
  },

  methods: {
    GetAllocatedVideosDetails: function GetAllocatedVideosDetails() {
      var _this = this;

      this.$store.dispatch('fetchUserSingleConceptCollection', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': 1 }).then(function (res) {
        if (res) {
          _this.showPlayListCards = true;
        }
      });
    },

    fetchPlayList: function fetchPlayList() {
      // var playlistView = this
      this.$store.dispatch('getUserPlayList', { profileId: this.profileId }).then(function (res) {}, function (err) {
        console.log('ERROR_IN_GETTING_PLAYLIST : ', err);
      });
    },
    // infiniteHandler - starts lazy loading
    infiniteHandler: function infiniteHandler($state) {
      var _this2 = this;

      this.globalState = $state;
      setTimeout(function () {
        _this2.showLibraryCard = true;
        $state.loaded();
      }, 2000);
    },

    // handleScroll - handles scrolling
    handleScroll: function handleScroll() {
      var _this3 = this;

      if (this.showLibraryCard && !this.showNewVideoCard) {
        setTimeout(function () {
          _this3.showNewVideoCard = true;
          if (_this3.$refs.infiniteLoader !== undefined) {
            _this3.globalState.complete();
          }
        }, 2000);
      }
    }
  }
});

/***/ }),

/***/ "/rev":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0A7L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0AB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0SGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frames_vue__ = __webpack_require__("qUkI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be3aae7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_frames_vue__ = __webpack_require__("IPdA");
function injectStyle (ssrContext) {
  __webpack_require__("NdPc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frames_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be3aae7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_frames_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0jZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__("hiCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    height: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this3 = this;

      options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this3.onFileChange(e, true);
      }).catch(function (err) {
        _this3.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "15GC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_libraryCards_vue__ = __webpack_require__("Ol2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c85914b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_libraryCards_vue__ = __webpack_require__("QHXS");
function injectStyle (ssrContext) {
  __webpack_require__("LXS2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_libraryCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c85914b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_libraryCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "17XY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container playlist-cards",
    attrs: {
      "id": "playlist"
    }
  }, [(_vm.$store.getters.getUserSingleConceptsCollection.length > 0) ? _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-blue",
    on: {
      "click": _vm.showCreateNewModal
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.CreateNewPlaylist')))])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [(_vm.$store.getters.getUserSingleConceptsCollection.length > 0) ? _c('div', {
    staticClass: "row",
    attrs: {
      "options": _vm.swiperOptionp3
    }
  }, _vm._l((_vm.$store.getters.getUserSingleConceptsCollection), function(collection) {
    return _c('div', {
      key: collection.contentId,
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "card-design"
    }, [_c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": _vm.makePath(collection.thumbnail, collection.type),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [_c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate no-line",
      attrs: {
        "title": collection.title
      }
    }, [_vm._v(" " + _vm._s(collection.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v("Your Rating")]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "rating-ptag",
      on: {
        "click": function($event) {
          _vm.showRating(collection.contentId)
        }
      }
    }, [_c('span', [_c('star-rating', {
      attrs: {
        "rating": collection.rating,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#aaa",
        "active-color": "#ffc000",
        "star-size": 15
      },
      on: {
        "rating-selected": _vm.setRating
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-center btn-padding"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.selectCollection(collection)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('playlist.AddToPlaylist')))])])])])])
  })) : _c('div', [_vm._m(1)]), _vm._v(" "), (_vm.$store.getters.getUserSingleConceptsCollection.length > 0) ? _c('div', {
    staticClass: "text-right"
  }, [(_vm.$store.getters.getCurrentPage !== _vm.$store.getters.getNumberOfPages) ? _c('button', {
    staticClass: "btn btn-blue",
    on: {
      "click": function($event) {
        _vm.loadNextSingleConcepts()
      }
    }
  }, [_vm._v("load More")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row text-alignment content-holder"
  }, [(_vm.$store.getters.getUserPlaylists !== null && _vm.$store.getters.getUserPlaylists.length > 0) ? _c('h6', {
    staticClass: "main-title col-12"
  }, [_vm._v("My Playlists")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row playlist-padding"
  }, [_vm._l((_vm.$store.getters.getUserPlaylists), function(playlist, index) {
    return _c('div', {
      key: playlist.plId,
      class: ['col-md-3 ' + index],
      style: ({
        order: index
      }),
      on: {
        "click": function($event) {
          _vm.getIndex(index, playlist.items.length)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (playlist.plId),
        expression: "playlist.plId"
      }],
      staticClass: "card-design",
      attrs: {
        "v-scroll-to": playlist.items.length == 0 ? '' : '#playAdd'
      },
      on: {
        "click": function($event) {
          _vm.getPlaylistById(playlist.plId)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": _vm.makePathForPlaylistCard(playlist),
        "src": _vm.makePathForPlaylistCard(playlist),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [_c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "title": playlist.plName
      }
    }, [_vm._v(_vm._s(playlist.plName))]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-end"
    }, [_c('div', {
      staticClass: "col"
    }, [((playlist.items.length <= 1)) ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(playlist.items.length) + "  " + _vm._s(_vm.$t('playlist.Concept')))]) : _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(playlist.items.length) + "  " + _vm._s(_vm.$t('playlist.Concepts')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('button', {
      staticClass: "btn btn-danger trash",
      attrs: {
        "title": _vm.$t('playlist.DeletePlaylist')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deletePlaylist(playlist.plId, playlist.plName)
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-delete"
    })])])])]), _vm._v(" "), (_vm.checkIsVisited(index)) ? _c('div', {
      staticClass: "text-center button-spacing"
    }, [_c('b-link', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goToContentViewer(playlist)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('playlist.ResumePlaying')))])], 1) : (playlist.items.length == 1) ? _c('div', {
      staticClass: "text-center button-spacing"
    }, [_c('b-link', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goToContentViewer(playlist)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY')))])], 1) : (playlist.items.length > 1) ? _c('div', {
      staticClass: "text-center button-spacing"
    }, [_c('b-link', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goToContentViewer(playlist)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_ALL')))])], 1) : _c('div', {
      staticClass: "message"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('playlist.labels.Add_Item_To_Playlist')) + "\n          ")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showArrow && (_vm.getCurrentPlaylistId == playlist.plId)),
        expression: "showArrow && (getCurrentPlaylistId == playlist.plId)"
      }],
      staticClass: "arrow-top"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "row playlist-lo",
    attrs: {
      "id": "playAdd"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, _vm._l((_vm.$store.getters.getUserPlaylists), function(playlist) {
    return _c('b-collapse', {
      key: playlist.plId,
      attrs: {
        "id": playlist.plId,
        "visible": _vm.showArrow
      }
    }, [(playlist.items !== null && playlist.items.length > 0) ? _c('div', {
      staticClass: "swiper-holder"
    }, [_c('swiper', {
      attrs: {
        "options": _vm.swiperOptionp5
      }
    }, [_vm._l((playlist.items), function(item) {
      return _c('swiper-slide', {
        key: item.itemId
      }, [_c('div', {
        directives: [{
          name: "b-toggle",
          rawName: "v-b-toggle.playlistlo",
          modifiers: {
            "playlistlo": true
          }
        }],
        staticClass: "card-design"
      }, [_c('div', {
        directives: [{
          name: "lazy-container",
          rawName: "v-lazy-container",
          value: ({
            selector: 'img'
          }),
          expression: "{ selector: 'img' }"
        }],
        staticClass: "card-design__img"
      }, [_c('img', {
        attrs: {
          "data-src": _vm.getItemThumbnailFromEnrolledLO(item),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-design__data"
      }, [_c('h3', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: {
            "hover": true
          }
        }],
        staticClass: "card-design__data-heading no-line text-truncate",
        attrs: {
          "title": item.itemName
        }
      }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
        staticClass: "ratingText"
      }, [_vm._v("Overall Rating")]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
        staticClass: "rating-ptag"
      }, [_c('span', [_c('star-rating', {
        attrs: {
          "rating": item.itemRating,
          "read-only": true,
          "increment": 0.5,
          "max-rating": 5,
          "inactive-color": "#96999a",
          "active-color": "#ffc000",
          "star-size": 15
        }
      })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center button-spacing"
      }, [_c('div', {
        staticClass: "col"
      }, [_c('button', {
        staticClass: "btn btn-green-o",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.playLO(item)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_NOW')))])]), _vm._v(" "), _c('div', {
        staticClass: "col-auto"
      }, [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            _vm.deleteItem(playlist.plId, item)
          }
        }
      }, [_c('span', {
        staticClass: "mdi mdi-delete"
      })])])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-button-prev",
      slot: "button-prev"
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-button-next",
      slot: "button-next"
    })], 2)], 1) : _vm._e()])
  }))])], 2), _vm._v(" "), _c('b-modal', {
    ref: "addPlayModalRef",
    staticClass: "text-left",
    attrs: {
      "id": "addplay",
      "hide-footer": "",
      "hide-header": "",
      "title": _vm.$t('playlist.AddToPlaylist')
    }
  }, [_c('div', {
    staticClass: "social d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('playlist.CreateNewPlaylist')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "newplay"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-music"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PlayList.plName),
      expression: "PlayList.plName"
    }],
    ref: "playListInputTitle",
    staticClass: "form-control",
    attrs: {
      "autofocus": "true",
      "type": "text",
      "placeholder": _vm.$t('playlist.placeholders.NameYourPlaylist'),
      "aria-describedby": "newplay",
      "disabled": _vm.selectedPlaylists.length > 0 ? true : false
    },
    domProps: {
      "value": (_vm.PlayList.plName)
    },
    on: {
      "change": function($event) {
        _vm.show()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.check($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PlayList.plName = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.userPlayLists.length > 0) ? _c('div', {
    staticClass: "d-block mb-3"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('playlist.labels.OR')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('playlist.labels.AddToExistingPlaylists')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }]
  }, [_c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "stacked": "",
      "name": "flavour2",
      "options": _vm.selectPlayListOptions
    },
    model: {
      value: (_vm.selectedPlaylists),
      callback: function($$v) {
        _vm.selectedPlaylists = $$v
      },
      expression: "selectedPlaylists"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.PlayList.plName != '') ? _c('b-btn', {
    staticClass: "btn btn-large btn-green-o",
    attrs: {
      "id": "addItem",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.check()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.AddToPlaylist')))]) : _c('b-btn', {
    staticClass: "btn btn-large btn-purple",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.CheckItemAdd()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.AddToPlaylist')))])], 1), _vm._v(" "), _c('b-modal', {
    ref: "createNewModalRef",
    staticClass: "text-left",
    attrs: {
      "id": "createnew",
      "hide-footer": "",
      "hide-header": "",
      "title": _vm.$t('playlist.CreateNewPlaylist')
    }
  }, [_c('div', [_c('div', {
    staticClass: " p-0"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PlayList.plName),
      expression: "PlayList.plName"
    }],
    ref: "playListInputBox",
    staticClass: "form-control",
    attrs: {
      "autofocus": "true",
      "type": "text",
      "placeholder": _vm.$t('playlist.placeholders.TypeNewPlaylistNameHere')
    },
    domProps: {
      "value": (_vm.PlayList.plName)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.checkCreate($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PlayList.plName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn btn-large btn-purple",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.checkCreate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.CreatePlaylist')))])], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('h6', {
    staticClass: "main-title col-12"
  }, [_vm._v("User Single Concept Collection")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noticemsg"
  }, [_c('br'), _c('span', [_vm._v(" You have no single concepts")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2f0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__ = __webpack_require__("0jZp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d17e214a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__ = __webpack_require__("+O1V");
function injectStyle (ssrContext) {
  __webpack_require__("ip3D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d17e214a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d17e214a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2k/b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageViewer_vue__ = __webpack_require__("OzLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c47e994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imageViewer_vue__ = __webpack_require__("lKwP");
function injectStyle (ssrContext) {
  __webpack_require__("TYun")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c47e994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imageViewer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2sew":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3656":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_headerLogin_vue__ = __webpack_require__("Ejfo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a31c895_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_headerLogin_vue__ = __webpack_require__("Ze7p");
function injectStyle (ssrContext) {
  __webpack_require__("5yCr")
  __webpack_require__("+P32")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_headerLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a31c895_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_headerLogin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "36GZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleOffset: {
      type: [String, Number],
      default: 600
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  /**
   * Catch window scroll event 
   * @return {void}
   */
  created: function created() {
    var _this = this;

    var catchScroll = function catchScroll() {
      _this.visible = window.pageYOffset > parseInt(_this.visibleOffset);
    };

    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };

    window.onscroll = catchScroll;
  },

  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
    }
  }
});

/***/ }),

/***/ "3Es0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmation_vue__ = __webpack_require__("e2XB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1dbf912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__ = __webpack_require__("YTfL");
function injectStyle (ssrContext) {
  __webpack_require__("Eoig")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1dbf912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3G4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myPlaylist"
  }, [_c('banner-search'), _vm._v(" "), (_vm.showPlayListCards) ? _c('playlist-cards') : _vm._e(), _vm._v(" "), (_vm.showLibraryCard && _vm.$store.getters.getUserSingleConceptsCollection != undefined && _vm.$store.getters.getUserSingleConceptsCollection != null && _vm.$store.getters.getUserSingleConceptsCollection.length == 0) ? _c('libraryCards') : _vm._e(), _vm._v(" "), (_vm.showLibraryCard && _vm.showNewVideoCard && _vm.$store.getters.getUserSingleConceptsCollection != undefined && _vm.$store.getters.getUserSingleConceptsCollection != null && _vm.$store.getters.getUserSingleConceptsCollection.length == 0) ? _c('newVideoCards') : _vm._e(), _vm._v(" "), (_vm.$store.getters.getUserSingleConceptsCollection != undefined && _vm.$store.getters.getUserSingleConceptsCollection != null && _vm.$store.getters.getUserSingleConceptsCollection.length == 0) ? _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3kQO":
/***/ (function(module, exports) {

module.exports = {"common":{"labels":{"surf_library":"SINGLE CONCEPTS","check_courses":"COURSES","log_in":"LOG IN","sign_up":"SIGN UP","logout":"Logout","your_profile":"Your Profile","now":"now","PLAY_NOW":"PLAY NOW","ADDED":"ADDED","ADD_TO_CART":"ADD TO CART","PLAY":"Play","PLAY_ALL":"Play All","your_Rating":"Your Rating","RATING_MSG":"Share your rating","ADD_MONEY":"Add Money","TRANSACTION_ID":"Transaction ID","GO_TO_COURSE":"Go To Course","MyCourses":"My Courses","Courses":"Courses","Duration":"Duration","Courses_in":"Courses in","POINTS":"POINTS","Ratings":"Ratings","OVERALL_RATING":"Overall Rating","Total_Points_Need_To_Purchase":"Total Points you need to purchase","Recommended_Courses":"Recommended Courses for you","Recently_added_Videos":"Recently Added Concepts","CART_WISHLIST_WITHOUT_LOGIN":"Please login before adding it to cart / wishlist","shareOn":"Share On","Back":"Back","All":"All","SearchPlaceHolder":"search topic you want to learn"},"alerts":{"DATA_NOT_VALID":"Please fill all details properly","DATA_EMPTY":"Required fields can not be empty","FIELD_EMPTY":"Required field can not be empty","ONLY_NUMERIC":"Only numerics are allowed","ONLY_ALPHABETS":"Only alphabets are allowed","ONLY_ALPHANUMERIC":"Only alphanumeric allowed","CART_ADDED_SUCCESS":"Added to cart successfully","RATING_ADDED":"Rating added successfully","ALL_CART_ADDED_SUCCESS":"All items have been added to the cart successfully","POINTS_IN_WALLET":"Points in your wallet"},"errors":{"videoTagError":"Looks like your browser does not support playing this video","CartItemAddError":"Please try adding later, we are sorry for the inconvenience","audioTagError":"Looks like your browser does not support playing this audio"}},"login":{"alerts":{"logout_success":"You have been logged out successfully, see you soon","logout_fail":""}},"profileDetails":{"labels":{"fullName":"Full Name","yourName":"Your Name","dob":"DOB","gender":"Gender","gender_male":"Male","gender_female":"Female","email":"Email","mobile":"Mobile","aboutMe":"About Me","skills":"Skills","editButtonText":"Edit Profile","saveButtonText":"Save Profile","watchButtonText":"Watch Now","WatchCount":"Watch Count","TotalWatchedDuration":"Total Watched Duration","PurchasedOn":"Purchased On","ExpiresOn":"Expires On","noLO":"Check out latest","Playlist":"Playlists","PurchasedVideos":"Single Concepts","PurchasedCourses":"Courses","CourseCompletionStatus":"Course Completion Status","SolvedChallenges":"Solved Challenges","timeSpent":"Time Spent","CompletedLectures":"Completed lectures","TotalLectures":"Total lectures","CourseStartDate":"Course Start Date:","CourseEndDate":"Course End Date:","PleaseWait":"Please wait...","No. of Concepts":"No. of Concepts","No.of Concept":"No. of Concept","Hi_I_am":"Hi! I am","Course_,starts_on":"Course starts on","and_expires_on":"and expires on","You've_solved":"You've solved","and_completed":"and completed","out_of":"out of","challenges":"challenges","lectures":"lectures","My_Rating":"Your Rating","Share_on":"Share On","item_purchased_on":"You've purchased this content on","item_expires_on":"and it expires on","Watch_Count":"Watch Count"},"placeholder":{"fullname":"Full Name","email":"Email Address","mobile":"Mobile Number","YourFullName":"Your full name","WriteAboutYourself":"Hi there ! Write about yourself here","contact":"contact","AccountType":"AccountType","SeeMore":"See more"},"alerts":{"DATA_NOT_VALID":"Please fill all details properly","FAILED_TO_UPDATE_PROFILE_DETAILS":"Oops there's an error, please try adding details later","FILE_UPLOADED_SUCCESS":"File successfully uploaded","FILE_DELETED_SUCCESS":"File successfully deleted","noVideosToDisplay":"Start adding videos in your playlist","File_replace_success":"file replaced successfully"},"errors":{"Name_cannot_empty":"Name can not be Empty!","Invalid_email_address":"Invalid email address","File_size_more_than_512":"File size more than 512kb","Can_not_upload_multiple_files":"You can not upload multiple files"}},"cart":{"labels":{"cart":"cart","Cost":"Cost","ItemsInYourCart":"Items in your cart","ItemInYourCart":"Item in your cart","InWishlist":"In wishlist","MoveToWishlist":"Move to wishlist","Points":"POINTS","Point":"POINT","RedeemedMsg":"Points will be automatically redeemed from wallet in case of sufficient balance.","NoCashTransactionMsg":"No cash transaction will be required.","TotalPointsReq":"Total Points Required","ProceedToRedem":"Proceed to redemption"},"placeholders":{},"alerts":{"DeletedFromCart":"Deleted from cart successfully","AddItemToCart":"Add item to your cart","RemovalConfirmation":"Are you sure, you want to remove item from Cart ?"}},"wallet":{"labels":{"WalletBalance":"Wallet Balance","YouHave":"You have","AddMoneyInWallet":"Add money in wallet","ContactUs":"Contact us for queries","WatchedFor":"Watched for","MinutesOn":"Minutes on","FailedToAddMsg":"Failed to add in wallet on","AddedToWalletOn":"Added to wallet on","PurchaseMadeOn":"Purchase made on","Activities":"Activities","Transactions":"Transactions","Points":"Points"},"placeholders":{"EnterAmount":"Enter amount"},"alerts":{"EnterValidAmount":"Kindly enter valid amount"}},"wishlist":{"labels":{"MyWishlist":"Wishlist","StudentRating":"Student rating","MoveToCart":"Move to cart","MoveAllToCart":"Move all to cart","AddCoursesInWishlist":"Add courses/concepts in your wishlist","RemoveFromWishlistMsg":"Remove from wishlist"},"placeholders":{},"alerts":{"RemoveItem":"Item removed from wishlist","RemoveItemConfirm":"Are you sure, you want to remove item from WishList ?","AddedToWishList":"Item Added To Wishlist"}},"course":{"numberOfStudentsEnrolled":"No. of students enrolled","courseDuration":"Course duration","lectures":"Lectures","noCourses":"Start adding","purchased":"Purchased","added":"ADDED","ratings":"Ratings","my_rating":"Your Rating","share_on":"Share On","view_all_courses":"View All Courses","students_review_about_course":"Students' Reviews About Course","course_description":"Course Description","download_syllabus":"Download Syllabus","trending_courses":"Trending Courses","GO_TO_COURSE":"GO TO COURSE"},"instructor_profile":{"course_taught_by":"This course is taught by","instructor_name":"Name of Instructor","designation":"Designation","view_profile":"View Profile"},"playlist":{"numOfViews":"No. of Views","duration":"Duration","noPlaylists":"Start creating your playlists","AddToPlaylist":"Add To Playlist","CreateNewPlaylist":"Create new playlist","VideoTagError":"Looks like your browser does not support playing this video","RemainingMsg":"remaining","DeletePlaylist":"Delete Playlist","Create":"Create","CreatePlaylist":"Create playlist","ResumePlaying":"Resume Playing","HereLink":"here","Concept":"Concept","Concepts":"Concepts","labels":{"MyCollection":"Collection","MyPlaylist":"My Playlist","RemoveFromThisPlaylist":"Remove from this playlist","PlaylistName":"Playlist Name","AddToExistingPlaylists":"Add to existing playlists","CreateNewPlaylistMsg":"Create new playlist!","BlankPlaylistMsg":"Start adding content in your playlist","AddFramesMsg":"You can add frames in this collection now! Start searching frames","ShowMsg":"","OR":"OR","AND":"AND","Show_more":"Show More","My_rating":"Your Rating","share_on":"Share On","Add_Item_To_Playlist":"You can add items from collection to this playlist"},"placeholders":{"TypePlaylistNameHere":"Type playlist name here","NameYourPlaylist":"Name your playlist","TypeNewPlaylistNameHere":"Type new playlist name here"},"alerts":{"ENTER_PLAYLIST_NAME":"Please type your playlist name","PLAYLIST_ALREADY_PRESENT":"Oops! This playlist already exists","ADDED_INTO_PLAYLIST":"Added into playlist","SELECT_PLAYLIST":"Please select any existing playlist or create a new one","PRESENT_IN_PLAYLIST":"is already present in ","PLAYLIST_CREATED":"Playlist created, start adding content now!","DELETE_ITEM":"Deleted","DELETE_PLAYLIST":"Playlist deleted","REMOVAL_CONFIRMATION":"Are you sure, you want to remove this item from playlist ?","PLAYLIST_DELETE_CONFIRMATION":"Are you sure, you want to delete playlist ?"}},"recommendation":{"labels":{"you_may_like":"You May Like","lo_label":"SINGLE CONCEPT"}},"libraryCards":{"labels":{"most_watched_Videos":"Most Watched Concepts","lo_label":"SINGLE CONCEPT","share_on":"Share On"}},"myCourses":{"labels":{"LearnAbout":"In next session you will learn about ...","RemainingMsg":"remaining","NoCourses":"Start purchasing your courses now!"}},"searchPage":{"labels":{"multipleResults":"Results for","singleResults":"Result for","ChooseCategory":"Choose Category","ShowMore":"Show More","ShowLess":"Show Less","Language":"Available in","Cost":"Cost","Duration":"Sort by Points","ClearAllFilters":"Clear all filters","loading":"Loading","showing":"Showing","resultsOutOf":"results out of","EnrolledCount":"Enrolled count","Lectures":"Lectures","Points":"POINTS","allResultsDisplayed":"All results displayed","noRecordsFound":"Try altering your search","EnterTextToSearch":"Start searching skills you want to learn"},"alerts":{"AddItemToWishlist":"Item added to wishlist","ItemRemovedFromWishlist":"Item removed from wishlist","AddItemToCart":"Item added to cart successfully","CartAddError":"Sorry, there was an error adding your item, plz try again"}},"contentViewer":{"labels":{"noResultFoundError":"There are no results","viewCountExhausted":"You have exceeded no of views","itemNotPurchased":"Please purchase this item to view"},"placeholder":{"searchContentHere":"Search your content here..."}},"footer":{"mahademy_title":"Powered by Maharashtra Knowledge Corporation Ltd. (MKCL) as Knowledge Partner and Solution Architect,","mkcl_title":"Maharashtra Knowledge Corporation Limited.","rights_reserved":"All Rights Reserved.","about":"About MKCL","disclaimer":"Disclaimer","privacy_policy":"Privacy Policy","copyright":"Copyright"},"offers":{"new_offers_available_soon":"NEW OFFERS WILL BE AVAILABLE SOON !"},"era_redirect":{"show_era":"Show ERA","token_set":"Token Set"},"payment":{"labels":{"payment_receive":"Congrats! Your transaction has been processed. We have successfully received an amount of","credits_added":"Credits added to your wallet","transaction_failed":"Transaction failed for amount","go_to_profile":"Go To Profile","go_to_home":"Go To Home","go_to_wallet":"Go To Wallet"}}}

/***/ }),

/***/ "3nNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    ref: "audioPlayer",
    attrs: {
      "id": "audioHolder",
      "autoplay": "",
      "controls": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mediaPath,
      "type": "audio/mpeg"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.errors.audioTagError')) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3pqy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newVideoCards',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */],
      isValidUser: false,
      isActive: false,
      notNextTick: true,
      obj: {},
      items: [],
      coList: [],
      loList: [],
      add: 'Add to Cart',
      itemDescription: 'Coarse is to help you with some basics of HTML',
      itemName: 'HTML5 Demo',
      swiperOption1: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 'auto',
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      selected: [], // Must be an array reference!
      options: [{ text: 'Playlist 1', value: 'Playlist 1' }, { text: 'Playlist 2', value: 'Playlist 2' }, { text: 'Playlist 3', value: 'Playlist 3' }, { text: 'Playlist 4', value: 'Playlist 4' }, { text: 'Playlist 5', value: 'Playlist 5' }, { text: 'Playlist 6', value: 'Playlist 6' }]
    };
  },

  methods: {
    makePath: function makePath(path) {
      return __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
    },
    removeFromWishList: function removeFromWishList(itemId) {
      var _this = this;

      this.$swal({
        title: this.$t('wishlist.alerts.RemoveItemConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this.$store.dispatch('removeWishListFromDb', { profileId: _this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
            _this.$toasted.success(_this.$t('wishlist.alerts.RemoveItem'));
          }, function (error) {
            console.log('error in removing item from db', error);
          });
        }
      });
    },
    addToWishList: function addToWishList(itemId) {
      var _this2 = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': itemId }).then(function (response) {
          _this2.$toasted.success(_this2.$t('wishlist.alerts.AddedToWishList'));
        }, function (error) {
          console.error('error in adding item to wishList', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    addToCart: function addToCart(id) {
      var _this3 = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
          _this3.$toasted.success(_this3.$t('common.alerts.CART_ADDED_SUCCESS'));
        }, function (error) {
          console.log('error in adding item to cart', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    goToLogin: function goToLogin() {
      this.$root.$emit('bv::show::modal', 'login');
      return;
      // window.MKCLAPI.login()
    },
    playLO: function playLO(val) {
      var _this4 = this;

      var tmp = [];
      tmp.push(val);
      this.$store.dispatch('setCurrentContentViewerPlaylist', tmp).then(function (response) {
        _this4.$store.dispatch('setIsPlaylist', false).then(function (response) {
          _this4.$router.push('/frames');
        }, function (playListErr) {
          console.log('playlist error', playListErr);
        });
      }, function (error) {
        console.error('error in removing from wishList', error);
      });
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchNewLosFromDb').then(function (response) {}, function (error) {
      console.log('error in fetchMostWatchedLosFromDb', error);
    });
    /* if (this.$store.getters.getIsLoggedIn) {
      // call api to fetch LOs from Db to be displayed
      this.$store.dispatch('fetchNewLosFromDb').then(response => {
      }, error => {
        console.log('error in fetchMostWatchedLosFromDb', error)
      })
    } else {
      // alert(this.$store.getters.getNewLos.length)
      if (this.$store.getters.getNewLos.length === 0) {
        // call api to fetch LOs from Db to be displayed
        this.$store.dispatch('fetchNewLosFromDb').then(response => {
        }, error => {
          console.log('error in fetchMostWatchedLosFromDb', error)
        })
      }
    } */
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$store.getters.getIsLoggedIn) {
      this.$store.dispatch('clearNewLosFromStore').then(function (response) {}, function (error) {
        console.log('error in clearNewLosFromStore', error);
      });
    }
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "3qEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//

// import awsEndpoint from './urlsigner'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    includeStyling: {
      type: Boolean,
      default: true,
      required: false
    },
    awss3: {
      type: Object,
      required: false,
      default: null
    },
    destroyDropzone: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data: function data() {
    return {
      isS3: false,
      wasQueueAutoProcess: true
    };
  },

  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) this.wasQueueAutoProcess = this.options.autoProcessQueue;
      }
      return defaultValues;
    }
  },
  methods: {
    manuallyAddFile: function manuallyAddFile(file, fileUrl) {
      file.manuallyAdded = true;
      this.dropzone.emit('addedfile', file);
      fileUrl && this.dropzone.emit('thumbnail', file, fileUrl);

      var thumbnails = file.previewElement.querySelectorAll('[data-dz-thumbnail]');
      for (var i = 0; i < thumbnails.length; i++) {
        thumbnails[i].style.width = this.dropzoneSettings.thumbnailWidth + 'px';
        thumbnails[i].style.height = this.dropzoneSettings.thumbnailHeight + 'px';
        thumbnails[i].style['object-fit'] = 'contain';
      }
      this.dropzone.emit('complete', file);
      if (this.dropzone.options.maxFiles) this.dropzone.options.maxFiles--;
      this.dropzone.files.push(file);
      this.$emit('vdropzone-file-added-manually', file);
    },
    setOption: function setOption(option, value) {
      this.dropzone.options[option] = value;
    },
    removeAllFiles: function removeAllFiles(bool) {
      this.dropzone.removeAllFiles(bool);
    },
    processQueue: function processQueue() {
      var dropzoneEle = this.dropzone;
      if (this.isS3 && !this.wasQueueAutoProcess) {
        this.getQueuedFiles().forEach(function (file) {
          // this.getSignedAndUploadToS3(file);
        });
      } else {
        this.dropzone.processQueue();
      }
      this.dropzone.on('success', function () {
        dropzoneEle.options.autoProcessQueue = true;
      });
      this.dropzone.on('queuecomplete', function () {
        dropzoneEle.options.autoProcessQueue = false;
      });
    },
    init: function init() {
      return this.dropzone.init();
    },
    destroy: function destroy() {
      return this.dropzone.destroy();
    },
    updateTotalUploadProgress: function updateTotalUploadProgress() {
      return this.dropzone.updateTotalUploadProgress();
    },
    getFallbackForm: function getFallbackForm() {
      return this.dropzone.getFallbackForm();
    },
    getExistingFallback: function getExistingFallback() {
      return this.dropzone.getExistingFallback();
    },
    setupEventListeners: function setupEventListeners() {
      return this.dropzone.setupEventListeners();
    },
    removeEventListeners: function removeEventListeners() {
      return this.dropzone.removeEventListeners();
    },
    disable: function disable() {
      return this.dropzone.disable();
    },
    enable: function enable() {
      return this.dropzone.enable();
    },
    filesize: function filesize(size) {
      return this.dropzone.filesize(size);
    },
    accept: function accept(file, done) {
      return this.dropzone.accept(file, done);
    },
    addFile: function addFile(file) {
      return this.dropzone.addFile(file);
    },
    removeFile: function removeFile(file) {
      this.dropzone.removeFile(file);
    },
    getAcceptedFiles: function getAcceptedFiles() {
      return this.dropzone.getAcceptedFiles();
    },
    getRejectedFiles: function getRejectedFiles() {
      return this.dropzone.getRejectedFiles();
    },
    getFilesWithStatus: function getFilesWithStatus() {
      return this.dropzone.getFilesWithStatus();
    },
    getQueuedFiles: function getQueuedFiles() {
      return this.dropzone.getQueuedFiles();
    },
    getUploadingFiles: function getUploadingFiles() {
      return this.dropzone.getUploadingFiles();
    },
    getAddedFiles: function getAddedFiles() {
      return this.dropzone.getAddedFiles();
    },
    getActiveFiles: function getActiveFiles() {
      return this.dropzone.getActiveFiles();
    },
    getSignedAndUploadToS3: function getSignedAndUploadToS3(file) {
      // awsEndpoint.sendFile(file, this.awss3)
      //   .then((response) => {
      //     if (response.success) {
      //       file.s3ObjectLocation = response.message
      //       setTimeout(() => this.dropzone.processFile(file))
      //       this.$emit('vdropzone-s3-upload-success', response.message);
      //     } else {
      //       if ('undefined' !== typeof message) {
      //         this.$emit('vdropzone-s3-upload-error', response.message);
      //       } else {
      //         this.$emit('vdropzone-s3-upload-error', "Network Error : Could not send request to AWS. (Maybe CORS error)");
      //       }
      //     }
      //   })
      //   .catch((error) => {
      //     alert(error);
      //   });
    },
    setAWSSigningURL: function setAWSSigningURL(location) {
      if (this.isS3) {
        this.awss3.signingURL = location;
      }
    }
  },
  mounted: function mounted() {
    if (this.$isServer && this.hasBeenMounted) {
      return;
    }
    this.hasBeenMounted = true;
    var Dropzone = __webpack_require__("vuv6"); //eslint-disable-line
    Dropzone.autoDiscover = false;
    this.dropzone = new Dropzone(this.$refs.dropzoneElement, this.dropzoneSettings);
    var vm = this;

    this.dropzone.on('thumbnail', function (file, dataUrl) {
      vm.$emit('vdropzone-thumbnail', file, dataUrl);
    });

    this.dropzone.on('addedfile', function (file) {
      // alert(file.name)
      if (vm.duplicateCheck) {
        if (this.files.length) {
          this.files.forEach(function (dzfile) {
            if (dzfile.name === file.name) {
              this.removeFile(file);
              vm.$emit('duplicate-file', file);
            }
          }, this);
        }
      }
      vm.$emit('vdropzone-file-added', file);
      // if (vm.isS3 && vm.wasQueueAutoProcess) {
      //   vm.getSignedAndUploadToS3(file);
      // }
    });

    this.dropzone.on('addedfiles', function (files) {
      vm.$emit('vdropzone-files-added', files);
    });

    // vm.on('removeCustomFile', function() {
    //   console.log('here')
    //   this.removeAllFiles(true)
    // })
    this.dropzone.on('removedfile', function (file) {
      vm.$emit('vdropzone-removed-file', file);
      if (file.manuallyAdded) vm.dropzone.options.maxFiles++;
    });

    this.dropzone.on('success', function (file, response) {
      vm.$emit('vdropzone-success', file, response);
      if (vm.isS3 && vm.wasQueueAutoProcess) {
        vm.setOption('autoProcessQueue', false);
      }
    });

    this.dropzone.on('successmultiple', function (file, response) {
      vm.$emit('vdropzone-success-multiple', file, response);
    });

    this.dropzone.on('error', function (file, message, xhr) {
      vm.$emit('vdropzone-error', file, message, xhr);
    });

    this.dropzone.on('errormultiple', function (files, message, xhr) {
      vm.$emit('vdropzone-error-multiple', files, message, xhr);
    });

    this.dropzone.on('sending', function (file, xhr, formData) {
      if (vm.isS3) formData.append('s3ObjectLocation', file.s3ObjectLocation);
      vm.$emit('vdropzone-sending', file, xhr, formData);
    });

    this.dropzone.on('sendingmultiple', function (file, xhr, formData) {
      vm.$emit('vdropzone-sending-multiple', file, xhr, formData);
    });

    this.dropzone.on('complete', function (file) {
      vm.$emit('vdropzone-complete', file);
    });

    this.dropzone.on('completemultiple', function (files) {
      vm.$emit('vdropzone-complete-multiple', files);
    });

    this.dropzone.on('canceled', function (file) {
      vm.$emit('vdropzone-canceled', file);
    });

    this.dropzone.on('canceledmultiple', function (files) {
      vm.$emit('vdropzone-canceled-multiple', files);
    });

    this.dropzone.on('maxfilesreached', function (files) {
      vm.$emit('vdropzone-max-files-reached', files);
    });

    this.dropzone.on('maxfilesexceeded', function (file) {
      vm.$emit('vdropzone-max-files-exceeded', file);
    });

    this.dropzone.on('processing', function (file) {
      vm.$emit('vdropzone-processing', file);
    });

    this.dropzone.on('processing', function (file) {
      vm.$emit('vdropzone-processing', file);
    });

    this.dropzone.on('processingmultiple', function (files) {
      vm.$emit('vdropzone-processing-multiple', files);
    });

    this.dropzone.on('uploadprogress', function (file, progress, bytesSent) {
      vm.$emit('vdropzone-upload-progress', file, progress, bytesSent);
    });

    this.dropzone.on('totaluploadprogress', function (totaluploadprogress, totalBytes, totalBytesSent) {
      vm.$emit('vdropzone-total-upload-progress', totaluploadprogress, totalBytes, totalBytesSent);
    });

    this.dropzone.on('reset', function () {
      vm.$emit('vdropzone-reset');
    });

    this.dropzone.on('queuecomplete', function () {
      vm.$emit('vdropzone-queue-complete');
    });

    this.dropzone.on('drop', function (event) {
      vm.$emit('vdropzone-drop', event);
    });

    this.dropzone.on('dragstart', function (event) {
      vm.$emit('vdropzone-drag-start', event);
    });

    this.dropzone.on('dragend', function (event) {
      vm.$emit('vdropzone-drag-end', event);
    });

    this.dropzone.on('dragenter', function (event) {
      vm.$emit('vdropzone-drag-enter', event);
    });

    this.dropzone.on('dragover', function (event) {
      vm.$emit('vdropzone-drag-over', event);
    });

    this.dropzone.on('dragleave', function (event) {
      vm.$emit('vdropzone-drag-leave', event);
    });

    vm.$emit('vdropzone-mounted');
  },
  beforeDestroy: function beforeDestroy() {
    if (this.destroyDropzone) this.dropzone.destroy();
  }
});

/***/ }),

/***/ "4Bwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bsearch",
    attrs: {
      "id": "searchBox"
    }
  }, [_c('div', {
    staticClass: "search-words"
  }, _vm._l((_vm.randomList), function(item, index) {
    return _c('div', {
      key: index,
      class: 'sw-' + index
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": item,
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "container search-div"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-11 col-md-7"
  }, [_c('div', {
    staticClass: "form-group-holder"
  }, [_c('Autocomplete', {
    ref: "txt_search",
    attrs: {
      "resetAfter": false,
      "openDirection": "bottom",
      "searchable": true,
      "value": _vm.searchText,
      "preserveSearch": true,
      "selectLabel": "Search",
      "deselectLabel": "Search",
      "selectedLabel": "Search",
      "tag-placeholder": "Search",
      "taggable": true,
      "optionsLimit": 5,
      "placeholder": _vm.$t('common.labels.SearchPlaceHolder'),
      "options": _vm.suggestions,
      "id": "example-text-input"
    },
    on: {
      "tag": _vm.addTag,
      "search-change": _vm.getSuggestions,
      "select": _vm.onSearch,
      "remove": _vm.onSearch
    }
  })], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4S4k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseCards_vue__ = __webpack_require__("cWK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125005f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseCards_vue__ = __webpack_require__("eO6M");
function injectStyle (ssrContext) {
  __webpack_require__("zSpc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125005f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4tQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footerArea',
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */]
    };
  },

  computed: {
    getCurrentYear: function getCurrentYear() {
      var date = new Date();
      var year = date.getFullYear();
      return year;
    }
  }
});

/***/ }),

/***/ "5+FY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cart-content container"
  }, [(_vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length == 0) ? _c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v("  Cart is empty :(")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" Start by adding any of the below course/concept in cart")])]) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('cart.labels.cart')))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('br'), _vm._v(" "), (_vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length > 0) ? _c('b-form-input', {
    attrs: {
      "placeholder": "search items from cart",
      "type": "text"
    },
    model: {
      value: (_vm.keyWord),
      callback: function($$v) {
        _vm.keyWord = $$v
      },
      expression: "keyWord"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.keyWord.length == 0) ? _c('div', {
    staticClass: "row justify-content-end details-1"
  }, [(_vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length <= 1) ? _c('h6', {
    staticClass: "col-7 text-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.getters.getCartData.items.length) + " " + _vm._s(_vm.$t('cart.labels.ItemInYourCart')))])]) : _c('h6', {
    staticClass: "col-7 text-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.getters.getCartData.items.length) + " " + _vm._s(_vm.$t('cart.labels.ItemsInYourCart')))])]), _vm._v(" "), _c('h6', {
    staticClass: "col-5 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('cart.labels.Cost')))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.getters.getCartDataMatchingKeyWord(_vm.keyWord)), function(cartItem, index) {
    return (_vm.$store.getters.getCartDataMatchingKeyWord(_vm.keyWord) !== undefined && _vm.$store.getters.getCartDataMatchingKeyWord(_vm.keyWord) !== null && _vm.$store.getters.getCartDataMatchingKeyWord(_vm.keyWord).length > 0) ? _c('div', {
      key: index,
      staticClass: "row details-2"
    }, [_c('div', {
      staticClass: "px-3 img-css"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(cartItem.thumbnail, cartItem.itemType),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-7 description"
    }, [_c('div', {
      staticClass: "c-title"
    }, [_vm._v(_vm._s(cartItem.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "cart-actions"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteOnCart(cartItem.itemId)
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-delete",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Delete\r\n              ")])])]), _vm._v(" "), (cartItem.amount <= 1) ? _c('div', {
      staticClass: "col cost text-right"
    }, [_vm._v("\r\n              " + _vm._s(cartItem.amount) + "  " + _vm._s(_vm.$t('cart.labels.Point')) + "\r\n          ")]) : _c('div', {
      staticClass: "col cost text-right"
    }, [_vm._v("\r\n              " + _vm._s(cartItem.amount) + " " + _vm._s(_vm.$t('cart.labels.Points')) + "\r\n          ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "row coupon-total"
  }, [(_vm.keyWord.length == 0) ? _c('div', {
    staticClass: "col  coupoun-css"
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('cart.labels.RedeemedMsg')) + "  " + _vm._s(_vm.$t('cart.labels.NoCashTransactionMsg')) + "\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.keyWord.length == 0) ? _c('div', {
    staticClass: "col text-right total-amt"
  }, [((_vm.total <= 1)) ? _c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('cart.labels.TotalPointsReq')) + " ")]), _vm._v(" " + _vm._s(_vm.total) + " " + _vm._s(_vm.$t('cart.labels.Point')) + "\r\n              ")]) : _c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('cart.labels.TotalPointsReq')) + " ")]), _vm._v(" " + _vm._s(_vm.total) + " " + _vm._s(_vm.$t('cart.labels.Points')) + "\r\n              ")]), _vm._v(" "), (_vm.$store.getters.getCartData.items.length !== 0 && _vm.keyWord.length == 0) ? _c('div', {
    staticClass: "pt-5"
  }, [_c('button', {
    staticClass: "btn btn-large btn-danger ",
    on: {
      "click": function($event) {
        _vm.clearUserCart()
      }
    }
  }, [_vm._v(" Clear Cart")]), _vm._v(" "), _c('b-link', {
    staticClass: "btn btn-large btn-main ml-0 hov",
    attrs: {
      "to": {
        name: 'confirmation',
        params: {
          'cartId': this.$store.getters.getCartData.cartId,
          'profileId': this.$store.getters.getProfileDetails.profileId,
          'amount': _vm.total
        }
      }
    }
  }, [_vm._v("\r\n                  " + _vm._s(_vm.$t('cart.labels.ProceedToRedem')) + "\r\n                ")])], 1) : _c('div', {
    staticClass: "pt-5"
  }, [(_vm.keyWord.length == 0) ? _c('button', {
    staticClass: "btn btn-large btn-main  hov",
    on: {
      "click": function($event) {
        _vm.checkCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cart.labels.ProceedToRedem')) + "\r\n              ")]) : _vm._e()])]) : _vm._e()])], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "52KT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    ref: "player",
    attrs: {
      "id": "videoHolder",
      "autoplay": "",
      "width": "100%",
      "controls": "",
      "controlsList": "nodownload"
    },
    on: {
      "ended": function($event) {
        _vm.playNext()
      }
    }
  }, [_c('source', {
    ref: "source",
    attrs: {
      "src": _vm.mediaPath,
      "type": "video/mp4"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5IuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'videoPlayer',
  props: ['path'],
  data: function data() {
    return {
      mediaPath: this.path,
      lang: 'en',
      media: '',
      videoHolder: '',
      currentTime: 0,
      previousCalled: 0
    };
  },
  mounted: function mounted() {
    this.videoHolder = document.getElementById('videoHolder');
    // set video time by fetchingprevious time
    if (this.$store.getters.getIsplaylist) {
      if (this.$store.getters.getcurrentPlaylist !== null && this.$store.getters.getcurrentPlaylist.length > 0) {
        // this.videoHolder.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
      } else {
          // this.videoHolder.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
        }
    } else {
        // this.videoHolder.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
      }
  },

  methods: {
    playNext: function playNext(event) {
      var _this = this;

      this.$store.dispatch('setLoaderStatus', true);
      if (this.$store.getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < this.$store.getters.getCurrentContentViewerPlaylist.length; i++) {
          if (this.$store.getters.getCurrentContentViewerPlaylist[i].contentId === this.$store.getters.getcurrentPlayingContent.contentId) {
            if (this.$store.getters.getCurrentContentViewerPlaylist.length - 1 > i) {
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                setTimeout(function () {
                  _this.$store.dispatch('setCurrentPlayingContent', _this.$store.getters.getCurrentContentViewerPlaylist[i + 1]).then(function (response) {
                    _this.$store.dispatch('setLoaderStatus', false);
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/contentviewer/updatelowatchcount', { 'profileId': _this.$store.getters.getProfileDetails.profileId, 'itemId': _this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId }).then(function (response) {
                      _this.$store.dispatch('fetchEnrolledItems', _this.$store.getters.getProfileDetails.profileId);
                    }).catch(function (err) {
                      console.log(err);
                    });
                    resolve(i);
                  });
                }, 1000);
              });
            } else {
              this.$store.dispatch('setLoaderStatus', false);
              break;
            }
          }
        }
      }
    }
  },
  watch: {
    path: function path(newValue, oldValue) {
      /* axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getPreviousContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
      this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
      .then(response => {
      })
      .catch(err => {
        console.log(err)
      }) */
      this.mediaPath = newValue;
      if (this.$store.getters.getIsplaylist) {
        // this.$store.dispatch('updatePlaylistItemDuration', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastDuration': this.$refs.player.currentTime}).then(response => {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getPreviousContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime), 'plId': this.$store.getters.getcurrentPlaylist.plId })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
        // })
      } else {}
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getPreviousContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            this.videoHolder = document.getElementById('videoHolder')
            var innerHTMLObj = '<source ref="source" src="' + newValue + '" type="video/mp4">'
            this.videoHolder.innerHTML = ''
            this.videoHolder.innerHTML = innerHTMLObj
            this.previousCalled = 0
            // this.$refs.player.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
            this.$refs.player.load()
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
        // this.videoHolder = document.getElementById('videoHolder')
        // var innerHTMLObj = '<source ref="source" src="' + newValue + '" type="video/mp4">'
        // this.videoHolder.innerHTML = ''
        // this.videoHolder.innerHTML = innerHTMLObj
        // this.previousCalled = 0
        // // this.$refs.player.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
        // this.$refs.player.load()

        // console.log('video:newpath:' + newValue + 'oldapth:' + oldValue)
      this.videoHolder = document.getElementById('videoHolder');
      var innerHTMLObj = '<source ref="source" src="' + newValue + '" type="video/mp4">';
      this.videoHolder.innerHTML = '';
      this.videoHolder.innerHTML = innerHTMLObj;
      this.previousCalled = 0;
      // this.$refs.player.currentTime = this.$store.getters.getEnrolledLODataByContentIdProfileId.lastViewedDuration
      this.$refs.player.load();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', { 'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': this.$refs.player.currentTime });
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
          /* return new Promise((resolve, reject) => {
            axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': parseInt(this.$refs.player.currentTime) })
            .then(response => {
              this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject()
            })
          }) */
        }
    }
    this.previousCalled = 0;
    this.$refs.player.pause();
  }
});

/***/ }),

/***/ "5Qkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5eOA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container course-wishlist"
  }, [_c('div', {
    staticClass: "pb-3 row justify-content-end"
  }, [_c('h6', {
    staticClass: "col-md-12 main-title"
  }, [_vm._v(_vm._s(_vm.$t('wishlist.labels.MyWishlist')))]), (_vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length > 0) ? _c('b-form-input', {
    attrs: {
      "placeholder": "search items from wishList",
      "type": "text"
    },
    model: {
      value: (_vm.keyWord),
      callback: function($$v) {
        _vm.keyWord = $$v
      },
      expression: "keyWord"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$store.getters.getWishListDataMatchingKeyWord(_vm.keyWord) !== undefined && _vm.$store.getters.getWishListDataMatchingKeyWord(_vm.keyWord) !== null && _vm.$store.getters.getWishListDataMatchingKeyWord(_vm.keyWord).length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.$store.getters.getWishListDataMatchingKeyWord(_vm.keyWord)), function(wishList, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm-6 col-md-5 col-lg-4 col-xl-3"
    }, [_c('div', {
      staticClass: "card-design"
    }, [_c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(wishList.Thumbnail, wishList.type),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [_c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "title": wishList.itemName
      }
    }, [_vm._v(_vm._s(wishList.itemName))]), _vm._v(" "), _c('h3', {
      staticClass: "card-design__data-cost"
    }), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col"
    }, [(!_vm.$store.getters.itemPresentInCartStatus(wishList.itemId)) ? _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(wishList.itemId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('wishlist.labels.MoveToCart')))]) : _c('button', {
      staticClass: "btn btn-green-o"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))])]), _vm._v(" "), (!_vm.$store.getters.itemPresentInCartStatus(wishList.itemId)) ? _c('div', {
      staticClass: "col-auto act-holder"
    }, [_c('button', {
      staticClass: "btn btn-danger trash",
      attrs: {
        "title": _vm.$t('wishlist.labels.RemoveFromWishlistMsg')
      },
      on: {
        "click": function($event) {
          _vm.removeDataFromWishList(_vm.profileId, wishList.itemId)
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-delete"
    })])]) : _vm._e()])])])])
  })), _vm._v(" "), (_vm.keyWord.length == 0 && _vm.$store.getters.getWishListDataNotPresentInCart(_vm.$store.getters.getCartData) != undefined && _vm.$store.getters.getWishListDataNotPresentInCart(_vm.$store.getters.getCartData) != null && _vm.$store.getters.getWishListDataNotPresentInCart(_vm.$store.getters.getCartData).length > 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-large btn-blue mt-3",
    on: {
      "click": function($event) {
        _vm.moveAllToCart(_vm.$store.getters.getWishListStoreData)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('wishlist.labels.MoveAllToCart')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large btn-danger mt-3",
    on: {
      "click": function($event) {
        _vm.clearUserWishList()
      }
    }
  }, [_vm._v(" Clear WishList")])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col noticemsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('wishlist.labels.AddCoursesInWishlist')))])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5yCr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "67tN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youtube_player_vue__ = __webpack_require__("P2BP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d463fd58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_youtube_player_vue__ = __webpack_require__("zcfq");
function injectStyle (ssrContext) {
  __webpack_require__("EfFD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youtube_player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d463fd58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_youtube_player_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6BFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wishList_vue__ = __webpack_require__("RvJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b486202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_wishList_vue__ = __webpack_require__("qELe");
function injectStyle (ssrContext) {
  __webpack_require__("P4Ul")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wishList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b486202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_wishList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Ha2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-cards-alt container section-holder"
  }, [(_vm.$store.getters.getSearchStoreData != null && _vm.$store.getters.getSearchStoreData != undefined && _vm.$store.getters.getSearchStoreData.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-10 col-sm-8 col-lg-3 filter-content"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.$store.getters.getCategoryStoreData != undefined && _vm.$store.getters.getCategoryStoreData != null && _vm.$store.getters.getCategoryStoreData.length > 0) ? _c('b-form-group', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.ChooseCategory')) + " ( " + _vm._s(_vm.$store.getters.getCategoryStoreData != undefined && _vm.$store.getters.getCategoryStoreData != null && _vm.$store.getters.getCategoryStoreData.length > 0 ? _vm.$store.getters.getCategoryStoreData.length : '') + " )")]), _vm._v(" "), _c('b-form-checkbox-group', {
    attrs: {
      "stacked": "",
      "name": "category",
      "options": _vm.showAllCategory == false ? _vm.$store.getters.getNCategoryStoreData(_vm.moreCategory) : _vm.$store.getters.getCategoryStoreData
    },
    model: {
      value: (_vm.categoriesSelected),
      callback: function($$v) {
        _vm.categoriesSelected = $$v
      },
      expression: "categoriesSelected"
    }
  }, [(!_vm.showAllCategory) ? _c('div', {
    staticClass: "sm",
    on: {
      "click": function($event) {
        _vm.showCategory()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.ShowMore')))]) : _c('div', {
    staticClass: "sm",
    on: {
      "click": function($event) {
        _vm.hideCategory()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.ShowLess')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY' && _vm.options != undefined && _vm.options != null && _vm.options.length > 0) ? _c('b-form-group', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.Language')) + " ( " + _vm._s(_vm.options.length) + " )")]), _vm._v(" "), _c('b-form-checkbox-group', {
    attrs: {
      "stacked": "",
      "name": "lang",
      "options": _vm.showAllLanguage == false ? _vm.halfoptions : _vm.options
    },
    model: {
      value: (_vm.languageSelected),
      callback: function($$v) {
        _vm.languageSelected = $$v
      },
      expression: "languageSelected"
    }
  }, [(!_vm.showAllLanguage) ? _c('div', {
    staticClass: "sm",
    on: {
      "click": function($event) {
        _vm.showLanguage()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.ShowMore')))]) : _c('div', {
    staticClass: "sm",
    on: {
      "click": function($event) {
        _vm.hideLanguage()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.ShowLess')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY' && _vm.value != undefined && _vm.value != null && _vm.value.length > 0 && _vm.cost != undefined && _vm.cost != null && _vm.cost.length > 0) ? _c('b-form-group', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.Cost')))]), _vm._v(" "), (_vm.checkForRTL()) ? _c('vue-slider', {
    ref: "slider",
    staticClass: "pb-4",
    attrs: {
      "reverse": true,
      "min": 0,
      "max": _vm.cost[1]
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('vue-slider', {
    ref: "slider",
    staticClass: "pb-4",
    attrs: {
      "min": 0,
      "max": _vm.cost[1]
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY' && _vm.duration != undefined && _vm.duration != null) ? _c('b-form-group', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.Duration')))]), _vm._v(" "), _c('b-form-radio-group', {
    attrs: {
      "stacked": "",
      "name": "dur",
      "options": _vm.duration
    },
    model: {
      value: (_vm.durationSelected),
      callback: function($$v) {
        _vm.durationSelected = $$v
      },
      expression: "durationSelected"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title filter",
    on: {
      "click": function($event) {
        _vm.clearFilters()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.ClearAllFilters')) + " ")])], 1)]), _vm._v(" "), (_vm.showLoader != undefined && _vm.showLoader != null && _vm.showLoader) ? _c('div', {
    staticClass: "col-lg-9 description align-middle"
  }, [_c('div', {
    staticClass: "total-results"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__("Pa+M"),
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('searchPage.labels.loading')) + "\n          ")])]) : _c('div', {
    staticClass: "col-lg-9 description align-middle"
  }, [(_vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }) !== undefined && _vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }) !== null && _vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length > 0) ? _c('div', [(_vm.instanceName !== 'MAHADEMY' && _vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length < _vm.$store.getters.getTotalResultLength) ? _c('span', {
    staticClass: "total-results"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.showing')) + " "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length))]), _vm._v(" " + _vm._s(_vm.$t('searchPage.labels.resultsOutOf')) + " " + _vm._s(_vm.$store.getters.getTotalResultLength) + " for "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.getSearchText))])]) : (_vm.instanceName !== 'MAHADEMY' && _vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length === _vm.$store.getters.getTotalResultLength) ? _c('span', {
    staticClass: "total-results"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.showing')) + " "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length))]), _vm._v(" " + _vm._s(_vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length > 1 ? _vm.$t('searchPage.labels.multipleResults') : _vm.$t('searchPage.labels.singleResults')) + "  "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.getSearchText))])]) : (_vm.instanceName === 'MAHADEMY' &&
    _vm.$store.getters.getFilteredData({
      'categorySelected': this.categoriesSelected,
      'languageSelected': this.languageSelected,
      'duration': this.durationSelected,
      'cost': this.value
    }).length === _vm.$store.getters.getTotalResultLength) ? _c('span', {
    staticClass: "total-results"
  }, [_vm._v("\n                                                      " + _vm._s(_vm.$store.getters.getSearchText) + " " + _vm._s(_vm.$t('searchPage.labels.showing')) + " "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  }).length))]), _vm._v("   " + _vm._s(_vm.$t('searchPage.labels.multipleResults')))]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.getters.getFilteredData({
    'categorySelected': this.categoriesSelected,
    'languageSelected': this.languageSelected,
    'duration': this.durationSelected,
    'cost': this.value
  })), function(tmp, i) {
    return _c('div', {
      key: i,
      staticClass: "card-design card-design-h"
    }, [(tmp.thumbnail.length != 0) ? _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(tmp.thumbnail),
        "alt": ""
      }
    })]) : (tmp.type == 'LO') ? _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__("K5UD"),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__("9oHV"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [(tmp.type == 'CO' && _vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
      staticClass: "card-design__data-heading",
      attrs: {
        "to": {
          name: 'coursePage',
          params: {
            contentId: tmp.contentId
          }
        }
      }
    }, [_vm._v(_vm._s(tmp.title))]) : _vm._e(), _vm._v(" "), (tmp.type == 'CO' && _vm.instanceName === 'MAHADEMY') ? _c('h3', {
      staticClass: "card-design__data-heading no-line"
    }, [_vm._v(_vm._s(tmp.title))]) : _vm._e(), _vm._v(" "), (tmp.type == 'LO') ? _c('h3', {
      staticClass: "card-design__data-heading no-line"
    }, [_vm._v(_vm._s(tmp.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(tmp.price) + " " + _vm._s(tmp.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row card-design__details"
    }, [_c('span', {
      staticClass: "col-auto card-design__data-ratings"
    }, [(tmp.rating == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('span', [_c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "rating": parseInt(tmp.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('span', [_c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "rating": parseInt(tmp.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e()]), _vm._v(" "), (tmp.type == 'LO' && tmp.duration !== 0) ? _c('span', {
      staticClass: "col-auto"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.Duration')))]), _c('strong', [_vm._v(_vm._s(parseInt(tmp.duration / 60)) + " min " + _vm._s(parseInt((tmp.duration / 60).toFixed(1).split('.')[1]) * 6 == 0 ? "" : parseInt((tmp.duration / 60).toFixed(1).split('.')[1]) * 6) + " " + _vm._s(parseInt((tmp.duration / 60).toFixed(1).split('.')[1]) * 6 === 0 ? "" : "sec"))])]) : _vm._e(), _vm._v(" "), (tmp.type == 'CO') ? _c('span', {
      staticClass: "col-auto"
    }, [_c('div', [_vm._v(_vm._s(_vm.$t('searchPage.labels.Lectures')))]), _c('strong', [_vm._v(_vm._s(tmp.totalNumberofLO))])]) : _vm._e(), _vm._v(" "), (tmp.languageId != undefined && _vm.displayLanguage(tmp.languageId) != undefined && _vm.displayLanguage(tmp.languageId) != null) ? _c('span', {
      staticClass: "col-auto"
    }, [_c('div', [_vm._v(_vm._s(_vm.$t('searchPage.labels.Language')))]), _c('strong', [_vm._v(_vm._s(_vm.displayLanguage(tmp.languageId)))])]) : _vm._e(), _vm._v(" "), (tmp.type !== null && tmp.type !== undefined && tmp.type === 'CO') ? _c('span', {
      staticClass: "col-auto"
    }, [_vm._v("\n                       Share via\n                       "), _c('share-on-media', {
      attrs: {
        "item": tmp,
        "labelOnTop": false
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "col-auto"
    }, [_vm._v("\n                       Tags\n                       "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.getTagString(tmp)))])])])]), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row box-action"
    }, [(_vm.$store.getters.getItemSubscriptionStatus({
        'id': tmp.contentId,
        'type': tmp.type
      }) != undefined &&
      _vm.$store.getters.getItemSubscriptionStatus({
        'id': tmp.contentId,
        'type': tmp.type
      }) != null &&
      _vm.$store.getters.getItemSubscriptionStatus({
        'id': tmp.contentId,
        'type': tmp.type
      }) ||
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': tmp.tagList
      }) != undefined &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': tmp.tagList
      }) != null &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': tmp.tagList
      })) ? _c('div', {
      staticClass: "col"
    }, [(tmp.type == 'CO') ? _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.playLO(tmp)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.GO_TO_COURSE')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.playLO(tmp)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_NOW')))])]) : (_vm.featureStatusInfoList.cart && _vm.$store.getters.itemPresentInCartStatus(tmp.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(tmp.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(tmp.contentId)) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))])]) : (_vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(tmp.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList.wishlist && _vm.$store.getters.getItemPurchasedStatus(tmp.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(tmp.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(tmp.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(tmp.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(tmp.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(tmp.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(tmp.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(tmp.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(tmp.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(tmp.contentId) != undefined && $store.getters.itemPresentInCartStatus(tmp.contentId)!= null && !$store.getters.itemPresentInCartStatus(tmp.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(tmp.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(tmp.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(tmp.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(tmp.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(tmp.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row box-action"
    }, [(_vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList.wishlist) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })]) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.allResultsDisplayed')))]), _vm._v(" "), _c('span', {
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.allResultsDisplayed')))])])], 2) : _c('div', [_c('div', {
    staticClass: "noticemsg"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.noRecordsFound')))])])])])]) : _c('div', [_c('div', {
    staticClass: "noticemsg"
  }, [(_vm.$store.getters.getSearchText.length > 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('searchPage.labels.noRecordsFound')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('searchPage.labels.EnterTextToSearch')))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6n+F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7FMw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myCourses_vue__ = __webpack_require__("npNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd93dfc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_myCourses_vue__ = __webpack_require__("nuTZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myCourses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd93dfc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_myCourses_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7lhL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "83HF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_headerLogin_vue__ = __webpack_require__("3656");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wishList_courseWishList_vue__ = __webpack_require__("Bhfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__allCourseCards_vue__ = __webpack_require__("tRWC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_bannerSearch_vue__ = __webpack_require__("IKiV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'allCourses',
  components: {
    footerArea: __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__["a" /* default */],
    headerLogin: __WEBPACK_IMPORTED_MODULE_1__common_headerLogin_vue__["a" /* default */],
    allCourseCards: __WEBPACK_IMPORTED_MODULE_3__allCourseCards_vue__["a" /* default */],
    courseWishlist: __WEBPACK_IMPORTED_MODULE_2__components_wishList_courseWishList_vue__["a" /* default */],
    bannerSearch: __WEBPACK_IMPORTED_MODULE_4__home_bannerSearch_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "8Fcd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "videoPlayer"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "videoInfo"
  }, [(_vm.courseDetails.contentId != undefined && _vm.courseDetails.contentId.length != 0) ? _c('div', {
    staticClass: "videoData"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.courseDetails.title != undefined && _vm.courseDetails.title != null) ? _c('h1', [_vm._v(_vm._s(_vm.courseDetails.title))]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', [(_vm.courseDetails.contentId != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != null && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId)) ? _c('div', [_c('div', {
    staticClass: "row justify-content-between"
  }, [(_vm.$store.getters.getItemPurchasedDates({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }).expiryDate != undefined && _vm.$store.getters.getItemPurchasedDates({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }).expiryDate != null) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$store.getters.getItemPurchasedDates({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }).expiryDate.split("/").join("-")))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Your course expires on")])]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.courseDetails.description != undefined && _vm.courseDetails.description != null) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(" " + _vm._s(_vm.courseDetails.description))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center course-details-row align-items-center justify-content-center"
  }, [(_vm.courseDetails.enrolledCount != undefined && _vm.courseDetails.enrolledCount != null) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.courseDetails.enrolledCount))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Students enrolled")])]) : _vm._e(), _vm._v(" "), (_vm.courseDetails.skills != undefined && _vm.courseDetails.skills != null && _vm.courseDetails.skills.length > 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', [_vm._v(_vm._s(_vm.courseDetails.skills.join(',')))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text text-center"
  }, [_vm._v("Skill Level")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 rating-star"
  }, [(_vm.isLoggedIn && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != null && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  })) ? _c('div', [_c('div', {
    on: {
      "click": function($event) {
        _vm.showRating(_vm.courseDetails.contentId)
      }
    }
  }, [_c('star-rating', {
    attrs: {
      "rating": _vm.courseDetails.rating,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 22
    },
    on: {
      "rating-selected": _vm.setRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.labels.your_Rating')))])]) : _c('div', [_c('star-rating', {
    attrs: {
      "rating": _vm.courseDetails.rating,
      "read-only": true,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 15
    },
    on: {
      "rating-selected": _vm.setRating
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))])], 1)]), _vm._v(" "), (_vm.courseDetails.totalNumberofLO != undefined && _vm.courseDetails.totalNumberofLO != null && _vm.courseDetails.totalNumberofLO != 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.courseDetails.totalNumberofLO))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Lectures")])]) : _vm._e(), _vm._v(" "), (_vm.courseDetails.duration != undefined && _vm.courseDetails.duration != null && _vm.courseDetails.duration != 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.courseDetails.duration + 'H') + " ")]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Course duration")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [(_vm.courseDetails.languageId != undefined && _vm.displayLanguage(_vm.courseDetails.languageId) != undefined && _vm.displayLanguage(_vm.courseDetails.languageId) != null) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.displayLanguage(_vm.courseDetails.languageId)))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Available in")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), (_vm.courseDetails.contentId != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != null && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId)) ? _c('div', [_c('div', {
    staticClass: "col-auto"
  }, [(_vm.courseDetails.contentId != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId) != null && _vm.$store.getters.getItemPurchasedStatus(_vm.courseDetails.contentId)) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.courseDetails.price) + " " + _vm._s(_vm.courseDetails.price > 1 ? 'Point' : 'Points'))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Course costs")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.isLoggedIn) ? _c('div', [(_vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  }) != null && _vm.$store.getters.getItemSubscriptionStatus({
    'id': _vm.courseDetails.contentId,
    'type': _vm.courseDetails.type
  })) ? _c('div', {
    staticClass: "pb-3"
  }, [_c('button', {
    staticClass: "btn btn-blue-no-bg btn-blk",
    on: {
      "click": function($event) {
        _vm.goToCourse(_vm.courseDetails)
      }
    }
  }, [_vm._v("GO TO COURSE")])]) : (_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', {
    staticClass: "pb-3"
  }, [(_vm.$store.getters.itemPresentInCartStatus(_vm.courseDetails.contentId)) ? _c('button', {
    staticClass: "btn btn-blue-no-bg btn-blk"
  }, [_vm._v("ADDED TO CART")]) : _c('button', {
    staticClass: "btn btn-blk btn-blue",
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.courseDetails.contentId)
      }
    }
  }, [_vm._v("ADD TO CART")])]) : _vm._e()]) : (_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Price")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.courseDetails.price) + " " + _vm._s(_vm.courseDetails.price > 1 ? 'Point' : 'Points'))]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blk btn-blue",
    on: {
      "click": function($event) {
        _vm.goToLogin()
      }
    }
  }, [_vm._v("ADD TO CART")])])]) : _vm._e()])])]) : _c('div', {
    staticClass: "noticemsg"
  }, [_vm._v("\n        SOMETHING WENT WRONG\n      ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8TUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    // logout - deleted the session from redux server and session and local storage
    logout: function logout() {
      var _this = this;

      if (JSON.parse(localStorage.getItem('ssoToken'))) {
        // if token is generated from SSO server call SSO API
        var header = this;
        window.MKCLAPI.logout().then(function () {
          header.$store.dispatch('clearUserData');
          header.$router.push({ path: '/advertisement' });
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        // if token is generated by liveDemy server then call liveDemy api
        this.$store.dispatch('logoutThirdPartyUser').then(function (res) {
          _this.$store.dispatch('clearUserData');
          _this.$router.push({ path: '/advertisement' });
        }, function (err) {
          console.log('ERROR_IN_REMOVING_SESSION_OF_THIRD_PARTY_USER : ', err);
        });
      }
    }
  },
  mounted: function mounted() {
    this.logout();
    /* if (JSON.parse(localStorage.getItem('ssoToken'))) {
      this.logout()
    } else {
      this.$store.dispatch('logoutThirdPartyUser').then(res => {
        this.$store.dispatch('clearUserData')
        this.$router.push({path: '/advertisement'})
      }, err => {
        console.log('ERROR_IN_REMOVING_SESSION_OF_THIRD_PARTY_USER : ', err)
      })
    } */
  }
});

/***/ }),

/***/ "8Wcx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadercss"
  }, [_c('div', {
    staticClass: "lds-css ng-scope"
  }, [_c('div', {
    staticClass: "lds-css ng-scope"
  }, [_c('div', {
    staticClass: "lds-ellipsis",
    staticStyle: {
      "margin-left": "42%"
    }
  }, [_c('div', [_c('div')]), _c('div', [_c('div')]), _c('div', [_c('div')]), _c('div', [_c('div')]), _c('div', [_c('div')])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8bW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trendingCourses_vue__ = __webpack_require__("tR9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54eb6e80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_trendingCourses_vue__ = __webpack_require__("cB1k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trendingCourses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54eb6e80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_trendingCourses_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9CB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_footerArea_vue__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__walletCards_vue__ = __webpack_require__("Ycb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wishList_courseWishList_vue__ = __webpack_require__("Bhfl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wallet',
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default.a,
    footerArea: __WEBPACK_IMPORTED_MODULE_3__common_footerArea_vue__["a" /* default */],
    courseWishlist: __WEBPACK_IMPORTED_MODULE_5__components_wishList_courseWishList_vue__["a" /* default */],
    walletCards: __WEBPACK_IMPORTED_MODULE_4__walletCards_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showWishList: false
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__main_js__["EventBus"].$emit('showNav', false);
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */] === 'MAHADEMY') {
      this.$router.push('/home');
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.globalState = $state;
      setTimeout(function () {
        _this.showWishList = true;
        // this.showLibraryCard = true
        $state.loaded();
      }, 2000);
    },

    // handleScroll - handles scrolling
    handleScroll: function handleScroll() {
      var _this2 = this;

      if (this.showWishList) {
        setTimeout(function () {
          _this2.showLibraryCard = true;
          if (_this2.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this2.globalState.complete();
          }
        }, 2000);
      }
    }
  }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9eHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_advertisementPage_vue__ = __webpack_require__("DQKk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cf5b1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_advertisementPage_vue__ = __webpack_require__("D0Ff");
function injectStyle (ssrContext) {
  __webpack_require__("AW49")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_advertisementPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cf5b1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_advertisementPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9mgw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9oHV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultCO.52f6fec.jpg";

/***/ }),

/***/ "AW49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Alzq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEvS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlistCards',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["e" /* INSTANCE_NAME */],
      keyWord: '',
      index: '',
      isOpen: false,
      showArrow: false,
      prevIndex: -1,
      isAccordianVisible: false,
      checkFlag: false,
      flag: false,
      isPresent: false,
      rating: 0.0,
      isActive: false,
      notNextTick: true,
      selectedPlaylists: [], // Must be an array reference!
      selectedCollection: null,
      currentPlaylist: {},
      resultData: [],
      options: [{ text: 'Playlist 1', value: 'Playlist 1' }, { text: 'Playlist 2', value: 'Playlist 2' }, { text: 'Playlist 3', value: 'Playlist 3' }, { text: 'Playlist 4', value: 'Playlist 4' }, { text: 'Playlist 5', value: 'Playlist 5' }, { text: 'Playlist 6', value: 'Playlist 6' }],
      swiperOptionpy: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      swiperOptionp3: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      swiperOptionp5: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      PlayList: {
        plId: '',
        plName: '',
        profileId: '',
        items: []
      },
      UserDetails: {
        profileId: '',
        plId: '',
        itemId: ''
      },
      profileId: this.$store.getters.getProfileDetails.profileId
    };
  },

  computed: {
    getCurrentPlaylistId: function getCurrentPlaylistId() {
      if (this.currentPlaylist.plId !== undefined && this.currentPlaylist.plId !== null) {
        return this.currentPlaylist.plId;
      } else {
        return '0';
      }
    },
    selectPlayListOptions: function selectPlayListOptions() {
      var options = [];
      var playList = this.$store.getters.getUserPlaylists;
      if (playList !== null && playList.length > 0) {
        // playList.forEach(playlist => {
        _.forEach(playList, function (playlist) {
          var obj = {};
          obj.value = playlist.plId;
          obj.text = playlist.plName;
          options.push(obj);
        });
      }
      return options;
    },
    userPlayLists: function userPlayLists() {
      return this.$store.getters.getUserPlaylists;
    },
    purchaseList: function purchaseList() {
      return this.$store.getters.getItemsEnrolledByType('LO');
      /* var purchaseList = []
      for (let i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
        if (this.$store.getters.getCourseEnrolled[i].courseType === 'LO') {
          purchaseList.push(this.$store.getters.getCourseEnrolled[i])
        }
      }
      return purchaseList
      */
    }
  },
  created: function created() {
    this.fetchCollection();
    this.getPurchasedItems();
    this.getPlaylistLOData();
    // this.$store.dispatch('fetchEnrolledCourses', this.profileId)
  },

  watch: {
    keyWord: function keyWord(oldValue, newValue) {
      // console.log(oldValue)
      if (oldValue.length === 0) {
        this.$store.dispatch('fetchUserSingleConceptCollection', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': 1 });
      }
    }
  },
  methods: {
    // searchSingleConcept
    searchSingleConcept: function searchSingleConcept() {
      if (this.keyWord.length !== 0) {} else {
        this.$store.dispatch('getSingleConceptSearchResult', { 'profileId': this.$store.getters.getProfileDetails.profileId });
        this.$toasted.error('Please enter keyword to search');
      }
    },

    // loadNextSingleConcepts
    loadNextSingleConcepts: function loadNextSingleConcepts() {
      this.$store.dispatch('fetchUserSingleConceptCollection', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': this.$store.getters.getCurrentPage + 1 });
    },

    setRating: function setRating(rating) {
      this.rating = rating;
    },
    showRating: function showRating(contentID) {
      var _this = this;

      this.$store.dispatch('showRating', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating }).then(function (response) {
        _this.$toasted.success(_this.$t('common.alerts.RATING_ADDED'));
      }, function (error) {
        _this.$toasted.error(error);
        console.log('error in adding rating', error);
      });
    },
    toggleAccordianVisibility: function toggleAccordianVisibility() {
      if (this.isAccordianVisible) {
        this.isAccordianVisible = false;
      } else {
        this.isAccordianVisible = true;
      }
    },
    makePath: function makePath(path, type) {
      if (path !== undefined && path !== null && path.length !== 0) {
        return __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
        // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
      } else {
        if (type === 'CO') {
          return '../../../static/assets/images/defaultCO.jpg';
        } else if (type === 'LO') {
          return '../../../static/assets/images/defaultLO.jpg';
        } else {
          return '../../../static/assets/images/defaultLO.jpg';
        }
      }
    },
    makePathForPlaylistCard: function makePathForPlaylistCard(playlist) {
      if (playlist.items.length > 0) {
        return this.getItemThumbnailFromEnrolledLO(playlist.items[0]);
      } else {
        return '../../../static/assets/images/defaultLO.jpg';
      }
    },
    getPlaylistById: function getPlaylistById(plId) {
      this.currentPlaylist = this.$store.getters.getPlaylist(plId);
    },
    checkValue: function checkValue(val) {
      if (val !== undefined || val === '') {
        if (val.length === 0) {
          return false;
        } else {
          return true;
        }
      }
    },
    checkIsVisited: function checkIsVisited(index) {
      if (this.$store.getters.getUserPlaylists[index].items.length !== 0) {
        for (var j = 0; j < this.$store.getters.getUserPlaylists[index].items.length; j++) {
          if (this.$store.getters.getUserPlaylists[index].items[j].status !== undefined) {
            if (this.$store.getters.getUserPlaylists[index].items[j].status.isVisited) {
              return true;
            }
          }
        }
        return false;
      }
    },
    checkCreate: function checkCreate() {
      if (this.PlayList.plName === '') {
        this.$toasted.error(this.$t('playlist.alerts.ENTER_PLAYLIST_NAME'), { theme: 'primary', duration: 800 });
        return;
      }
      if (!this.isExist()) {
        this.createPlaylist();
      } else {
        this.$toasted.error(this.PlayList.plName + '\n' + this.$t('playlist.alerts.PLAYLIST_ALREADY_PRESENT'), { theme: 'primary', duration: 800 });
      }
    },
    getPurchasedItems: function getPurchasedItems() {
      var _this2 = this;

      window.axios.post('/r/viewCourseEnrolledData', { profileId: this.$store.getters.getProfileDetails.profileId }).then(function (response) {
        _this2.resultData = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showAddPlayModal: function showAddPlayModal() {
      this.$refs.addPlayModalRef.show();
    },
    hideAddPlayModal: function hideAddPlayModal() {
      this.$refs.addPlayModalRef.hide();
    },
    showCreateNewModal: function showCreateNewModal() {
      var self = this;
      this.$refs.createNewModalRef.show();
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].nextTick().then(function () {
        self.$refs.playListInputBox.focus();
      });
      // console.log(this.$refs.playListInputBox)
      // this.$refs.playListInputBox.focus()
    },
    hideCreateNewModal: function hideCreateNewModal() {
      this.$refs.createNewModalRef.hide();
    },
    check: function check() {
      var _this3 = this;

      if (this.PlayList.plName === '') {
        this.$toasted.error(this.$t('playlist.alerts.ENTER_PLAYLIST_NAME'), { theme: 'primary', duration: 800 });
        return;
      }
      if (!this.isExist()) {
        this.createPlaylist().then(function (res) {
          _this3.selectedPlaylists.push(res.plId);
          _this3.addInPlayListStore();
          _this3.$toasted.success(_this3.selectedCollection.title + '\n' + _this3.$t('playlist.alerts.ADDED_INTO_PLAYLIST') + res.plName, { theme: 'primary', duration: 6000 });
        });
        return;
      } else {
        this.$toasted.error(this.PlayList.plName + '\n' + this.$t('playlist.alerts.PLAYLIST_ALREADY_PRESENT'), { theme: 'primary', duration: 800 });
      }
    },
    isExist: function isExist() {
      for (var i = 0; i < this.$store.getters.getUserPlaylists.length; i++) {
        if (this.$store.getters.getUserPlaylists[i].plName.toUpperCase().replace(/[^a-zA-Z0-9\s]/g, '') === this.PlayList.plName.toUpperCase().replace(/[^a-zA-Z0-9\s]/g, '')) {
          return true;
        }
      }
      return false;
    },
    CheckItemAdd: function CheckItemAdd() {
      if (this.selectedPlaylists.length === 0) {
        this.$toasted.error(this.$t('playlist.alerts.SELECT_PLAYLIST'), { theme: 'primary', duration: 800 });
        return;
      } else {
        // For Already exists item
        for (var i = 0; i < this.selectedPlaylists.length; i++) {
          for (var j = 0; j < this.$store.getters.getUserPlaylists.length; j++) {
            this.isPresent = false;
            if (this.selectedPlaylists[i] === this.$store.getters.getUserPlaylists[j].plId) {
              for (var k = 0; k < this.$store.getters.getUserPlaylists[j].items.length; k++) {
                if (this.$store.getters.getUserPlaylists[j].items[k].itemId === this.selectedCollection.contentId) {
                  this.isPresent = true;
                  // this.$toasted.error(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.PRESENT_IN_PLAYLIST') + this.$store.getters.getUserPlaylists[j].plName, { theme: 'primary', duration: 6000 })
                  break;
                } else {
                  this.isPresent = false;
                  // this.$toasted.success(this.selectedCollection.title + '\n' + 'added into ' + this.$store.getters.getUserPlaylists[j].plName, { theme: 'primary', duration: 6000 })
                }
              }
              //  return isPresent
              if (this.isPresent === true) {
                this.$toasted.error(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.PRESENT_IN_PLAYLIST') + this.$store.getters.getUserPlaylists[j].plName, {
                  theme: 'primary',
                  duration: 6000
                });
                break;
              } else {
                this.$toasted.success(this.selectedCollection.title + '\n' + this.$t('playlist.alerts.ADDED_INTO_PLAYLIST') + this.$store.getters.getUserPlaylists[j].plName, {
                  theme: 'primary',
                  duration: 6000
                });
              }
            }
          }
        }
        this.addInPlayListStore();
        this.selectedPlaylists = [];
        this.selectedPlaylists = '';
      }
    },
    addInPlayListStore: function addInPlayListStore() {
      var playlistView = this;
      // this.selectedPlaylists.forEach(function (playListId) {
      _.forEach(this.selectedPlaylists, function (playListId) {
        var obj = {};
        obj.plId = playListId;
        var item = {};
        item.itemId = playlistView.selectedCollection.contentId;
        item.itemDescription = playlistView.selectedCollection.description;
        item.itemName = playlistView.selectedCollection.title;
        item.itemType = playlistView.selectedCollection.type;
        obj.item = item;
        playlistView.AddToPlayListDB(playListId, item);
        // playlistView.$store.dispatch('addItemInPlaylist', obj)
        // .then(res => {
        //   playlistView.AddToPlayListDB(playListId, item.itemName)
        // })
      });
      this.selectedPlaylists = [];
      this.hideAddPlayModal();
    },
    selectCollection: function selectCollection(collection) {
      var self = this;
      this.selectedPlaylists = [];
      this.PlayList.plName = '';
      this.selectedCollection = collection;
      this.$refs.addPlayModalRef.show();
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].nextTick().then(function () {
        self.$refs.playListInputTitle.focus();
      });
    },

    fetchCollection: function fetchCollection() {
      var playlistView = this;
      window.axios.get('r/viewCollection').then(function (response) {
        playlistView.$store.commit('setCollectionList', response.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    createPlaylist: function createPlaylist() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var PlayListdata = {
          plName: _this4.PlayList.plName,
          profileId: _this4.$store.getters.getProfileDetails.profileId,
          items: []
        };
        _this4.$store.dispatch('createPlaylist', PlayListdata).then(function (res) {
          _this4.$toasted.success(_this4.PlayList.plName + '\n' + _this4.$t('playlist.alerts.PLAYLIST_CREATED'), { theme: 'primary', duration: 800 });
          _this4.PlayList.plName = '';
          _this4.hideAddPlayModal();
          _this4.hideCreateNewModal();
          resolve(res);
        }).catch(function (err) {
          _this4.$.error(err, { theme: 'primary', duration: 800 });
        });
      });
    },
    AddToPlayListDB: function AddToPlayListDB(playlistId, item) {
      var _this5 = this;

      var playlistObj = this.$store.getters.getPlaylist(playlistId);
      playlistObj.items.push(item);
      var url = 'r/updatePlayList';
      window.axios.post(url, playlistObj).then(function (response) {
        _this5.$store.commit('updatePlaylistItems', response.data);
        // this.$toasted.success(item.itemName + '\n' + this.$t('playlist.alerts.ADDED_INTO_PLAYLIST') + playlistObj.plName, { theme: 'primary', duration: 800 })
      }).catch(function (err) {
        console.log(err);
      });
    },
    deleteItem: function deleteItem(plId, itemsData) {
      var _this6 = this;

      this.UserDetails.profileId = this.$store.getters.getProfileDetails.profileId;
      this.UserDetails.plId = plId;
      this.UserDetails.itemId = itemsData.itemId;
      // sweet alert added by Kumargauravs for confirmation of delete item
      this.$swal({
        title: this.$t('playlist.alerts.REMOVAL_CONFIRMATION'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this6.$store.dispatch('removePlayListFromDb', _this6.UserDetails);
          _this6.$toasted.success(itemsData.itemName + '\n' + _this6.$t('playlist.alerts.DELETE_ITEM'), { theme: 'primary', duration: 800 });
          _this6.selectedPlaylists = [];
          _this6.selectedPlaylists = '';
        }
      });
    },
    deletePlaylist: function deletePlaylist(plId, plname) {
      var _this7 = this;

      var PlayListdata = {
        profileId: this.$store.getters.getProfileDetails.profileId,
        plId: plId,
        plName: plname
      };
      this.$swal({
        title: this.$t('playlist.alerts.PLAYLIST_DELETE_CONFIRMATION'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this7.$store.dispatch('daletePlaylist', PlayListdata);
          _this7.$toasted.error(plname + '\n' + _this7.$t('playlist.alerts.DELETE_PLAYLIST'), { theme: 'primary', duration: 800 });
          _this7.selectedPlaylists = [];
          _this7.selectedPlaylists = '';
          _this7.PlayList.plName = '';
        }
      });
      // window.axios
      //   .post('o/createPlayList/' + this.$store.getters.getProfileDetails.profileId, PlayListdata)
      //   .then(response => {
      //     console.log('data===' + response.data)
      //     this.$store.dispatch('setUserPlayLists', response.data)
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
    },
    goToContentViewer: function goToContentViewer(playList) {
      var _this8 = this;

      var LOData = [];
      LOData.push(playList);
      window.axios.post('r/learningobject/getlodatabyplaylist', LOData).then(function (response) {
        _this8.$store.dispatch('setCurrentContentViewerPlaylist', response.data);
        if (response.data.length > 0) {
          _this8.contentPath = response.data[0].path[0].filePath;
          _this8.$store.dispatch('setCurrentPlayingContent', response.data[0]);
          _this8.$store.dispatch('setCurrentPlaylist', playList).then(function (response) {
            _this8.$store.dispatch('setIsPlaylist', true).then(function (response) {
              _this8.$router.push('/frames');
            });
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    playLO: function playLO(value) {
      var _this9 = this;

      if (this.$store.getters.getLOObjectByItemId(value.itemId).type === 'LO') {
        var playlist = [];
        playlist.push(this.$store.getters.getLOObjectByItemId(value.itemId));
        this.$store.dispatch('setCurrentContentViewerPlaylist', playlist).then(function (response) {
          _this9.$store.dispatch('setIsPlaylist', false).then(function (response) {
            _this9.$router.push('/frames');
          });
        });
      } else {
        this.$toasted.error('This is course');
      }
    },
    getItemName: function getItemName(item) {
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          return this.$store.getters.getCollectionList[i].title;
        }
      }
    },
    getItemNameFromEnrolledLO: function getItemNameFromEnrolledLO(item) {
      // alert(123)
      for (var i = 0; i < this.$store.getters.getItemsEnrolledByType('LO').length; i++) {
        if (this.$store.getters.getItemsEnrolledByType('LO')[i].contentId === item.itemId) {
          return this.$store.getters.getItemsEnrolledByType('LO')[i].title;
        }
      }
      /* for (var i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
        if (this.$store.getters.getCourseEnrolled[i].contentId === item.itemId && this.$store.getters.getCourseEnrolled[i].courseType === 'LO') {
          return this.$store.getters.getCourseEnrolled[i].title
        }
      } */
    },
    getItemRating: function getItemRating(item) {
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          return this.$store.getters.getCollectionList[i].rating;
        }
      }
    },
    getItemDuration: function getItemDuration(item) {
      var TotalDuration = 0;
      var LastViewedDuration = 0;
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          TotalDuration = this.$store.getters.getCollectionList[i].duration;
          // console.log('total time', TotalDuration)
        }
      }
      LastViewedDuration = this.$store.getters.getLastViewedDurationbyContentId(item.itemId);
      // alert(TotalDuration)
      var PercentRemaining = 100;
      if (TotalDuration !== 0) {
        var RemainingTime = TotalDuration - LastViewedDuration;
        PercentRemaining = RemainingTime / TotalDuration * 100;
      }
      // var PercentRemainingMsg = PercentRemaining + '% remaining'
      return PercentRemaining;
    },
    getItemThumbnailFromLO: function getItemThumbnailFromLO(item) {
      for (var i = 0; i < this.$store.getters.getCollectionList.length; i++) {
        if (this.$store.getters.getCollectionList[i].contentId === item.itemId) {
          return this.$store.getters.getCollectionList[i].thumbnail;
        }
      }
    },
    getItemThumbnailFromEnrolledLO: function getItemThumbnailFromEnrolledLO(item) {
      var thumbnailPath = '../../../static/assets/images/defaultLO.jpg';
      if (item !== undefined && item !== null) {
        for (var i = 0; i < this.$store.getters.getItemsEnrolledByType('LO').length; i++) {
          if (this.$store.getters.getItemsEnrolledByType('LO')[i].contentId === item.itemId) {
            var thumbnail = this.$store.getters.getItemsEnrolledByType('LO')[i].thumbnail;
            if (thumbnail !== undefined && thumbnail !== null && thumbnail.length !== 0) {
              thumbnailPath = __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + this.$store.getters.getItemsEnrolledByType('LO')[i].thumbnail;
            }
          }
        }
        /* for (var i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
          if (this.$store.getters.getCourseEnrolled[i].contentId === item.itemId && this.$store.getters.getCourseEnrolled[i].courseType === 'LO') {
            var thumbnail = this.$store.getters.getCourseEnrolled[i].thumbnail
            if (thumbnail !== undefined && thumbnail !== null && thumbnail.length !== 0) {
              thumbnailPath = CDP_CDN_THUMBNAIL_URL + '/' + this.$store.getters.getCourseEnrolled[i].thumbnail
            }
          }
        } */
      }
      return thumbnailPath;
    },
    getPlaylistLOData: function getPlaylistLOData() {
      var _this10 = this;

      window.axios.post('r/learningobject/getlodatabyplaylist', this.$store.getters.getUserPlaylists).then(function (response) {
        _this10.$store.dispatch('setLOMasterDataByPlaylist', response.data);
      });
    },
    addToCart: function addToCart(id) {
      var _this11 = this;

      this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
        _this11.$toasted.success(_this11.$t('common.alerts.CART_ADDED_SUCCESS'));
      }, function (error) {
        console.log('error in adding item to cart', error);
      });
    },
    show: function show() {},
    getIndex: function getIndex(index, itemLength) {
      if (itemLength > 0) {
        if (this.prevIndex === index) {
          if (this.showArrow === false) {
            this.showArrow = true;
          } else {
            this.showArrow = false;
          }
        } else {
          this.showArrow = true;
          this.prevIndex = index;
        }
        if (index <= 3) {
          document.getElementById('playAdd').style.order = '3';
        } else if (index > 3 && index <= 7) {
          document.getElementById('playAdd').style.order = '7';
        } else if (index > 7 && index <= 11) {
          document.getElementById('playAdd').style.order = '11';
        } else if (index > 11 && index <= 15) {
          document.getElementById('playAdd').style.order = '15';
        } else if (index > 15 && index <= 19) {
          document.getElementById('playAdd').style.order = '19';
        } else {
          document.getElementById('playAdd').style.order = '100';
        }
      } else {
        this.showArrow = false;
      }
    }
  }
});

/***/ }),

/***/ "BPWz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bhfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseWishList_vue__ = __webpack_require__("X2Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d76dfd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseWishList_vue__ = __webpack_require__("5eOA");
function injectStyle (ssrContext) {
  __webpack_require__("dcG8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseWishList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d76dfd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseWishList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C+QQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);


function isEmpty(opt) {
  if (opt === 0) return false;
  if (Array.isArray(opt) && opt.length === 0) return true;
  return !opt;
}

function not(fun) {
  return function () {
    return !fun.apply(undefined, arguments);
  };
}

function includes(str, query) {
  /* istanbul ignore else */
  if (str === undefined) str = 'undefined';
  if (str === null) str = 'null';
  if (str === false) str = 'false';
  var text = str.toString().toLowerCase();
  return text.indexOf(query.trim()) !== -1;
}

function filterOptions(options, search, label, customLabel) {
  return options.filter(function (option) {
    return includes(customLabel(option, label), search);
  });
}

function stripGroups(options) {
  return options.filter(function (option) {
    return !option.$isLabel;
  });
}

function flattenOptions(values, label) {
  return function (options) {
    return options.reduce(function (prev, curr) {
      /* istanbul ignore else */
      if (curr[values] && curr[values].length) {
        prev.push({
          $groupLabel: curr[label],
          $isLabel: true
        });
        return prev.concat(curr[values]);
      }
      return prev;
    }, []);
  };
}

function filterGroups(search, label, values, groupLabel, customLabel) {
  return function (groups) {
    return groups.map(function (group) {
      var _ref;

      /* istanbul ignore else */
      if (!group[values]) {
        console.warn('Options passed to vue-multiselect do not contain groups, despite the config.');
        return [];
      }
      var groupOptions = filterOptions(group[values], search, label, customLabel);

      return groupOptions.length ? (_ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, groupLabel, group[groupLabel]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, values, groupOptions), _ref) : [];
    });
  };
}

var flow = function flow() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, x);
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      isOpen: false,
      prefferedOpenDirection: 'below',
      optimizedHeight: this.maxHeight
    };
  },

  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: true
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Presets the selected options value.
     * @type {Object||Array||String||Integer}
     */
    value: {
      type: null,
      default: function _default() {
        return [];
      }
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: 'Select option'
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: true
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default: function _default(option, label) {
        if (isEmpty(option)) return '';
        return label ? option[label] : option;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: 'Press enter to create a tag'
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: 'top'
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: false
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1000
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: false
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: false
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    /* istanbul ignore else */
    if (!this.multiple && !this.clearOnSelect) {
      console.warn('[Vue-Multiselect warn]: ClearOnSelect and Multiple props can’t be both set to false.');
    }
    if (!this.multiple && this.max) {
      console.warn('[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false.');
    }
    if (this.preselectFirst && !this.internalValue.length && this.options.length) {
      this.select(this.filteredOptions[0]);
    }
  },

  computed: {
    internalValue: function internalValue() {
      return this.value || this.value === 0 ? Array.isArray(this.value) ? this.value : [this.value] : [];
    },
    filteredOptions: function filteredOptions() {
      var search = this.search || '';
      var normalizedSearch = search.toLowerCase().trim();

      var options = this.options.concat();

      /* istanbul ignore else */
      if (this.internalSearch) {
        options = this.groupValues ? this.filterAndFlat(options, normalizedSearch, this.label) : filterOptions(options, normalizedSearch, this.label, this.customLabel);
      } else {
        options = this.groupValues ? flattenOptions(this.groupValues, this.groupLabel)(options) : options;
      }

      options = this.hideSelected ? options.filter(not(this.isSelected)) : options;

      /* istanbul ignore else */
      if (this.taggable && normalizedSearch.length && !this.isExistingOption(normalizedSearch)) {
        if (this.tagPosition === 'bottom') {
          options.push({ isTag: true, label: search });
        } else {
          options.unshift({ isTag: true, label: search });
        }
      }

      return options.slice(0, this.optionsLimit);
    },
    valueKeys: function valueKeys() {
      var _this = this;

      if (this.trackBy) {
        return this.internalValue.map(function (element) {
          return element[_this.trackBy];
        });
      } else {
        return this.internalValue;
      }
    },
    optionKeys: function optionKeys() {
      var _this2 = this;

      var options = this.groupValues ? this.flatAndStrip(this.options) : this.options;
      return options.map(function (element) {
        return _this2.customLabel(element, _this2.label).toString().toLowerCase();
      });
    },
    currentOptionLabel: function currentOptionLabel() {
      return this.multiple ? this.searchable ? '' : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? '' : this.placeholder;
    }
  },
  watch: {
    internalValue: function internalValue() {
      /* istanbul ignore else */
      if (this.resetAfter && this.internalValue.length) {
        this.search = '';
        this.$emit('input', this.multiple ? [] : null);
      }
    },
    search: function search() {
      this.$emit('search-change', this.search, this.id);
    }
  },
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue: function getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },

    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @returns {Array} returns a filtered and flat options list
     */
    filterAndFlat: function filterAndFlat(options, search, label) {
      return flow(filterGroups(search, label, this.groupValues, this.groupLabel, this.customLabel), flattenOptions(this.groupValues, this.groupLabel))(options);
    },

    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @returns {Array} returns a flat options list without group labels
     */
    flatAndStrip: function flatAndStrip(options) {
      return flow(flattenOptions(this.groupValues, this.groupLabel), stripGroups)(options);
    },

    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch: function updateSearch(query) {
      this.search = query;
    },

    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @returns {Boolean} returns true if element is available
     */
    isExistingOption: function isExistingOption(query) {
      return !this.options ? false : this.optionKeys.indexOf(query) > -1;
    },

    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected: function isSelected(option) {
      var opt = this.trackBy ? option[this.trackBy] : option;
      return this.valueKeys.indexOf(opt) > -1;
    },

    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel: function getOptionLabel(option) {
      if (isEmpty(option)) return '';
      /* istanbul ignore else */
      if (option.isTag) return option.label;
      /* istanbul ignore else */
      if (option.$isLabel) return option.$groupLabel;

      var label = this.customLabel(option, this.label);
      /* istanbul ignore else */
      if (isEmpty(label)) return '';
      return label;
    },

    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select: function select(option, key) {
      /* istanbul ignore else */
      if (option.$isLabel && this.groupSelect) {
        this.selectGroup(option);
        return;
      }
      if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isDisabled || option.$isLabel) return;
      /* istanbul ignore else */
      if (this.max && this.multiple && this.internalValue.length === this.max) return;
      /* istanbul ignore else */
      if (key === 'Tab' && !this.pointerDirty) return;
      if (option.isTag) {
        this.$emit('tag', option.label, this.id);
        this.search = '';
        if (this.closeOnSelect && !this.multiple) this.deactivate();
      } else {
        var isSelected = this.isSelected(option);

        if (isSelected) {
          if (key !== 'Tab') this.removeElement(option);
          return;
        }

        this.$emit('select', option, this.id);

        if (this.multiple) {
          this.$emit('input', this.internalValue.concat([option]), this.id);
        } else {
          this.$emit('input', option, this.id);
        }

        /* istanbul ignore else */
        if (this.clearOnSelect) this.search = '';
      }
      /* istanbul ignore else */
      if (this.closeOnSelect) this.deactivate();
    },

    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup: function selectGroup(selectedGroup) {
      var _this3 = this;

      var group = this.options.find(function (option) {
        return option[_this3.groupLabel] === selectedGroup.$groupLabel;
      });

      if (!group) return;

      if (this.wholeGroupSelected(group)) {
        this.$emit('remove', group[this.groupValues], this.id);

        var newValue = this.internalValue.filter(function (option) {
          return group[_this3.groupValues].indexOf(option) === -1;
        });

        this.$emit('input', newValue, this.id);
      } else {
        var optionsToAdd = group[this.groupValues].filter(not(this.isSelected));

        this.$emit('select', optionsToAdd, this.id);
        this.$emit('input', this.internalValue.concat(optionsToAdd), this.id);
      }
    },

    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected: function wholeGroupSelected(group) {
      return group[this.groupValues].every(this.isSelected);
    },

    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @returns {type}        description
     */
    removeElement: function removeElement(option) {
      var shouldClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /* istanbul ignore else */
      if (this.disabled) return;
      /* istanbul ignore else */
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }

      var index = (typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === 'object' ? this.valueKeys.indexOf(option[this.trackBy]) : this.valueKeys.indexOf(option);

      this.$emit('remove', option, this.id);
      if (this.multiple) {
        var newValue = this.internalValue.slice(0, index).concat(this.internalValue.slice(index + 1));
        this.$emit('input', newValue, this.id);
      } else {
        this.$emit('input', null, this.id);
      }

      /* istanbul ignore else */
      if (this.closeOnSelect && shouldClose) this.deactivate();
    },

    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement: function removeLastElement() {
      /* istanbul ignore else */
      if (this.blockKeys.indexOf('Delete') !== -1) return;
      /* istanbul ignore else */
      if (this.search.length === 0 && Array.isArray(this.internalValue)) {
        this.removeElement(this.internalValue[this.internalValue.length - 1], false);
      }
    },

    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate: function activate() {
      var _this4 = this;

      /* istanbul ignore else */
      if (this.isOpen || this.disabled) return;

      this.adjustPosition();
      /* istanbul ignore else  */
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      /* istanbul ignore else  */
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          return _this4.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
    },

    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate: function deactivate() {
      /* istanbul ignore else */
      if (!this.isOpen) return;

      this.isOpen = false;
      /* istanbul ignore else  */
      if (this.searchable) {
        this.$refs.search.blur();
      } else {
        this.$el.blur();
      }
      if (!this.preserveSearch) this.search = '';
      this.$emit('close', this.getValue(), this.id);
    },

    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle: function toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },

    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition: function adjustPosition() {
      if (typeof window === 'undefined') return;

      var spaceAbove = this.$el.getBoundingClientRect().top;
      var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === 'below' || this.openDirection === 'bottom') {
        this.prefferedOpenDirection = 'below';
        this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
      } else {
        this.prefferedOpenDirection = 'above';
        this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
      }
    }
  }
});

/***/ }),

/***/ "C+nI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'instructorProfile',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "CK32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCookie */
//inside
var axios = __webpack_require__("mtWM")

var config = {
  clientId: null,
  mkclLoginServerURL: null,
  mkclLoginClientURL: null,
  mkclSignUpURL: null,
  redirectUrl: null,
  callback: null
}

const LOGIN_API = '/o/login/validateuser'
const LOGOUT_API = '/r/logout'
const VALIDATE_TOKEN_API = '/o/isValidToken'
const GET_CLIENT_CONFIG_API = '/o/getclientconfig'
  
// var eventBus = document.createElement('P')

function login(username, password) {
  // console.log('in login')
  //call to login api
  // alert(config.clientId)
  return new Promise(function (resolve, reject) {
    var loginUrl = config.mkclLoginServerURL + LOGIN_API
    axios.post(loginUrl, { 'username': username, 'password': password },
      { headers: { 'clientId': config.clientId } })
      .then(function (res) {
        if (res.status === 200) {
          var token = res.headers.authorization
          if (token === null) {
            token = localStorage.getItem('token')
          }
          // on success , set token cookie 
          setToken(token)
          // set cookies for client group members
          sendTokenToClientGroupMembers(token)
          // call to callback function
          resolve(token)
          if (config.callback !== null) {
            config.callback(token).then(function () { })
          }
        } else if (res.status === 208) {
          reject(new Error('MAX_SESSION_LIMIT_REACHED'))
        }
      }).catch(function (err) {
        // console.log('err 8888888 : ', err.response.status)
        reject(err.response.status)
      })
  })
  
}

function sendTokenToClientGroupMembers(jwtToken) {
  // alert('sendTokenToClientGroupMembers')
  getClientConfig(config.clientId).then(function(clientConfig) {
    var clientGroupMembers = clientConfig.group.groupmembers
    var iframeDiv
    var bodyElements = document.getElementsByTagName('body')
    iframeDiv = document.getElementById('iframeDiv')
    //deleting existing iframdiv container for iframes
    // console.log(document.getElementById('iframeDiv'))
    // alert(iframeDiv !== null)
    if (iframeDiv !== null && iframeDiv.hasChildNodes()) {
      // bodyElements.removeChild(iframeDiv)
      //removing existing iframes
      iframeDiv.innerHTML = ''
    }
    //creating iframdiv conatainer for iframes
    iframeDiv = document.createElement('div')
    iframeDiv.id = 'iframeDiv'
    
    // console.log(bodyElement)
    bodyElements[0].appendChild(iframeDiv)
    clientGroupMembers.forEach(function (clientMember) {
      getClientConfig(clientMember).then(function(config) {
        var memberReturnUrl = config.purpose.returnurl
        // alert(memberReturnUrl)
        var ifrm = document.createElement('iframe')
        ifrm.setAttribute('src', memberReturnUrl)
        ifrm.style.visibility = 'none'
        // ifrm.style.height = '0px'
        // ifrm.style.width = '0px'
        iframeDiv.appendChild(ifrm)
        ifrm.addEventListener('load', function () {
          // alert('load' + memberReturnUrl)
          var receiverPath = new URL(memberReturnUrl)
          var receiverOrigin = receiverPath.origin
          // alert('sending to' + receiverOrigin)
          ifrm.contentWindow.postMessage({ isLogin: true, token: jwtToken }, receiverOrigin)
        })
      })
    })
    iframeDiv.style.display = 'none'
  })
}

function getClientConfig(clientId) {
  return new Promise(function(resolve, reject) {
    var clientConfigUrl = config.mkclLoginServerURL + GET_CLIENT_CONFIG_API
    axios.post(clientConfigUrl, { 'clientid': clientId })
    .then(function (res) {
      resolve(res.data)
    }).catch(function () {
      reject(new Error('ERR_FEATCHING_CLIENT_CONFIG:' + clientId))
    })
  })
}

function signUp() {
  // window.open('', '', 'height=200')
  var MKCLLoginUrl = config.mkclSignUpURL + '?clientId=' + config.clientId
  window.location.href = MKCLLoginUrl
}

// function loginPopup () {
//   // window.open('http://www.google.com')
//   // var currentUrl = window.location.href
//   var MKCLLoginUrl = config.mkclLoginClientURL + '?clientId=' + config.clientId
//   let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=yes,menubar=yes,
//   width=0,height=0,left=50,top=50`
//   window.open(MKCLLoginUrl, 'test', params)
//   // window.location.href = MKCLLoginUrl
// }

window.onload = function () {
  window.addEventListener('message', receiveMessage, false)
}

function sendTokenAcknoledgement(err) {
  var parentPath = new URL(config.mkclLoginClientURL)
  var parentOrigin = parentPath.origin
  var parent = window.parent
  if (err !== null) {
    // parent.postMessage({ 'isTokenReceived': true, 'isError': true, 'errorMsg': err.message }, parentOrigin)
    return
  }
  // alert('sendTokenAcknoledgement solar')
  // parent.postMessage({ 'isTokenReceived': true, 'isError': false, 'errorMsg': '' }, parentOrigin)
}

function receiveMessage(event) {
  var loginUrl = new URL(config.mkclLoginClientURL)
  var loginOrigin = loginUrl.origin
  // if (event.origin === loginOrigin) {
  if (true) {
    if (event.data.isLogin !== undefined && event.data.isLogin) {
      var token = event.data.token
      if (token !== undefined && token !== null) {
        setToken(token)
        if (config.callback !== null) {
          config.callback(token).then(function () {
            sendTokenAcknoledgement(null)
          }).catch(function (e) {
            sendTokenAcknoledgement(e)
          })
        }
        // let loggedEvent = new CustomEvent('loggedIn', {detail: token}) // (2)
        // redirectWithTimeout()
        // eventBus.dispatchEvent(loggedEvent)
      }
    }
  }
}

function setToken(token) {
  // window.localStorage.setItem('token', token)
  // alert('setToken ' + config.clientId)
  setCookie(config.clientId, token)
}
function getToken() {
  // return window.localStorage.getItem('token')
  return getCookie(config.clientId)
}

function removeToken() {
  // window.localStorage.removeItem('token')
  deleteCookie(config.clientId)
}

// function redirectWithTimeout () {
//   var redirectUrl = config.redirectUrl
//   // alert(redirectUrl)
//   if (redirectUrl !== undefined || redirectUrl !== null) {
//     setTimeout(function () {
//       window.location.href = config.redirectUrl
//     }, 1000)
//   }
// }

function isTokenValid(token) {
  // var token = GetCookie(config.clientId)
  // var token = getToken()
  return new Promise(function (resolve, reject) {
    if (token === null) {
      token = localStorage.getItem('token')
    }
    var validateTokenUrl = config.mkclLoginServerURL + VALIDATE_TOKEN_API
    axios.post(validateTokenUrl, { 'clientId': config.clientId, 'token': token }).then(function (res) {
      resolve(res)
    }).catch(function (err) {
      removeToken()
      reject(err)
    })
  })
}

function isLoggedIn() {
  var token = getToken()
  if (token !== undefined && token !== null) {
    return true
  } else {
    return false
  }
}

function logout() {
  return new Promise(function (resolve, reject) {
    var logoutUrl = config.mkclLoginServerURL + LOGOUT_API
    axios.get(logoutUrl, { headers: { 'clientId': config.clientId } }).then(function () {
      removeToken()
      resolve()
    }).catch(function (e) {
      reject(e)
    })
  })
}

function init(options) {
  Object.keys(options).forEach(function (key) {
    config[key] = options[key]
  })
}

function getCookieVal(offset) {
  var endstr = document.cookie.indexOf(';', offset)
  if (endstr === -1) {
    endstr = document.cookie.length
  }
  return unescape(document.cookie.substring(offset, endstr))
}

function getCookie(name) {
  var arg = name + '='
  var alen = arg.length
  var clen = document.cookie.length
  var i = 0
  while (i < clen) {
    var j = i + alen
    if (document.cookie.substring(i, j) === arg) return getCookieVal(j)
    i = document.cookie.indexOf(' ', i) + 1
    if (i === 0) break
  }
  return null
}

function setCookie(name, value) {
  //   var expirationDate = new Date()
  //   var cookieString = ''
  //   expirationDate.setFullYear(expirationDate.getFullYear() + 1)
  // // Build the set-cookie string:
  //   cookieString = name + '=' + value + ';' + 'expires =' + expirationDate.toUTCString()
  // // Create or update the cookie:
  //   document.cookie = cookieString
  document.cookie = name + '=' + value + '; path= /'
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

var sso = {
  getToken: getToken,
  login: login,
  logout: logout,
  isLoggedIn: isLoggedIn,
  // isSessionPresent: isSessionPresent,
  isTokenValid: isTokenValid,
  removeToken: removeToken,
  signUp: signUp
}


function install(vue, options) {
  vue.prototype.$sso = sso
  window.MKCLAPI = sso
  
  if (options != undefined && options !== null) {
    Object.keys(options).forEach(function (key) {
      config[key] = options[key]
    })
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),

/***/ "Cn0U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder",
    attrs: {
      "id": "new-video-cards"
    }
  }, [(_vm.$store.getters.getMostWatchedLos !== undefined && _vm.$store.getters.getNewLos !== null && _vm.$store.getters.getNewLos.length > 0) ? _c('div', {
    staticClass: "pb-2 row justify-content-end"
  }, [_c('h6', {
    staticClass: "main-title col-12 text-left"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.Recently_added_Videos')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getMostWatchedLos !== undefined && _vm.$store.getters.getNewLos !== null && _vm.$store.getters.getNewLos.length > 0) ? _c('div', {
    staticClass: "swiper-holder"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption1
    }
  }, [_vm._l((_vm.$store.getters.getNewLos), function(added, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "card-design"
    }, [(added.thumbnail.length != 0) ? _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": _vm.makePath(added.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": "../../../static/assets/images/defaultLO.jpg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [_c('div', {
      staticClass: "lo-label"
    }, [_vm._v(_vm._s(_vm.$t('libraryCards.labels.lo_label')))]), _vm._v(" "), _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": added.title
      }
    }, [_vm._v(_vm._s(added.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(added.price) + " " + _vm._s(added.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]) : _vm._e(), _vm._v(" "), (parseInt(added.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(added.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(added.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row mt-3"
    }, [(
      _vm.$store.getters.getItemSubscriptionStatus({
        'id': added.contentId,
        'type': added.type
      }) != undefined &&
      _vm.$store.getters.getItemSubscriptionStatus({
        'id': added.contentId,
        'type': added.type
      }) != null &&
      _vm.$store.getters.getItemSubscriptionStatus({
        'id': added.contentId,
        'type': added.type
      }) ||
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': added.tagList
      }) != undefined &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': added.tagList
      }) != null &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': added.tagList
      })
    ) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.playLO(added)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_NOW')))])]) : (_vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [(_vm.$store.getters.itemPresentInCartStatus(added.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(added.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(added.contentId)) ? _c('button', {
      staticClass: "btn btn-green-alt"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(added.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList.wishlist && _vm.$store.getters.getItemPurchasedStatus(added.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(added.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(added.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(added.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(added.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(added.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(added.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(added.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(added.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(added.contentId) != undefined && $store.getters.itemPresentInCartStatus(added.contentId)!= null && !$store.getters.itemPresentInCartStatus(added.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(added.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(added.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(added.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(added.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(added.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row mt-3"
    }, [(_vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList.wishlist) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })]) : _vm._e()])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D0Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advertisementPage"
  }, [_c('div', {
    staticClass: "content-holder"
  }, [_c('div', {
    staticClass: "container section-holder"
  }, [(!_vm.isLoggedIn) ? _c('div', {
    staticClass: "noticemsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.alerts.logout_success')))])]) : _vm._e()]), _vm._v(" "), _c('trendingCourses')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DQKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_newVideoCards__ = __webpack_require__("q9mY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_bannerSearch_vue__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_trendingCourses__ = __webpack_require__("8bW+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'advertisementPage',
  components: {
    newVideoCards: __WEBPACK_IMPORTED_MODULE_1__home_newVideoCards__["a" /* default */],
    bannerSearch: __WEBPACK_IMPORTED_MODULE_2__home_bannerSearch_vue__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_3__home_courseCards__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_4__home_libraryCards__["a" /* default */],
    trendingCourses: __WEBPACK_IMPORTED_MODULE_5__home_trendingCourses__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {
    checkTokenValidity: function checkTokenValidity() {
      var home = this;
      var token = window.MKCLAPI.getToken();
      if (token !== undefined && token !== null) {
        window.MKCLAPI.isTokenValid(token).then(function () {
          // token is valid
        }).catch(function () {
          home.$store.dispatch('clearUserData');
          window.MKCLAPI.removeToken();
        });
      }
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  mounted: function mounted() {
    this.checkTokenValidity();
    __WEBPACK_IMPORTED_MODULE_0__main_js__["EventBus"].$emit('showNav', true);
  }
});

/***/ }),

/***/ "Dq3d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_playlist_vue__ = __webpack_require__("/qkF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420dec82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_playlist_vue__ = __webpack_require__("3G4Z");
function injectStyle (ssrContext) {
  __webpack_require__("a/52")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_playlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420dec82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_playlist_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DqTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pointer: 0,
      pointerDirty: false
    };
  },

  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition: function pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements: function visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions: function filteredOptions() {
      this.pointerAdjust();
    },
    isOpen: function isOpen() {
      this.pointerDirty = false;
    }
  },
  methods: {
    optionHighlight: function optionHighlight(index, option) {
      return {
        'multiselect__option--highlight': index === this.pointer && this.showPointer,
        'multiselect__option--selected': this.isSelected(option)
      };
    },
    groupHighlight: function groupHighlight(index, selectedGroup) {
      var _this = this;

      if (!this.groupSelect) {
        return ['multiselect__option--disabled'];
      }

      var group = this.options.find(function (option) {
        return option[_this.groupLabel] === selectedGroup.$groupLabel;
      });

      return [this.groupSelect ? 'multiselect__option--group' : 'multiselect__option--disabled', { 'multiselect__option--highlight': index === this.pointer && this.showPointer }, { 'multiselect__option--group-selected': this.wholeGroupSelected(group) }];
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter',
          key = _ref.key;

      /* istanbul ignore else */
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerForward: function pointerForward() {
      /* istanbul ignore else */
      if (this.pointer < this.filteredOptions.length - 1) {
        this.pointer++;
        /* istanbul ignore next */
        if (this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight) {
          this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerBackward: function pointerBackward() {
      if (this.pointer > 0) {
        this.pointer--;
        /* istanbul ignore else */
        if (this.$refs.list.scrollTop >= this.pointerPosition) {
          this.$refs.list.scrollTop = this.pointerPosition;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerBackward();
      } else {
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerReset: function pointerReset() {
      /* istanbul ignore else */
      if (!this.closeOnSelect) return;
      this.pointer = 0;
      /* istanbul ignore else */
      if (this.$refs.list) {
        this.$refs.list.scrollTop = 0;
      }
    },
    pointerAdjust: function pointerAdjust() {
      /* istanbul ignore else */
      if (this.pointer >= this.filteredOptions.length - 1) {
        this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0;
      }

      if (this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) {
        this.pointerForward();
      }
    },
    pointerSet: function pointerSet(index) {
      this.pointer = index;
      this.pointerDirty = true;
    }
  }
});

/***/ }),

/***/ "E/Wt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__("36GZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_479514a1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__("NljK");
function injectStyle (ssrContext) {
  __webpack_require__("+EsQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_479514a1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EOnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseList',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "EdzJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EfFD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ejfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_autocomplete__ = __webpack_require__("Yv+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_blockui__ = __webpack_require__("KVzY");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
function sendMessageToAndroid(message) {
  Android.sendMessage(message);
}
/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_blockui__["default"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "headerLogin",
  props: ["status"],
  components: { Autocomplete: __WEBPACK_IMPORTED_MODULE_6__components_autocomplete__["a" /* default */] },
  data: function data() {
    return {
      signUpStatus: true,
      togglePasswordInputType: true,
      app_env: null,
      tempUsername: "",
      isLinkingOperationPerformed: false,
      displayName: "",
      options: {
        enablePrivilege: true,
        consumerKey: "4ifqJFwVtJ3aq15rfNeUAUzcW",
        consumerSecret: "f3lDB7ep4nsFdL7lGmNjKsgmg8FiagPXwvwN14BWdBcQq84Gbq"
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: true
      },
      googleSignInParams: {
        client_id: "844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com"
      },
      msg: "Please wait...",
      url: "static/assets/images/Spinner.svg", // It is important to import the loading image then use here
      blockUi: false,
      tokenForPasswordChange: "",
      mobileAlreadyInUse: false,
      emailAlreadyInUse: false,
      optOnMail: [{ text: "Send OTP on email", value: true }],
      obj: {
        fullname: false,
        DOB: false,
        gender: false,
        email: false,
        mobilenumber: false,
        username: false
      },
      genderList: [{ text: "Male", value: "M" }, { text: "Female", value: "F" }],
      signUpObj: {
        contactDetails: {
          email: {
            address: null
          },
          mobile: {
            number: null,
            verifiedOn: null
          }
        },
        personalDetails: {
          dob: null,
          fullName: null,
          gender: null
        },
        userName: null,
        password: null
      },
      config: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      errorList: [],
      showUsernameSuggestion: false,
      suggestedUserName: [],
      isLoginWithInvalidCredentials: false,
      genderSelected: "",
      emptyUsername: false,
      emptyPassword: false,
      date: "",
      fullname: "",
      DOB: "",
      gender: "",
      email: "",
      mobile: "",
      username: "",
      password: "",
      otpInput: "",
      confirmPassword: "",
      isShown: false,
      otpOptions: [],
      isOtpRequestSend: false,
      loading: false,
      scrollPosition: null,
      isValidUser: false,
      suggestions: [],
      wordlist: [],
      searchText: "",
      queryText: "",
      latitude: 0,
      longitude: 0,
      invalidUsernameOtp: false,
      invalidOtp: false,
      passwordMismatch: false,
      defaultOptions: {
        maximumAge: 0,
        timeout: 2000,
        enableHighAccuracy: false
      },
      bag: new __WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* ErrorBag */](),
      profile: "",
      userNameForPasswordReset: "",
      thirdPartyUserObj: {
        email: "",
        mobile: "",
        userName: "",
        jvId: "",
        mkclIdentificationNumber: ""
      },
      askForMobile: false,
      askForEmail: false,
      showContact: false,
      showEmail: false,
      showPasswordHint: false,
      // passwordChangeAuth: ''
      mobileDevice: false,
      caseFalse: false,
      userEnteredValue: "",
      afficilator: "",
      profileId: "",
      usernameFromAfficilatorApi: "",
      strike_length: false,
      strike_cap_alpha: false,
      strike_no_char: "",
      showSpecialCharErr: false,
      isContactDetailsOtpSend: false,
      isMultipleAccount: false,
      isLinkingPermission: false,
      associatedProfileId: "",
      contactMobile: "",
      livedemyEnv: localStorage.getItem("app_env"),
      instanceName: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["e" /* INSTANCE_NAME */],
      featureList: null
    };
  },
  created: function created() {
    // this.mobileDevice = this.$route.params.mobileDevice
    this.mobileDevice = localStorage.getItem("mobileDevice");
    // this.getSignUpStatus()
    // this.app_env = local
    // initializeFaceBookSDK()
  },

  methods: {
    focusOnForgetPasswordModal: function focusOnForgetPasswordModal(e) {
      this.$refs.usernameForgotInput.focus();
    },
    focusOnSignUpModal: function focusOnSignUpModal(e) {
      this.$refs.fullName.focus();
    },
    focusOnLoginModal: function focusOnLoginModal(e) {
      this.$refs.username.focus();
    },
    isAppEnvMahademy: function isAppEnvMahademy() {
      if (localStorage.getItem("app_env") !== null && localStorage.getItem("app_env") !== undefined && localStorage.getItem("app_env") === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["f" /* MAHADEMY_APP_ENV */]) {
        return true;
      }
      return false;
    },
    getUserDefaultCategory: function getUserDefaultCategory() {
      return __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */];
    },

    // isMobileDevice - returns status indicating whether user is logged in on mobile device or not
    isMobileDevice: function isMobileDevice() {
      return localStorage.getItem("mobileDevice");
    },

    // checkForTabOrSpaces - check for tab or space in ip
    // return true if space of tab found
    checkForTabOrSpaces: function checkForTabOrSpaces(ip) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        for (var i = 0; i < ip.length; i++) {
          if (ip.charCodeAt(i) === 9 || ip.charCodeAt(i) === 32) {
            resolve(true);
          }
        }
        resolve(false);
      });
    },

    // countCapitalAlphabets - returns number of capital alphabets in ip
    countCapitalAlphabets: function countCapitalAlphabets(ip) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var count = 0;
        for (var i = 0; i < ip.length; i++) {
          if (ip.charCodeAt(i) >= 65 && ip.charCodeAt(i) <= 90) {
            count++;
          }
        }
        resolve(count);
      });
    },

    // validatePasswordInput - checks whether password is valid according to rules
    // rules : no tab or space, length min 12, one capital letter, must contain at least one number, no rule for special character
    // returns false if invalid password else true
    validatePasswordInput: function validatePasswordInput(ip) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (ip.length !== 0) {
          // check length
          if (ip.length >= 4) {
            _this.strike_length = true;
          } else {
            _this.strike_length = false;
            resolve(false);
          }
          _this.countCapitalAlphabets(ip).then(function (res) {
            if (res === 0 || res < 1) {
              // check if ip has no capital letter or more than one capital letter
              _this.strike_cap_alpha = false;
              // return false // ip has no or more than one capital letter
              resolve(false); // ip has no or more than one capital letter
            } else {
              _this.strike_cap_alpha = true;
              resolve(true);
              /* var numList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
              for (var i = 0; i < ip.length; i++) {
                if (numList.includes(parseInt(ip[i]))) {
                  resolve(true) // valid passwword
                }/*  else {
                  if (i + 1 === ip.length) {
                    resolve(false) // ip has no numeric h=characters
                  }
                }
              } */
            }
          });
        } else {
          // console.log('l f')
          _this.strike_cap_alpha = false;
          resolve(false);
        }
      });
    },

    // goOffline - used for android app
    goOffline: function goOffline() {
      sendMessageToAndroid("go-offline");
    },

    // sendtoMobileLogin - used for android app
    sendtoMobileLogin: function sendtoMobileLogin() {
      sendMessageToAndroid("login");
    },

    // validateForNumberInput - checks whether ip value contains number or alphabet
    // parameter toReturnError - decides whether to return error or simply toast it
    // returns false if contains alphabet
    validateForNumberInput: function validateForNumberInput(ip, toReturnError) {
      var numList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      for (var val = 0; val < ip.split("").length; val++) {
        if (numList.includes(parseInt(ip[val])) === false) {
          if (!toReturnError) {
            // donot return the error
            this.$toasted.error("OTP must contain only numeric characters");
            break;
          } else {
            // return the error
            return false;
          }
        } else {
          if (val + 1 === ip.split("").length) {
            return true;
          }
        }
      }
    },

    // validateForTextInput - checks whether ip value contains alphabetic or non - alphabetic characters
    // parameter toReturnError - decides whether to return error or simply toast it
    // returns false if constains non - alphabetic characters
    validateForTextInput: function validateForTextInput(ip, toReturnError) {
      var ipList = ip.trim("").replace(/\s/g, "").toLowerCase().split("");
      var alphabet = "abcdefghijklmnopqrstuvwxyz";
      var alphabetList = alphabet.split("");
      for (var i = 0; i < ipList.length; i++) {
        if (alphabetList.includes(ipList[i]) === false) {
          if (!toReturnError) {
            // toast the error
            this.$toasted.error("Input must not contain any non alphabetic charaters");
          } else {
            // return the error
            return false;
          }
        } else {
          if (i + 1 === ipList.length) {
            return true;
          }
        }
      }
    },

    // enrollThirdPartyUser - resgister the third party data
    enrollThirdPartyUser: function enrollThirdPartyUser() {
      var _this2 = this;

      this.showContact = false;
      this.showEmail = false;
      if (this.thirdPartyUserObj.email.length === 0) {
        this.thirdPartyUserObj.userName = this.thirdPartyUserObj.email;
      }
      /*
        steps for registration :
        1. enroll user in liveDemy db
        2. create token for user
        3. store token and set flags
        4. logged in user
      */
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var registrationObject = {
          userName: _this2.thirdPartyUserObj.email,
          email: _this2.thirdPartyUserObj.email,
          mobile: _this2.thirdPartyUserObj.mobile,
          mkclIdentificationNumber: _this2.thirdPartyUserObj.mkclIdentificationNumber
        };
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/enrollNewUser", registrationObject).then(function (res) {
          // step 1 success [enroll user in liveDemy db]
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/createTokenForSocialUser", {
            userName: _this2.thirdPartyUserObj.email
          }).then(function (res) {
            // step 2 success [create token for user]
            /*
            set information to be set in local storage
            token => created by liveDemy server
            isLoggedin => flag to be seted for mantaining session storage accross multiple tabs
            ssoToken => flag to be seted if token is generated by sso server
            */
            localStorage.setItem("token", res.data);
            localStorage.setItem("isLoggedIn", true);
            localStorage.setItem("ssoToken", false);
            // step 3 success [store token and set flags]
            _this2.$store.dispatch("signInThirdPartyUser", res.data).then(function (res) {
              // step 4 success [logged in user]
              // this.$refs.loginModal.hide()
              resolve();
            }, function (error) {
              console.log("ERROR_IN_SIGN_IN : ", error);
              reject(error);
            });
          }).catch(function (err) {
            console.log("ERROR_IN_CREATING_TOKEN :", err);
            reject(err);
          });
        }).catch(function (err) {
          console.log("ERROR_IN_ENROLLING_NEW_USER : ", err);
          reject(err);
        });
      });
    },

    // resetThirdPartyUserObj - clear previous data
    resetThirdPartyUserObj: function resetThirdPartyUserObj() {
      this.thirdPartyUserObj.email = "";
      this.thirdPartyUserObj.mobile = "";
      this.thirdPartyUserObj.userName = "";
      this.thirdPartyUserObj.jvId = "";
      this.thirdPartyUserObj.mkclIdentificationNumber = "";
    },

    // storeThirdPartyData - called when user login for 1st time
    storeThirdPartyData: function storeThirdPartyData(thirdParty, dataFromThirdParty) {
      this.resetThirdPartyUserObj();
      if (dataFromThirdParty.name !== undefined || dataFromThirdParty.name !== null) {
        this.displayName = dataFromThirdParty.name;
      }
      if (thirdParty === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["h" /* THIRDPARTY_FACEBOOK_USER */]) {
        this.thirdPartyUserObj.mkclIdentificationNumber = dataFromThirdParty.id;
        this.showContact = true;
        this.showEmail = true;
        this.$refs.registrationInfoModal.show();
      } else if (thirdParty === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["i" /* THIRDPARTY_GOOGLE_USER */]) {
        this.thirdPartyUserObj.mkclIdentificationNumber = dataFromThirdParty.email;
        this.showContact = true;
        this.thirdPartyUserObj.email = dataFromThirdParty.email;
        this.userName = dataFromThirdParty.email;
        this.$refs.registrationInfoModal.show();
      }
    },

    // onFBSignInSuccess - mtd called on successfull sign In from facebook
    onFBSignInSuccess: function onFBSignInSuccess(response) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__main_js__["facebookUserDetails"])().then(function (res) {
        _this3.storeThirdPartyData(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["h" /* THIRDPARTY_FACEBOOK_USER */], res);
      });
    },
    onSignInSuccess: function onSignInSuccess(googleUser) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.blockUi = true;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/verifySocialMediaUser", { profileId: googleUser.El }).then(function (res) {
          // console.log(JSON.stringify(res))
          if (res.status === 200 && res.data.remark === "IDENTIFICATION_NUMBER_NOT_REGISTERED") {
            _this4.blockUi = false;
            _this4.$toasted.error("Google account is not linked with livedemy...");
            // this.$refs.loginModal.hide()
            resolve();
          } else if (res.status === 200 && res.data.remark === "SUCCESS") {
            _this4.$store.dispatch("setUserStoreData", res.data.userData).then(function (storeResponse) {
              if (storeResponse) {
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("ssoToken", false);
                _this4.$toasted.success("Welcome user...");
                _this4.blockUi = false;
                _this4.$refs.loginModal.hide();
              }
            });
          }
        }).catch(function (err) {
          _this4.blockUi = false;
          // this.$refs.loginModal.hide()
          console.log(err);
          _this4.$toasted.error("Error while signing in with Google..");
          reject();
        });
      });
    },
    onSignInError: function onSignInError(error) {
      this.$toasted.error("Something went wrong... please try again");
      // `error` contains any error occurred.
      console.log("ERROR_WHILE_THIRD_PARTY_SIGN_IN : ", error);
    },
    assignError: function assignError(isError, fieldName, value) {
      this.obj[fieldName] = isError;
      if (fieldName === "email" && !isError) {
        // alert(value)
        this.isDuplicateEmailOrMobile("email", value);
      } else if (fieldName === "mobilenumber" && !isError) {
        this.isDuplicateEmailOrMobile("mobile", value);
      }
    },

    // isAnyFieldBlank - checks whether feilds are blank during sign up
    isAnyFieldBlank: function isAnyFieldBlank() {
      if (this.email !== "") {
        if (this.mobile !== "") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkForUsernameAvailability: function checkForUsernameAvailability(username) {
      var _this5 = this;

      // return new Promise((resolve, reject) => {
      if (!this.checkForError() && !this.isAnyFieldBlank()) {
        this.signUpObj.personalDetails.fullName = this.email;
        this.signUpObj.contactDetails.email.address = this.email;
        this.signUpObj.contactDetails.mobile.number = this.mobile;
        this.signUpObj.userName = this.username;
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/isUsernameAvailable", _this5.signUpObj).then(function (res) {
            if (res.status === 208) {
              _this5.$toasted.error("username already in use");
              _this5.showUsernameSuggestion = true;
              _this5.suggestedUserName = res.data.usernames;
              // this.signUpObj.username = username
              // reject()
              resolve();
            } else if (res.status === 200) {
              _this5.$toasted.success("username available");
              _this5.showUsernameSuggestion = false;
              // this.signUpObj.username = username
              resolve();
            }
          }).catch(function (err) {
            console.log("ERROR_IN_CHECKING_AVAILABLE_USERNAME : ", err);
            reject(err);
          });
        });
      } else {
        this.$toasted.error("please fill proper details");
      }
    },
    handleOtpResend: function handleOtpResend() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/resendotp", { username: _this6.userNameForPasswordReset }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
          _this6.$toasted.success("OTP sent");
          resolve();
        }).catch(function (err) {
          console.log("ERROR_IN_RESENDING_OTP : ", err);
          reject();
        });
      });
    },

    // reset - resets the flags and values
    reset: function reset() {
      this.togglePasswordInputType = true;
      this.isShown = false;
      this.userEnteredValue = "";
      this.isContactDetailsOtpSend = false;
      this.isLinkingOperationPerformed = false;
      this.userNameForPasswordReset = "";
      this.errors.clear();
      this.blockUi = false;
      this.fullname = "";
      this.date = "";
      this.genderSelected = "";
      this.signUpObj.personalDetails.fullName = null;
      this.signUpObj.contactDetails.email.address = null;
      this.signUpObj.contactDetails.mobile.number = null;
      this.signUpObj.userName = null;
      this.signUpObj.password = null;
      this.passwordMismatch = false;
      this.invalidOtp = false;
      this.invalidUsernameOtp = false;
      this.isOtpRequestSend = false;
      this.username = "";
      this.password = "";
      this.otpInput = "";
      this.confirmPassword = "";
      this.otpOptions = [];
      this.emptyUsername = false;
      this.emptyPassword = false;
      this.email = "";
      this.mobile = "";
      this.isLoginWithInvalidCredentials = false;
      this.emailAlreadyInUse = false;
      this.mobileAlreadyInUse = false;
      this.isMultipleAccount = false, this.isLinkingPermission = false, this.associatedProfileId = "", this.contactMobile = "";
    },
    resetPasswordPolicyFlags: function resetPasswordPolicyFlags() {
      this.strike_length = false;
      this.strike_cap_alpha = false;
      this.strike_no_char = false;
    },

    // handleRegistration - register user on liveDemy
    handleRegistration: function handleRegistration() {
      var _this7 = this;

      var errorList = "";
      var blankEmailError = false;
      var blankMobileError = false;
      var blankFullNameError = false;
      // check for full name
      if (this.fullname.trim().length === 0 || !this.validateForTextInput(this.fullname, true)) {
        blankFullNameError = true;
        errorList = "full name";
      }
      // check for email
      if (this.email.length === 0 || this.email.indexOf("@") < 1 || this.email.lastIndexOf(".") < this.email.indexOf("@") + 2 || this.email.lastIndexOf(".") + 2 >= this.email.length) {
        if (blankFullNameError) {
          errorList = errorList + ", email";
          blankEmailError = true;
        } else {
          blankEmailError = true;
          errorList = "email";
        }
      }
      // check for mobile
      if (this.mobile.length === 0 || this.mobile.length < 10 || !this.validateForNumberInput(this.mobile, true)) {
        if (blankEmailError || blankFullNameError) {
          blankMobileError = true;
          errorList = errorList + ", mobile";
        } else {
          errorList = "mobile";
          blankMobileError = true;
        }
      }
      // check for valid password input
      this.validatePasswordInput(this.password).then(function (res) {
        if (!res) {
          // password not valid
          if (blankMobileError || blankEmailError || blankFullNameError) {
            errorList = errorList + ", password ";
          } else {
            errorList = "password";
          }
        }
        // no errors begin then encrypt password and begin Registration
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__main_js__["encrtpyDetailsUsingMd5"])(_this7.password).then(function (res) {
          // console.log(res)
          var encryptedPassword = res;
          if (errorList === "") {
            // if valid email, mobile and password entered by user
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/registerUser", {
                fullName: _this7.fullname.trim(),
                userName: _this7.email,
                accountDetails: [{
                  jvId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */],
                  email: _this7.email,
                  mobile: _this7.mobile,
                  isActive: true,
                  password: encryptedPassword
                }],
                roles: [__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["k" /* LIVEDEMY_DEFAULT_USER_RIGHT */]],
                linkingPermission: false
              }).then(function (res) {
                if (res.status === 200) {
                  _this7.$toasted.success("Registration Successfull");
                  _this7.reset();
                  _this7.$refs.signupModal.hide();
                  _this7.$refs.loginModal.show();
                  resolve(true);
                } else {
                  _this7.$toasted.errors("Something went wrong");
                  reject(false);
                }
              }).catch(function (err) {
                // console.log(JSON.stringify(err.response.data))
                console.log("error in registration : ", err.response.data);
                _this7.$toasted.error(err.response.data);
                reject(false);
              });
            });
          } else {
            // invalid input entered by user
            // console.log(errorList)
            _this7.$toasted.error("Enter appropriate input for " + errorList);
          }
        });
      });
    },

    // isDuplicateEmailOrMobile - returns true if value for key is unique else false
    isDuplicateEmailOrMobile: function isDuplicateEmailOrMobile(key, value) {
      if (value.length !== 0) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/isDuplicateEmailOrMobile", null, {
            headers: { key: key, value: value }
          }).then(function (res) {
            if (res.status === 200) {
              // value for key is unique
              resolve(true);
            } else if (res.status === 208) {
              // value for key is already in use
              resolve(false);
            }
          }).catch(function (err) {
            console.log("ERROR_IN_GETTING_UNIQUE_FEILD_STATUS : ", err);
            reject();
          });
        });
      }
    },

    // clearLocalStorage - clears the content from local storage
    clearLocalStorage: function clearLocalStorage() {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (localStorage.length !== 0) {
          for (var i = 0; i < localStorage.length; i++) {
            localStorage.removeItem(localStorage.key(i));
            if (i + 1 === localStorage.length) {
              resolve(true);
            }
          }
        } else {
          resolve(true);
        }
      });
    },

    // handleOtpVerification - verifies user entered otp
    handleOtpVerification: function handleOtpVerification(evt) {
      var _this8 = this;

      evt.preventDefault();
      if (this.otpInput.length === 0) {
        this.$toasted.error("OTP field cannot be blanked");
      } else if (this.validateForNumberInput(this.otpInput, true) === false) {
        this.$toasted.error("OTP must contain only numeric characters");
      } else {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          // console.log(SSO_URL + '/o/forgotpassword/verifyotp')
          _this8.blockUi = true;
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/verifyotp", { username: _this8.userNameForPasswordReset, otp: _this8.otpInput }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
            if (res.status === 200) {
              // console.log(JSON.stringify(res))
              // this.passwordChangeAuth = res.headers.authorization
              _this8.blockUi = false;
              _this8.invalidOtp = false;
              _this8.isOtpRequestSend = false;
              _this8.password = "";
              _this8.clearLocalStorage().then(function (response) {
                localStorage.setItem("tokenForPasswordChange", res.headers.authorization);
                _this8.tokenForPasswordChange = res.headers.authorization;
                //  console.log(this.tokenForPasscwordChange)
                _this8.$refs.passwordChangeModal.show();
                _this8.$toasted.success("OTP Verifed");
                resolve();
              });
            }
          }).catch(function (err) {
            _this8.blockUi = false;
            _this8.invalidOtp = true;
            console.log("ERROR_IN_VERIFIYNG_OTP : ", err);
            reject();
          });
        });
      }
    },

    // handleOtpRequest - sends the otp request
    handleOtpRequest: function handleOtpRequest(evt) {
      var _this9 = this;

      // Prevent modal from closing
      // evt.preventDefault()
      if (this.username.length === 0) {
        this.$toasted.error("Email / mobile number cannot be empty");
      } else {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          _this9.blockUi = true;
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/getBasicProfile", null, {
            headers: { userName: _this9.username }
          }).then(function (res) {
            _this9.usernameFromAfficilatorApi = res.data.userName;
            _this9.isMultipleAccount = res.data.multipleAccounts;
            _this9.isLinkingPermission = res.data.linkingPermission;
            _this9.afficilator = res.data.afficilator;
            _this9.profileId = res.data.profileId;
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/login/validateusername", { username: res.data.userName }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
              _this9.userNameForPasswordReset = res.data;
              if (res.status === 200) {
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/sendotp", {
                  username: _this9.userNameForPasswordReset,
                  isemail: _this9.otpOptions[0]
                }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
                  if (res.status === 200) {
                    _this9.invalidUsernameOtp = false;
                    _this9.blockUi = false;
                    _this9.isOtpRequestSend = true;
                    _this9.$toasted.success("OTP sent");
                    resolve();
                  }
                }).catch(function (err) {
                  console.log("ERROR_IN_SENDING_OTP : ", err);
                  _this9.blockUi = false;
                  reject();
                });
              }
            }).catch(function (err) {
              _this9.invalidUsernameOtp = true;
              _this9.$toasted.error("Please enter registered mobile number");
              // console.log(this.invalidUsernameOtp)
              _this9.blockUi = false;
              console.log("ERROR_IN_VALIDATING_USERNAME : ", err);
              reject();
            });
          }).catch(function (err) {
            _this9.blockUi = false;
            console.log("ERROR_IN_GETTING_USERNAME : ", err);
            _this9.invalidUsernameOtp = true;
          });
        });
        // this.isOtpRequestSend = true
        // api to verify SSO
      }
    },

    // isUserContactEmpty - check if contact details are not empty
    isUserContactEmpty: function isUserContactEmpty(contactDetails) {
      // console.log(JSON.stringify(contactDetails))
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (contactDetails === null) {
          // console.log('e')
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },

    // verifyEmailAndMobile - verifies whether the user entered details
    verifyEmailAndMobile: function verifyEmailAndMobile(key, value) {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this10.blockUi = true;
        _this10.contactMobile = _this10.userEnteredValue;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/verifytheContactDetails", null, {
          headers: { key: "mobile", value: _this10.userEnteredValue }
        }).then(function (res) {
          // console.log('-->', JSON.stringify(res.data))
          _this10.associatedProfileId = res.data.profileId;
          _this10.userNameForPasswordReset = res.data.associatedUserName;
          // console.log('associated username : ', this.userNameForPasswordReset)
          if (res.data.remark === "AVAILABLE") {
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/login/validateusername", { username: _this10.usernameFromAfficilatorApi }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
              if (res.status === 200) {
                _this10.blockUi = false;
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/sendotp", {
                  username: _this10.usernameFromAfficilatorApi,
                  isemail: true
                }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
                  if (res.status === 200) {
                    _this10.blockUi = false;
                    _this10.$toasted.success("OTP sent");
                    _this10.isContactDetailsOtpSend = true;
                    resolve();
                  }
                }).catch(function (err) {
                  console.log("ERROR_IN_SENDING_OTP : ", err);
                  _this10.blockUi = false;
                  reject();
                });
              }
            }).catch(function (err) {
              _this10.invalidUsernameOtp = true;
              _this10.$toasted.error("Please enter registered mobile number");
              // console.log(this.invalidUsernameOtp)
              _this10.blockUi = false;
              console.log("ERROR_IN_VALIDATING_USERNAME : ", err);
              reject();
            });
          } else {
            _this10.$toasted.error("Enter contact detail is associated with other account");
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/sendotp", { username: _this10.userNameForPasswordReset, isemail: true }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
              if (res.status === 200) {
                _this10.blockUi = false;
                _this10.$toasted.success("OTP sent");
                // this.usernameFromAfficilatorApi = this.userNameForPasswordReset
                _this10.$refs.askCredentialModal.hide();
                _this10.userEnteredValue = "";
                _this10.$refs.otpVerificationForAccountLinkingModal.show();
                resolve();
              }
            }).catch(function (err) {
              console.log("ERROR_IN_SENDING_OTP : ", err);
              _this10.blockUi = false;
              reject();
            });
          }
        }).catch(function (err) {
          console.log("ERROR_IN_VERIFYING_ACCOUNT_DETAILS : ", err);
          reject(err);
        });
      });
    },

    // verifyOtp - used during password linking
    verifyOtp: function verifyOtp(otpValue) {
      var _this11 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/verifyotp", { username: _this11.userNameForPasswordReset, otp: otpValue }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
          // console.log(JSON.stringify({'currentProfileId': this.profileId, 'newProfileId': this.associatedProfileId, 'afficilator': this.afficilator}))
          _this11.$toasted.success("OTP verified");
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/transferUserData", null, {
            headers: {
              currentProfileId: _this11.profileId,
              newProfileId: _this11.associatedProfileId,
              afficilator: _this11.afficilator,
              contact: _this11.contactMobile
            }
          }).then(function (res) {
            _this11.$toasted.success("ACCOUNT LINKED");
            _this11.reset();
            _this11.$refs.otpVerificationForAccountLinkingModal.hide();
            _this11.$refs.loginModal.show();
            resolve();
          }).catch(function (err) {
            console.log("ERROR_IN_TRANSFERING_ACCOUNT_DETAILS : ", err);
            reject();
          });
        }).catch(function (err) {
          console.log("ERROR_IN_VERIFYING_OTP : ", err);
          _this11.$toasted.error("Something went wrong");
          reject(err);
        });
      });
    },

    // addUserContactDetails - adds the user contact details to user profile
    addUserContactDetails: function addUserContactDetails() {
      var _this12 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/addUserContactDetails", {
          profileId: _this12.profileId,
          accountDetails: [{ jvId: _this12.afficilator }]
        }, { headers: { key: "mobile", value: _this12.userEnteredValue } }).then(function (res) {
          resolve(true);
        }).catch(function (err) {
          console.log("ERROR_IN_ADDING_CONTACT_DETAILS : ", err);
          reject(false);
        });
      });
    },

    // contactDetailsOtpVerification - called during otp verification during accountDetails
    contactDetailsOtpVerification: function contactDetailsOtpVerification() {
      var _this13 = this;

      if (this.otpInput.length === 0) {
        this.$toasted.error("OTP field cannot be blanked");
      } else if (this.validateForNumberInput(this.otpInput, true) === false) {
        this.$toasted.error("OTP must contain only numeric characters");
      } else {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          _this13.blockUi = true;
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/verifyotp", { username: _this13.usernameFromAfficilatorApi, otp: _this13.otpInput }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
            if (res.status === 200) {
              _this13.addUserContactDetails().then(function (res) {
                if (res) {
                  _this13.reset();
                  _this13.$refs.askCredentialModal.hide();
                  _this13.$toasted.success("Contact details updated, Please reLogin");
                  _this13.blockUi = false;
                  resolve();
                } else {
                  _this13.$toasted.error("Something went wrong");
                  _this13.blockUi = false;
                  reject();
                }
              });
            }
          }).catch(function (err) {
            console.log("ERROR_IN_OTP_VERIFICATION : ", err);
            _this13.blockUi = false;
            reject();
          });
        });
      }
    },

    // checkContactDetails - checks the user input
    checkContactDetails: function checkContactDetails() {
      if (this.userEnteredValue.length !== 0) {
        this.verifyEmailAndMobile("mobile", this.value);
      } else {
        this.$toasted.error("Please fill details");
      }
    },

    // handleLogin - logins user through liveDemy form
    handleLogin: function handleLogin(evt) {
      var _this14 = this;

      evt.preventDefault();
      if (this.username.length === 0 || this.password.length === 0) {
        // check for valid login input
        if (this.username.length === 0 && this.password.length === 0) {
          this.emptyUsername = true;
          this.emptyPassword = true;
        } else if (this.username.length === 0) {
          this.emptyUsername = true;
        } else {
          this.emptyPassword = true;
        }
      } else {
        // input valid
        // alert('in else')
        this.emptyUsername = false;
        this.emptyPassword = false;
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__main_js__["encrtpyDetailsUsingMd5"])(_this14.password).then(function (res) {
            // generated encryptrd username
            _this14.blockUi = true;
            var encryptedPassword = res;
            _this14.tempUsername = _this14.username;
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/getBasicProfile", null, {
              headers: { userName: _this14.username }
            }).then(function (res) {
              _this14.afficilator = res.data.afficilator;
              _this14.profileId = res.data.profileId;
              _this14.usernameFromAfficilatorApi = res.data.userName;
              if (res.data.linkingPermission && res.data.multipleAccounts) {
                // multiple account non - merged
                _this14.$swal({
                  title: "Hey user, your multiple accounts are merged. Do you want to maintain the common Password ?",
                  icon: "warning",
                  buttons: true,
                  dangerMode: true
                }).then(function (isPermissionGiven) {
                  if (isPermissionGiven) {
                    _this14.isLinkingOperationPerformed = true;
                    _this14.$refs.loginModal.hide();
                    _this14.$refs.forgetPasswordModal.show();
                    _this14.handleOtpRequest();
                  } else {
                    if (res.data.afficilator === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */]) {
                      // user registered via liveDemy
                      _this14.$store.dispatch("userSignIn", {
                        username: res.data.userName,
                        password: encryptedPassword,
                        jvId: res.data.afficilator,
                        linkingPermission: res.data.linkingPermission
                      }).then(function (res) {
                        if (res === "success") {
                          _this14.$refs.loginModal.hide();
                          _this14.isLoginWithInvalidCredentials = false;
                          _this14.$toasted.success("Welcome user");
                          _this14.blockUi = false;
                          _this14.reset();
                          _this14.$store.dispatch("getMostSearchedWordList");
                          resolve();
                        }
                      }, function (error) {
                        if (error === 417) {
                          _this14.blockUi = false;
                          _this14.isLoginWithInvalidCredentials = true;
                          reject(error);
                        }
                      });
                    } else {
                      // user registered through jointVenture
                      //  console.log(res.data.afficilator)
                      // return new Promise((resolve, reject) => {
                      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/verifyJointVentureCredentials", {
                        username: _this14.username,
                        password: encryptedPassword,
                        jvId: res.data.afficilator
                      }).then(function (res) {
                        _this14.$store.dispatch("setUserStoreData", res.data).then(function (storeResponse) {
                          if (storeResponse) {
                            localStorage.setItem("isLoggedIn", true);
                            localStorage.setItem("token", res.headers.token);
                            localStorage.setItem("ssoToken", false);
                            _this14.$toasted.success("Welcome user");
                            _this14.blockUi = false;
                            _this14.$refs.loginModal.hide();
                            _this14.reset();
                            _this14.$store.dispatch("getMostSearchedWordList");
                            resolve();
                          } else {
                            _this14.blockUi = false;
                            _this14.$toasted.error("Something went wrong");
                            reject();
                          }
                        });
                      }).catch(function (err) {
                        console.log("ERROR_IN_VERIFYING_JOINT_VENTURE_USER : ", err);
                        reject(err);
                      });
                      // })
                    }
                  }
                });
              } else if (!res.data.linkingPermission && !res.data.multipleAccounts) {
                // single account
                if (res.data.afficilator === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */]) {
                  // user registered via liveDemy
                  _this14.$store.dispatch("userSignIn", {
                    username: res.data.userName,
                    password: encryptedPassword,
                    jvId: res.data.afficilator,
                    linkingPermission: res.data.linkingPermission
                  }).then(function (res) {
                    if (res === "success") {
                      _this14.$refs.loginModal.hide();
                      _this14.isLoginWithInvalidCredentials = false;
                      _this14.$toasted.success("Welcome user");
                      _this14.blockUi = false;
                      _this14.reset();
                      _this14.$store.dispatch("getMostSearchedWordList");
                      resolve();
                    }
                  }, function (error) {
                    if (error === 417) {
                      _this14.blockUi = false;
                      _this14.isLoginWithInvalidCredentials = true;
                      reject(error);
                    }
                  });
                } else {
                  // user registered through jointVenture
                  __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/verifyJointVentureCredentials", {
                    username: _this14.username,
                    password: encryptedPassword,
                    jvId: res.data.afficilator
                  }).then(function (res) {
                    if (res.data.profileDetails.accountDetails !== null) {
                      _this14.$store.dispatch("setUserStoreData", res.data).then(function (storeResponse) {
                        if (storeResponse) {
                          localStorage.setItem("isLoggedIn", true);
                          localStorage.setItem("token", res.headers.token);
                          localStorage.setItem("ssoToken", false);
                          _this14.$toasted.success("Welcome user");
                          _this14.blockUi = false;
                          _this14.$refs.loginModal.hide();
                          _this14.reset();
                          _this14.$store.dispatch("getMostSearchedWordList");
                          resolve();
                        } else {
                          _this14.blockUi = false;
                          _this14.$toasted.error("Something went wrong");
                          reject();
                        }
                      });
                    } else {
                      _this14.$refs.loginModal.hide();
                      _this14.$refs.askCredentialModal.show();
                      _this14.$toasted.error("Hey user, please enter contact details to proceed");
                      _this14.blockUi = false;
                      resolve();
                    }
                  }).catch(function (err) {
                    console.log("ERROR_IN_VERIFYING_JOINT_VENTURE_USER : ", err);
                    reject(err);
                  });
                }
              } else if (!res.data.linkingPermission && res.data.multipleAccounts) {
                // multiple merged
                _this14.$store.dispatch("userSignIn", {
                  username: res.data.userName,
                  password: encryptedPassword,
                  jvId: res.data.afficilator,
                  linkingPermission: res.data.linkingPermission
                }).then(function (res) {
                  if (res === "success") {
                    _this14.$refs.loginModal.hide();
                    _this14.isLoginWithInvalidCredentials = false;
                    _this14.$toasted.success("Welcome user");
                    _this14.blockUi = false;
                    _this14.reset();
                    _this14.$store.dispatch("getMostSearchedWordList");
                    resolve();
                  }
                }, function (error) {
                  if (error === 417) {
                    console.log("....");
                    _this14.blockUi = false;
                    _this14.isLoginWithInvalidCredentials = true;
                    reject();
                  }
                });
              }
            }).catch(function (err) {
              _this14.blockUi = false;
              console.log("ERROR_IN_FETCHING_USERNAME_FOR_USER : ", err);
              _this14.isLoginWithInvalidCredentials = true;
              reject(err);
            });
          });
        });
      }
    },

    // handleCommonPasswordRequest - used to set the common password
    handleCommonPasswordRequest: function handleCommonPasswordRequest() {
      var _this15 = this;

      if (this.password.length === 0 || this.confirmPassword.length === 0) {
        this.$toasted.error("please enter details");
      } else if (this.password !== this.confirmPassword) {
        this.$toasted.error("password mismatch");
      } else {
        this.validatePasswordInput(this.password).then(function (res) {
          if (res) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__main_js__["encrtpyDetailsUsingMd5"])(_this15.password).then(function (res) {
                var encryptedPassword = res;
                _this15.blockUi = true;
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/changepassword", {
                  username: _this15.usernameFromAfficilatorApi,
                  password: encryptedPassword,
                  confirmpassword: encryptedPassword
                }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (res) {
                  if (res.status === 200) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                      // console.log(this.userNameForPasswordReset)
                      // console.log(this.userName)
                      // console.log('tempUsername-->', this.tempUsername)
                      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/changeJointVenturePassword", {
                        profileId: _this15.profileId,
                        password: "",
                        jvId: _this15.afficilator
                      }).then(function (response) {
                        if (response.status === 200) {
                          _this15.$toasted.success("Password reseted");
                          // this.$refs.passwordChangeModal.hide()
                          _this15.$refs.loginModal.show();
                          _this15.blockUi = false;
                          _this15.reset();
                          _this15.isLinkingOperationPerformed = false;
                          resolve();
                        }
                      }).catch(function (err) {
                        console.log("ERROR_IN_CHANGING_JOINT_VENTURE_PASSWORD :", err);
                        _this15.reset();
                        _this15.blockUi = false;
                        thos.$toasted.error("Error in Reseting Password");
                        reject();
                      });
                    });
                  }
                }).catch(function (err) {
                  _this15.blockUi = false;
                  console.log("ERROR_IN_SENDING_RESETING_PASSWORD : ", err);
                  _this15.reset();
                  reject();
                });
              });
            });
          } else {
            _this15.$toasted.success("Password doesn't match the guildelines");
            // resolve()
          }
        });
      }
    },

    // handlePasswordReset - reseting the password
    handlePasswordReset: function handlePasswordReset(evt) {
      var _this16 = this;

      // Prevent modal from closing
      if (this.confirmPassword.length === 0 && this.password.length === 0) {
        this.$toasted.error("Please fill details");
      } else if (this.confirmPassword != this.password) {
        this.$toasted.error("Password mismatched");
      } else {
        this.validatePasswordInput(this.password).then(function (res) {
          if (res) {
            _this16.blockUi = true;
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__main_js__["encrtpyDetailsUsingMd5"])(_this16.password).then(function (res) {
                // get encrypted password
                var encryptedPassword = res;
                /*
                  if 2 cases :
                    case 1 : single account or merged account
                    case 2 : multiple non merged account
                */
                if (!_this16.isLinkingPermission && !_this16.isMultipleAccount || !_this16.isLinkingPermission && _this16.isMultipleAccount) {
                  // console.log('reset SSO')
                  __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/changepassword", {
                    username: _this16.usernameFromAfficilatorApi,
                    password: encryptedPassword,
                    confirmpassword: encryptedPassword
                  }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (response) {
                    _this16.blockUi = false;
                    _this16.$refs.passwordChangeModal.hide();
                    _this16.$refs.loginModal.show();
                    _this16.reset();
                    _this16.$toasted.success("Password reseted");
                    resolve();
                  }).catch(function (err) {
                    console.log("ERROR_IN_UPDATING_SSO_PASSWORD : ", err);
                    _this16.$toasted.error("Something went wrong");
                    _this16.blockUi = false;
                    reject(err);
                  });
                } else if (_this16.isLinkingPermission && _this16.isMultipleAccount) {
                  if (_this16.afficilator === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */]) {
                    // user registerd through liveDemy
                    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["j" /* SSO_URL */] + "/o/forgotpassword/changepassword", {
                      username: _this16.usernameFromAfficilatorApi,
                      password: encryptedPassword,
                      confirmpassword: encryptedPassword
                    }, { headers: { ClientId: __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["a" /* SSO_CLIENT_ID */] } }).then(function (response) {
                      _this16.blockUi = false;
                      _this16.reset();
                      _this16.$refs.passwordChangeModal.hide();
                      _this16.$refs.loginModal.show();
                      _this16.isLinkingOperationPerformed = false;
                      _this16.$toasted.success("Password reseted");
                      resolve();
                    }).catch(function (err) {
                      // console.log('ERROR_IN_UPDATING_SSO_PASSWORD')
                      _this16.$toasted.error("Something went wrong : ", err);
                      _this16.blockUi = false;
                      reject(err);
                    });
                  } else {
                    // user registered through jvId
                    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/changeJointVenturePassword", {
                      profileId: _this16.profileId,
                      password: encryptedPassword,
                      jvId: _this16.afficilator
                    }).then(function (response) {
                      if (response.status === 200) {
                        _this16.$toasted.success("Password reseted");
                        _this16.$refs.passwordChangeModal.hide();
                        _this16.$refs.loginModal.show();
                        _this16.blockUi = false;
                        _this16.reset();
                        _this16.isLinkingOperationPerformed = false;
                        resolve();
                      }
                    }).catch(function (err) {
                      _this16.blockUi = false;
                      console.log("ERROR_IN_CHANGING_JV_PASSWORD : ", err);
                      reject();
                    });
                  }
                }
              }); // encryptedPassword ends
            }); // promise ends
          } else {
            _this16.$toasted.error("Password doesn't match the guidelines");
          }
        });
      }
    },
    isPresentInSuggestions: function isPresentInSuggestions(elementToSearch) {
      var isPresent = false;
      // console.log(this.suggestions)
      this.suggestions.forEach(function (element) {
        if (element === elementToSearch) {
          isPresent = true;
        }
      });
      return isPresent;
    },
    addTag: function addTag(newTag) {
      if (!this.isPresentInSuggestions(newTag)) {
        this.suggestions.unshift(newTag);
      }
      this.searchText = newTag;
      this.onSearch(newTag);
    },
    updateScroll: function updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    checkNavStatus: function checkNavStatus() {
      if (this.status !== undefined && this.status !== null && this.status) {
        return true;
      } else {
        return false;
      }
    },
    errorQuery: function errorQuery() {
      var _this17 = this;

      if (this.searchText !== undefined && this.searchText !== null && this.searchText.length !== 0) {
        var contentCategory = "";
        if (this.$store.getters.getProfileDetails === undefined || this.$store.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.getProfileDetails).length === 0 && this.$store.getters.getProfileDetails.constructor === Object) {
          contentCategory = "LIVEDEMY";
        } else {
          contentCategory = this.$store.getters.getUserJvID(this.$store.getters.getProfileDetails.accountDetails);
        }
        this.$store.dispatch("getSearchResult", {
          searchText: this.searchText,
          location: { coordinates: [0, 0] },
          userId: this.userId
        }, { headers: { contentCategory: contentCategory } }).then(function (response) {
          _this17.$store.dispatch("fetchSearchCategory").then(function (response) {
            // this.searchText = ''
            __WEBPACK_IMPORTED_MODULE_4__main_js__["EventBus"].$emit("searchEvent", _this17.searchText);
            _this17.loading = false;
            _this17.$router.push({
              name: "searchPageAlt",
              params: {
                search: _this17.searchText
              }
            });
          }, function (error) {
            console.log(_this17.$t("common.errors.error_fetching_category"), error);
          });
        }, function (error) {
          console.log(_this17.$t("common.errors.error_setting_search_data"), error);
        });
      }
    },
    sendQuery: function sendQuery() {
      var _this18 = this;

      // console.log('in sendQuery')
      if (this.searchText !== undefined && this.searchText !== null && this.searchText.length !== 0) {
        this.$store.dispatch("getSearchResult", {
          searchText: this.searchText,
          location: { coordinates: [this.longitude, this.latitude] },
          userId: this.userId
        }).then(function (response) {
          _this18.$store.dispatch("fetchSearchCategory").then(function (response) {
            // this.searchText = ''
            __WEBPACK_IMPORTED_MODULE_4__main_js__["EventBus"].$emit("searchEvent", _this18.searchText);
            _this18.loading = false;
            _this18.$router.push({
              name: "searchPageAlt",
              params: {
                search: _this18.searchText
              }
            });
          }, function (error) {
            console.log(_this18.$t("common.errors.error_fetching_category"), error);
          });
        }, function (error) {
          console.log(_this18.$t("common.errors.error_setting_search_data"), error);
        });
      }
    },
    sendSearchQuery: function sendSearchQuery(position) {
      // console.log('in sendSearchQuery')
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      // console.log(this.latitude, this.longitude)
      this.sendQuery();
    },
    handleRejection: function handleRejection(error) {
      // console.log('handle rejection')
      switch (error.code) {
        case error.PERMISSION_DENIED:
          // console.log('User denied the request for Geolocation.')
          this.errorQuery();
          break;
        case error.POSITION_UNAVAILABLE:
          // console.log('Location information is unavailable.')
          this.errorQuery();
          break;
        case error.TIMEOUT:
          // console.log('The request to get user location timed out.')
          this.errorQuery();
          break;
        case error.UNKNOWN_ERROR:
          // console.log('An unknown error occurred.')
          this.errorQuery();
          break;
      }
    },
    onSearch: function onSearch(val) {
      this.loading = true;
      // storing search text
      this.$store.dispatch("changeSearchType", "all");
      this.searchText = val;
      // storing profileId
      if (this.isLoggedIn) {
        var profileDetails = this.$store.getters.getProfileDetails;
        if (profileDetails !== null && profileDetails.profileId != null) {
          this.userId = profileDetails.profileId;
        }
      }
      // asking permission to get Location
      if (this.caseFalse) {
        // console.log('supporting')
        navigator.geolocation.getCurrentPosition(this.sendSearchQuery, this.handleRejection, this.defaultOptions);
      } else {
        // console.log('Your browser doesn\'t support')
        this.errorQuery();
      }
    },
    getMostSearchedWordList: function getMostSearchedWordList() {
      this.$store.dispatch("getMostSearchedWordList");
    },
    signUp: function signUp() {
      window.MKCLAPI.signUp();
    },
    checkOffer: function checkOffer() {
      if (this.$store.getters.getOffers !== undefined && this.$store.getters.getOffers !== null) {
        if (this.$store.getters.getOffers.length !== 0) {
          return true;
        }
      } else {
        return false;
      }
    },
    login: function login() {
      window.MKCLAPI.login();
    },
    exitFromMahademy: function exitFromMahademy() {
      var here = this;
      if (localStorage.getItem("app_env") === __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["f" /* MAHADEMY_APP_ENV */]) {
        localStorage.removeItem("app_env");
        localStorage.removeItem("token");
        here.$store.dispatch("clearUserData");
        window.location = __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["l" /* MAHADEMY_EXIT_URL */];
      }
    },
    logout: function logout() {
      this.reset();
      if (JSON.parse(localStorage.getItem("ssoToken"))) {
        // if token is generated from SSO server call SSO API
        var header = this;
        window.MKCLAPI.logout().then(function () {
          header.$store.dispatch("clearUserData");
          header.$router.push({ path: "/advertisement" });
        }).catch(function (err) {
          console.log(err);
        });
      } else if (localStorage.getItem("mobileDevice")) {
        sendMessageToAndroid("logout");
        var header = this;
        window.MKCLAPI.logout().then(function () {
          header.$store.dispatch("clearUserData");
          header.$router.push({ path: "/advertisement" });
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        // if token is generated by liveDemy server then call liveDemy api
        // console.log('here...')
        this.$store.dispatch("clearUserData");
        // this.$store.dispatch('logoutThirdPartyUser').then(res => {
        //   this.$store.dispatch('clearUserData')
        //   this.$router.push({path: '/advertisement'})
        // }, err => {
        //   console.log('ERROR_IN_REMOVING_SESSION_OF_THIRD_PARTY_USER : ', err)
        // })
      }
    },
    goToSearchPage: function goToSearchPage(id) {
      var _this19 = this;

      // console.log(id)
      if (id === "allBtn") {
        this.$store.dispatch("changeSearchType", "all").then(function (response) {}, function (error) {
          console.log(_this19.$t("common.errors.error_changing_search_type"), error);
        });
      } else if (id === "courseBtn") {
        this.$store.dispatch("changeSearchType", "CO").then(function (response) {}, function (error) {
          console.log(_this19.$t("common.errors.error_changing_search_type"), error);
        });
      } else {
        this.$store.dispatch("changeSearchType", "LO").then(function (response) {}, function (error) {
          console.log(_this19.$t("common.errors.error_changing_search_type"), error);
        });
      }
      // window.scrollTo(0, 0)
      this.searchText = this.$store.getters.getSearchText;
      this.$store.dispatch("removePreviousSearchResult").then(function (response) {
        if (_this19.searchText !== undefined && _this19.searchText !== null && _this19.searchText.length !== 0) {
          // storing profileId
          if (_this19.isLoggedIn) {
            var profileDetails = _this19.$store.getters.getProfileDetails;
            if (profileDetails !== null && profileDetails.profileId != null) {
              _this19.userId = profileDetails.profileId;
            }
          }
          var caseFalse = false;
          // asking permission to get Location
          if (caseFalse) {
            // if (navigator.geolocation) {
            // console.log('supporting')
            navigator.geolocation.getCurrentPosition(_this19.sendSearchQuery, _this19.handleRejection, _this19.defaultOptions);
          } else {
            // console.log('Your browser doesn\'t support')
            _this19.errorQuery();
          }
        } else {
          _this19.$router.push({ path: "/searchPageAlt" });
        }
      }, function (error) {
        console.log("error in clearing search store data from SEARCHCARDALT", error);
      });
      // this.$router.push({ path: '/searchPageAlt' })
    },
    getSuggestions: function getSuggestions(searchText) {
      var banner = this;
      if (searchText.length === 0) {
        this.suggestions = [];
        // this.searchText = ''
        return;
      } else if (searchText.length >= 2) {
        var contentCategory = "";
        if (this.$store.getters.getProfileDetails === undefined || this.$store.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.getProfileDetails).length === 0 && this.$store.getters.getProfileDetails.constructor === Object) {
          contentCategory = __WEBPACK_IMPORTED_MODULE_3__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
        } else {
          contentCategory = this.$store.getters.getUserJvID(this.$store.getters.getProfileDetails.accountDetails);
        }
        this.previousSuggestionsForSearchText = searchText;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("o/getSuggestionBasedOnKeyword", { searchText: searchText }, { headers: { contentCategory: contentCategory } }).then(function (res) {
          if (res.status === 200) {
            // alert(res.data.length)
            banner.suggestions = res.data;
            // banner.suggestions.unshift(banner.searchText)
          }
        });
      }
    },
    getSignUpStatus: function getSignUpStatus() {
      var _this20 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("o/getsignupstatus", null).then(function (res) {
        _this20.signUpStatus = res.data;
      }).catch(function (e) {
        console.log("err in getting signUp status :", e);
      });
    },
    getFeatureStatusInfoList: function getFeatureStatusInfoList() {
      var _this21 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("o/features/getfeaturesinfolist").then(function (res) {
        _this21.featureList = res.data;
      }).catch(function (e) {
        console.log("error in getting feature list : ", e);
      });
    }
  },
  mounted: function mounted() {
    // alert(123)
    // this.getSignUpStatus()
    this.getFeatureStatusInfoList();
    this.$store.dispatch("fetchAllOffersFromDb").then(function (response) {}, function (error) {
      console.error("error in fertching offers", error);
    });
    window.addEventListener("scroll", this.updateScroll);
  },

  computed: {
    basicProfile: function basicProfile() {
      return this.$store.getters.getProfileDetails;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "Eoig":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EpJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchPageAlt_vue__ = __webpack_require__("Vg5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd00337_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_searchPageAlt_vue__ = __webpack_require__("vzA0");
function injectStyle (ssrContext) {
  __webpack_require__("F9i6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchPageAlt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd00337_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_searchPageAlt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F9i6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fu3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('embed', {
    attrs: {
      "id": "swfHolder",
      "src": _vm.mediaPath + '?module=' + _vm.$store.state.contentViewer.currentPlayingcontent.passcode,
      "width": "100%",
      "height": "100%",
      "flashvars": "ver=alcera_1",
      "type": "application/x-shockwave-flash"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GGTQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__("424j");







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
var state = {
  SelectedcontentId: '',
  CourseDetails: {},
  CurrentCourse: {}
};
var getters = {
  getSelectedcontentId: function getSelectedcontentId(state) {
    return state.SelectedcontentId;
  },
  getCourseDetails: function getCourseDetails(state) {
    return state.CourseDetails;
  },
  getCurrentCourse: function getCurrentCourse(state) {
    return state.CurrentCourse;
  }
};
var mutations = {
  setSelectedcontentId: function setSelectedcontentId(state, data) {
    state.SelectedcontentId = data;
  },
  setCourseDetails: function setCourseDetails(state, data) {
    state.CourseDetails = data;
  },
  setCurrentCourse: function setCurrentCourse(state, data) {
    state.CurrentCourse = data;
  }
};
var actions = {
  setCurrentCourse: function setCurrentCourse(context, data) {
    context.commit('setCurrentCourse', data);
  },
  getCourseDetails: function getCourseDetails(context, Id) {
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('o/getlodetails', {
      'contentId': Id
    }).then(function (response) {
      context.commit('setCourseDetails', response.data);
      window.location.href = '#/coursePage';
    }).catch(function (e) {
      console.log(e);
    });
    window.location.href = '#/coursePage';
    // this.$router.push({path: '/searchPageAlt'})
  },
  checkExpiryDateForCO: function checkExpiryDateForCO(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/r/viewItemValidityStatus', {
        'contentId': data.contentId,
        'profileId': context.getters.getProfileDetails.profileId
      }).then(function (response) {
        // alert(response.data)
        if (response.data === __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__["n" /* NOT_EXPIRED_STATUS */]) {
          context.dispatch('goToERACoursePage', data);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].toasted.error('Course Has Expired');
        }
        resolve();
      }).catch(function (err) {
        // this.$toasted.error(err)
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].toasted.error('Something went wrong !');
        // Vue.toasted.error(err)
        reject(err);
      });
    });
  },
  goToERACoursePage: function goToERACoursePage(context, data) {
    // alert(context.getters.getProfileDetails)
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__["o" /* ERA_GATEWAY_URL */], {
        'learnerID': context.getters.getProfileDetails.profileId,
        // 'CourseID': course.contentId
        'learnerType': __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__["p" /* ERA_LEARNER_TYPE */]
      }).then(function (response) {
        var courseUrl = response.data.baseurl;
        // alert(courseUrl)
        // alert(JSON.stringify(response.data))
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/r/coreemalogin/eraauthentication', { 'courseID': data.contentId, 'serverURL': response.data.serverurl }).then(function (response) {
          delete response.data.eraCourseURL;
          window.sessionStorage.setItem('eraData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          // console.log(JSON.stringify(response.data))
          // location.href = window.location.origin + constants.ERA_COURSE_URL
          location.href = courseUrl;
        }).catch(function (error) {
          alert('era' + error);
        });
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "GLDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wallet"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('walletCards')], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-gray"
  }, [(_vm.showWishList) ? _c('courseWishlist') : _vm._e()], 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HF4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid course-card-css"
  }, _vm._l((_vm.$store.getters.getCategoryStoreData), function(cat, i) {
    return _c('div', {
      key: i
    }, _vm._l((_vm.$store.getters.getAllCOs), function(item, j) {
      return _c('div', {
        key: j
      }, [(_vm.isPresent(cat, item.category)) ? _c('div', [_c('div', {
        staticClass: "pb-3 row justify-content-end"
      }, [_c('h6', {
        staticClass: "col-md-12 text-left main-title"
      }, [_vm._v(_vm._s(_vm.$t('common.labels.Courses_in')) + " " + _vm._s(cat))])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('swiper', [_c('swiper-slide', [_c('div', [_c('div', {
        staticClass: "card-course"
      }, [_c('div', {
        staticClass: "img-fluid",
        staticStyle: {
          "background-image": "url('../../static/assets/images/ref3.jpg')"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card-content"
      }, [_c('p', {
        staticClass: "course-name"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
        staticClass: "course-cost"
      }, [_vm._v(_vm._s(_vm.$t('common.labels.POINTS')) + " " + _vm._s(item.price))]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "course-text"
      }, [_vm._v(_vm._s(_vm.$t('course.numberOfStudentsEnrolled')) + "\n                        "), _c('strong', {
        staticClass: "pl-2"
      }, [_vm._v(" " + _vm._s(item.enrolledCount) + " +")])])]), _vm._v(" "), _c('div', {
        staticClass: "rating-ptag"
      }, [_vm._v(" " + _vm._s(_vm.$t('common.labels.Ratings')) + "\n                      "), (parseInt(item.rating) == 0) ? _c('span', [_c('star-rating', {
        attrs: {
          "rating": parseInt(item.rating),
          "read-only": true,
          "increment": 0.5,
          "max-rating": 5,
          "inactive-color": "#96999a",
          "active-color": "#ffc000",
          "star-size": 15
        }
      })], 1) : _c('span', [_c('star-rating', {
        attrs: {
          "rating": parseInt(item.rating.toFixed(1)),
          "read-only": true,
          "increment": 0.5,
          "max-rating": 5,
          "inactive-color": "#96999a",
          "active-color": "#ffc000",
          "star-size": 15
        }
      })], 1)]), _vm._v(" "), _c('div', {
        staticClass: "pt-3"
      }, [(_vm.presentInWishListStore(item.contentId)) ? _c('div', [_c('div', {
        staticClass: "heart",
        class: {
          'is-active': true
        },
        attrs: {
          "title": "Add to Wishlist"
        },
        on: {
          "click": function($event) {
            _vm.removeFromWishList(item.contentId)
          }
        }
      })]) : _c('div', [_c('div', {
        staticClass: "heart",
        class: {
          'is-active': false
        },
        attrs: {
          "title": "Add to Wishlist"
        },
        on: {
          "click": function($event) {
            _vm.addToWishList(item.contentId)
          }
        }
      })]), _vm._v(" "), (_vm.inPurchase(item.contentId)) ? _c('div', [_c('button', {
        staticClass: "btn mb-2 btn-blue-outline"
      }, [_vm._v(_vm._s(_vm.$t('course.purchased')))])]) : (_vm.cartAdd(item.contentId)) ? _c('div', [_c('button', {
        staticClass: "btn btn-blue mb-2"
      }, [_vm._v(_vm._s(_vm.$t('course.added')))])]) : _c('div', [_c('button', {
        staticClass: "btn btn-blue-outline mb-2",
        on: {
          "click": function($event) {
            _vm.addToCart(item.contentId)
          }
        }
      }, [_vm._v("ADD TO CART")])])])])])])])], 1), _vm._v(" "), _c('div', {
        attrs: {
          "options": _vm.swiperOptionCourse
        }
      }, [_c('div', {
        staticClass: "swiper-button-prev swiper-course-prev",
        slot: "button-prev"
      }, [_c('i', {
        staticClass: "mdi mdi-chevron-left"
      })]), _vm._v(" "), _c('div', {
        staticClass: "swiper-button-next swiper-course-next",
        slot: "button-next"
      }, [_c('i', {
        staticClass: "mdi mdi-chevron-right"
      })])])], 1)]) : _vm._e()])
    }))
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HOUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareOnMedia_vue__ = __webpack_require__("UkLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5280fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shareOnMedia_vue__ = __webpack_require__("a4mb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareOnMedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5280fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shareOnMedia_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HReX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartContent_vue__ = __webpack_require__("T5Nu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wishList_courseWishList__ = __webpack_require__("Bhfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_newVideoCards__ = __webpack_require__("q9mY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_home_trendingCourses__ = __webpack_require__("8bW+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cart',
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a,
    footerArea: __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__["a" /* default */],
    cartContent: __WEBPACK_IMPORTED_MODULE_4__cartContent_vue__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_6__home_courseCards__["a" /* default */],
    courseWishlist: __WEBPACK_IMPORTED_MODULE_5__components_wishList_courseWishList__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_7__components_home_libraryCards__["a" /* default */],
    newVideoCards: __WEBPACK_IMPORTED_MODULE_8__components_home_newVideoCards__["a" /* default */],
    trendingCourses: __WEBPACK_IMPORTED_MODULE_9__components_home_trendingCourses__["a" /* default */]
  },
  data: function data() {
    return {
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    };
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["e" /* INSTANCE_NAME */] === 'MAHADEMY') {
      this.$router.push('/home');
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__main_js__["EventBus"].$emit('showNav', false);
  },

  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.globalState = $state;
      setTimeout(function () {
        _this.showTrendingCard = true;
        // this.showLibraryCard = true
        $state.loaded();
      }, 2000);
    },
    handleScroll: function handleScroll() {
      var _this2 = this;

      if (this.showTrendingCard && !this.showLibraryCard) {
        setTimeout(function () {
          _this2.showLibraryCard = true;
          if (_this2.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this2.globalState.complete();
          }
        }, 2000);
      } else if (this.showTrendingCard && this.showLibraryCard) {
        setTimeout(function () {
          _this2.showNewVideoCard = true;
          if (_this2.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this2.globalState.complete();
          }
        }, 2000);
      }
    }
  }
});

/***/ }),

/***/ "I5rd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I7CV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bannerSearch_vue__ = __webpack_require__("x4Sc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f79bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_bannerSearch_vue__ = __webpack_require__("4Bwl");
function injectStyle (ssrContext) {
  __webpack_require__("r4Bi")
  __webpack_require__("zM7h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bannerSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f79bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_bannerSearch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IPdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frames-css"
  }, [_c('div', {
    staticClass: "bg-gradient-gray"
  }, [_c('framesVideo')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_playList__ = __webpack_require__("e6+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_offer__ = __webpack_require__("rkxy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_wishList__ = __webpack_require__("U5lF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_cards__ = __webpack_require__("LrGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_filter__ = __webpack_require__("z4IK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_search__ = __webpack_require__("dI8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_login__ = __webpack_require__("jeSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_profile__ = __webpack_require__("PMOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_cart__ = __webpack_require__("u3Ct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_collection__ = __webpack_require__("f5rE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_courseDetails__ = __webpack_require__("GGTQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_contentViewer__ = __webpack_require__("UKJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex_persistedstate__ = __webpack_require__("424j");


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  modules: {
    profile: __WEBPACK_IMPORTED_MODULE_11__modules_profile__["a" /* default */],
    playList: __WEBPACK_IMPORTED_MODULE_4__modules_playList__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_10__modules_login__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_12__modules_cart__["a" /* default */],
    cards: __WEBPACK_IMPORTED_MODULE_7__modules_cards__["a" /* default */],
    filter: __WEBPACK_IMPORTED_MODULE_8__modules_filter__["a" /* default */],
    wishList: __WEBPACK_IMPORTED_MODULE_6__modules_wishList__["a" /* default */],
    offer: __WEBPACK_IMPORTED_MODULE_5__modules_offer__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_9__modules_search__["a" /* default */],
    contentViewer: __WEBPACK_IMPORTED_MODULE_15__modules_contentViewer__["a" /* default */],
    courseDetails: __WEBPACK_IMPORTED_MODULE_14__modules_courseDetails__["a" /* default */],
    collection: __WEBPACK_IMPORTED_MODULE_13__modules_collection__["a" /* default */]
  },
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex_persistedstate__["a" /* default */])({ storage: window.sessionStorage })]
}));

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "If75":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IfgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-content container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [(!_vm.isEdit) ? _c('div', {
    staticClass: "user-details",
    attrs: {
      "id": "displayprofile"
    }
  }, [_c('div', {
    staticClass: "pic"
  }, [(_vm.basicProfile.profileImg != '') ? _c('div', {
    staticClass: "img-edit",
    attrs: {
      "id": "image"
    }
  }, [_c('b-tooltip', {
    attrs: {
      "target": "image",
      "title": "Edit profile"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.basicProfile.profileImg,
      "width": "200",
      "height": "200"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-edit",
    on: {
      "click": _vm.editBasicProfile
    }
  }, [_c('i', {
    staticClass: "mdi mdi-pencil"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.basicProfile.profileImg == '') ? _c('div', {
    staticClass: "img-edit",
    attrs: {
      "id": "image"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("7lhL"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('button', {
    staticClass: "btn btn-edit",
    on: {
      "click": _vm.editBasicProfile
    }
  }, [_c('i', {
    staticClass: "mdi mdi-pencil"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.basicProfile.profileImg != '') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger btn-block text-center",
    on: {
      "click": function($event) {
        _vm.DeleteFile(_vm.basicProfile.profileImg)
      }
    }
  }, [_vm._v("Remove Profile Picture")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', [_vm._v(_vm._s(_vm.basicProfile.fullName) + " ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.contact')) + " :")]), _vm._v(" "), _vm._l((_vm.basicProfile.accountDetails), function(accountInfo, index) {
    return _c('div', {
      key: index
    }, [_c('div', [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.AccountType')) + " : ")]), _vm._v(_vm._s(accountInfo.jvId))]), _c('br'), _vm._v(" "), (accountInfo.email != undefined && accountInfo.email != null && accountInfo.email.length > 0) ? _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.$t('profileDetails.placeholder.email')) + " : ")]), _vm._v(_vm._s(accountInfo.email))]) : _vm._e(), (accountInfo.email != undefined && accountInfo.email.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), (accountInfo.mobile != undefined && accountInfo.mobile != null && accountInfo.mobile.length > 0) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.mobile')) + "  : ")]), _vm._v(_vm._s(accountInfo.mobile))]) : _vm._e(), (accountInfo.mobile != undefined && accountInfo.mobile.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), (accountInfo.portedUserName != undefined && accountInfo.portedUserName != null && accountInfo.portedUserName.length > 0) ? _c('span', [_c('b', [_vm._v("Username : ")]), _vm._v(_vm._s(accountInfo.portedUserName))]) : _vm._e(), (accountInfo.portedUserName.length != undefined && accountInfo.portedUserName.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), (index + 1 < _vm.basicProfile.accountDetails.length) ? _c('br') : _vm._e()]), _vm._v(" "), (index + 1 === _vm.basicProfile.accountDetails.length) ? _c('hr') : _vm._e()])
  })], 2), _vm._v(" "), (_vm.$store.getters.getProfileDetails.mobile != undefined && _vm.$store.getters.getProfileDetails.mobile != null) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("Contact")]), _vm._v(" "), (_vm.$store.getters.getProfileDetails.mobile.length !== 0) ? _c('span', [_vm._v(_vm._s(_vm.$store.getters.getProfileDetails.mobile))]) : _c('span', [_vm._v("Add contact details")])]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.skills != undefined && _vm.skills != null && _vm.skills.length > 0) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("skills")]), _vm._v(" "), _vm._l((_vm.skills), function(skill, i) {
    return _c('div', {
      key: i
    }, [_c('span', [_vm._v(_vm._s(skill))])])
  }), _vm._v(" "), _c('hr')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.aboutMe')))]), _vm._v(" "), (_vm.basicProfile.aboutMe == '') ? _c('span', [_vm._v(_vm._s(_vm.$t('profileDetails.labels.Hi_I_am')) + " " + _vm._s(_vm.basicProfile.fullName))]) : _c('span', [_vm._v(_vm._s(_vm.basicProfile.aboutMe))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blue btn-block",
    on: {
      "click": _vm.editBasicProfile
    }
  }, [_vm._v("\r\n               " + _vm._s(_vm.$t('profileDetails.labels.editButtonText')))])]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-details",
    attrs: {
      "id": "editprofile"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "col-md-12 upload-pic"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("Your Profile Picture")]), _vm._v(" "), _c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "guides": true,
      "view-mode": 2,
      "drag-mode": "crop",
      "auto-crop-area": 1,
      "min-container-width": 150,
      "min-container-height": 80,
      "background": true,
      "rotatable": true,
      "src": _vm.getImageSrc(),
      "img-style": {
        'width': '300px',
        'height': '200px'
      }
    }
  }), _vm._v(" "), (_vm.fileExceedLimit) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('b', [_vm._v(" Image size should be less than " + _vm._s(_vm.maxFilesize * 1000) + " kb")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.imgSrc != '') ? _c('button', {
    staticClass: "btn btn-blue ",
    attrs: {
      "disabled": _vm.fileExceedLimit
    },
    on: {
      "click": _vm.cropImage
    }
  }, [_vm._v("Crop")]) : _vm._e(), _vm._v(" "), (_vm.imgSrc != '') ? _c('button', {
    staticClass: "btn btn-blue ",
    attrs: {
      "disabled": _vm.fileExceedLimit
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("Upload")]) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_c('span', [_vm._v("Select new profile image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "font-size": "1.2em",
      "padding": "10px 0"
    },
    attrs: {
      "type": "file",
      "name": "image",
      "id": "imgUpload",
      "accept": "image/*"
    },
    on: {
      "change": _vm.setImage
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.yourName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_name),
      expression: "in_name"
    }],
    ref: "name",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": _vm.$t('profileDetails.placeholder.YourFullName'),
      "value": "Neha Sharma"
    },
    domProps: {
      "value": (_vm.in_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.in_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.$store.getters.getProfileDetails.mobile != undefined && _vm.$store.getters.getProfileDetails.mobile != null && _vm.$store.getters.getProfileDetails.mobile.length == 0) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.contact')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "placeholder": _vm.$store.getters.getProfileDetails.mobile.length === 0 ? 'Enter contact details' : ''
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.aboutMe')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_aboutMe),
      expression: "in_aboutMe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "3",
      "placeholder": _vm.$t('profileDetails.placeholder.WriteAboutYourself')
    },
    domProps: {
      "value": (_vm.in_aboutMe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.in_aboutMe = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blue btn-block",
    on: {
      "click": _vm.saveBasicProfile
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.saveButtonText')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "card-tabs"
  }, [_c('div', {
    staticClass: "tabs-css"
  }, [_c('b-tabs', [_c('hr'), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('profileDetails.labels.PurchasedCourses')
    }
  }, [_vm._l((_vm.enrolledCourses), function(course, i) {
    return _c('div', {
      key: i,
      staticClass: "card-design card-design-profile"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [(_vm.checkValue(course.thumbnail)) ? _c('div', [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": _vm.makePath(course.thumbnail),
        "alt": ""
      }
    })]) : _c('div', [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": __webpack_require__("9oHV"),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 align-self-center"
    }, [_c('h5', {
      staticClass: "card-design__data-heading",
      on: {
        "click": function($event) {
          _vm.learnCourse(course)
        }
      }
    }, [_vm._v(_vm._s(course.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("\r\n                                      " + _vm._s(_vm.$t('profileDetails.labels.Course_starts_on')) + " "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(course.purchasedDate, "Do MMM, YYYY ")))]), _vm._v("\r\n                                      " + _vm._s(_vm.$t('profileDetails.labels.and_expires_on'))), _c('span', [_vm._v(_vm._s(_vm._f("moment")(course.expiryDate, "Do MMM, YYYY ")))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-design__details"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__metadata"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profileDetails.labels.You\'ve_solved')) + " "), _c('strong', [_vm._v(_vm._s(course.allocationDetails == undefined ? 0 : course.allocationDetails.solvedChallengeCount))]), _vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.challenges')) + " ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.and_completed')) + " "), _c('strong', [_vm._v(" " + _vm._s(course.allocationDetails == undefined ? 0 : course.allocationDetails.completedAggregationCount) + " ")]), _vm._v(_vm._s(_vm.$t('profileDetails.labels.lectures')) + " ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.out_of')) + " "), _c('strong', [_vm._v(" " + _vm._s(course.allocationDetails == undefined ? 0 : course.allocationDetails.courseMetadata.totalAggregations) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("Course costs " + _vm._s(course.price) + " " + _vm._s(course.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row card-design__data-ratings"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "col"
    }, [_c('span', {
      staticClass: "ratingText"
    }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.My_Rating')) + " ")]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "rating": course.rating,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      },
      on: {
        "rating-selected": _vm.setRating
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('share-on-media', {
      attrs: {
        "item": course,
        "labelOnTop": false
      }
    })], 1)])])])])])
  }), _vm._v(" "), (_vm.enrolledCourses.length == 0) ? _c('div', [_c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('course.noCourses')) + "\r\n                               "), _c('router-link', {
    staticClass: "linkcss",
    attrs: {
      "to": "home"
    }
  }, [_vm._v("courses!")])], 1)])]) : _vm._e()], 2), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('profileDetails.labels.PurchasedVideos')
    }
  }, [_vm._l((_vm.$store.getters.getUserSingleConceptsCollection), function(lo, j) {
    return _c('div', {
      key: j,
      staticClass: "card-design card-design-profile"
    }, [_c('div', {
      staticClass: "row"
    }, [(_vm.checkValue(lo.thumbnail)) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": _vm.makePath(lo.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": __webpack_require__("K5UD"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 align-self-center"
    }, [_c('h5', {
      staticClass: "card-design__data-heading no-line",
      on: {
        "click": function($event) {
          _vm.learnLO(lo)
        }
      }
    }, [_vm._v(_vm._s(lo.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__details"
    }, [_c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("\r\n                                          " + _vm._s(_vm.$t('profileDetails.labels.item_purchased_on')) + "\r\n                                            "), _c('span', [_vm._v(" " + _vm._s(_vm._f("moment")(lo.purchasedDate, "Do MMM, YYYY ")) + " ")]), _vm._v(" "), _vm._v("\r\n                                            " + _vm._s(_vm.$t('profileDetails.labels.item_expires_on')) + "\r\n                                            "), _c('span', [_vm._v(" " + _vm._s(_vm._f("moment")(lo.expiryDate, "Do MMM, YYYY ")) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("Single concept costs " + _vm._s(lo.price) + " " + _vm._s(lo.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (lo.courseType === 'LO') ? _c('div', {
      on: {
        "click": function($event) {
          _vm.showRating(lo.contentId)
        }
      }
    }, [_c('br'), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('span', {
      staticClass: "ratingText"
    }, [_vm._v(" Your Rating ")]) : _vm._e(), _vm._v(" "), _c('star-rating', {
      attrs: {
        "rating": lo.rating,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      },
      on: {
        "rating-selected": _vm.setRating
      }
    })], 1) : _vm._e()])])])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-blue",
    staticStyle: {
      "text-color": "#eee"
    },
    attrs: {
      "to": "playlist"
    }
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.SeeMore')))]), _vm._v(" "), (_vm.enrolledLOs.length == 0) ? _c('div', [_c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('profileDetails.labels.noLO')) + "\r\n                               "), _c('router-link', {
    staticClass: "linkcss",
    attrs: {
      "to": "home"
    }
  }, [_vm._v(" concepts! ")])], 1)])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('profileDetails.labels.Playlist')
    }
  }, [_vm._l((_vm.playLists), function(playlist) {
    return (!playlist.isWishList) ? _c('div', {
      key: playlist.plId,
      staticClass: "card-design card-design-profile"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": __webpack_require__("K5UD"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 align-self-center"
    }, [_c('h5', {
      staticClass: "card-design__data-heading"
    }, [_vm._v(_vm._s(playlist.plName))]), _vm._v(" "), _c('div', {
      staticClass: "card-design__details"
    }, [((playlist.items.length <= 1)) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('No. of Concept')))]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(playlist.items.length))])]) : _c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('No. of Concepts')))]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(playlist.items.length))])])]), _vm._v(" "), (playlist.items.length == 0) ? _c('div', {
      staticClass: "action-btn"
    }, [_c('button', {
      staticClass: "btn btn-blue",
      on: {
        "click": _vm.goToPlaylist
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.watchButtonText')))])]) : _c('div', {
      staticClass: "action-btn"
    }, [_c('button', {
      staticClass: "btn btn-blue",
      on: {
        "click": function($event) {
          _vm.goToContentViewer(playlist)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.watchButtonText')))])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.playLists.length == 0) ? _c('div', [_c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v("\r\n                                 " + _vm._s(_vm.$t('playlist.noPlaylists')) + "\r\n                                 "), _c('router-link', {
    staticClass: "linkcss",
    attrs: {
      "to": "playlist"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.now')) + "!")])], 1)])]) : _vm._e()], 2) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === true),
      expression: "loading===true"
    }],
    staticClass: "loader-wraper"
  }, [_c('div', {
    staticClass: "loader-box"
  }, [_vm._m(0), _vm._v(" "), _c('h6', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.PleaseWait')))])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-roller"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ImpT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IvKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobileHome',
  data: function data() {
    return {
      token: ''
    };
  },
  created: function created() {
    if (this.$route.params.token !== 'none') {
      this.token = 'Bearer ' + this.$route.params.token;
      localStorage.setItem('token', this.token);
    }
    localStorage.setItem('mobileDevice', true);
    if (localStorage.getItem('token') !== null) {
      this.handleLogin();
    } else {
      this.$router.replace({ path: '/home' });
    }
  },

  methods: {
    handleLogin: function handleLogin() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/o/loginForSocialUser', null, { headers: { 'Authorization': localStorage.getItem('token') } }).then(function (res) {
        _this.$store.dispatch('setUserStoreData', res.data).then(function (res) {
          _this.$router.replace({ path: '/home' });
        });
      });
    }
  }
});

/***/ }),

/***/ "J+V2":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!function(n){"use strict";function t(n,t){var r=(65535&n)+(65535&t);return(n>>16)+(t>>16)+(r>>16)<<16|65535&r}function r(n,t){return n<<t|n>>>32-t}function e(n,e,o,u,c,f){return t(r(t(t(e,n),t(u,f)),c),o)}function o(n,t,r,o,u,c,f){return e(t&r|~t&o,n,t,u,c,f)}function u(n,t,r,o,u,c,f){return e(t&o|r&~o,n,t,u,c,f)}function c(n,t,r,o,u,c,f){return e(t^r^o,n,t,u,c,f)}function f(n,t,r,o,u,c,f){return e(r^(t|~o),n,t,u,c,f)}function i(n,r){n[r>>5]|=128<<r%32,n[14+(r+64>>>9<<4)]=r;var e,i,a,d,h,l=1732584193,g=-271733879,v=-1732584194,m=271733878;for(e=0;e<n.length;e+=16)i=l,a=g,d=v,h=m,g=f(g=f(g=f(g=f(g=c(g=c(g=c(g=c(g=u(g=u(g=u(g=u(g=o(g=o(g=o(g=o(g,v=o(v,m=o(m,l=o(l,g,v,m,n[e],7,-680876936),g,v,n[e+1],12,-389564586),l,g,n[e+2],17,606105819),m,l,n[e+3],22,-1044525330),v=o(v,m=o(m,l=o(l,g,v,m,n[e+4],7,-176418897),g,v,n[e+5],12,1200080426),l,g,n[e+6],17,-1473231341),m,l,n[e+7],22,-45705983),v=o(v,m=o(m,l=o(l,g,v,m,n[e+8],7,1770035416),g,v,n[e+9],12,-1958414417),l,g,n[e+10],17,-42063),m,l,n[e+11],22,-1990404162),v=o(v,m=o(m,l=o(l,g,v,m,n[e+12],7,1804603682),g,v,n[e+13],12,-40341101),l,g,n[e+14],17,-1502002290),m,l,n[e+15],22,1236535329),v=u(v,m=u(m,l=u(l,g,v,m,n[e+1],5,-165796510),g,v,n[e+6],9,-1069501632),l,g,n[e+11],14,643717713),m,l,n[e],20,-373897302),v=u(v,m=u(m,l=u(l,g,v,m,n[e+5],5,-701558691),g,v,n[e+10],9,38016083),l,g,n[e+15],14,-660478335),m,l,n[e+4],20,-405537848),v=u(v,m=u(m,l=u(l,g,v,m,n[e+9],5,568446438),g,v,n[e+14],9,-1019803690),l,g,n[e+3],14,-187363961),m,l,n[e+8],20,1163531501),v=u(v,m=u(m,l=u(l,g,v,m,n[e+13],5,-1444681467),g,v,n[e+2],9,-51403784),l,g,n[e+7],14,1735328473),m,l,n[e+12],20,-1926607734),v=c(v,m=c(m,l=c(l,g,v,m,n[e+5],4,-378558),g,v,n[e+8],11,-2022574463),l,g,n[e+11],16,1839030562),m,l,n[e+14],23,-35309556),v=c(v,m=c(m,l=c(l,g,v,m,n[e+1],4,-1530992060),g,v,n[e+4],11,1272893353),l,g,n[e+7],16,-155497632),m,l,n[e+10],23,-1094730640),v=c(v,m=c(m,l=c(l,g,v,m,n[e+13],4,681279174),g,v,n[e],11,-358537222),l,g,n[e+3],16,-722521979),m,l,n[e+6],23,76029189),v=c(v,m=c(m,l=c(l,g,v,m,n[e+9],4,-640364487),g,v,n[e+12],11,-421815835),l,g,n[e+15],16,530742520),m,l,n[e+2],23,-995338651),v=f(v,m=f(m,l=f(l,g,v,m,n[e],6,-198630844),g,v,n[e+7],10,1126891415),l,g,n[e+14],15,-1416354905),m,l,n[e+5],21,-57434055),v=f(v,m=f(m,l=f(l,g,v,m,n[e+12],6,1700485571),g,v,n[e+3],10,-1894986606),l,g,n[e+10],15,-1051523),m,l,n[e+1],21,-2054922799),v=f(v,m=f(m,l=f(l,g,v,m,n[e+8],6,1873313359),g,v,n[e+15],10,-30611744),l,g,n[e+6],15,-1560198380),m,l,n[e+13],21,1309151649),v=f(v,m=f(m,l=f(l,g,v,m,n[e+4],6,-145523070),g,v,n[e+11],10,-1120210379),l,g,n[e+2],15,718787259),m,l,n[e+9],21,-343485551),l=t(l,i),g=t(g,a),v=t(v,d),m=t(m,h);return[l,g,v,m]}function a(n){var t,r="",e=32*n.length;for(t=0;t<e;t+=8)r+=String.fromCharCode(n[t>>5]>>>t%32&255);return r}function d(n){var t,r=[];for(r[(n.length>>2)-1]=void 0,t=0;t<r.length;t+=1)r[t]=0;var e=8*n.length;for(t=0;t<e;t+=8)r[t>>5]|=(255&n.charCodeAt(t/8))<<t%32;return r}function h(n){return a(i(d(n),8*n.length))}function l(n,t){var r,e,o=d(n),u=[],c=[];for(u[15]=c[15]=void 0,o.length>16&&(o=i(o,8*n.length)),r=0;r<16;r+=1)u[r]=909522486^o[r],c[r]=1549556828^o[r];return e=i(u.concat(d(t)),512+8*t.length),a(i(c.concat(e),640))}function g(n){var t,r,e="";for(r=0;r<n.length;r+=1)t=n.charCodeAt(r),e+="0123456789abcdef".charAt(t>>>4&15)+"0123456789abcdef".charAt(15&t);return e}function v(n){return unescape(encodeURIComponent(n))}function m(n){return h(v(n))}function p(n){return g(m(n))}function s(n,t){return l(v(n),v(t))}function C(n,t){return g(s(n,t))}function A(n,t,r){return t?r?s(t,n):C(t,n):r?m(n):p(n)} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return A}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=A:n.md5=A}(this);
//# sourceMappingURL=md5.min.js.map

/***/ }),

/***/ "K5UD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultLO.0ef54f7.jpg";

/***/ }),

/***/ "K8l1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pdfViewer',
  props: ['path'],
  data: function data() {
    return {
      mediaPath: this.path
    };
  },

  watch: {
    path: function path(newValue, oldValue) {
      // console.log('pdf:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue;
      this.pdfHolder = document.getElementById('pdfHolder');
      // this.clone = this.pdfHolder.cloneNode(true)
      // this.clone.setAttribute('src', newValue)
      // this.pdfHolder.parentNode.replaceChild(this.clone, this.pdfHolder)
      var innerHTMLObj = '<object  :data="' + newValue + '" ></object>';
      this.pdfHolder.innerHTML = '';
      this.pdfHolder.innerHTML = innerHTMLObj;
    }
  },
  mounted: function mounted() {
    // console.log('pdf viewer path:' + this.mediaPath)
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('pdf destroy called')
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', { 'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 });
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
          /* return new Promise((resolve, reject) => {
            axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
            .then(response => {
              this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject()
            })
          }) */
        }
    }
  }
});

/***/ }),

/***/ "KUKW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KxOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
__webpack_require__("ImpT");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cartContent',
  data: function data() {
    return {
      itemId: '',
      keyWord: ''
    };
  },
  created: function created() {
    this.$store.dispatch('viewCartData', this.$store.getters.getProfileDetails.profileId);
  },

  computed: {
    total: function total() {
      var total1 = 0;
      if (this.$store.getters.getCartData.items !== undefined && this.$store.getters.getCartData.items !== null) {
        for (var index = 0; index < this.$store.getters.getCartData.items.length; index++) {
          total1 = total1 + parseInt(this.$store.getters.getCartData.items[index].amount);
        }
      }
      return total1;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  methods: {
    clearUserCart: function clearUserCart() {
      var _this = this;

      this.$swal({
        title: 'Do yo want to remove all the items from cart ?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/clearUserCart', { 'profileId': _this.$store.getters.getProfileDetails.profileId }).then(function (res) {
              if (res.status === 200) {
                _this.$store.dispatch('clearCartItemsInStore').then(function (res) {
                  _this.$toasted.success('cart emptied');
                  resolve();
                }, function (err) {
                  console.log('ERROR_IN_CLEARING_CART_ITEMS : ', err);
                  reject();
                });
              } else {
                reject();
              }
            }).catch(function (err) {
              console.log('ERROR_IN_CLEARING_CART : ', err);
              _this.$toasted.error('something went wrong');
              reject(err);
            });
          });
        }
      });
    },
    deleteOnCart: function deleteOnCart(itemId) {
      var _this2 = this;

      this.$swal({
        title: this.$t('cart.alerts.RemovalConfirmation'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this2.$store.dispatch('deleteData', { itemId: itemId, profileId: _this2.$store.getters.getProfileDetails.profileId, cartId: _this2.$store.getters.getCartData.cartId }).then(function (response) {
            _this2.$toasted.success(_this2.$t('cart.alerts.DeletedFromCart'));
            if (!_this2.$store.getters.itemPresentInWishListStatus(itemId)) {
              _this2.addToWishList(itemId);
            }
          }, function (error) {
            console.log('Error in deleting item to cart', error);
          });
        }
      });
    },
    checkCart: function checkCart() {
      this.$toasted.error(this.$t('cart.alerts.AddItemToCart'));
    },
    makePath: function makePath(path, type) {
      if (path.length !== 0) {
        return __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
        // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
      } else {
        if (type === 'CO') {
          return '../../../static/assets/images/defaultCO.jpg';
        } else if (type === 'LO') {
          return '../../../static/assets/images/defaultLO.jpg';
        }
      }
    },
    addToWishList: function addToWishList(itemId) {
      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
          // this.$toasted.success('Item added to wishlist')
        }, function (error) {
          console.error('error in adding item to wishList', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    }
  }
});

/***/ }),

/***/ "LCRK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LXS2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LYxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_dropzone_vue__ = __webpack_require__("3qEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e7f4b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_vue_dropzone_vue__ = __webpack_require__("O+xH");
function injectStyle (ssrContext) {
  __webpack_require__("xQzG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_dropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e7f4b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_vue_dropzone_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LqM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("yUvN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4993de42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("Sj1J");
function injectStyle (ssrContext) {
  __webpack_require__("/ES+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4993de42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LrGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);







// var axios = window.axios
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
var state = {
  // recommendedCourses: [],
  mostWatchedLOs: [], // libraryCards
  newLOs: [], // newVideoCards
  allCourses: [], // trendingCourses
  // allLOs: []
  recommendedItems: [] // los n cos to be recommended to userd
};
var getters = {
  /* getRecommendedCoursesData: function (state) {
    return state.recommendedCourses
  }, */
  // return data for recommendation
  getrecommendedItems: function getrecommendedItems(state) {
    return state.recommendedItems;
  },
  // return data for libraryCards
  getMostWatchedLos: function getMostWatchedLos(state) {
    return state.mostWatchedLOs;
  },
  // return data for newVideoCards
  getNewLos: function getNewLos(state) {
    return state.newLOs;
  },
  // return data for trendingCourses
  getAllCOs: function getAllCOs(state) {
    return state.allCourses;
  }
  // unknown
  // getAllLOs: function (state) {
  //   return state.allLOs
  // }
};
var actions = {
  // rcommended courser
  // called from recommendtaion for fetching
  fetchRecommendedItemsFromDB: function fetchRecommendedItemsFromDB(context, data) {
    // alert(JSON.stringify(data))
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/getContentBasedRecommendation', data).then(function (response) {
        context.commit('setRecommendedItems', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },

  // trendingCourses
  // called from trendingCourses for fetching
  fetchAllCOsFromDb: function fetchAllCOsFromDb(context) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var objectCategory = '';
      // console.log('co', JSON.stringify(context.getters.getProfileDetails))
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        // console.log('here')
        objectCategory = __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails);
        // console.log(objectCategory)
      }
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('o/getTrendingCourses', { headers: { 'contentCategory': objectCategory } }).then(function (response) {
        context.commit('setAllCosStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },

  // called from trendingCourses for reseting
  clearAllCosFromStore: function clearAllCosFromStore(context) {
    context.commit('clearAllCosStoreData', []);
  },

  // libraryCards
  // called from libraryCards for fetching
  fetchMostWatchedLosFromDb: function fetchMostWatchedLosFromDb(context) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var objectCategory = '';
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        // console.log('here')
        objectCategory = __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails);
        // console.log(objectCategory)
      }
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('o/getmostwatchedlos', { headers: { 'contentCategory': objectCategory } }).then(function (response) {
        context.commit('setMostWatchedLosStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },

  // called from libraryCards for reseting
  clearMostWatchedLosFromStore: function clearMostWatchedLosFromStore(context) {
    context.commit('clearMostWatchedLosStoreData', []);
  },

  // newVideoCards
  // called from newVideoCards for fetching
  fetchNewLosFromDb: function fetchNewLosFromDb(context) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var objectCategory = '';
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        objectCategory = __WEBPACK_IMPORTED_MODULE_5__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails);
      }
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('o/newlolist', { headers: { 'contentCategory': objectCategory } }).then(function (response) {
        context.commit('setNewLosStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },

  // called from newVideoCards for reseting
  clearNewLosFromStore: function clearNewLosFromStore(context) {
    context.commit('clearNewLosStoreData', []);
  }
  // unknown
  /* fetchAllLOsFromDb (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('o/getalllos'
        )
        .then(response => {
          context.commit('setAllLOsStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  }, */
  // unknown
  /* fetchRecommendedCoursesFromDb (context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('r/getrecommendation', {
          'profileId': data
        })
        .then(response => {
          context.commit('setRecommendedCoursesStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  } */

};
var mutations = {
  // recommendation courses
  // used for setting recommendation
  setRecommendedItems: function setRecommendedItems(state, data) {
    if (data === null) {
      state.recommendedItems = [];
    } else {
      state.recommendedItems = data;
    }
  },

  // used for resetting recommendation
  clearRecommendedItems: function clearRecommendedItems(state) {
    state.recommendedItems = [];
  },

  // trending courses
  // used for setting trendingCourses
  setAllCosStoreData: function setAllCosStoreData(state, data) {
    if (data === null) {
      state.allCourses = [];
    } else {
      state.allCourses = data;
    }
  },

  // used for resetting trendingCourses
  clearAllCosStoreData: function clearAllCosStoreData(state) {
    state.allCourses = [];
  },

  // libraryCards
  // used for setting libraryCards
  setMostWatchedLosStoreData: function setMostWatchedLosStoreData(state, data) {
    if (data === null) {
      state.mostWatchedLOs = [];
    } else {
      state.mostWatchedLOs = data;
    }
  },

  // used for resetting libraryCards
  clearMostWatchedLosStoreData: function clearMostWatchedLosStoreData(state) {
    state.mostWatchedLOs = [];
  },

  // newVideoCards
  // used for setting newVideoCards
  setNewLosStoreData: function setNewLosStoreData(state, data) {
    if (data === null) {
      state.newLOs = [];
    } else {
      state.newLOs = data;
    }
  },

  // used for resetting newVideoCards
  clearNewLosStoreData: function clearNewLosStoreData(state) {
    state.newLOs = [];
  }
  // unknown
  /* setAllLOsStoreData (state, data) {
    if (data === null) {
      state.allLOs = []
    } else {
      state.allLOs = data
    }
  }, */
  // unknown
  // clearAllLOsStoreData (state) {
  //   state.allLOs = []
  // },
  // not in use
  /* setRecommendedCoursesStoreData (state, data) {
    if (data === null) {
      state.recommendedCourses = []
    } else {
      state.recommendedCourses = data
    }
  }, */
  // not in use
  /* clearRecommendedCoursesStoreData (state) {
    state.recommendedCourses = []
  } */

};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e73ab45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qGEf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e73ab45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MxVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__("PNuO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8519194_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__("hJMx");
function injectStyle (ssrContext) {
  __webpack_require__("Y1BO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8519194_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1ea29058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("zFIj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1ea29058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gAnalysis", function() { return gAnalysis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encrtpyDetailsUsingMd5", function() { return encrtpyDetailsUsingMd5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "base64Encode", function() { return base64Encode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "base64Decode", function() { return base64Decode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "facebookUserDetails", function() { return facebookUserDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_assets_plugins_bootstrap_v4_1_1_bootstrap_min_css__ = __webpack_require__("I5rd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_assets_plugins_bootstrap_v4_1_1_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_assets_plugins_bootstrap_v4_1_1_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_plugins_materialdesignicons_css_materialdesignicons_min_css__ = __webpack_require__("EdzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_plugins_materialdesignicons_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_assets_plugins_materialdesignicons_css_materialdesignicons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_styles_scss_swiper_css__ = __webpack_require__("V3cl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_styles_scss_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_assets_styles_scss_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_assets_styles_scss_template_scss__ = __webpack_require__("/9U9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_assets_styles_scss_template_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_assets_styles_scss_template_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_md5_min__ = __webpack_require__("J+V2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_md5_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_js_md5_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_assets_styles_scss_vue_animate_css__ = __webpack_require__("OeAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_assets_styles_scss_vue_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_assets_styles_scss_vue_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_scroll_reveal__ = __webpack_require__("4t5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_scroll_reveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_scroll_reveal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_backtotop__ = __webpack_require__("vJRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_js_ssomodule_js__ = __webpack_require__("CK32");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex_i18n__ = __webpack_require__("kmDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_localization_en_json__ = __webpack_require__("3kQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_localization_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__static_localization_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_localization_mr_json__ = __webpack_require__("k1mU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_localization_mr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__static_localization_mr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_progressbar__ = __webpack_require__("zYko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuebar__ = __webpack_require__("CoJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_moment_jalaali__ = __webpack_require__("wTx/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_moment_jalaali___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_moment_jalaali__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_swal__ = __webpack_require__("nUxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_swal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_swal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_social_sharing__ = __webpack_require__("VK1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vue_analytics__);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import '../static/js/fbSdk.js'








__webpack_require__("ImpT");


















// import GSignInButton from 'vue-google-signin-button'
// import FBSignInButton from 'vue-facebook-signin-button'
var InfiniteLoading = __webpack_require__("qK+J");

var isProd = "production" !== 'production';
// stg ga id:UA-121174698-1
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34_vue_analytics___default.a, {
  id: 'UA-121063410-1',
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  autoTracking: {
    exception: true
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_progressbar___default.a, {
  color: '#ADFF2F',
  failedColor: 'red'
});
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_moment_jalaali___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].i18n.add('en', __WEBPACK_IMPORTED_MODULE_22__static_localization_en_json___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].i18n.add('mr', __WEBPACK_IMPORTED_MODULE_23__static_localization_mr_json___default.a);
// set the start locale to use
if (true) {
  if (false) {
    Vue.i18n.set('mr');
  } else {
    __WEBPACK_IMPORTED_MODULE_9_vue__["default"].i18n.set('en');
  }
} else {
  Vue.i18n.set('en');
}
window.axios = __WEBPACK_IMPORTED_MODULE_20_axios___default.a;
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__static_js_ssomodule_js__["a" /* default */], {
  clientId: __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__["a" /* SSO_CLIENT_ID */],
  mkclLoginServerURL: __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__["b" /* MKCL_LOGIN_SERVER_URL */],
  mkclLoginClientURL: __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__["c" /* MKCL_LOGIN_CLIENT_URL */],
  mkclSignUpURL: __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__["d" /* MKCL_SIGNUP_URL */]
});
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.productionTip = false;
// Vue.use(GSignInButton)
// Vue.use(FBSignInButton)
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_vue_bootstrap_datetimepicker___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vue_swal___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_vue_lazyload___default.a, {});
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_scroll_reveal___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_backtotop__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_toasted___default.a, {
  duration: 3200,
  theme: 'primary'
});
// Vue.use(CryptoJS)


// Google analyitcs
var gAnalysis = function gAnalysis() {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'UA-121174698-1');
};

// event bus for deciding nav buttons or search bar on header 
var EventBus = new __WEBPACK_IMPORTED_MODULE_9_vue__["default"]();
// initializeFaceBookSDK - register FB sdk
/* export const initializeFaceBookSDK = () => {
  window.fbAsyncInit = function() {
    var obj = {
      appId: FACEBOOK_LOGIN_APP_ID,
      cookie: true,  // enable cookies to allow the server to access the session
      xfbml: true,  // parse social plugins on this page
      version: 'v2.8' // use graph api version 2.8
    }
    // console.log(JSON.stringify(FB))
    if (FB !== undefined) {
      FB.init(obj)
    }
  }
} */

// create md5 encrytion
var encrtpyDetailsUsingMd5 = function encrtpyDetailsUsingMd5(str) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    // console.log(md5(str))
    // console.log(md5(str, PASSWORD_ENCRYPION_KEY))
    resolve(__WEBPACK_IMPORTED_MODULE_8__static_js_md5_min___default()(str));
  });
};
var base64Encode = function base64Encode(str) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    // console.log(str)
    var encodedString = btoa(str);
    console.log(encodedString);
    // return encodedString
    resolve(encodedString);
  });
};
var base64Decode = function base64Decode(str) {
  var decodedString = atob(str);
  // console.log(decodedString)
};
// facebookUserDetails - returns user facebook details
var facebookUserDetails = function facebookUserDetails() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    FB.api('/me', function (dude) {
      resolve(dude);
    });
  });
};
// vis - used to check if current tab is active or not
var vis = function () {
  var stateKey, eventKey;
  var keys = {
    hidden: 'visibilitychange',
    webkitHidden: 'webkitvisibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange'
  };
  for (stateKey in keys) {
    if (stateKey in document) {
      eventKey = keys[stateKey];
      break;
    }
  }
  return function (c) {
    if (c) document.addEventListener(eventKey, c);
    return !document[stateKey];
  };
}();

vis(function () {

  if (localStorage.getItem('isLoggedIn') !== null) {
    if (vis()) {
      // tween resume() code goes here
      setTimeout(function () {
        // console.log('tab is visible - has focus')
        if (localStorage.getItem('token') !== null) {
          // var tokenTakenFromSSO = (localStorage.getItem('ssoToken') === 'true')
          __WEBPACK_IMPORTED_MODULE_20_axios___default.a.get('/o/loginForSocialUser', { headers: { 'clientId': __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__["a" /* SSO_CLIENT_ID */], 'Authorization': localStorage.getItem('token') } }).then(function (response) {
            if (response.status === 200) {
              var userData = response.data;
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('clearCartData');
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setCartData', userData.cartDetails);
              // console.log(JSON.stringify(userData.cartDetails))
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setProfileDetails', userData.profileDetails);
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setWishListStoreData', userData.wishListItems);
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setUserPlaylists', userData.userPlaylists);
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setItemsEnrolled', userData.enrolledLearningObject); // storing all LOs and COs purchased by user
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setIsLoggedIn', true);
              localStorage.setItem('isLoggedIn', true);
            }
          }).catch(function (e) {
            console.log(e);
          });
        } else {
          // console.log(localStorage.getItem('isLoggedIn'))
          if (localStorage.getItem('isLoggedIn') == null) {
            // console.log('logging out')
            __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */].push({ path: '/advertisement' });
            __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].dispatch('clearUserData');
          }
        }
      }, 100);
    } else {
      // console.log('tab is invisible - has blur') 
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].dispatch('clearUserData');
  }
});

if (localStorage.getItem('isLoggedIn')) {
  var sessionObj = JSON.parse(sessionStorage.vuex);
  if (sessionObj.profile.profileDetails === null || sessionObj.profile.profileDetails.profileId === undefined) {
    // console.log('in other tab : need for getting session')
    __WEBPACK_IMPORTED_MODULE_20_axios___default.a.get('/server/o/loginForSocialUser', { headers: { 'clientId': __WEBPACK_IMPORTED_MODULE_27__components_common_constants_js__["a" /* SSO_CLIENT_ID */], 'Authorization': localStorage.getItem('token') } }).then(function (response) {
      if (response.status === 200) {
        var userData = response.data;
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setCartData', userData.cartDetails);
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setProfileDetails', userData.profileDetails);
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setWishListStoreData', userData.wishListItems);
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setUserPlaylists', userData.userPlaylists);
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setItemsEnrolled', userData.enrolledLearningObject); // storing all LOs and COs purchased by user
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('setIsLoggedIn', true);
        localStorage.setItem('isLoggedIn', true);
      }
    }).catch(function (e) {
      console.log('Failed to initialize user Profile' + e.response.data);
      localStorage.removeItem('isLoggedIn');
    });
  } else {
    // console.log('in same tab : no need for getting session')
  }
}

if (false) {
  // set baseUrl from app
  axios.defaults.baseURL = 'http://localhost:8083/server';
  window.serverPath = axios.defaults.baseURL;
} else {
  // for prod
  // axios.defaults.baseURL = '/'
  // window.serverPath = window.location.origin
  __WEBPACK_IMPORTED_MODULE_20_axios___default.a.defaults.baseURL = '/server/';
  // window.serverPath = process.ServerURL
}

__WEBPACK_IMPORTED_MODULE_20_axios___default.a.interceptors.request.use(function (config) {
  // Do something before request is sent
  var tokenString = window.MKCLAPI.getToken();
  if (tokenString != null) {
    config.headers.Authorization = tokenString;
  } else {
    if (localStorage.getItem('token') !== null) {
      // user had logged in
      config.headers.Authorization = localStorage.getItem('token');
    } else {
      // user had not logged in and is reseting password

      config.headers.Authorization = localStorage.getItem('tokenForPasswordChange');
      // console.log('removing')
      localStorage.removeItem('tokenForPasswordChange');
    }
  }
  // console.log(tokenString)
  return config;
}, function (error) {
  // Do something with request error
  console.log('intercept error');
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_20_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response !== null && error.response.status === 401) {
    if (error.response.data === 'ERR_ACCOUNT_DEACTIVATED') {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].toasted.error('your account seems to be deactivated');
    }
    __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].dispatch('clearUserData');
    __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */].push({ path: '/home' });
    window.MKCLAPI.removeToken();
    window.MKCLAPI.login();
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

__WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */].beforeEach(function (to, from, next) {
  // console.log('router')
  // alert('before each')
  if (localStorage.getItem('app_env') !== 'mahademy' && localStorage.getItem('app_env') !== undefined && localStorage.getItem('app_env') !== null) {
    // console.log('in')
    if (to.matched.some(function (record) {
      return record.meta.requireAuth;
    })) {
      var token = window.MKCLAPI.getToken();
      // console.log('in', token)
      window.MKCLAPI.isTokenValid(token).then(function () {
        next();
      }).catch(function () {
        // console.log('here')
        __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].dispatch('clearUserData');
        __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */].push({ path: '/home' });
        __WEBPACK_IMPORTED_MODULE_19__static_js_ssomodule_js__["a" /* default */].login();
      });
    } else {
      // console.log(JSON.stringify(to))
      next();
    }
  } else {
    // console.log('else')
    next();
  }
});

var featureEnableList = null;

if (featureEnableList == null) {
  __WEBPACK_IMPORTED_MODULE_20_axios___default.a.get('o/features/getfeaturesinfolist').then(function (res) {
    featureEnableList = res.data;
  }).catch(function (e) {
    console.log('error in getting feature list : ', e);
  });
}

__WEBPACK_IMPORTED_MODULE_9_vue__["default"].mixin({
  data: function data() {
    return {
      get featureStatusInfoList() {
        return featureEnableList;
      }
    };
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_9_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */], InfiniteLoading: InfiniteLoading }
});

/***/ }),

/***/ "NIRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_success_vue__ = __webpack_require__("qODG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d00ffb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_success_vue__ = __webpack_require__("sRaq");
function injectStyle (ssrContext) {
  __webpack_require__("mfkx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d00ffb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_success_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NTYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseReview',
  components: { StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a },
  mounted: function mounted() {
    // alert(JSON.stringify(this.$store.getters.getCurrentCourse))
    // this.$store.dispatch('getCourseDetails', this.$store.getters.getProfileDetails.profileId)
    // alert(JSON.stringify(this.$store.getters.getCourseDetails))
  },

  data: function data() {
    return {
      notNextTick: true,
      swiperOptionReview: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-review-next',
        prevButton: '.swiper-review-prev',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: false
      }
    };
  }
});

/***/ }),

/***/ "NdPc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NljK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "back-to-top-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vue-back-to-top",
    style: (("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "default"
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.text) + "\n        ")])])])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O+xH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dropzoneElement",
    class: {
      'vue-dropzone dropzone': _vm.includeStyling
    },
    attrs: {
      "id": _vm.id
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OeAh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ol2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "libraryCards",
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */],
      showDismissibleAlert: false,
      isValidUser: false,
      isActive: false,
      notNextTick: true,
      obj: {},
      items: [],
      coList: [],
      loList: [],
      add: "Add to Cart",
      itemDescription: "Coarse is to help you with some basics of HTML",
      itemName: "HTML5 Demo",
      swiperOption2: {
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        slidesPerView: "auto",
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      selected: [], // Must be an array reference!
      options: [{ text: "Playlist 1", value: "Playlist 1" }, { text: "Playlist 2", value: "Playlist 2" }, { text: "Playlist 3", value: "Playlist 3" }, { text: "Playlist 4", value: "Playlist 4" }, { text: "Playlist 5", value: "Playlist 5" }, { text: "Playlist 6", value: "Playlist 6" }]
    };
  },

  methods: {
    goToLogin: function goToLogin() {
      // window.MKCLAPI.login()
      this.$root.$emit("bv::show::modal", "login");
      return;
    },
    makePath: function makePath(path) {
      return __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + "/" + path;
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },
    addToWishList: function addToWishList(itemId) {
      var _this = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch("insertWishListInDb", {
          profileId: this.$store.getters.getProfileDetails.profileId,
          itemId: itemId
        }).then(function (response) {
          _this.$toasted.success(_this.$t("wishlist.alerts.AddedToWishList"));
        }, function (error) {
          console.error("error in adding item to wishList", error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    removeFromWishList: function removeFromWishList(itemId) {
      var _this2 = this;

      this.$swal({
        title: this.$t("wishlist.alerts.RemoveItemConfirm"),
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this2.$store.dispatch("removeWishListFromDb", {
            profileId: _this2.$store.getters.getProfileDetails.profileId,
            itemId: itemId
          }).then(function (response) {
            _this2.$toasted.success(_this2.$t("wishlist.alerts.RemoveItem"));
          }, function (error) {
            console.log("error in removing item from db", error);
          });
        }
      });
    },
    addToCart: function addToCart(id) {
      var _this3 = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch("addCartData", {
          itemId: id,
          profileId: this.$store.getters.getProfileDetails.profileId,
          cartId: this.$store.getters.getCartData.cartId
        }).then(function (response) {
          _this3.$toasted.success(_this3.$t("common.alerts.CART_ADDED_SUCCESS"));
        }, function (error) {
          console.log("error in adding item to cart", error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    playLO: function playLO(val) {
      var _this4 = this;

      var LOObj = [];
      LOObj.push(val);
      this.$store.dispatch("setCurrentContentViewerPlaylist", LOObj).then(function (response) {
        // resolve()
        _this4.$store.dispatch("setIsPlaylist", false).then(function (response) {
          _this4.$router.push("/frames");
        });
      });
      /* return new Promise((resolve) => {
        axios.post('r/learningobject/getlodatabyitemid', {'itemId': val.contentId}).then(Response => {
          if (Response.status === 200) {
            LOObj = Response.data
            // console.log(JSON.stringify(LOObj))
            this.$store.dispatch('setCurrentContentViewerPlaylist', LOObj).then(response => {
              resolve()
              this.$store.dispatch('setIsPlaylist', false).then(response => {
                this.$router.push('/frames')
              })
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }) */
    }
  },
  beforeDestroy: function beforeDestroy() {
    // clear store data
    if (this.$store.getters.getIsLoggedIn) {
      this.$store.dispatch("clearMostWatchedLosFromStore").then(function (response) {}, function (error) {
        console.log("error in clearMostWatchedLosFromStore", error);
      });
    }
  },
  mounted: function mounted() {
    this.$store.dispatch("fetchMostWatchedLosFromDb").then(function (response) {
      // console.log('feteched')
    }, function (error) {
      console.log("error in fetchMostWatchedLosFromDb", error);
    });
    /* if (this.$store.getters.getIsLoggedIn) {
      // call api to fetch LOs from Db to be displayed
      this.$store.dispatch('fetchMostWatchedLosFromDb').then(
        response => {
          console.log('feteched')
        },
        error => {
          console.log('error in fetchMostWatchedLosFromDb', error)
        }
      )
    } else {
      if (this.$store.getters.getMostWatchedLos.length === 0) {
        this.$store.dispatch('fetchMostWatchedLosFromDb').then(
          response => {},
          error => {
            console.log('error in fetchMostWatchedLosFromDb', error)
          }
        )
      }
    } */
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "OzLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'imageViewer',
  props: ['path'],
  data: function data() {
    return {
      mediaPath: this.path
    };
  },

  watch: {
    path: function path(newValue, oldValue) {
      // console.log('image:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue;
      this.imgHolder = document.getElementById('imgHolder');
      this.clone = this.imgHolder.cloneNode(true);
      this.clone.setAttribute('src', newValue);
      this.imgHolder.parentNode.replaceChild(this.clone, this.imgHolder);
    }
  },
  mounted: function mounted() {
    // console.log('image viewer path:' + this.mediaPath)
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', { 'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 });
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
          /* return new Promise((resolve, reject) => {
            axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
            .then(response => {
              this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject()
            })
          }) */
        }
    }
  }
});

/***/ }),

/***/ "P2BP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'youtube-player',
  props: ['path'],
  loaded: true,
  data: function data() {
    return {};
  },

  watch: {
    path: function path(newValue, oldValue) {
      this.init(newValue, oldValue);
    }
  },
  methods: {
    init: function init(newValue, oldValue) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var innerHTMLObj = '<object  width="100%"  > <embed class="player" height="400px" src="' + newValue + '" width="100%" ></embed> </object>';
        _this.youtube = document.getElementById('youtube');
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.youtube) === undefined || _this.youtube === null || _this.youtube === '') {
          // resolve(true)
        } else {
          _this.youtube.innerHTML = '';
          // console.log('here' + this.$store.getters.getPasscode)
          _this.youtube.innerHTML = innerHTMLObj;
        }
        resolve(true);
      });
    }
  }
});

/***/ }),

/***/ "P4Ul":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5xh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERA_COURSE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ERA_LEARNER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOT_EXPIRED_STATUS; });
/* unused harmony export EXPIRED_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return IMAGE_UPLOAD_MAX_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CDN_BUSSINESSHEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return THIRDPARTY_GOOGLE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return THIRDPARTY_FACEBOOK_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LIVEDEMY_DEFAULT_USER_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAHADEMY_APP_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SSO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SSO_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MKCL_LOGIN_SERVER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MKCL_LOGIN_CLIENT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MKCL_SIGNUP_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ERA_GATEWAY_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CDP_CDN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CDN_UPLOAD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CDN_DELETE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PAYMENT_REQUEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SHARE_ON_MEDIA_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CDN_CLIENTHEADER; });
/* unused harmony export FACEBOOK_LOGIN_APP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GOOGLE_SIGN_IN_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LIVEDEMY_DEFAULT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEFAULT_OBJECT_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MAHADEMY_EXIT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INSTANCE_NAME; });
/* unused harmony export FEEDBACK_MAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CDP_CDN_THUMBNAIL_URL; });
var ERA_COURSE_URL = '/era/#/initera';
var ERA_LEARNER_TYPE = 'livedemy';
var NOT_EXPIRED_STATUS = 'ITEM_NOT_EXPIRED';
var EXPIRED_STATUS = 'ITEM_NOT_EXPIRED';
var IMAGE_UPLOAD_MAX_SIZE = 0.512; // the file size is in mb taken by dropzone
var CDN_BUSSINESSHEADER = 'ERA'; // common for development and staging
var THIRDPARTY_GOOGLE_USER = 'GOOGLE';
var THIRDPARTY_FACEBOOK_USER = 'FACEBOOK';
var LIVEDEMY_DEFAULT_USER_RIGHT = 'learner';
var MAHADEMY_APP_ENV = 'mahademy';
var ssoUrl = '';
var ssoClientId = '';
var mkclLoginServerUrl = '';
var mkclLoginClientUrl = '';
var mkclSignupUrl = '';
var eraGatewayUrl = '';
var cdpCdnUrl = '';
var cdpUploadUrl = '';
var cdpDeleteUrl = '';
var paymentRequestUrl = '';
var shareOnMediaUrl = '';
var cdnClientHeader = '';
var facebookLoginAppId = '';
var googleSignInAppId = '';
var livedemyDefaultUser = '';
var defaultObjectCategory = '';
var mahademyExitUrl = '';
var instanceName = '';
var feedBackMail = '';
if (false) {
     ssoUrl = 'http://10.2.10.42:3030';
     ssoClientId = 'LiveDemy2';
     mkclLoginServerUrl = 'http://10.2.10.42:3030';
     mkclLoginClientUrl = 'http://10.2.10.42:3030/#/login';
     mkclSignupUrl = 'http://10.2.10.42:3030/#/register';
     eraGatewayUrl = 'http://10.2.10.42:3037/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'http://10.2.10.230:3032/';
     cdpUploadUrl = 'https://livedemystg.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://livedemystg.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'http://localhost:8083/#/coursePage/';
     cdnClientHeader = 'LiveDemy';
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = '';
     instanceName = 'LIVEDEMY';
     feedBackMail = 'livedemysupport@mkcl.org';
} else if (false) {
     ssoUrl = 'https://livedemystg.mkcl.org/loginserver';
     ssoClientId = 'LIVEDEMY_STG';
     mkclLoginServerUrl = 'https://livedemystg.mkcl.org/loginserver/';
     mkclLoginClientUrl = 'https://livedemystg.mkcl.org/sso/#/login';
     mkclSignupUrl = 'https://livedemystg.mkcl.org/sso/#/register';
     eraGatewayUrl = 'https://livedemystg.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'https://livedemystg.mkcl.org/cdpcdn/';
     cdpUploadUrl = 'https://livedemystg.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://livedemystg.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'https://livedemystg.mkcl.org/#/coursePage/';
     cdnClientHeader = 'LiveDemy'; // common for development and staging
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = 'http://mahademy.mkcl.org/mahademy/';
     instanceName = 'LIVEDEMY';
     feedBackMail = 'livedemysupport@mkcl.org';
} else if (false) {
     ssoUrl = 'https://learning.mkcl.org/loginserver';
     ssoClientId = 'LIVEDEMY_MKCL';
     mkclLoginServerUrl = 'https://learning.mkcl.org/loginserver/';
     mkclLoginClientUrl = 'https://learning.mkcl.org/sso/#/login'; // unused
     mkclSignupUrl = 'https://learning.mkcl.org/sso/#/register'; // unused
     eraGatewayUrl = 'https://learning.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'https://cdpcdn.mkcl.org';
     cdpUploadUrl = 'https://learning.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://learning.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'https://10.2.11.6:8083/#/coursePage/';
     cdnClientHeader = 'LIVEDEMYMKCL'; // common for development and staging
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = '';
     instanceName = 'LIVEDEMY';
     feedBackMail = 'livedemysupport@mkcl.org';
} else if (true) {
     ssoUrl = 'https://livedemy.mkcl.org/loginserver';
     ssoClientId = 'LIVEDEMY';
     mkclLoginServerUrl = 'https://livedemy.mkcl.org/loginserver/';
     mkclLoginClientUrl = 'https://livedemy.mkcl.org/sso/#/login';
     mkclSignupUrl = 'https://livedemy.mkcl.org/sso/#/register';
     eraGatewayUrl = 'https://livedemy.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'https://livedemy.mkcl.org/cdpcdn/';
     cdpUploadUrl = 'https://livedemy.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://livedemy.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'https://livedemy.mkcl.org/#/coursePage/';
     cdnClientHeader = 'LIVEDEMYPROD';
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = '';
     instanceName = 'LIVEDEMY';
     feedBackMail = 'livedemysupport@mkcl.org';
} else if (process.env.NODE_ENV === 'mahademy') {
     ssoUrl = 'https://livedemystg.mkcl.org/loginserver';
     ssoClientId = 'MahaDemy';
     mkclLoginServerUrl = 'http://mahademy.mkcl.org/mahademy/loginserver/';
     mkclLoginClientUrl = 'https://livedemystg.mkcl.org/sso/#/login';
     mkclSignupUrl = 'https://livedemystg.mkcl.org/sso/#/register';
     eraGatewayUrl = 'http://mahademy.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'http://mahademy.mkcl.org/cdpcdn/';
     cdpUploadUrl = 'http://mahademy.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'http://mahademy.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'http://mahademy.mkcl.org/mahademy/#/coursePage/';
     cdnClientHeader = 'MahaDemy';
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'MAHADEMY';
     defaultObjectCategory = 'MAHADEMY';
     instanceName = 'MAHADEMY';
     mahademyExitUrl = 'http://mahademy.mkcl.org/login/#/home';
     feedBackMail = 'livedemysupport@mkcl.org';
} else if (process.env.NODE_ENV === 'mfslivedemy') {
     ssoUrl = 'https://mfslivedemy.mkcl.org/loginserver';
     ssoClientId = 'LIVEDEMY';
     mkclLoginServerUrl = 'https://mfslivedemy.mkcl.org/loginserver/';
     mkclLoginClientUrl = 'https://mfslivedemy.mkcl.org/sso/#/login';
     mkclSignupUrl = 'https://mfslivedemy.mkcl.org/sso/#/register';
     eraGatewayUrl = 'https://mfslivedemy.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'https://mfslivedemy.mkcl.org/cdpcdn/';
     cdpUploadUrl = 'https://mfslivedemy.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://mfslivedemy.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'https://mfslivedemy.mkcl.org/#/coursePage/';
     cdnClientHeader = 'LIVEDEMYPROD';
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = '';
     instanceName = 'mfslivedemy';
     feedBackMail = 'livedemysupport@mkcl.org';
} else if (process.env.NODE_ENV === 'marketing') {
     ssoUrl = 'https://marketinglivedemydemo.mkcl.org/loginserver';
     ssoClientId = 'LIVEDEMY';
     mkclLoginServerUrl = 'https://marketinglivedemydemo.mkcl.org/loginserver/';
     mkclLoginClientUrl = 'https://marketinglivedemydemo.mkcl.org/sso/#/login';
     mkclSignupUrl = 'https://marketinglivedemydemo.mkcl.org/sso/#/register';
     eraGatewayUrl = 'https://marketinglivedemydemo.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'https://marketinglivedemydemo.mkcl.org/cdpcdn/';
     cdpUploadUrl = 'https://marketinglivedemydemo.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://marketinglivedemydemo.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'https://marketinglivedemydemo.mkcl.org/#/coursePage/';
     cdnClientHeader = 'LIVEDEMYPROD';
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = '';
     instanceName = 'LIVEDEMY';
     feedBackMail = 'livedemy@mkcl.org';
} else if (process.env.NODE_ENV === 'mfsstaging') {
     ssoUrl = 'https://mfslivedemystg.mkcl.org/loginserver';
     ssoClientId = 'LIVEDEMY_STG';
     mkclLoginServerUrl = 'https://mfslivedemystg.mkcl.org/loginserver/';
     mkclLoginClientUrl = 'https://mfslivedemystg.mkcl.org/sso/#/login';
     mkclSignupUrl = 'https://mfslivedemystg.mkcl.org/sso/#/register';
     eraGatewayUrl = 'https://mfslivedemystg.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner';
     cdpCdnUrl = 'https://mfslivedemystg.mkcl.org/cdpcdn/';
     cdpUploadUrl = 'https://mfslivedemystg.mkcl.org/cdnupload/?s-o';
     cdpDeleteUrl = 'https://mfslivedemystg.mkcl.org/cdndelete/o/deletefile';
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome';
     shareOnMediaUrl = 'https://mfslivedemystg.mkcl.org/#/coursePage/';
     cdnClientHeader = 'LiveDemy';
     facebookLoginAppId = '241796203256981';
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com';
     livedemyDefaultUser = 'LIVEDEMY';
     defaultObjectCategory = 'LIVEDEMY';
     mahademyExitUrl = '';
     instanceName = 'mfslivedemy';
     feedBackMail = 'livedemysupport@mkcl.org';
}
var SSO_URL = ssoUrl;
var SSO_CLIENT_ID = ssoClientId;
var MKCL_LOGIN_SERVER_URL = mkclLoginServerUrl;
var MKCL_LOGIN_CLIENT_URL = mkclLoginClientUrl;
var MKCL_SIGNUP_URL = mkclSignupUrl;
var ERA_GATEWAY_URL = eraGatewayUrl;
var CDP_CDN_URL = cdpCdnUrl;
var CDN_UPLOAD_URL = cdpUploadUrl;
var CDN_DELETE_URL = cdpDeleteUrl;
var PAYMENT_REQUEST_URL = paymentRequestUrl;
var SHARE_ON_MEDIA_URL = shareOnMediaUrl;
var CDN_CLIENTHEADER = cdnClientHeader;
var FACEBOOK_LOGIN_APP_ID = facebookLoginAppId;
var GOOGLE_SIGN_IN_APP_ID = googleSignInAppId;
var LIVEDEMY_DEFAULT_USER = livedemyDefaultUser;
var DEFAULT_OBJECT_CATEGORY = defaultObjectCategory;
var MAHADEMY_EXIT_URL = mahademyExitUrl;
var INSTANCE_NAME = instanceName;
var FEEDBACK_MAIL = feedBackMail;
var CDP_CDN_THUMBNAIL_URL = CDP_CDN_URL + 'thumbnail';

/***/ }),

/***/ "PK6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticStyle: {
      "background-image": "url(static/assets/images/footer.png)"
    },
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-6 copyright"
  }, [_vm._v("\n                © " + _vm._s(_vm.$t('footer.copyright')) + " " + _vm._s(_vm.getCurrentYear) + " " + _vm._s(_vm.$t('footer.mkcl_title'))), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('footer.rights_reserved')) + "\n            ")]), _vm._v(" "), _vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "col-lg-12 "
  }, [_vm._v("\n               " + _vm._s(_vm.$t('footer.mahademy_title')) + "  © " + _vm._s(_vm.$t('footer.copyright')) + " " + _vm._s(_vm.getCurrentYear) + " " + _vm._s(_vm.$t('footer.mkcl_title')) + "\n            ")])])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "visibleOffset": "600",
      "bottom": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-to-top",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-up"
  })])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 olinks"
  }, [_c('ul')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PMOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__ = __webpack_require__("P5xh");



var state = {
  profileDetails: {},
  // coursesEnrolled: {},
  // coursesCOEnrolled: [],
  // LOsEnrolled: [],
  itemsEnrolled: [] // stores all LOs and COs purchased by user
};
var getters = {
  getUserJvID: function getUserJvID(state) {
    return function (accountDetails) {
      // var  objectCategory = ''
      for (var i = 0; i < accountDetails.length; i++) {
        if (accountDetails[i].jvId !== __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */] && accountDetails[i].jvId !== __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["h" /* THIRDPARTY_FACEBOOK_USER */] && accountDetails[i].jvId !== __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["i" /* THIRDPARTY_GOOGLE_USER */]) {
          return accountDetails[i].jvId;
        }
      }
      return __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */];
    };
  },
  // returns purchased date and expiry date of enrolled Object
  // required to display on in coursePage's bannerVideo component
  getItemPurchasedDates: function getItemPurchasedDates(state, getters) {
    return function (itemDetails) {
      // console.log('here', JSON.stringify(itemDetails))
      for (var i = 0; i < getters.getItemsEnrolledByType(itemDetails.type).length; i++) {
        // console.log(i)
        if (getters.getItemsEnrolledByType(itemDetails.type)[i].contentId === itemDetails.id) {
          var expiryDate = getters.getItemsEnrolledByType(itemDetails.type)[i].expiryDate.split('T')[0].split('-').reverse().join('/');
          var purchaseDate = getters.getItemsEnrolledByType(itemDetails.type)[i].purchasedDate.split('T')[0].split('-').reverse().join('/');
          return {
            purchaseDate: purchaseDate, expiryDate: expiryDate
          };
        }
      }
    };
  },
  // returns true if item subscription is not expired else false if expired
  // here we check if item is purchased by user then validity based on current date,expiry date
  // for CO & LO check  current date and expiry date
  getItemSubscriptionStatus: function getItemSubscriptionStatus(state, getters) {
    return function (itemDetails) {
      // var index
      var expiryDate;
      // get expiry date and check if user had purchased item
      // console.log(getters.getItemsEnrolledByType(itemDetails.type))
      if (getters.getItemsEnrolledByType(itemDetails.type) !== undefined && getters.getItemsEnrolledByType(itemDetails.type) !== null && getters.getItemsEnrolledByType(itemDetails.type).length > 0) {
        // console.log('in')
        for (var i = 0; i < getters.getItemsEnrolledByType(itemDetails.type).length; i++) {
          if (itemDetails.id === getters.getItemsEnrolledByType(itemDetails.type)[i].contentId) {
            // index = i
            expiryDate = getters.getItemsEnrolledByType(itemDetails.type)[i].expiryDate;
            break;
          }
        }
        // if expiryDate is undefined then user had not purchased item
        if (expiryDate === undefined) {
          return false;
        } else {
          // continue comparision with current date and expiryDate
          var currentDate = new Date();
          var expiryDateList = expiryDate.substring(0, expiryDate.indexOf('T')).split('-');
          var newDate = {
            'year': expiryDateList[0],
            'month': parseInt(expiryDateList[1]) - 1,
            'day': expiryDateList[2]
          };
          expiryDateList = [];
          expiryDateList = expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.indexOf('.')).split(':');
          newDate['hour'] = expiryDateList[0];
          newDate['min'] = expiryDateList[1];
          newDate['sec'] = expiryDateList[2];
          expiryDate = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec']);
          if (currentDate >= expiryDate) {
            return false;
          } else {
            return true;
            // if (this.$store.getters.getCourseEnrolled[index].watchedOn.length < this.$store.getters.getCourseEnrolled[index].allowedViewCount) {
            //   return true
            // } else {
            //   return false
            // }
            // if (itemDetails.type === 'LO') {
            //   // console.log('for lo')
            //   if (getters.getItemsEnrolledByType('LO')[index].watchedOn.length < getters.getItemsEnrolledByType('LO')[index].allowedViewCount) {
            //     // console.log('returning', getters.getItemsEnrolledByType('LO')[index].title)
            //     return true
            //   } else {
            //     return false
            //   }
            // } else {
            //   // console.log('for co')
            //   return true // for co
            // }
          }
        }
      }
    };
  },
  // checks whether tag is allocated to user
  getTagAllocationStatus: function getTagAllocationStatus(state, getters) {
    return function (itemDetails) {
      // prepare profile tagList
      if (getters.getProfileDetails.tagList !== null && getters.getProfileDetails.tagList !== undefined) {
        var profileTagList = [];
        for (var i = 0; i < getters.getProfileDetails.tagList.length; i++) {
          profileTagList.push(getters.getProfileDetails.tagList[i].tagName);
        }
        for (var _i = 0; _i < itemDetails.contentTagList.length; _i++) {
          if (profileTagList.includes(itemDetails.contentTagList[_i].tag)) {
            return true;
          }
        }
      }
      return false;
    };
  },
  // returns items purchased by user based on itemType
  // itemType can be : ALL, LO, CO
  getItemsEnrolledByType: function getItemsEnrolledByType(state, getters) {
    return function (itemType) {
      // if item Type is ALL send all LOs n COs
      if (itemType === 'ALL') {
        return state.itemsEnrolled;
      } else {
        // sort base on itemType i.e LOs n COs
        var items = [];
        for (var i = 0; i < state.itemsEnrolled.length; i++) {
          if (state.itemsEnrolled[i].courseType === itemType) {
            items.push(state.itemsEnrolled[i]);
          }
        }
        return items;
      }
    };
  },
  // returns True if user had purchased item else False if not
  getItemPurchasedStatus: function getItemPurchasedStatus(state, getters) {
    return function (itemId) {
      // console.log('---->', getters.getIsLoggedIn)
      if (getters.getIsLoggedIn) {
        var itemStatus = false;
        for (var i = 0; i < state.itemsEnrolled.length; i++) {
          if (state.itemsEnrolled[i].contentId === itemId) {
            itemStatus = true;
            break;
          }
        }
        return itemStatus;
      } else {
        return false;
      }
    };
  },
  getProfileDetails: function getProfileDetails(state) {
    return state.profileDetails;
  },
  // getCourseEnrolled: state => { return state.coursesEnrolled },
  getPurchaseStatus: function getPurchaseStatus(state, getters) {
    return function (itemId) {
      var flag = false;
      for (var i = 0; i < getters.getCourseEnrolled.length; i++) {
        if (getters.getCourseEnrolled[i].contentId === itemId) {
          flag = true;
          break;
        } else {
          flag = false;
        }
      }
      return flag;
    };
  },
  // getCourseCOEnrolled: state => { return state.coursesCOEnrolled },
  // getLOsEnrolled: state => { return state.LOsEnrolled },
  getLastViewedDurationbyContentId: function getLastViewedDurationbyContentId(state, getters) {
    return function (contentId) {
      var matchedEnrolledObj = null;
      // alert(getters.getLOsEnrolled.length)
      if (getters.getItemsEnrolledByType('LO').length !== 0) {
        getters.getItemsEnrolledByType('LO').forEach(function (element) {
          // alert(JSON.stringify(element))
          if (element.contentId === contentId && element.watchedOn.length !== 0) {
            matchedEnrolledObj = element;
            // alert(JSON.stringify('null' + element.watchedOn))
            // var watchlenght = element.watchedOn.length
            // return element.watchedOn[watchlenght - 1].duration
          } else {
              // return 0
            }
        });
      }
      if (matchedEnrolledObj !== null && matchedEnrolledObj.watchedOn.length !== 0) {
        var watchlenght = matchedEnrolledObj.watchedOn.length;
        // alert('watch time' + (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60))
        return matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60;
      } else {
        // console.log('return 0')
        return 0;
      }
    };
  },
  /* getLastViewedDurationbyContentId: function (state, getters) {
    return function (contentId) {
      var matchedEnrolledObj = null
      // alert(getters.getLOsEnrolled.length)
      if (getters.getLOsEnrolled.length !== 0) {
        getters.getLOsEnrolled.forEach(element => {
          // alert(JSON.stringify(element))
          if (element.contentId === contentId && element.watchedOn.length !== 0) {
            matchedEnrolledObj = element
            // alert(JSON.stringify('null' + element.watchedOn))
            // var watchlenght = element.watchedOn.length
            // return element.watchedOn[watchlenght - 1].duration
          } else {
            // return 0
          }
        })
      }
      if (matchedEnrolledObj !== null && matchedEnrolledObj.watchedOn.length !== 0) {
        var watchlenght = matchedEnrolledObj.watchedOn.length
        // alert('watch time' + (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60))
        return (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60)
      } else {
        // console.log('return 0')
        return 0
      }
    }
  }, */
  getEnrolledLODataByContentIdProfileId: function getEnrolledLODataByContentIdProfileId(state, getters) {
    // var result = {}
    // console.log(JSON.stringify(getters.getItemsEnrolledByType('LO')))
    if (getters.getItemsEnrolledByType('LO').length !== null) {
      for (var i = 0; i < getters.getItemsEnrolledByType('LO').length; i++) {
        if (getters.getItemsEnrolledByType('LO')[i] !== null) {
          // console.log(JSON.stringify(getters.getItemsEnrolledByType('LO')[i]))
          // console.log(getters.getItemsEnrolledByType('LO')[i].contentId)
          // console.log(getters.getcurrentPlayingContent.contentId)
          if (getters.getItemsEnrolledByType('LO')[i].profileId === getters.getProfileDetails.profileId && getters.getItemsEnrolledByType('LO')[i].contentId === getters.getcurrentPlayingContent.contentId) {
            // console.log(JSON.stringify(getters.getItemsEnrolledByType('LO')[i].expiryDate))
            return getters.getItemsEnrolledByType('LO')[i];
            // console.log(JSON.stringify(result))
          }
        }
      }
    }
  },
  getExpiryDateForNonPurchaseLO: function getExpiryDateForNonPurchaseLO(getters) {
    return function (detailsObj) {
      // console.log(JSON.stringify(detailsObj.LotagList))
      // console.log(JSON.stringify(detailsObj.userAssignedTagList))
      return '';
    };
  }
};
var mutations = {
  // stores all LOs and COs purchased by user on login
  setItemsEnrolled: function setItemsEnrolled(state, data) {
    state.itemsEnrolled = data;
  },
  setProfileDetails: function setProfileDetails(state, data) {
    state.profileDetails = data;
  },
  setProfileID: function setProfileID(state, id) {
    // console.log('setting profile Id')
    if (state.profileDetails === null) {
      state.profileDetails = {};
    }
    state.profileDetails.profileId = id;
  },
  setProfileImg: function setProfileImg(state, imagePath) {
    if (state.profileDetails === null) {
      state.profileDetails = {};
    }
    state.profileDetails.profileImg = imagePath;
  },

  // setCourseEnrolled (state, data) {
  //   state.coursesEnrolled = data
  // },
  // setLOEnrolled (state, data) {
  //   state.LOsEnrolled = data
  // },
  // setCourseCOEnrolled (state, data) {
  //   state.coursesCOEnrolled = data
  // },
  // clearCOEnrolledData (state) {
  //   state.coursesCOEnrolled = []
  //   state.coursesEnrolled = []
  // },
  // clearLOEnrolledData (state) {
  //   state.LOsEnrolled = []
  // },
  clearProfileDetails: function clearProfileDetails(state) {
    state.profileDetails = null;
  },
  clearEnrolledItemsDetails: function clearEnrolledItemsDetails(state) {
    state.itemsEnrolled = [];
  },
  setLinkedAccountsDetailsInStore: function setLinkedAccountsDetailsInStore(state, data) {
    state.profileDetails.accountDetails = data;
  }
};

var actions = {
  addLinkedAccountsDetailsInStore: function addLinkedAccountsDetailsInStore(context, data) {
    var accountDetails = context.getters.getProfileDetails.accountDetails;
    // console.log('b4', JSON.stringify(accountDetails))
    accountDetails.push(data);
    // console.log('aF', JSON.stringify(accountDetails))
    context.commit('setLinkedAccountsDetailsInStore', accountDetails);
  },

  // resets the user display picture
  removeDiplayPictureFromStore: function removeDiplayPictureFromStore(context) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var profileObj = context.getters.getProfileDetails;
      // console.log(JSON.stringify(profileObj))
      // alert(profileObj.profileImg)
      profileObj.profileImg = '';
      context.commit('setProfileDetails', profileObj);
      resolve(true);
    });
  },

  // returns skills of user
  getUserSkillsFromDB: function getUserSkillsFromDB(context, data) {
    // alert(JSON.stringify(data))
    /* var itemIdList = []
    for (let i = 0; i < getters.getItemsEnrolledByType('CO').length; i++) {
      if (getters.getItemsEnrolledByType('CO')[i].allocationDetails.completionPercentage === 100) {
        itemIdList.push({'contentId': getters.getItemsEnrolledByType('CO')[i].contentId})
      }
    } */
    if (data.length !== 0) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/getLoSkills', data).then(function (response) {
          // console.log(JSON.stringify(response.data))
          resolve(response.data);
        }).catch(function (err) {
          console.log('error in getting lo skills from db :', err);
          reject(err);
        });
      });
    }
  },

  // called for saving user profile changes
  saveProfileChanges: function saveProfileChanges(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/r/updateBasicProfile', data).then(function (response) {
        context.dispatch('fetchProfile', context.getters.getProfileDetails.profileId).then(function () {
          resolve();
        }).catch(function (err) {
          console.log('err profile fetched : ', err);
          reject(err);
        });
        // b.in_profileImage = ''
        resolve();
      }).catch(function (error) {
        console.log('error in  saving profile details : ', error);
        reject(error);
      });
    });
  },

  // called for replace file
  replaceFile: function replaceFile(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // console.log(JSON.stringify(data))
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(data.url, data.formData, { headers: { 'Bussiness-Code': data.BussinessCode, 'Client-Code': data.ClientCode } }).then(function (Response) {
        // console.log('success', Response.status)
        resolve(Response);
      }).catch(function (error) {
        console.log('err in store file', error);
        reject(error);
      });
    });
  },

  // called for uploading file
  uploadFile: function uploadFile(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // console.log(JSON.stringify(data))
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(data.url, data.formData, { headers: { 'Bussiness-Code': data.BussinessCode, 'Client-Code': data.ClientCode } }).then(function (Response) {
        // console.log('success', Response.status)
        resolve(Response);
      }).catch(function (error) {
        console.log('err in store file', error);
        reject(error);
      });
    });
  },

  // called for deleting file
  deleteFile: function deleteFile(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(data.url, { url: data.filePath }, { headers: { 'Bussiness-Code': data.BussinessCode, 'Client-Code': data.ClientCode } }).then(function (Response) {
        resolve();
      }).catch(function (error) {
        console.log('error  in deleting file', error);
        reject(error);
      });
    });
  },
  fetchProfile: function fetchProfile(context, data) {
    // console.log('dataReceived' + data)
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/r/getUserProfile', {
        'profileId': data
      }).then(function (res) {
        // console.log('res=>' + JSON.stringify(res.data.items))
        // context.commit('setCartID', res.data.cartId)
        if (res.data.items !== null) {
          context.commit('setProfileDetails', res.data);
        }
        resolve();
      }).catch(function (err) {
        console.log('error viewing', err);
        reject(err);
      });
    });
  },

  /* fetchEnrolledCourses (context, data) {
    // console.log('dataReceived' + data)
    return new Promise((resolve, reject) => {
      axios.post('/r/viewCourseEnrolledData', {
        'profileId': data
      })
      .then(res => {
        if (res.data !== null || res.data.length !== 0) {
          context.commit('setCourseEnrolled', res.data)
        }
        var LOArray = []
        var COArray = []
        if (res.data.items !== null) {
          res.data.forEach(element => {
            if (element.courseType === 'CO') {
              COArray.push(element)
            } else if (element.courseType === 'LO') {
              LOArray.push(element)
            }
            //  this Arrays are used seperately for lo & co
            context.commit('setCourseCOEnrolled', COArray)
            context.commit('setLOEnrolled', LOArray)
          })
          resolve()
        }
      })
      .catch(err => {
        console.log('error viewing', err)
        reject(err)
      })
    })
  }, */
  fetchEnrolledItems: function fetchEnrolledItems(context, data) {
    // console.log('dataReceived' + data)
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/r/viewCourseEnrolledData', {
        'profileId': data
      }).then(function (res) {
        if (res.data !== null || res.data.length !== 0) {
          context.commit('setItemsEnrolled', res.data);
        }
        resolve();
      }).catch(function (err) {
        console.log('error viewing', err);
        reject(err);
      });
    });
  },
  updateProfileItemDuration: function updateProfileItemDuration(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('updateProfileItemDuration', data);
      resolve();
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "PNuO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_footerArea_vue__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profileContent_vue__ = __webpack_require__("gIzc");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',
  components: {
    footerArea: __WEBPACK_IMPORTED_MODULE_1__common_footerArea_vue__["a" /* default */],
    profileContent: __WEBPACK_IMPORTED_MODULE_2__profileContent_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__main_js__["EventBus"].$emit('showNav', false);
  }
});

/***/ }),

/***/ "Pa+M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eclipse.bd947bc.gif";

/***/ }),

/***/ "QBt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recommendation',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  data: function data() {
    return {
      isValidUser: false,
      isActive: false,
      notNextTick: true,
      obj: {},
      items: [],
      coList: [],
      loList: [],
      add: 'Add to Cart',
      itemDescription: 'Coarse is to help you with some basics of HTML',
      itemName: 'HTML5 Demo',
      swiperOption2: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      selected: [], // Must be an array reference!
      options: [{ text: 'Playlist 1', value: 'Playlist 1' }, { text: 'Playlist 2', value: 'Playlist 2' }, { text: 'Playlist 3', value: 'Playlist 3' }, { text: 'Playlist 4', value: 'Playlist 4' }, { text: 'Playlist 5', value: 'Playlist 5' }, { text: 'Playlist 6', value: 'Playlist 6' }]
    };
  },

  methods: {
    goToLogin: function goToLogin() {
      // window.MKCLAPI.login()
      this.$toasted.success(this.$t('common.labels.CART_WISHLIST_WITHOUT_LOGIN'));
      return;
    },
    makePath: function makePath(path) {
      return __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },
    addToWishList: function addToWishList(itemId) {
      var _this = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
          _this.$toasted.success(_this.$t('wishlist.alerts.AddedToWishList'));
        }, function (error) {
          console.error('error in adding item to wishList', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    removeFromWishList: function removeFromWishList(itemId) {
      var _this2 = this;

      this.$swal({
        title: this.$t('wishlist.alerts.RemoveItemConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this2.$store.dispatch('removeWishListFromDb', { profileId: _this2.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
            _this2.$toasted.success(_this2.$t('wishlist.alerts.RemoveItem'));
          }, function (error) {
            console.log('error in removing item from db', error);
          });
        }
      });
    },
    addToCart: function addToCart(id) {
      var _this3 = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
          _this3.$toasted.success(_this3.$t('common.alerts.CART_ADDED_SUCCESS'));
        }, function (error) {
          console.log('error in adding item to cart', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    playLO: function playLO(val) {
      var _this4 = this;

      var LOObj = [];
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/learningobject/getlodatabyitemid', { 'itemId': val.contentId }).then(function (Response) {
          if (Response.status === 200) {
            LOObj = Response.data;
            _this4.$store.dispatch('setCurrentContentViewerPlaylist', LOObj).then(function (response) {
              resolve();
              _this4.$store.dispatch('setIsPlaylist', false).then(function (response) {
                _this4.$router.push('/frames');
              });
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // clear store data
    if (this.$store.getters.getIsLoggedIn) {
      this.$store.dispatch('clearMostWatchedLosFromStore').then(function (response) {}, function (error) {
        console.log('error in clearMostWatchedLosFromStore', error);
      });
    }
  },
  mounted: function mounted() {
    if (this.$store.getters.getIsLoggedIn && this.$store.getters.getProfileDetails.profileId !== undefined && this.$store.getters.getProfileDetails.profileId !== null) {
      // call api to fetch recommeded items from Db to be displayed
      this.$store.dispatch('fetchRecommendedItemsFromDB', { 'profileId': this.$store.getters.getProfileDetails.profileId }).then(function (response) {}, function (error) {
        console.log('error in fetchMostWatchedLosFromDb', error);
      });
    } /* else {
      if (this.$store.getters.getrecommendedItems.length === 0) {
        this.$store.dispatch('fetchMostWatchedLosFromDb').then(
          response => {},
          error => {
            console.log('error in fetchMostWatchedLosFromDb', error)
          }
        )
      }
      } */
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "QHXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder",
    attrs: {
      "id": "library-cards"
    }
  }, [(_vm.$store.getters.getMostWatchedLos !== undefined && _vm.$store.getters.getMostWatchedLos !== null && _vm.$store.getters.getMostWatchedLos.length > 0) ? _c('div', {
    staticClass: "pb-2 row"
  }, [_c('h6', {
    staticClass: "main-title col-12 text-left"
  }, [_vm._v(_vm._s(_vm.$t('libraryCards.labels.most_watched_Videos')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-alert', {
    staticClass: "alert-info",
    attrs: {
      "dismissible": "",
      "show": true
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = true
      }
    }
  }, [_c('strong', [_vm._v("Single Concepts")]), _vm._v(" are videos less than 2 hours in length that explains a single concept.\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getMostWatchedLos !== undefined && _vm.$store.getters.getMostWatchedLos !== null && _vm.$store.getters.getMostWatchedLos.length > 0) ? _c('div', {
    staticClass: "swiper-holder"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_vm._l((_vm.$store.getters.getMostWatchedLos), function(item, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "card-design"
    }, [(item.thumbnail.length != 0) ? _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": _vm.makePath(item.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": "../../../static/assets/images/defaultLO.jpg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [_c('div', {
      staticClass: "lo-label"
    }, [_vm._v(_vm._s(_vm.$t('libraryCards.labels.lo_label')))]), _vm._v(" "), _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(item.price) + " " + _vm._s(item.price > 1 ? 'Points' : 'Point '))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]) : _vm._e(), _vm._v(" "), (parseInt(item.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(item.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(item.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row mt-3"
    }, [(
      (_vm.$store.getters.getItemSubscriptionStatus({
          'id': item.contentId,
          'type': item.type
        }) != undefined &&
        _vm.$store.getters.getItemSubscriptionStatus({
          'id': item.contentId,
          'type': item.type
        }) != null &&
        _vm.$store.getters.getItemSubscriptionStatus({
          'id': item.contentId,
          'type': item.type
        })) ||
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': item.tagList
      }) != undefined &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': item.tagList
      }) != null &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': item.tagList
      })
    ) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.playLO(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_NOW')))])]) : (_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [(_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(item.contentId)) ? _c('button', {
      staticClass: "btn btn-green-alt"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(item.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList && _vm.featureStatusInfoList.wishlist && _vm.$store.getters.getItemPurchasedStatus(item.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(item.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(item.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(item.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(item.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(item.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(item.contentId) != undefined && $store.getters.itemPresentInCartStatus(item.contentId)!= null && !$store.getters.itemPresentInCartStatus(item.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(item.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(item.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(item.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row mt-3"
    }, [(_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList && _vm.featureStatusInfoList.wishlist) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })]) : _vm._e()])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instructorProfile_vue__ = __webpack_require__("C+nI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53bd2c19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_instructorProfile_vue__ = __webpack_require__("SUk2");
function injectStyle (ssrContext) {
  __webpack_require__("wGr/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instructorProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53bd2c19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_instructorProfile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RLDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RO7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "course-review"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col pb-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('course.students_review_about_course')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 pt-2"
  }, [_c('div', {
    staticClass: "star-wrapper"
  }, [_c('div', {
    staticClass: "rating-ptag"
  }, [_c('span', {
    staticClass: "library-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('course.ratings')) + "\n    "), (parseInt(_vm.$store.getters.getCurrentCourse.rating) == 0) ? _c('span', [_c('star-rating', {
    attrs: {
      "rating": parseInt(_vm.$store.getters.getCurrentCourse.rating),
      "read-only": true,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 15
    }
  })], 1) : _c('span', [_c('star-rating', {
    attrs: {
      "rating": parseInt(_vm.$store.getters.getCurrentCourse.rating.toFixed(1)),
      "read-only": true,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 15
    }
  })], 1)])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-8"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-swiper"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOptionReview
    }
  }, _vm._l((10), function(n) {
    return _c('swiper-slide', {
      key: n
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-11 offset-md-1"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row align-items-center"
    }, [_c('div', {
      staticClass: "col-auto"
    }, [_c('div', {
      staticClass: "user-img"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/user.png",
        "width": "100",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 user-name"
    }, [_c('span', [_vm._v(" Student Name")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("12 days to go")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "rating-star"
    }, [_c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star-half-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 description pt-3"
    }, [_vm._v("\n                                    I absolutely loved it - it was about building blocks and I learned a lot quickly. I also liked how we started simple and built on it."), _c('br'), _vm._v("\n                                    I did not find the tic-tac and cards assignments that useful - more data oriented assignments could def. be more useful. In general - awesome.\n                                  ")])])])])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "options": _vm.swiperOptionReview
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev swiper-review-prev",
    slot: "button-prev"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-review-next",
    slot: "button-next"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])])], 1)])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "histo"
  }, [_c('div', {
    staticClass: "histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      5     ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-five"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "four histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      4           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-four"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "three histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      3           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-three"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "two histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      2           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-two"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "one histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      1           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-one"
    }
  })])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RvJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_bannerSearch__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__courseWishList__ = __webpack_require__("Bhfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_newVideoCards__ = __webpack_require__("q9mY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_trendingCourses__ = __webpack_require__("8bW+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wishlist',
  components: {
    bannerSearch: __WEBPACK_IMPORTED_MODULE_2__components_home_bannerSearch__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_4__components_home_courseCards__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default.a,
    courseWishlist: __WEBPACK_IMPORTED_MODULE_3__courseWishList__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_5__components_home_libraryCards__["a" /* default */],
    newVideoCards: __WEBPACK_IMPORTED_MODULE_6__components_home_newVideoCards__["a" /* default */],
    trendingCourses: __WEBPACK_IMPORTED_MODULE_7__components_home_trendingCourses__["a" /* default */]
  },
  data: function data() {
    return {
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    };
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$emit('showNav', true);
  },

  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.globalState = $state;
      setTimeout(function () {
        _this.showTrendingCard = true;
        // this.showLibraryCard = true
        $state.loaded();
      }, 2000);
    },

    // handleScroll - handles scrolling
    handleScroll: function handleScroll() {
      var _this2 = this;

      if (this.showTrendingCard && !this.showLibraryCard) {
        setTimeout(function () {
          _this2.showLibraryCard = true;
          if (_this2.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this2.globalState.complete();
          }
        }, 2000);
      } else if (this.showTrendingCard && this.showLibraryCard) {
        setTimeout(function () {
          _this2.showNewVideoCard = true;
          if (_this2.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this2.globalState.complete();
          }
        }, 2000);
      }
    }
  }
});

/***/ }),

/***/ "SUfU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SUk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instructor-profile section-holder"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('instructor_profile.course_taught_by')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "user-details"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.$t('instructor_profile.instructor_name')))]), _vm._v(" "), _c('div', {
    staticClass: "user-title"
  }, [_vm._v(_vm._s(_vm.$t('instructor_profile.designation')))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "user-title"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('instructor_profile.view_profile')) + " ")])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/user.png",
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rating-star"
  }, [_c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star-half",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" (234 votes)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sj1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('banner-search'), _vm._v(" "), _c('div', {
    staticClass: "content-holder"
  }, [(_vm.showTrendingCard) ? _c('trendingCourses') : _vm._e(), _vm._v(" "), _c('div', [(_vm.showLibraryCard) ? _c('libraryCards') : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.showNewVideoCard) ? _c('newVideoCards') : _vm._e()], 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T5Nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cartContent_vue__ = __webpack_require__("KxOz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fb86e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_cartContent_vue__ = __webpack_require__("5+FY");
function injectStyle (ssrContext) {
  __webpack_require__("Alzq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cartContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fb86e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_cartContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TYun":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U1bo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseReview_vue__ = __webpack_require__("NTYh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d01d8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseReview_vue__ = __webpack_require__("RO7/");
function injectStyle (ssrContext) {
  __webpack_require__("BPWz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseReview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d01d8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseReview_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U5lF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__("424j");




// import swal from 'sweetalert'

var wishListData = [];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var state = {
  wishList: []
};
var getters = {
  // returns the filltered wishList content
  getWishListDataMatchingKeyWord: function getWishListDataMatchingKeyWord(state, getters) {
    return function (keyWord) {
      var result = [];
      if (keyWord.length === 0) {
        result = getters.getWishListStoreData;
      } else {
        result = getters.getWishListStoreData.filter(function (obj) {
          return obj.itemName.toLowerCase().includes(keyWord.toLowerCase());
        });
      }
      return result;
    };
  },
  // returns True or False depending on whether item is present in wishList
  itemPresentInWishListStatus: function itemPresentInWishListStatus(state, getters) {
    return function (itemId) {
      for (var i = 0; i < getters.getWishListStoreData.length; i++) {
        if (getters.getWishListStoreData[i].itemId === itemId) {
          return true;
        }
      }
      return false;
    };
  },
  // returns only those items present in wishList and not in cart
  getWishListDataNotPresentInCart: function getWishListDataNotPresentInCart(state, getters) {
    return function (searchParameters) {
      wishListData = [];
      getters.getWishListStoreData.forEach(function (element) {
        var isExist = false;
        searchParameters.items.forEach(function (element1) {
          if (element1.itemId === element.itemId) {
            isExist = true;
          }
        });
        if (!isExist) {
          wishListData.push(element);
        }
      });
      return wishListData;
    };
  },
  // returns data present in wishList
  getWishListStoreData: function getWishListStoreData(state) {
    return state.wishList;
  }
};
var actions = {
  insertWishListInDb: function insertWishListInDb(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('r/addWishListItems', {
        'profileId': data.profileId, 'itemId': data.itemId
      }).then(function (response) {
        context.commit('setWishListStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },
  removeWishListFromDb: function removeWishListFromDb(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('r/deleteWishListItems', {
        'profileId': data.profileId, 'itemId': data.itemId
      }).then(function (response) {
        // alert(JSON.stringify(response.data))
        context.commit('setWishListStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },
  getWishListFromDb: function getWishListFromDb(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('r/viewWishListItems', {
        'profileId': data
      }).then(function (response) {
        context.commit('setWishListStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  },
  resetWishListInStore: function resetWishListInStore(context) {
    context.commit('clearWishListStoreData');
  }
};
var mutations = {
  setWishListStoreData: function setWishListStoreData(state, data) {
    if (data === null) {
      state.wishList = [];
    } else {
      state.wishList = data;
    }
  },
  clearWishListStoreData: function clearWishListStoreData(state) {
    state.wishList = [];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "UKJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



// import lodash from 'lodash'
var state = {
  currentPlayingcontent: null,
  currentContentPath: null,
  showLoader: false,
  isPlaylist: false,
  showNext: true,
  showPrevious: false,
  currentContentViewerPlaylist: [],
  previousHitTime: 0,
  isPurchase: false,
  previousContentData: {}
};
var getters = {
  getcurrentPlayingContent: function getcurrentPlayingContent(state) {
    return state.currentPlayingcontent;
  },
  getCurrentContentPath: function getCurrentContentPath(state, getters) {
    return function (languageId) {
      for (var i = 0; i < getters.getcurrentPlayingContent.path.length; i++) {
        if (getters.getcurrentPlayingContent.path[i].languageId === languageId) {
          return getters.getcurrentPlayingContent.path[i].filePath;
        }
      }
      // return state.currentPlayingcontent.path[0].filePath
    };
  },
  getLoaderStatus: function getLoaderStatus(state) {
    return state.showLoader;
  },
  getIsplaylist: function getIsplaylist(state) {
    return state.isPlaylist;
  },
  getShowNextStatus: function getShowNextStatus(state) {
    return state.showNext;
  },
  getShowPreviousStatus: function getShowPreviousStatus(state) {
    return state.showPrevious;
  },
  getCurrentContentViewerPlaylist: function getCurrentContentViewerPlaylist(state) {
    return state.currentContentViewerPlaylist;
  },
  getContentById: function getContentById(state, getters) {
    return function (contentId) {
      // console.log(contentId)
      if (getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < getters.getCurrentContentViewerPlaylist.length; i++) {
          if (getters.getCurrentContentViewerPlaylist[i].contentId === contentId) {
            return getters.getCurrentContentViewerPlaylist[i];
          }
        }
      }
    };
  },
  getPreviousHitTime: function getPreviousHitTime(state) {
    return state.previousHitTime;
  },
  getIsPurchase: function getIsPurchase(state, getters) {
    return function (itemId) {
      var result = false;
      if (getters.getProfileDetails !== null) {
        for (var i = 0; i < getters.getItemsEnrolledByType('LO').length; i++) {
          if (getters.getItemsEnrolledByType('LO')[i].contentId === itemId) {
            result = true;
          }
        }
        return result;
      }
    };
  },
  /* getIsPurchase: (state, getters) => itemId => {
    var result = false
    if (getters.getProfileDetails !== null) {
      for (var i = 0; i < getters.getLOsEnrolled.length; i++) {
        if (getters.getLOsEnrolled[i].contentId === itemId) {
          result = true
        }
      }
      return result
    }
  }, */
  getPreviousContent: function getPreviousContent(state) {
    return state.previousContentData;
  },
  getSearchPlaylistLO: function getSearchPlaylistLO(state, getters) {
    return function (inputString) {
      var result = [];
      if (inputString !== '') {
        result = getters.getCurrentContentViewerPlaylist.filter(function (obj) {
          return obj.title.toLowerCase().includes(inputString.toLowerCase());
        });
      } else {
        result = getters.getCurrentContentViewerPlaylist;
      }
      return result;
    };
  }
};
var mutations = {
  setCurrentPlayingContent: function setCurrentPlayingContent(state, data) {
    state.currentPlayingcontent = data;
  },
  setLoaderStatus: function setLoaderStatus(state, data) {
    state.showLoader = data;
  },
  setIsPlaylist: function setIsPlaylist(state, data) {
    state.isPlaylist = data;
  },
  setShowNext: function setShowNext(state, data) {
    state.showNext = data;
  },
  setShowPrevious: function setShowPrevious(state, data) {
    state.showPrevious = data;
  },
  setCurrentContentViewerPlaylist: function setCurrentContentViewerPlaylist(state, data) {
    state.currentContentViewerPlaylist = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].type === 'LO') {
        state.currentContentViewerPlaylist.push(data[i]);
      }
    }
  },
  setPreviousHitTime: function setPreviousHitTime(state, data) {
    state.previousHitTime = data;
  },
  setPreviousContent: function setPreviousContent(state, data) {
    state.previousContentData = data;
  },
  setCurrentLanguage: function setCurrentLanguage(state, data) {
    // console.log('mutations call')
    state.currentLanguageId = data;
  }
};

var actions = {
  // get item purchase status
  // 3 response : ITEM_NOT_PURCHASED_BY_USER, VIEW_LIMIT_CROSSED, ITEM_NOT_EXPIRED
  getPurchaseStatus: function getPurchaseStatus(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/viewItemValidityStatus', data).then(function (response) {
        /* if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
          this.isPurchase = false
        }
        if (response.data === 'VIEW_LIMIT_CROSSED') {
          this.isPurchase = false
          this.showViewCountExhaustedMsg = true
        }
        if (response.data === 'ITEM_NOT_EXPIRED') {
          this.isPurchase = true
        } */
        resolve(response);
      }).catch(function (err) {
        console.log('error in getting purchase status : ', err);
        reject(err);
      });
    });
  },

  // updates the watch count of LO
  updatelowatchcount: function updatelowatchcount(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/contentviewer/updatelowatchcount', data).then(function (response) {
        resolve();
      }).catch(function (err) {
        console.log('error in updatelowatchcount : ', err);
        reject();
      });
    });
  },

  // shows rating
  showRating: function showRating(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/r/rating/addratingdata', data).then(function (response) {
        resolve();
      }).catch(function (error) {
        // this.$toasted.error(error)
        console.log('error in showing rating : ', error);
        reject(error);
      });
    });
  },
  setCurrentPlayingContent: function setCurrentPlayingContent(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      context.commit('setCurrentPlayingContent', data);
      resolve();
    }).catch(function (error) {
      // this.$toasted.error(error)
      console.log('error in showing rating12345678 : ', error);
      // reject(error)
    });
    // context.commit('setCurrentPlayingContent', data)
  },
  setLoaderStatus: function setLoaderStatus(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setLoaderStatus', data);
      resolve();
    });
  },
  setIsPlaylist: function setIsPlaylist(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setIsPlaylist', data);
      resolve();
    });
  },
  updatePlaylistItemDuration: function updatePlaylistItemDuration(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('updatePlaylistItemDuration', data);
      resolve();
    });
  },
  setShowNext: function setShowNext(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setShowNext', data);
      resolve();
    });
  },
  setShowPrevious: function setShowPrevious(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setShowPrevious', data);
      resolve();
    });
  },
  setCurrentContentViewerPlaylist: function setCurrentContentViewerPlaylist(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setCurrentContentViewerPlaylist', data);
      resolve();
    });
  },
  setPreviousHitTime: function setPreviousHitTime(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setPreviousHitTime', data);
      resolve();
    });
  },
  setPreviousContent: function setPreviousContent(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setPreviousContent', data);
      resolve();
    });
  },
  setCurrentLang: function setCurrentLang(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      // console.log('action call')
      context.commit('setCurrentLanguage', data);
      resolve();
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "UkLu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shareOnMedia',
  props: ['item', 'labelOnTop'],
  data: function data() {
    return {
      shareBaseUrl: __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["t" /* SHARE_ON_MEDIA_URL */]
    };
  }
});

/***/ }),

/***/ "V2Ez":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3cl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vg5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_bannerSearch__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__searchCardsAlt__ = __webpack_require__("ZIc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_newVideoCards__ = __webpack_require__("q9mY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_searchPage_loadercss__ = __webpack_require__("nILK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_trendingCourses_vue__ = __webpack_require__("8bW+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchPageAlt',
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default.a,
    bannerSearch: __WEBPACK_IMPORTED_MODULE_2__components_home_bannerSearch__["a" /* default */],
    newVideoCards: __WEBPACK_IMPORTED_MODULE_6__components_home_newVideoCards__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_4__components_home_courseCards__["a" /* default */],
    searchCardsAlt: __WEBPACK_IMPORTED_MODULE_3__searchCardsAlt__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_5__components_home_libraryCards__["a" /* default */],
    loadercss: __WEBPACK_IMPORTED_MODULE_7__components_searchPage_loadercss__["a" /* default */],
    trendingCourses: __WEBPACK_IMPORTED_MODULE_8__components_home_trendingCourses_vue__["a" /* default */]
  },
  data: function data() {
    return {
      textPreviouslySearched: '',
      globalState: '',
      showTrendingCards: false,
      showLibraryCards: false,
      showNewVideoCards: false,
      continueScrolling: true
    };
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  // `created () {
  //   // alert(this.$route.params.search)
  // },`
  methods: {
    handleScroll: function handleScroll() {
      var _this = this;

      if (this.showTrendingCards && !this.showLibraryCards) {
        // console.log('in if')
        setTimeout(function () {
          _this.showLibraryCards = true;
          // this.showSection = true
          if (_this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            // this.globalState.complete()
            _this.globalState.loaded();
          }
        }, 2000);
      } else if (this.showTrendingCards && this.showLibraryCards) {
        // console.log('in else')
        setTimeout(function () {
          _this.showNewVideoCards = true;
          // this.showSection = true
          if (_this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this.globalState.complete();
          }
        }, 2000);
      }
      if (this.$store.getters.getSearchType === 'all') {
        if (this.showTrendingCards && this.showLibraryCards && this.showNewVideoCards) {
          this.continueScrolling = false;
        }
      } else if (this.$store.getters.getSearchType === 'LO') {
        if (this.showLibraryCards && this.showNewVideoCards) {
          this.continueScrolling = false;
        }
      } else if (this.$store.getters.getSearchType === 'CO') {
        if (this.showTrendingCards) {
          this.continueScrolling = false;
        }
      }
    },
    infiniteHandler1: function infiniteHandler1($state) {
      var _this2 = this;

      // alert(123?)
      this.globalState = $state;
      setTimeout(function () {
        _this2.showTrendingCards = true;
        $state.loaded();
      }, 2000);
    },
    checkTokenValidity: function checkTokenValidity() {
      var home = this;
      var token = window.MKCLAPI.getToken();
      if (token !== undefined && token !== null) {
        window.MKCLAPI.isTokenValid(token).then(function () {
          // token is valid
        }).catch(function () {
          home.$store.dispatch('clearUserData');
          window.MKCLAPI.removeToken();
        });
      }
    }
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__main_js__["gAnalysis"])();
    // var x1 = Math.floor(document.getElementById('searchBox').getBoundingClientRect().top)
    // var x2 = Math.floor(document.getElementById('example-text-input').getBoundingClientRect().top)
    // var displacement = Math.floor(document.getElementById('example-text-input').getBoundingClientRect().top) - ((x2 - x1) / 2)
    // window.scrollTo(0, displacement)
    __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$emit('showNav', true);
  },
  created: function created() {
    this.textPreviouslySearched = this.$route.params.search;
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "Voaj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WE48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-list section-holder container"
  }, [_c('div', {
    staticClass: "row pb-4 justify-content-end"
  }, [_c('h6', {
    staticClass: "col-md-6 text-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('course.course_description')))])]), _vm._v(" "), _c('h6', {
    staticClass: "col-md-6 text-right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('download_syllabus')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2 video-col"
  }, [_c('video', {
    staticClass: "video-css",
    attrs: {
      "poster": "../../static/assets/images/8.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": __webpack_require__("n/uR"),
      "type": "video/mp4"
    }
  }), _vm._v("\r\n                    " + _vm._s(_vm.$t('common.errors.videoTagError')) + "\r\n                ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2 video-col"
  }, [_c('video', {
    staticClass: "video-css",
    attrs: {
      "width": "100%",
      "height": "240",
      "poster": "../../static/assets/images/ref2.png"
    }
  }, [_c('source', {
    attrs: {
      "src": __webpack_require__("n/uR"),
      "type": "video/mp4"
    }
  }), _vm._v("\r\n                     " + _vm._s(_vm.$t('common.errors.videoTagError')) + "\r\n                ")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "play-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-play-circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7 description"
  }, [_c('h5', [_vm._v("Topic1")]), _vm._v(" "), _c('p', [_vm._v("What is user going to learn in this topic, what are the take aways from this topic.\r\n                    A short note about the topic"), _c('br'), _vm._v("What is user going to learn in this topic, what are the take aways from this topic\r\n                    A short note about the topic\r\n                ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "play-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-play-circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7 description"
  }, [_c('h5', [_vm._v("Topic1")]), _vm._v(" "), _c('p', [_vm._v("What is user going to learn in this topic, what are the take aways from this topic.\r\n                    A short note about the topic"), _c('br'), _vm._v("What is user going to learn in this topic, what are the take aways from this topic\r\n                    A short note about the topic\r\n                ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X2Tg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseWishlist',
  data: function data() {
    return {
      profileId: this.$store.getters.getProfileDetails.profileId,
      keyWord: ''
    };
  },

  methods: {
    clearUserWishList: function clearUserWishList() {
      var _this = this;

      this.$swal({
        title: 'Do yo want to remove all the items from wishList ?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/clearUserWishList', { 'profileId': _this.$store.getters.getProfileDetails.profileId }).then(function (res) {
              if (res.status === 200) {
                _this.$store.dispatch('resetWishListInStore').then(function (res) {
                  _this.$toasted.success('wishList emptied');
                  resolve();
                }, function (err) {
                  console.log('ERROR_IN_RESETING_STORE : ', err);
                  reject();
                });
              } else {
                reject();
              }
            }).catch(function (err) {
              console.log('ERROR_IN_CLEARING_WISHLIST : ', err);
              _this.$toasted.success('Something went wrong');
              reject();
            });
          });
        }
      });
    },
    makePath: function makePath(path, type) {
      if (path.length !== 0) {
        return __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
        // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
      } else {
        if (type === 'CO') {
          return '../../../static/assets/images/defaultCO.jpg';
        } else if (type === 'LO') {
          return '../../../static/assets/images/defaultLO.jpg';
        }
      }
    },
    removeDataFromWishList: function removeDataFromWishList(profileId, itemId) {
      var _this2 = this;

      this.$swal({
        title: this.$t('wishlist.alerts.RemoveItemConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this2.$store.dispatch('removeWishListFromDb', { profileId: profileId, itemId: itemId }).then(function (response) {
            _this2.$toasted.success(_this2.$t('wishlist.alerts.RemoveItem'));
          }, function (error) {
            console.log('error in removing item from db', error);
          });
        }
      });
    },
    addToCart: function addToCart(id) {
      var _this3 = this;

      this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
        _this3.$toasted.success(_this3.$t('common.alerts.CART_ADDED_SUCCESS'));
      }, function (error) {
        _this3.$toasted.error(_this3.$t('common.errors.CartItemAddError'));
        console.log('error in adding item to cart', error);
      });
      // this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: id })
    },
    moveAllToCart: function moveAllToCart(obj) {
      var _this4 = this;

      var _loop = function _loop(i) {
        _this4.$store.dispatch('addCartData', { itemId: obj[i].itemId, profileId: _this4.$store.getters.getProfileDetails.profileId, cartId: _this4.$store.getters.getCartData.cartId }).then(function (response) {
          if (i === obj.length - 1) {
            _this4.$toasted.success(_this4.$t('common.alerts.ALL_CART_ADDED_SUCCESS'));
          }
        }, function (error) {
          _this4.$toasted.error(_this4.$t('common.errors.CartItemAddError'));
          console.log('error in adding item to cart', error);
        });
        // this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: obj[i].itemId })
      };

      for (var i = 0; i < obj.length; i++) {
        _loop(i);
      }
    },
    cartAdd: function cartAdd(itemId) {
      if (this.$store.getters.getCartData.items !== undefined && this.$store.getters.getCartData.items !== null) {
        for (var j = 0; j < this.$store.getters.getCartData.items.length; j++) {
          if (this.$store.getters.getCartData.items[j].itemId === itemId) {
            return true;
          }
        }
      }
      return false;
    }
  },
  created: function created() {
    // alert('in created')
    this.$store.dispatch('getWishListFromDb', this.profileId);
    // alert('after')
    // alert(JSON.stringify(this.wishListData))
  }
});

/***/ }),

/***/ "Y0XU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y1BO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YAMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'walletCards',
  components: {},
  data: function data() {
    return {
      amount: 0,
      search: '',
      walletId: '',
      amountToAdd: '',
      walletTransList: [],
      activityList: [],
      upsString: '',
      url: __WEBPACK_IMPORTED_MODULE_1__common_constants_js__["q" /* PAYMENT_REQUEST_URL */],
      transactionTime: '',
      searchFor: true
    };
  },
  created: function created() {
    this.getWalletAmount();
    this.getActivities();
  },

  methods: {
    addMoney: function addMoney() {
      var _this = this;

      if (this.amountToAdd === '' || this.amountToAdd <= '0') {
        this.$toasted.error(this.$t('wallet.alerts.EnterValidAmount'));
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/wallet/purchaseHistory', {
        profileId: this.$store.getters.getProfileDetails.profileId,
        walletId: this.walletId,
        totalAmount: parseInt(this.amountToAdd)
      }).then(function (res) {
        if (res.data !== '') {
          _this.upsString = res.data;
          _this.submitUpsForm();
          // this.getWalletAmount()
        } else {
          alert('Error');
        }
      }).catch(function (err) {
        console.log('Error in Updating wallet Amount', err);
      });
    },
    submitUpsForm: function submitUpsForm() {
      // console.log('this.upsString >> ' + this.upsString)
      document.getElementById('someId').value = this.upsString;
      document.getElementById('upsForm').submit();
    },
    getWalletAmount: function getWalletAmount() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/wallet/getWalletDetailsbyUser', {
          profileId: _this2.$store.getters.getProfileDetails.profileId
        }).then(function (res) {
          _this2.amount = res.data.totalAmount;
          _this2.walletId = res.data.walletId;
          resolve(_this2.amount);
        }).catch(function (err) {
          console.log('Error in getting Wallet details', err);
          reject();
        });
      });
      // return this.amount
    },
    getTransactionData: function getTransactionData() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/walletTransaction/getUserWalletTransactions', {
          profileId: _this3.$store.getters.getProfileDetails.profileId,
          walletId: _this3.walletId
        }).then(function (res) {
          _this3.searchFor = false;
          _this3.walletTransList = res.data;
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reverse(_this3.walletTransList);
          resolve();
        }).catch(function (err) {
          console.log('Error in Getting Transaction Data', err);
          reject();
        });
      });
    },
    getActivities: function getActivities() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/GetLOActivityRoute', {
          profileId: _this4.$store.getters.getProfileDetails.profileId
        }).then(function (res) {
          _this4.searchFor = true;
          _this4.activityList = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(res.data, 'recentTime', 'desc');
          resolve();
        }).catch(function (err) {
          console.log('Error in Getting Activities Data', err);
          reject();
        });
      });
    }
  },
  computed: {
    filteredWalletList: function filteredWalletList() {
      var _this5 = this;

      return this.walletTransList.filter(function (wallet) {
        return wallet.status.toLowerCase().includes(_this5.search.toLowerCase()) || wallet.cartId.toLowerCase().includes(_this5.search.toLowerCase());
      });
    },
    filteredActivityList: function filteredActivityList() {
      var _this6 = this;

      return this.activityList.filter(function (activity) {
        return activity.title.toLowerCase().includes(_this6.search.toLowerCase());
      });
    }
  }
});

/***/ }),

/***/ "YTfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "confirm-css"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cartid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-link', {
    attrs: {
      "to": {
        name: 'cart'
      }
    }
  }, [_vm._v("\n                  Back\n                ")]), _vm._v(" "), _c('span', [_vm._v("Transaction ID - " + _vm._s(this.$route.params.cartId))])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "bal"
  }, [_vm._v(_vm._s(this.amount))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.alerts.POINTS_IN_WALLET')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "bal"
  }, [_vm._v(" " + _vm._s(this.total1) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.Total_Points_Need_To_Purchase')))])])]), _vm._v(" "), _c('div', {
    staticClass: "addmoney"
  }, [(_vm.amount != undefined && _vm.total1 != undefined && _vm.amount != null && _vm.total1 != null && _vm.amount >= _vm.total1) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-blue btn-payment btn-large btn-responsive",
    attrs: {
      "id": "button"
    },
    on: {
      "click": function($event) {
        _vm.paymentGateway()
      }
    }
  }, [_vm._v("Proceed to Payment")])]) : _c('div', {
    staticClass: "col-10 text-center align-self-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.total1),
      expression: "total1"
    }],
    staticClass: "form-control col",
    attrs: {
      "type": "number",
      "placeholder": "Enter amount to add"
    },
    domProps: {
      "value": (_vm.total1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.total1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-radius btn-blue btn-large ",
    on: {
      "click": function($event) {
        _vm.addMoney()
      }
    }
  }, [_vm._v("Add Money")]), _vm._v(" "), _c('h6', [_vm._v("On clicking the \"add Money\" button you will be redirected to our payment gateway")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length > 0) ? _c('courseWishlist') : _vm._e()], 1), _vm._v(" "), _c('form', {
    attrs: {
      "action": _vm.url,
      "method": "POST",
      "id": "upsForm",
      "name": "upsForm"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upsString),
      expression: "upsString"
    }],
    attrs: {
      "name": "upsString",
      "type": "hidden",
      "id": "someId"
    },
    domProps: {
      "value": (_vm.upsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upsString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "reqFrom",
      "value": "goLang",
      "type": "hidden"
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_course_coursePage__ = __webpack_require__("mH3w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_searchPage_searchPageAlt__ = __webpack_require__("EpJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_home__ = __webpack_require__("LqM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cart_cart__ = __webpack_require__("jzGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_wallet__ = __webpack_require__("sBpB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profile_profile__ = __webpack_require__("MxVX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_course_allCourses__ = __webpack_require__("aYcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_wishList_wishList__ = __webpack_require__("6BFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_myCourses_myCourses__ = __webpack_require__("7FMw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_playList_playlist__ = __webpack_require__("Dq3d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_contentViewer_frames__ = __webpack_require__("0SGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cart_confirmation__ = __webpack_require__("3Es0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_cart_success__ = __webpack_require__("NIRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_logout_liveDemyLogout__ = __webpack_require__("hL9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_advertisement_advertisementPage__ = __webpack_require__("9eHO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_mobileHome__ = __webpack_require__("pA/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_mahademyHome__ = __webpack_require__("lIyY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_toasted__);





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_toasted___default.a, {
  duration: 3200,
  theme: 'primary'
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/coursePage/:contentId/:title?',
    name: 'coursePage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_course_coursePage__["a" /* default */],
    meta: { requireAuth: false }
  }, {
    path: '/advertisement',
    name: 'advertisementPage',
    component: __WEBPACK_IMPORTED_MODULE_16__components_advertisement_advertisementPage__["a" /* default */],
    meta: { requireAuth: false }
  }, {
    path: '/cart',
    name: 'cart',
    component: __WEBPACK_IMPORTED_MODULE_5__components_cart_cart__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_home_home__["a" /* default */],
    meta: { requireAuth: false }
  }, {
    path: '/searchPageAlt',
    name: 'searchPageAlt',
    component: __WEBPACK_IMPORTED_MODULE_3__components_searchPage_searchPageAlt__["a" /* default */],
    meta: { requireAuth: false }
  }, {
    path: '/wallet',
    name: 'wallet',
    component: __WEBPACK_IMPORTED_MODULE_6__components_wallet_wallet__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/profile',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_7__components_profile_profile__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/allCourses',
    name: 'allCourses',
    component: __WEBPACK_IMPORTED_MODULE_8__components_course_allCourses__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/wishList',
    name: 'wishList',
    component: __WEBPACK_IMPORTED_MODULE_9__components_wishList_wishList__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/mycourses',
    name: 'myCourses',
    component: __WEBPACK_IMPORTED_MODULE_10__components_myCourses_myCourses__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/playlist',
    name: 'playlist',
    component: __WEBPACK_IMPORTED_MODULE_11__components_playList_playlist__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/frames',
    name: 'frames',
    component: __WEBPACK_IMPORTED_MODULE_12__components_contentViewer_frames__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/confirmation',
    name: 'confirmation',
    component: __WEBPACK_IMPORTED_MODULE_13__components_cart_confirmation__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/success/:transactionId/:amount/:status',
    name: 'success',
    component: __WEBPACK_IMPORTED_MODULE_14__components_cart_success__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/livedemylogout',
    name: 'liveDemyLogout',
    component: __WEBPACK_IMPORTED_MODULE_15__components_logout_liveDemyLogout__["a" /* default */],
    meta: { requireAuth: false }
  }, {
    path: '/mobileHome/:token',
    name: 'mobileHome',
    component: __WEBPACK_IMPORTED_MODULE_17__components_mobileHome__["a" /* default */],
    meta: { requireAuth: true }
  }, {
    path: '/mahademyHome/:token',
    name: 'mahademyHome',
    component: __WEBPACK_IMPORTED_MODULE_18__components_mahademyHome__["a" /* default */],
    meta: { requireAuth: true }
  }]
}));

/***/ }),

/***/ "Ycb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_walletCards_vue__ = __webpack_require__("YAMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1852e9b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_walletCards_vue__ = __webpack_require__("bNYp");
function injectStyle (ssrContext) {
  __webpack_require__("If75")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_walletCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1852e9b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_walletCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yu1t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerArea_vue__ = __webpack_require__("4tQt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd0a41f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_footerArea_vue__ = __webpack_require__("PK6y");
function injectStyle (ssrContext) {
  __webpack_require__("sD0W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cd0a41f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd0a41f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_footerArea_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yv+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Multiselect__ = __webpack_require__("zK0k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiselectMixin__ = __webpack_require__("C+QQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pointerMixin__ = __webpack_require__("DqTG");
/* unused harmony reexport Multiselect */
/* unused harmony reexport multiselectMixin */
/* unused harmony reexport pointerMixin */




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Multiselect__["a" /* default */]);



/***/ }),

/***/ "ZIc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchCardsAlt_vue__ = __webpack_require__("phBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30702e79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_searchCardsAlt_vue__ = __webpack_require__("6Ha2");
function injectStyle (ssrContext) {
  __webpack_require__("Y0XU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchCardsAlt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30702e79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_searchCardsAlt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZNv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-page"
  }, [_c('cartContent'), _vm._v(" "), (_vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length > 0) ? _c('courseWishlist') : _vm._e(), _vm._v(" "), (_vm.showTrendingCard && _vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length == 0 && _vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('trendingCourses') : _vm._e(), _vm._v(" "), (_vm.showTrendingCard && _vm.showLibraryCard && _vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length == 0 && _vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('libraryCards') : _vm._e(), _vm._v(" "), (_vm.showLibraryCard && _vm.showLibraryCard && _vm.showNewVideoCard && _vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length == 0 && _vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('newVideoCards') : _vm._e(), _vm._v(" "), ((_vm.$store.getters.getCartData.items !== undefined && _vm.$store.getters.getCartData.items !== null && _vm.$store.getters.getCartData.items.length == 0) && (_vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0)) ? _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ze7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-login",
    class: {
      onn: _vm.scrollPosition > 41
    }
  }, [(_vm.blockUi) ? _c('BlockUI', {
    attrs: {
      "message": _vm.msg,
      "url": _vm.url
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "topnav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center py-2"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "col-md-8 offers"
  }, [(_vm.checkOffer()) ? _c('div', [(_vm.$store.getters.getOffers !== undefined && _vm.$store.getters.getOffers !== null && _vm.$store.getters.getOffers.length == 1) ? _c('div', [_c('a', [_vm._v("\n                " + _vm._s(_vm.$store.getters.getOffers[0].offerTitle) + " "), _c('strong', [_vm._v("OFFER CODE : ")]), _vm._v(" " + _vm._s(_vm.$store.getters.getOffers[0].offerCode) + "\n              ")])]) : _c('div', [_c('b', [_c('span', [_vm._v(_vm._s(_vm.$t('offers.new_offers_available_soon')))])])])]) : _c('div', [_c('b', [_c('span', [_vm._v(_vm._s(_vm.$t('offers.new_offers_available_soon')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn !== undefined && _vm.isLoggedIn !== null && _vm.isLoggedIn) ? _c('div', {
    staticClass: "col-md-4 user-links ml-auto"
  }, [_c('span', {
    staticClass: "nav-t"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'myCourses'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.MyCourses')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'playlist'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.labels.MyPlaylist')))]) : _vm._e(), _vm._v(" "), (_vm.isMobileDevice()) ? _c('b-btn', {
    staticClass: "router-link",
    on: {
      "click": _vm.goOffline
    }
  }, [_vm._v("Go Offline")]) : _vm._e()], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg"
    }
  }, [_c('div', {
    staticClass: "row no-gutters align-items-center"
  }, [(_vm.instanceName === 'mfslivedemy') ? _c('div', {
    staticClass: "col col-lg-3 mfs-logo"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/mfs-logo.png",
      "alt": "mfslivedemy"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'MAHADEMY') ? _c('div', {
    staticClass: "col col-lg-3 maha-demy"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/mahademylogo.png",
      "alt": "MAHADEMY"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'LIVEDEMY') ? _c('div', {
    staticClass: "col col-lg-3"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/livedemy-logo-1.png",
      "alt": "LIVEDEMY"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-block d-md-none"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-collapse"
  }, [_c('b-collapse', {
    staticClass: "justify-content-center",
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [(_vm.checkNavStatus()) ? _c('div', {
    staticClass: "m-links-holder"
  }, [_c('div', {
    staticClass: "menu-links"
  }, [_c('span', {
    class: _vm.$store.getters.getSearchType === 'all' ? 'active' : 'inActive',
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        _vm.goToSearchPage('allBtn')
      },
      "focus": function($event) {
        _vm.goToSearchPage('allBtn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.All')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('span', {
    class: _vm.$store.getters.getSearchType === 'CO' ? 'active' : 'inActive',
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": function($event) {
        _vm.goToSearchPage('courseBtn')
      },
      "focus": function($event) {
        _vm.goToSearchPage('courseBtn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.check_courses')))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('span', {
    class: _vm.$store.getters.getSearchType === 'LO' ? 'active' : 'inActive',
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        _vm.goToSearchPage('libraryBtn')
      },
      "focus": function($event) {
        _vm.goToSearchPage('libraryBtn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.surf_library')))]) : _vm._e()])]) : _c('div', {
    staticClass: "m-search-holder"
  }, [_c('Autocomplete', {
    ref: "txt_search",
    attrs: {
      "resetAfter": false,
      "openDirection": "bottom",
      "searchable": true,
      "value": _vm.searchText,
      "preserveSearch": true,
      "selectLabel": "Search",
      "deselectLabel": "Search",
      "selectedLabel": "Search",
      "tag-placeholder": "Search",
      "taggable": true,
      "optionsLimit": 5,
      "placeholder": _vm.$t('common.labels.SearchPlaceHolder'),
      "options": _vm.suggestions,
      "id": "example-text-input"
    },
    on: {
      "tag": _vm.addTag,
      "search-change": _vm.getSuggestions,
      "select": _vm.onSearch,
      "remove": _vm.onSearch
    }
  }), _vm._v(" "), (_vm.loading !== undefined && _vm.loading !== null && _vm.loading && !_vm.checkNavStatus()) ? _c('div', {
    staticClass: "ms-loader"
  }, [_c('div', {
    staticClass: "loader-dr"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.loading')))])]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-3"
  }, [_c('div', {
    staticClass: "h-right"
  }, [(_vm.isLoggedIn) ? _c('div', {
    staticClass: "h-user"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "icons-css"
  }, [(_vm.featureList && _vm.featureList.wishlist) ? _c('router-link', {
    staticClass: "wishlist  d-xs3-block",
    attrs: {
      "to": {
        name: 'wishList'
      },
      "tabindex": "4"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-heart",
    attrs: {
      "title": "Wishlist",
      "aria-hidden": "true"
    }
  }), _c('span', {
    class: _vm.$store.getters.getWishListStoreData != undefined && _vm.$store.getters.getWishListStoreData != null && _vm.$store.getters.getWishListStoreData.length > 0 ? 'count' : ''
  }, [_vm._v(_vm._s(_vm.$store.getters.getWishListStoreData != undefined && _vm.$store.getters.getWishListStoreData != null && _vm.$store.getters.getWishListStoreData.length > 0 ? _vm.$store.getters.getWishListStoreData.length : ""))])]) : _vm._e(), _vm._v(" "), (_vm.featureList && _vm.featureList.cart) ? _c('router-link', {
    staticClass: "cart",
    attrs: {
      "to": {
        name: 'cart'
      },
      "tabindex": "5"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cart",
    attrs: {
      "title": "Cart",
      "aria-hidden": "true"
    }
  }), _c('span', {
    class: _vm.$store.getters.getCartData.items != undefined && _vm.$store.getters.getCartData.items != null && _vm.$store.getters.getCartData.items.length > 0 ? 'count' : ''
  }, [_vm._v(_vm._s(_vm.$store.getters.getCartData.items != undefined && _vm.$store.getters.getCartData.items != null && _vm.$store.getters.getCartData.items.length > 0 ? _vm.$store.getters.getCartData.items.length : ""))])]) : _vm._e(), _vm._v(" "), (_vm.featureList && _vm.featureList.wallet) ? _c('router-link', {
    staticClass: "wallet  d-xs3-block",
    attrs: {
      "to": {
        name: 'wallet'
      },
      "tabindex": "6"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-wallet",
    attrs: {
      "title": "Wallet",
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-user"
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "link",
      "right": "",
      "no-caret": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [(_vm.basicProfile.profileImg != '') ? _c('img', {
    attrs: {
      "src": _vm.basicProfile.profileImg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.basicProfile.profileImg == '') ? _c('img', {
    attrs: {
      "src": "static/assets/images/user.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-chevron-down"
  })]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-account-box-outline"
  }), _vm._v(" " + _vm._s(_vm.$t('common.labels.your_profile')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-power"
  }), _vm._v(" " + _vm._s(_vm.$t('common.labels.logout')))]) : _vm._e(), _vm._v(" "), (_vm.instanceName == 'MAHADEMY') ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitFromMahademy($event)
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-power"
  }), _vm._v(" " + _vm._s(_vm.$t('common.labels.Back')))]) : _vm._e()], 2)], 1)]) : _c('div', {
    staticClass: "h-links"
  }, [(!_vm.isMobileDevice()) ? _c('b-link', {
    on: {
      "click": function () {
        _vm.reset()
        _vm.isLoginWithInvalidCredentials = false
        this$1.$refs.loginModal.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.log_in')) + "\n                ")]) : _c('b-link', {
    on: {
      "click": _vm.sendtoMobileLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.log_in')) + "\n                ")]), _vm._v(" "), (_vm.featureList != null && _vm.featureList != undefined && _vm.featureList.signUp !== null && _vm.featureList.signUp !== undefined && _vm.featureList.signUp) ? _c('b-link', {
    on: {
      "click": function () {
        _vm.resetPasswordPolicyFlags()
        _vm.reset()
        this$1.$refs.signupModal.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.sign_up')) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "loginModal",
    staticClass: "text-left",
    attrs: {
      "id": "login",
      "hide-footer": "",
      "title": "Welcome back !"
    },
    on: {
      "shown": _vm.focusOnLoginModal
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(_vm.isLoginWithInvalidCredentials) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Invalid login details !")]) : _vm._e(), (_vm.isLoginWithInvalidCredentials) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Email / Mobile no")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "username",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email / mobile no",
      "aria-describedby": "username",
      "id": "username",
      "tabindex": "7"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptyUsername && _vm.username.length === 0),
      expression: "emptyUsername && username.length === 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v("Username cannot be empty")])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "type": "password",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "type": "text",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptyPassword && _vm.password.length === 0),
      expression: "emptyPassword && password.length === 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v("Password cannot be empty")])]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('span', {
    staticClass: "input-icon mdi mdi-eye",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = false
      }
    }
  }) : _c('span', {
    staticClass: "input-icon mdi mdi-eye-off",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = true
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forgotpwd d-flex"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function () {
        _vm.resetPasswordPolicyFlags()
        _vm.reset()
        this$1.$refs.forgetPasswordModal.show()
      }
    }
  }, [_vm._v("Forgot Password?")])])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "6"
    },
    on: {
      "click": _vm.handleLogin,
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), (_vm.featureList != null && _vm.featureList != undefined && _vm.featureList.signUp !== null && _vm.featureList.signUp !== undefined && _vm.featureList.signUp) ? _c('div', {
    staticClass: "d-flex justify-content-center sub-title newuser",
    on: {
      "click": function () {
        _vm.reset()
        _vm.resetPasswordPolicyFlags()
        this$1.$refs.signupModal.show()
      }
    }
  }, [_vm._v("New User?  "), _c('a', {
    attrs: {
      "href": "#",
      "tabindex": "7"
    }
  }, [_vm._v("Sign Up")])]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "signupModal",
    staticClass: "text-left",
    attrs: {
      "id": "signup",
      "hide-footer": "",
      "title": "Sign up and start learning now!"
    },
    on: {
      "shown": _vm.focusOnSignUpModal
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "fullname"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[a-zA-Z ]*$/
        }
      }),
      expression: "{rules:{required: true, regex: /^[a-zA-Z ]*$/}}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    ref: "fullName",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your full name",
      "aria-describedby": "fullname",
      "name": "fullname",
      "autofocus": "",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fullname')),
      expression: "errors.has('fullname')"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('fullname')))])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.emailAlreadyInUse) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Email id already in use")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Your email ID",
      "aria-describedby": "email",
      "tabindex": "9"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email') && _vm.email.length != 0),
      expression: "errors.has('email') && email.length != 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.mobileAlreadyInUse) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Mobile number already in use")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "mobile"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|length:10'),
      expression: "'required|numeric|length:10'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mobile number",
      "placeholder": "Enter mobile",
      "aria-describedby": "mobile",
      "tabindex": "10"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobile number') && _vm.mobile.length != 0),
      expression: "errors.has('mobile number') && mobile.length != 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('mobile number')))])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "11"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleRegistration()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "name": "password",
      "type": "text",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "11"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleRegistration()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password') && _vm.password.length != 0),
      expression: "errors.has('password') && password.length != 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('span', {
    staticClass: "input-icon mdi mdi-eye",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = false
      }
    }
  }) : _c('span', {
    staticClass: "input-icon mdi mdi-eye-off",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = true
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Password must have: ")]), _vm._v(" "), _c('ul', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_cap_alpha),
      expression: "!strike_cap_alpha"
    }]
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_cap_alpha),
      expression: "strike_cap_alpha"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_length),
      expression: "!strike_length"
    }]
  }, [_vm._v(" At least 4 characters ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_length),
      expression: "strike_length"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 4 characters ")])])])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large col-12 login-btn",
    attrs: {
      "variant": "outline-danger",
      "tabindex": "12"
    },
    on: {
      "click": function($event) {
        _vm.handleRegistration()
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center sub-title newuser",
    on: {
      "click": function () {
        _vm.reset()
        this$1.$refs.loginModal.show()
      }
    }
  }, [_vm._v("Already have an account?  "), _c('a', {
    attrs: {
      "href": "#",
      "tabindex": "13"
    }
  }, [_vm._v("Login")])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "forgetPasswordModal",
    staticClass: "text-left",
    attrs: {
      "id": "forgetPassword",
      "hide-footer": "",
      "title": "Forgot Password?"
    },
    on: {
      "shown": _vm.focusOnForgetPasswordModal
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(!_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Email / mobile no")]) : _vm._e(), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "input-group"
  }, [(_vm.invalidUsernameOtp) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v(" Invalid details entered")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "name"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "usernameForgotInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email / mobile no",
      "aria-describedby": "text",
      "tabindex": "14",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Enter OTP")]) : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otpInput),
      expression: "otpInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter OTP",
      "aria-describedby": "email",
      "tabindex": "18",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.otpInput)
    },
    on: {
      "keyup": function($event) {
        _vm.validateForNumberInput(_vm.otpInput, false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otpInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.invalidOtp) ? _c('small', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Oops! The OTP you've entered is invalid, try entering it again, else click on resend OTP link below")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "tabindex": "15"
    }
  }, [(_vm.isOtpRequestSend) ? _c('b-link', {
    staticClass: "w-100 resend-otp",
    on: {
      "click": function($event) {
        _vm.handleOtpResend()
      }
    }
  }, [_vm._v("Resend OTP")]) : _vm._e()], 1), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('b-form-group', [_c('b-form-checkbox-group', {
    ref: "otpcheckRef",
    attrs: {
      "id": "otpcheck",
      "name": "",
      "options": _vm.optOnMail
    },
    model: {
      value: (_vm.otpOptions),
      callback: function($$v) {
        _vm.otpOptions = $$v
      },
      expression: "otpOptions"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "17"
    },
    on: {
      "click": _vm.handleOtpRequest
    }
  }, [_vm._v("Send OTP")]) : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "19"
    },
    on: {
      "click": _vm.handleOtpVerification
    }
  }, [_vm._v("Verify OTP")]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "passwordChangeModal",
    staticClass: "text-left",
    attrs: {
      "id": "passwordChange",
      "hide-footer": "",
      "title": "Change password"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("New password")]), _vm._v(" "), (_vm.passwordMismatch) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Password doesn't match")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "name"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "newPasswordInputField",
    staticClass: "form-control with-icon",
    attrs: {
      "type": "password",
      "placeholder": "Enter new password",
      "aria-describedby": "text",
      "tabindex": "20"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "newPasswordInputField",
    staticClass: "form-control with-icon",
    attrs: {
      "type": "text",
      "placeholder": "Enter new password",
      "aria-describedby": "text",
      "tabindex": "20"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('span', {
    staticClass: "input-icon mdi mdi-eye",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = false
      }
    }
  }) : _c('span', {
    staticClass: "input-icon mdi mdi-eye-off",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = true
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Password must have: ")]), _vm._v(" "), _c('ul', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_cap_alpha),
      expression: "!strike_cap_alpha"
    }]
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_cap_alpha),
      expression: "strike_cap_alpha"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_length),
      expression: "!strike_length"
    }]
  }, [_vm._v(" At least 4 characters ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_length),
      expression: "strike_length"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 4 characters ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "name"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password",
      "aria-describedby": "text",
      "tabindex": "21"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isLinkingOperationPerformed) ? _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCommonPasswordRequest
    }
  }, [_vm._v("Submit")]) : _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "22"
    },
    on: {
      "click": _vm.handlePasswordReset
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "mobileNumberModal",
    staticClass: "text-left",
    attrs: {
      "id": "mobileNumber",
      "hide-footer": "",
      "title": "Welcome to Livedemy!"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Contact no")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter contact no",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.enrollGoogleUser()
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "registrationInfoModal",
    staticClass: "text-left",
    attrs: {
      "id": "registrationInfo",
      "hide-footer": "",
      "title": "Welcome to Livedemy!"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(_vm.showContact) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Contact no")]) : _vm._e(), _vm._v(" "), (_vm.showContact) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thirdPartyUserObj.mobile),
      expression: "thirdPartyUserObj.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter contact no",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.thirdPartyUserObj.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thirdPartyUserObj.mobile = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Email address")]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thirdPartyUserObj.email),
      expression: "thirdPartyUserObj.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email address",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.thirdPartyUserObj.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thirdPartyUserObj.email = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.enrollThirdPartyUser()
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "askCredentialModal",
    staticClass: "text-left",
    attrs: {
      "id": "askCredential",
      "hide-footer": "",
      "title": "Hey, user we do not have any contact details associated with user. Please enter contact details"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(!_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Mobile number")]) : _vm._e(), _vm._v(" "), (!_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEnteredValue),
      expression: "userEnteredValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter mobile number",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.userEnteredValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEnteredValue = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("OTP")]) : _vm._e(), _vm._v(" "), (_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otpInput),
      expression: "otpInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.otpInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otpInput = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isContactDetailsOtpSend) ? _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.checkContactDetails()
      }
    }
  }, [_vm._v("Send OTP")]) : _vm._e(), _vm._v(" "), (_vm.isContactDetailsOtpSend) ? _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.contactDetailsOtpVerification()
      }
    }
  }, [_vm._v("Verify OTP")]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "otpVerificationForAccountLinkingModal",
    staticClass: "text-left",
    attrs: {
      "id": "otpVerificationForAccountLinking",
      "hide-footer": "",
      "title": "Hey, user we do not have any contact details associated with user. Please enter contact details"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("OTP ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEnteredValue),
      expression: "userEnteredValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter OTP",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.userEnteredValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEnteredValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.verifyOtp(_vm.userEnteredValue)
      }
    }
  }, [_vm._v("Send OTP")])], 1)], 1)])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a/52":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a2h3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allCourses"
  }, [_c('bannerSearch'), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }, [_c('div', [_c('section', [_c('allCourseCards')], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a4mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.labelOnTop) ? _c('div', {
    staticClass: "shareOnText"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.shareOn')) + " ")]) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareBaseUrl + _vm.item.contentId,
      "title": _vm.item.title,
      "description": _vm.item.description,
      "quote": _vm.item.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "social-links"
          }, [_c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-email"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-facebook"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-twitter"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-linkedin"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_playlistCards_vue__ = __webpack_require__("BEvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4788e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_playlistCards_vue__ = __webpack_require__("17XY");
function injectStyle (ssrContext) {
  __webpack_require__("+fIq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_playlistCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4788e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_playlistCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aXMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mahademyHome',
  data: function data() {
    return {
      token: ''
    };
  },
  created: function created() {
    if (this.$route.params.token !== 'none') {
      this.token = this.$route.params.token;
      localStorage.setItem('ssoToken', false);
      localStorage.setItem('token', this.token);
      localStorage.setItem('isLoggedIn', true);
    }
    localStorage.setItem('app_env', __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["f" /* MAHADEMY_APP_ENV */]);
    if (localStorage.getItem('token') !== null) {
      this.handleLogin();
    }
  },

  methods: {
    handleLogin: function handleLogin() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/o/loginForSocialUser', null, { headers: { 'Authorization': localStorage.getItem('mahademyToken') } }).then(function (res) {
        _this.$store.dispatch('setUserStoreData', res.data).then(function (res) {
          _this.$router.replace({ path: '/home' });
        });
      }).catch(function (err) {
        console.log('error occured in redirection: ', err);
      });
    }
  }
});

/***/ }),

/***/ "aYcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allCourses_vue__ = __webpack_require__("83HF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7973ce7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_allCourses_vue__ = __webpack_require__("a2h3");
function injectStyle (ssrContext) {
  __webpack_require__("SUfU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allCourses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7973ce7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_allCourses_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bNYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wallet-cards container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-4"
  }, [_c('div', {
    staticClass: "card-bal highlight"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('wallet.labels.WalletBalance')))]), _vm._v(" "), _c('div', {
    staticClass: "bal"
  }, [_vm._v("\n            " + _vm._s(_vm.amount) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "info pt-20"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('wallet.labels.YouHave')) + " " + _vm._s(_vm.amount) + " " + _vm._s(_vm.$t('common.alerts.POINTS_IN_WALLET')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "pt-3"
  }, [_c('i', {
    staticClass: "mdi mdi-currency-inr"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.addmoney",
      modifiers: {
        "addmoney": true
      }
    }]
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('wallet.labels.AddMoneyInWallet')))])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "addmoney"
    }
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountToAdd),
      expression: "amountToAdd"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('wallet.placeholders.EnterAmount')
    },
    domProps: {
      "value": (_vm.amountToAdd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amountToAdd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "input-group-addon btn btn-blue",
    attrs: {
      "id": "addm"
    },
    on: {
      "click": function($event) {
        _vm.addMoney()
      }
    }
  }, [_vm._v("Add")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "pt-2"
  }, [_c('i', {
    staticClass: "mdi mdi-email"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:livedemysupport@mkcl.org?",
      "target": "_top"
    }
  }, [_vm._v(_vm._s(_vm.$t('wallet.labels.ContactUs')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "card-history"
  }, [_c('div', {
    staticClass: "search-items"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.searchFor ? 'By activity title' : 'By transaction id'
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-css"
  }, [_c('b-tabs', [_c('hr'), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('wallet.labels.Activities'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.getActivities()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "tab-content-holder"
  }, [(_vm.filteredActivityList != undefined && _vm.filteredActivityList.length > 0) ? _c('div', {
    staticClass: "vbar-holder"
  }, _vm._l((_vm.filteredActivityList), function(activity, i) {
    return _c('div', {
      key: i,
      staticClass: "item item-adj"
    }, [_c('div', {
      staticClass: "row row-hover"
    }, [_c('div', {
      staticClass: "col align-self-center text-left"
    }, [_c('div', {
      staticClass: "i-title"
    }, [_vm._v(_vm._s(activity.title))]), _vm._v(" "), _c('div', {
      staticClass: "i-details"
    }, [_vm._v(_vm._s(_vm.$t('wallet.labels.WatchedFor')) + " " + _vm._s(Math.round(((activity.duration) / 60) * 100) / 100) + " " + _vm._s(_vm.$t('wallet.labels.MinutesOn')) + " " + _vm._s(_vm._f("moment")(activity.recentTime, "Do MMM, YYYY h:mm A")))])]), _vm._v(" "), _c('div', {
      staticClass: "col align-self-center amount-text-align"
    }, [_c('div', {
      staticClass: "amount"
    }, [_vm._v("\n                          " + _vm._s(activity.price) + " " + _vm._s(_vm.$t('wallet.labels.Points')) + "\n                        ")])])])])
  })) : _c('div', {
    staticClass: "vbar-holder"
  }, [_c('p', [_vm._v(" Not enough activities have occurred to show")])])])]), _vm._v(" "), _c('b-tab', {
    staticClass: "transaction",
    attrs: {
      "title": _vm.$t('wallet.labels.Transactions')
    },
    on: {
      "click": function($event) {
        _vm.getTransactionData()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "tab-content-holder"
  }, [(_vm.filteredWalletList != undefined && _vm.filteredWalletList.length > 0) ? _c('div', {
    staticClass: "vbar-holder"
  }, _vm._l((_vm.filteredWalletList), function(transaction, i) {
    return _c('div', {
      key: i,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "row row-hover align-items-center mb-3"
    }, [_c('div', {
      staticClass: "col align-self-center text-left"
    }, [_c('div', {
      staticClass: "badge badge-success-alt",
      class: {
        'badge-success-alt': transaction.status === 'SUCCESS', 'badge-danger-alt': transaction.status === 'FAILED', 'badge-pending-alt': transaction.status === 'PENDING'
      }
    }, [_vm._v(_vm._s(transaction.status))]), _vm._v(" "), (transaction.status === 'FAILED') ? _c('div', {
      staticClass: "i-title"
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('wallet.labels.FailedToAddMsg')) + " " + _vm._s(_vm._f("moment")(transaction.transactionDate, "Do MMM, YYYY h:mm A")) + "\n                          "), _c('div', {
      staticClass: "i-details"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.TRANSACTION_ID')) + " " + _vm._s(transaction.cartId))])]) : (transaction.walletTransType == 'IN') ? _c('div', {
      staticClass: "i-title"
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('wallet.labels.AddedToWalletOn')) + " " + _vm._s(_vm._f("moment")(transaction.transactionDate, "Do MMM, YYYY h:mm A")) + "\n                          "), _c('div', {
      staticClass: "i-details"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.TRANSACTION_ID')) + " " + _vm._s(transaction.cartId))])]) : _c('div', {
      staticClass: "i-title"
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('wallet.labels.PurchaseMadeOn')) + " " + _vm._s(_vm._f("moment")(transaction.transactionDate, "Do MMM, YYYY h:mm A")) + "\n                          "), _c('div', {
      staticClass: "i-details"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.TRANSACTION_ID')) + " " + _vm._s(transaction.cartId))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-auto align-self-center text-right"
    }, [_c('div', {
      staticClass: "amount"
    }, [_c('i', {
      staticClass: "mdi mdi-currency-inr"
    }), _vm._v(_vm._s(transaction.amount) + "\n                        ")])])])])
  })) : _c('div', {
    staticClass: "vbar-holder"
  }, [_c('p', [_vm._v(" Transaction details are not available")])])])])], 1)], 1)])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": _vm.url,
      "method": "POST",
      "id": "upsForm",
      "name": "upsForm"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upsString),
      expression: "upsString"
    }],
    attrs: {
      "name": "upsString",
      "type": "hidden",
      "id": "someId"
    },
    domProps: {
      "value": (_vm.upsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upsString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "reqFrom",
      "value": "goLang",
      "type": "hidden"
    }
  })])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "input-group-addon btn btn-gray",
    attrs: {
      "id": "search-items"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cB1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder",
    attrs: {
      "id": "trending-course"
    }
  }, [(_vm.$store.getters.getAllCOs !== undefined && _vm.$store.getters.getAllCOs !== null && _vm.$store.getters.getAllCOs.length > 0) ? _c('div', {
    staticClass: "pb-2 row justify-content-end"
  }, [_c('h6', {
    staticClass: "main-title col-12 text-left"
  }, [_vm._v(_vm._s(_vm.$t('course.trending_courses')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getAllCOs !== undefined && _vm.$store.getters.getAllCOs !== null && _vm.$store.getters.getAllCOs.length > 0) ? _c('div', {
    staticClass: "swiper-holder"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOptionLib
    }
  }, _vm._l((_vm.$store.getters.getAllCOs), function(course, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "card-design"
    }, [(course.thumbnail.length != 0) ? _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(course.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__("9oHV"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "tag": "h3",
        "title": course.title,
        "to": {
          name: 'coursePage',
          params: {
            contentId: course.contentId
          }
        }
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'MAHADEMY') ? _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": course.title
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(course.price) + " " + _vm._s(course.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]) : _vm._e(), _vm._v(" "), (parseInt(course.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": parseInt(course.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": parseInt(course.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('share-on-media', {
      attrs: {
        "item": course,
        "labelOnTop": true
      }
    }), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row box-action"
    }, [_c('div', {
      staticClass: "col"
    }, [(_vm.$store.getters.getItemSubscriptionStatus({
      'id': course.contentId,
      'type': course.type
    }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
      'id': course.contentId,
      'type': course.type
    }) != null && _vm.$store.getters.getItemSubscriptionStatus({
      'id': course.contentId,
      'type': course.type
    })) ? _c('div', [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToCourse(course)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('course.GO_TO_COURSE')))])]) : (_vm.featureStatusInfoList.cart) ? _c('div', [(_vm.$store.getters.itemPresentInCartStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(course.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(course.contentId)) ? _c('button', {
      staticClass: "btn btn-green-alt"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(course.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e()]), _vm._v(" "), (_vm.featureStatusInfoList.wishlist && _vm.$store.getters.getItemPurchasedStatus(course.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(course.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(course.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(course.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(course.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(course.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(course.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(course.contentId) != undefined && $store.getters.itemPresentInCartStatus(course.contentId)!= null && !$store.getters.itemPresentInCartStatus(course.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(course.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(course.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(course.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(course.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row box-action"
    }, [(_vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList.wishlist) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })]) : _vm._e()])], 1)])])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "options": _vm.swiperOptionLib
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev swiper-lib-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-lib-next",
    slot: "button-next"
  })])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "text-left",
    attrs: {
      "id": "addplay",
      "hide-footer": "",
      "hide-header": "",
      "title": "Add to Playlist"
    }
  }, [_c('div', {
    staticClass: "social d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('playlist.CreateNewPlaylist')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "newplay"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-music"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name your playlist",
      "aria-describedby": "newplay"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("OR")]), _vm._v(" "), _c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('playlist.labels.AddToExistingPlaylists')) + " ")]), _vm._v(" "), _c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "stacked": "",
      "name": "flavour2",
      "options": _vm.options
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "showmore d-flex"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Show more")])])], 1), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.AddToPlaylist')))])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cFcx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_framesVideo_vue__ = __webpack_require__("s0Kx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_599ddaf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_framesVideo_vue__ = __webpack_require__("jxDs");
function injectStyle (ssrContext) {
  __webpack_require__("6n+F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_framesVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_599ddaf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_framesVideo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQNi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cWK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseCards',
  components: { StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a },
  data: function data() {
    return {
      wishListData: [],
      cartData: [],
      isActive: false,
      notNextTick: true,
      itemName: 'Go Lang',
      itemDescription: 'Learn Go lang',
      swiperOptionCourse: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-course-next',
        prevButton: '.swiper-course-prev',
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      }
    };
  },
  mounted: function mounted() {
    if (this.isLoggedIn) {
      this.$store.dispatch('fetchRecommendedCoursesFromDb', this.$store.getters.getProfileDetails.profileId).then(function (response) {}, function (error) {
        console.log('error in fetchRecommendedCoursesFromDb', error);
      });
    }
  },

  methods: {
    checkValue: function checkValue(val) {
      // alert('val====>' + val)
      if (val.length === 0) {
        // alert('t')
        return false;
      } else {
        // alert('f')
        return true;
      }
    },
    removeFromWishList: function removeFromWishList(itemId) {
      this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {}, function (error) {
        console.error('error in removing item from wishList', error);
      });
    },
    addToWishList: function addToWishList(itemId) {
      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {}, function (error) {
          console.error('error in adding item to wishList', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    presentInWishListStore: function presentInWishListStore(itemId) {
      for (var i = 0; i < this.$store.getters.getWishListStoreData.length; i++) {
        if (this.$store.getters.getWishListStoreData[i].itemId === itemId) {
          return true;
        }
      }
    },
    addToCart: function addToCart(id) {
      var _this = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
          _this.$toasted.success('Added to cart Successfully');
        }, function (error) {
          _this.$toasted.error('error in adding item to cart');
          console.log('error in adding item to cart', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    inCart: function inCart(itemId) {
      for (var i = 0; i < this.$store.getters.getCartData.items.length; i++) {
        if (this.$store.getters.getCartData.items[i].itemId === itemId) {
          return true;
        }
      }
    },
    generatePath: function generatePath(path) {
      return "background-image: url('" + path + "')";
    },
    ViewDetails: function ViewDetails(contentId) {
      var Data = this;
      Data.$store.dispatch('getCourseDetails', contentId);
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "culI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swfPlayer',
  loaded: true,
  props: ['path'],
  data: function data() {
    return {
      mediaPath: this.path
    };
  },

  watch: {
    path: function path(newValue, oldValue) {
      // console.log('swf:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue;
      // var innerHTMLObj = '<object id="swfHolder" width="100%"  height="300px" controls> <param name="FlashVars" value="ver="  /> <param name="movie" value=' + encodeURI(newValue + '?module=' + this.$store.getters.getPasscode) + '"  />            <param name="quality" value="high" />            <param name="bgcolor" value="#ffffff" />            <param name="wmode" value="opaque" /></object>'
      var innerHTMLObj = '<object  width="100%"   controls> <embed class="player" height="400px" src="' + newValue + '?module=' + this.$store.state.contentViewer.currentPlayingcontent.passcode + '" width="100%" controls  flashvars="ver=alcera_1" type="application/x-shockwave-flash"></embed> </object>';
      this.swfHolder = document.getElementById('swfHolder');
      this.swfHolder.innerHTML = '';
      // console.log('here' + this.$store.getters.getPasscode)
      this.swfHolder.innerHTML = innerHTMLObj;
    }
  },
  mounted: function mounted() {
    // console.log('swf player path:' + this.medipaPath)
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('swf player destroy called')
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', { 'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 });
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
          /* return new Promise((resolve, reject) => {
            axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
              .then(response => {
                this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
                resolve()
              })
              .catch(err => {
                console.log(err)
                reject()
              })
          }) */
        }
    }
  }
});

/***/ }),

/***/ "dI8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a);
var state = {
  search: [],
  totalResult: 0,
  searchType: 'all',
  searchText: '',
  startIndex: 0,
  lastIndex: 0,
  searchPrice: [],
  // isSearchClicked: false,
  mostSearchedWordList: []
  // var result = []
};var getters = {
  getTotalResultLength: function getTotalResultLength(state) {
    return state.totalResult;
  },
  getFirstIndex: function getFirstIndex(state) {
    return state.startIndex;
  },
  getLastIndex: function getLastIndex(state) {
    return state.lastIndex;
  },
  getSearchPrice: function getSearchPrice(state) {
    return state.searchPrice;
  },
  getSearchText: function getSearchText(state) {
    return state.searchText;
  },
  getSearchType: function getSearchType(state) {
    return state.searchType;
  },

  getSearchStoreData: function getSearchStoreData(state) {
    return state.search;
  },
  getMostSearchedWordList: function getMostSearchedWordList(state) {
    return state.mostSearchedWordList;
  },
  // returns result matching filters
  getFilteredData: function getFilteredData(state, getters) {
    return function (searchParameters) {
      var searchResult = [];
      // check if user has selected category filter
      if (searchParameters.categorySelected.length !== 0 && searchParameters.categorySelected !== null) {
        for (var i = 0; i < getters.getSearchStoreData.length; i++) {
          for (var j = 0; j < searchParameters.categorySelected.length; j++) {
            if (getters.getSearchStoreData[i].category.includes(searchParameters.categorySelected[j])) {
              searchResult.push(getters.getSearchStoreData[i]);
            } else {
              if (j + 1 === searchParameters.categorySelected.length) {
                break;
              }
            }
          }
        }
      }
      // check if user has selected language filter
      if (searchParameters.languageSelected.length !== 0 && searchParameters.languageSelected !== null) {
        // perform action on result obtained after category filter
        if (searchResult.length !== 0) {
          var tmp = [];
          for (var _i = 0; _i < searchResult.length; _i++) {
            for (var _j = 0; _j < searchParameters.languageSelected.length; _j++) {
              if (searchResult[_i].languageId.includes(searchParameters.languageSelected[_j])) {
                tmp.push(searchResult[_i]);
                break;
              }
            }
          }
          searchResult = tmp;
        } else {
          // check if user has not selected category filter
          if (searchParameters.categorySelected.length === 0) {
            for (var _i2 = 0; _i2 < getters.getSearchStoreData.length; _i2++) {
              for (var _j2 = 0; _j2 < searchParameters.languageSelected.length; _j2++) {
                if (getters.getSearchStoreData[_i2].languageId.includes(searchParameters.languageSelected[_j2])) {
                  var isObjExists = false;
                  for (var k = 0; k < searchResult.length; k++) {
                    if (searchResult[k].contentId === getters.getSearchStoreData[_i2].contentId) {
                      isObjExists = true;
                      break;
                    }
                  }
                  if (!isObjExists) {
                    searchResult.push(getters.getSearchStoreData[_i2]);
                  }
                } else {
                  if (_j2 + 1 === searchParameters.languageSelected.length) {
                    break;
                  }
                }
              }
            }
          }
        }
      }
      // check if user has selected duration filter
      if (searchParameters.duration !== null && searchParameters.duration.length !== 0) {
        // perform action on result obtained after category filter & language filter
        if (searchResult.length !== 0) {
          if (searchParameters.duration === 0) {
            searchResult = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(searchResult, ['price'], ['asc']);
          } else {
            searchResult = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(searchResult, ['price'], ['desc']);
          }
        } else {
          // check if user has not selected category filter and language
          if (searchParameters.languageSelected.length === 0 && searchParameters.categorySelected.length === 0) {
            if (searchParameters.duration === 0) {
              searchResult = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(getters.getSearchStoreData, ['price'], ['asc']);
            } else {
              searchResult = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(getters.getSearchStoreData, ['price'], ['desc']);
            }
          }
        }
      }
      // check if user has selected cost filter
      if (searchParameters.cost.length !== 0 && searchParameters.cost !== null) {
        // perform action on result obtained after category filter , language filter & cost filter
        if (searchResult.length !== 0) {
          var _tmp = [];
          for (var _i3 = 0; _i3 < searchResult.length; _i3++) {
            if (searchParameters.cost[0] <= searchResult[_i3].price && searchResult[_i3].price <= searchParameters.cost[1]) {
              _tmp.push(searchResult[_i3]);
            }
          }
          searchResult = _tmp;
        } else {
          // check if user had not selected category filter , language filter & cost filter
          if (searchParameters.categorySelected.length === 0 && searchParameters.languageSelected.length === 0 && searchParameters.duration.length === 0) {
            for (var _i4 = 0; _i4 < getters.getSearchStoreData.length; _i4++) {
              if (searchParameters.cost[0] <= getters.getSearchStoreData[_i4].price && getters.getSearchStoreData[_i4].price <= searchParameters.cost[1]) {
                searchResult.push(getters.getSearchStoreData[_i4]);
              }
            }
          }
        }
      }
      return searchResult;
    };
  }
};
var actions = {
  // change search text
  changeSearchText: function changeSearchText(context, data) {
    context.commit('setSearchText', data);
  },

  // reset search text
  clearSearchText: function clearSearchText(context) {
    context.commit('clearSearchText');
  },

  // set earch type : all/LO/CO
  changeSearchType: function changeSearchType(context, data) {
    context.commit('setSearchType', data);
  },
  getMostSearchedWordList: function getMostSearchedWordList(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var profileId = null;
      var profileDetails = context.getters.getProfileDetails;
      if (profileDetails !== null && profileDetails.profileId !== null) {
        profileId = profileDetails.profileId;
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('o/getMostSearchedWordList', {
        'userId': profileId
      }).then(function (response) {
        context.commit('setMostSearchedWordList', response.data);
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  // stores search result
  // called on first search
  getSearchResult: function getSearchResult(context, data) {
    // save search Text
    context.commit('setSearchText', data.searchText);
    data['startIndex'] = 0;
    data['lastIndex'] = 5;
    data['type'] = context.getters.getSearchType;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var objectCategory = '';
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        // console.log('here')
        objectCategory = __WEBPACK_IMPORTED_MODULE_6__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails);
        // console.log(objectCategory)
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('o/getsearchresult', data, { headers: { 'contentCategory': objectCategory } }).then(function (response) {
        // set total no of result used to stop lazy loading
        context.commit('setTotalLength', parseInt(response.headers.totalresult));
        // store search result
        context.commit('setSearchStoreData', response.data);
        resolve();
      }).catch(function (error) {
        console.log('catch', error);
        reject(error);
      });
    });
  },

  // stores result for lazyLoading
  appendSearchResult: function appendSearchResult(context, data) {
    // set startIndex & lastIndex
    context.commit('setIndexes', { 'startIndex': data.startIndex, 'lastIndex': data.lastIndex });
    data['type'] = context.getters.getSearchType;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var objectCategory = '';
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        objectCategory = __WEBPACK_IMPORTED_MODULE_6__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails);
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('o/getsearchresult', data, { headers: { 'contentCategory': objectCategory } }).then(function (response) {
        // get old result
        var oldResult = context.getters.getSearchStoreData;
        // append new result to old
        for (var i = 0; i < response.data.length; i++) {
          oldResult.push(response.data[i]);
        }
        // save result (old + new)
        context.commit('setSearchStoreData', oldResult);
        resolve();
      }).catch(function (error) {
        console.log('catch', error);
        reject(error);
      });
    });
  },

  // clears search store
  removePreviousSearchResult: function removePreviousSearchResult(context) {
    context.commit('clearSearchStoreData');
  },

  // set index
  setIndexesOnSearch: function setIndexesOnSearch(context) {
    context.commit('setIndexes', { 'startIndex': 0, 'lastIndex': 5 });
  }
};
var mutations = {
  resetMostSearchWordList: function resetMostSearchWordList(state) {
    state.mostSearchedWordList = [];
  },
  setIndexes: function setIndexes(state, data) {
    state.startIndex = data.startIndex;
    state.lastIndex = data.lastIndex;
  },
  setTotalLength: function setTotalLength(state, data) {
    state.totalResult = data;
  },
  setSearchStoreData: function setSearchStoreData(state, data) {
    if (data === null || data.length === 0) {
      state.search = [];
      state.searchPrice = [0, 0];
      state.startIndex = 0;
      state.lastIndex = 0;
      state.totalResult = 0;
    } else {
      if (data.length > 0) {
        state.search = data;
        if (state.lastIndex === 0) {
          state.startIndex = 0;
          state.lastIndex = 5;
        }
        // compute max price
        var max = data[0].price;
        for (var i = 1; i < data.length; i++) {
          if (data[i].price > max) {
            max = data[i].price;
          }
        }
        state.searchPrice = [0, max];
      }
      // else {
      //  state.searchPrice = [0, 0]
      // }
    }
  },
  setSearchPrice: function setSearchPrice(state, data) {
    state.searchPrice[0] = data.low;
    state.searchPrice[1] = data.high;
  },
  setMostSearchedWordList: function setMostSearchedWordList(state, data) {
    if (data === null) {
      state.mostSearchedWordList = [];
    } else {
      state.mostSearchedWordList = data;
    }
  },
  clearSearchStoreData: function clearSearchStoreData(state, data) {
    state.search = [];
    state.searchPrice = [];
    state.totalResult = 0;
    state.searchText = '';
    state.startIndex = 0;
    state.lastIndex = 0;
    state.searchPrice = [];
    // state.isSearchClicked = false
  },
  setSearchText: function setSearchText(state, data) {
    state.searchText = data;
  },
  clearSearchText: function clearSearchText(state, data) {
    state.searchText = '';
  },
  setSearchType: function setSearchType(state, data) {
    state.searchType = data;
  },
  resetSearchType: function resetSearchType(state, data) {
    state.searchType = 'all';
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "dMGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdfViewer_vue__ = __webpack_require__("K8l1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f33602b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_pdfViewer_vue__ = __webpack_require__("pUck");
function injectStyle (ssrContext) {
  __webpack_require__("0A7L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdfViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f33602b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_pdfViewer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dYQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoPlayer_vue__ = __webpack_require__("5IuU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e13353fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_videoPlayer_vue__ = __webpack_require__("52KT");
function injectStyle (ssrContext) {
  __webpack_require__("xm+/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e13353fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_videoPlayer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dcG8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dnSH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dtsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bannerVideo_vue__ = __webpack_require__("tfJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_instructorProfile_vue__ = __webpack_require__("R5f5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__courseObjectives_vue__ = __webpack_require__("zsv+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__courseList_vue__ = __webpack_require__("uvl3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__courseReview__ = __webpack_require__("U1bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__home_libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {EventBus} from '@/main.js'










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coursePage',
  data: function data() {
    return {
      courseId: ''
    };
  },

  components: {
    footerArea: __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__["a" /* default */],
    bannerVideo: __WEBPACK_IMPORTED_MODULE_1__bannerVideo_vue__["a" /* default */],
    instructorProfile: __WEBPACK_IMPORTED_MODULE_2__profile_instructorProfile_vue__["a" /* default */],
    courseObjectives: __WEBPACK_IMPORTED_MODULE_3__courseObjectives_vue__["a" /* default */],
    courseList: __WEBPACK_IMPORTED_MODULE_4__courseList_vue__["a" /* default */],
    courseReview: __WEBPACK_IMPORTED_MODULE_5__courseReview__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_6__home_courseCards__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_7__home_libraryCards__["a" /* default */]
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_8__main_js__["EventBus"].$emit('showNav', false);
    // alert(JSON.stringify(this.$store.getters.getCurrentCourse))
  },
  created: function created() {
    this.courseId = this.$route.params.contentId;
    // console.log(this.$route.params.id)
    // alert(this.$route.params.id)
  }
});

/***/ }),

/***/ "e2XB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_swal__ = __webpack_require__("nUxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_swal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_swal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_footerArea_vue__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wishList_courseWishList_vue__ = __webpack_require__("Bhfl");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import headerLoginNoMenu from './common/headerLoginNoMenu.vue'

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_swal___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confirmation',
  components: {
    footerArea: __WEBPACK_IMPORTED_MODULE_5__common_footerArea_vue__["a" /* default */],
    courseWishlist: __WEBPACK_IMPORTED_MODULE_6__components_wishList_courseWishList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      walletId: '',
      amount: 0,
      balance: false,
      amountToAdd: '',
      upsString: '',
      url: __WEBPACK_IMPORTED_MODULE_1__common_constants_js__["q" /* PAYMENT_REQUEST_URL */],
      total1: 0
    };
  },
  mounted: function mounted() {
    this.totalAmountToPay();
  },
  created: function created() {
    this.getWalletAmount();
    /* return new Promise((resolve, reject) => {
      axios
        .post('/r/cartView', {
          profileId: this.$store.getters.getProfileDetails.profileId
        })
        .then(res => {
          if (res.data !== null) {
            if (res.data.items.length !== 0) {
              res.data.items.forEach(element => {
                this.total1 = this.total1 + parseInt(element.amount)
                alert(this.total1)
              })
            }
            // this.$route.params.amount = total1
          }
          resolve()
        })
        .catch(err => {
          console.log('error viewing::', err)
          reject(err)
        })
    }) */
  },

  methods: {
    totalAmountToPay: function totalAmountToPay() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/r/cartView', {
          profileId: _this.$store.getters.getProfileDetails.profileId
        }).then(function (res) {
          if (res.data !== null) {
            if (res.data.items.length !== 0) {
              res.data.items.forEach(function (element) {
                _this.total1 = _this.total1 + parseInt(element.amount);
                // alert(this.total1)
                // console.log('to pay', this.total1)
              });
            }
            // this.$route.params.amount = total1
          }
          resolve();
        }).catch(function (err) {
          console.log('error viewing::', err);
          reject(err);
        });
      });
    },
    paymentGateway: function paymentGateway() {
      var _this2 = this;

      // alert(JSON.stringify(this.$store.getters.getCartData))
      document.getElementById('button').disabled = true;
      var obj = {};
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/wallet/paymentRequest', {
          profileId: _this2.$store.getters.getProfileDetails.profileId,
          totalAmount: _this2.total1,
          cartId: _this2.$route.params.cartId,
          items: _this2.$store.getters.getCartData.items
        }).then(function (res) {
          if (res.data === 0) {
            _this2.$router.push({ name: 'success', params: { amount: _this2.$route.params.amount, transactionId: _this2.$route.params.cartId, status: 'success', payementMode: 'wallet' } });
            obj.cartId = '';
            obj.items = [];
            _this2.$store.commit('clearCartData');
          } else if (res.data === -1) {
            _this2.$toasted.error('Error In Payment Service');
          } else {
            // alert('Add ' + res.data + ' to your wallet')
            // this.$swal('Dear User', 'Kindly add ' + res.data + ' for purchase.', 'warning')
            _this2.$toasted.error('Dear User Kindly add ' + res.data + ' Points');
            _this2.amountToAdd = res.data;
            // alert(this.amountToAdd)
            _this2.balance = true;
          }
          resolve();
        }).catch(function (err) {
          console.log('Error in Payment Service', err);
          reject();
        });
        document.getElementById('button').disabled = false;
      });
    },
    addMoney: function addMoney() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/wallet/purchaseHistory', {
          profileId: _this3.$store.getters.getProfileDetails.profileId,
          walletId: _this3.walletId,
          totalAmount: parseInt(_this3.total1)
          // totalAmount: parseInt(this.amountToAdd)
        }).then(function (res) {
          if (res.data !== '') {
            _this3.upsString = res.data;
            _this3.submitUpsForm();
            // this.getWalletAmount()
          } else {
            console.log('Error');
          }
          resolve();
        }).catch(function (err) {
          console.log('Error in Updating wallet Amount', err);
          reject();
        });
      });
    },
    submitUpsForm: function submitUpsForm() {
      // console.log('this.upsString >> ' + this.upsString)
      document.getElementById('someId').value = this.upsString;
      document.getElementById('upsForm').submit();
    },
    getWalletAmount: function getWalletAmount() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('r/wallet/getWalletDetailsbyUser', {
          profileId: _this4.$store.getters.getProfileDetails.profileId
        }).then(function (res) {
          _this4.amount = res.data.totalAmount;
          _this4.walletId = res.data.walletId;
          resolve(_this4.amount);
        }).catch(function (err) {
          console.log('ERROR_IN_GETTING_WALLET_AMOUNT : ', err);
          reject();
        });
      });
      // return this.amount
    }
  }
});

/***/ }),

/***/ "e6+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _ = __webpack_require__("M4fF");
var state = {
  currentPlaylist: {},
  userPlaylists: [],
  // courseLearned: {},
  loMasterData: [],
  allocatedVideos: [],
  numberOfPages: 0,
  currentPage: 0,
  singleConceptCollection: []
};
var getters = {
  getCurrentPage: function getCurrentPage(state) {
    return state.currentPage;
  },

  /* getAllocatedVideos (state) {
    return state.allocatedVideos
  }, */
  getUserSingleConceptsCollection: function getUserSingleConceptsCollection(state) {
    // console.log('getting getUserSingleConceptsCollection')
    return state.singleConceptCollection;
  },
  getNumberOfPages: function getNumberOfPages(state) {
    return state.numberOfPages;
  },
  getcurrentPlaylist: function getcurrentPlaylist(state) {
    return state.currentPlaylist;
  },
  getUserPlaylists: function getUserPlaylists(state) {
    return state.userPlaylists;
  },

  getPlaylist: function getPlaylist(state) {
    return function (plId) {
      var currentPlaylist = null;
      // state.userPlaylists.forEach(function (element) {
      _.forEach(state.userPlaylists, function (element) {
        if (element.plId === plId) {
          currentPlaylist = element;
          return;
        }
      });
      return currentPlaylist;
    };
  },
  getLOMasterData: function getLOMasterData(state) {
    return state.loMasterData;
  },
  getLOObjectByItemId: function getLOObjectByItemId(state, getters) {
    return function (itemId) {
      for (var i = 0; i < getters.getCollectionList.length; i++) {
        if (getters.getCollectionList[i].contentId === itemId) {
          return getters.getCollectionList[i];
        }
      }
      // return state.currentPlayingcontent.path[0].filePath
    };
  },
  getPlayListLOData: function getPlayListLOData(state, getters) {
    return function (playlist) {
      var result = [];
      for (var i = 0; i < playlist.items; i++) {
        for (var j = 0; j < getters.getCollectionList.length; j++) {
          if (playlist.items[i] === getters.getCollectionList[i].contentId) {
            result.push(getters.getCollectionList[i]);
          }
        }
      }
      return result;
    };
  },
  getLastPlayedContent: function getLastPlayedContent(state, getters) {
    return function (contentId) {
      if (getters.getcurrentPlaylist.items !== null) {
        for (var i = 0; i < getters.getcurrentPlaylist.items.length; i++) {
          if (getters.getcurrentPlaylist.items[i].itemId === contentId) {
            return getters.getcurrentPlaylist.items[i].lastViewedDuration;
          }
        }
      }
    };
  }
};
var mutations = {
  resetPlayListDetailsPaginationDetailsInStore: function resetPlayListDetailsPaginationDetailsInStore(state) {
    state.numberOfPages = 0;
    state.currentPage = 0;
    state.singleConceptCollection = [];
  },
  clearPlaylistData: function clearPlaylistData(state) {
    state.userPlaylists = [];
  },
  updatePlaylistItems: function updatePlaylistItems(state, updatedPlaylist) {
    _.forEach(state.userPlaylists, function (playlist, index) {
      if (playlist.plId === updatedPlaylist.plId) {
        state.userPlaylists[index].items = updatedPlaylist.items;
        return;
      }
    });
  },

  appendPlaylist: function appendPlaylist(state, data) {
    state.userPlaylists.push(data);
  },
  setCurrentPlaylist: function setCurrentPlaylist(state, data) {
    state.currentPlaylist = data;
  },
  setUserPlaylists: function setUserPlaylists(state, data) {
    if (data !== null) {
      state.userPlaylists = data;
    }
  },
  addItemInPlaylist: function addItemInPlaylist(state, data) {
    // state.userPlaylists.forEach(function (element) {
    _.forEach(state.userPlaylists, function (element) {
      if (element.plId === data.plId) {
        element.items.push(data.item);
        return;
      }
    });
    return;
  },
  updatePlaylistItemDuration: function updatePlaylistItemDuration(state, data) {
    state.currentPlaylist.lastItemViewed.itemId = data.itemId;
    state.currentPlaylist.lastItemViewed.itemViewedDuration = data.lastDuration;
  },
  setLOMasterDataByPlaylist: function setLOMasterDataByPlaylist(state, data) {
    state.loMasterData = data;
  },
  updatePlayListLastItemViewedByPlaylistId: function updatePlayListLastItemViewedByPlaylistId(state, data) {
    // console.log('>>>>>>>>', JSON.stringify(data))
    if (state.userPlaylists !== null) {
      for (var i = 0; i < state.userPlaylists.length; i++) {
        if (state.userPlaylists[i].plId === data.plId) {
          state.userPlaylists[i].lastItemViewed.itemId = data.itemId;
          state.userPlaylists[i].lastItemViewed.lastViewedDuration = data.lastViewedDuration;
          break;
        }
      }
    }
  },
  SetUserSingleVideoCollectionInStore: function SetUserSingleVideoCollectionInStore(state, data) {
    // console.log(' in mutation SetUserSingleVideoCollectionInStore')
    // console.log(JSON.stringify(data))
    // console.log(data.noOfPages)
    // console.log(data.collectionList)
    state.currentPage = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.currentPage));
    if (data.noOfPages !== undefined) {
      state.numberOfPages = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.noOfPages));
    }
    state.singleConceptCollection = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.collectionList));
  }
};
var actions = {
  resetPlayListDetailsPaginationDetails: function resetPlayListDetailsPaginationDetails(context) {
    context.commit('resetPlayListDetailsPaginationDetailsInStore');
  },
  getUserPlayList: function getUserPlayList(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.axios.post('r/getAllPlaylists', data).then(function (response) {
        context.commit('setUserPlaylists', response.data);
        resolve();
      }).catch(function (err) {
        console.log('ERROR_IN_FETCHING_PLAYLIST : ', err);
        reject(err);
      });
    });
  },

  addItemInPlaylist: function addItemInPlaylist(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('addItemInPlaylist', data);
      resolve();
    });
  },
  setCurrentPlaylist: function setCurrentPlaylist(context, data) {
    context.commit('setCurrentPlaylist', data);
  },
  removePlayListFromDb: function removePlayListFromDb(context, data) {
    window.axios.post('r/deletePlayListItem', data).then(function (response) {
      context.commit('setUserPlaylists', response.data);
    }).catch(function (err) {
      console.log(err);
    });
  },
  createPlaylist: function createPlaylist(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.axios.post('r/createPlayList', data).then(function (response) {
        context.commit('appendPlaylist', response.data);
        resolve(response.data);
        // context.commit('setUserPlaylists', response.data)
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  daletePlaylist: function daletePlaylist(context, data) {
    window.axios.post('r/deletePlayList', data).then(function (response) {
      context.commit('setUserPlaylists', response.data);
    }).catch(function (err) {
      console.log(err);
    });
  },
  updatePlaylistItemDuration: function updatePlaylistItemDuration(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('updatePlaylistItemDuration', data);
      resolve();
    });
  },
  setLOMasterDataByPlaylist: function setLOMasterDataByPlaylist(context, data) {
    context.commit('setLOMasterDataByPlaylist', data);
  },
  updatePlayListLastItemViewedByPlaylistId: function updatePlayListLastItemViewedByPlaylistId(context, data) {
    context.commit('updatePlayListLastItemViewedByPlaylistId', data);
  },

  // fetchUserSingleConceptCollection - fetch the user single concepts collection page wise
  fetchUserSingleConceptCollection: function fetchUserSingleConceptCollection(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('o/getUserSingleConceptsCollection', { 'profileId': data.profileId, 'pageNo': data.pageNo }).then(function (res) {
        if (data.pageNo === 1) {
          res.data['collectionList'] = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.data.collectionList));
          res.data['currentPage'] = context.getters.getCurrentPage + 1;
          context.commit('SetUserSingleVideoCollectionInStore', res.data);
          resolve(res);
        } else {
          // console.log('append result to data')
          // var playList = JSON.parse(JSON.stringify(context.getters.getUserSingleConceptsCollection))
          var userSingleConceptCollection = {};
          var singleConceptPlayList = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(context.getters.getUserSingleConceptsCollection));
          for (var i = 0; i < res.data.collectionList.length; i++) {
            singleConceptPlayList.push(res.data.collectionList[i]);
          }
          // userSingleConceptCollection['collectionList'] = JSON.parse(JSON.stringify(context.getters.getUserSingleConceptsCollection)).concat(JSON.parse(JSON.stringify(res.data.collectionList)))
          // console.log('singleConceptPlayList ::: ', JSON.stringify(singleConceptPlayList))
          userSingleConceptCollection['collectionList'] = singleConceptPlayList;
          userSingleConceptCollection['currentPage'] = context.getters.getCurrentPage + 1;
          context.commit('SetUserSingleVideoCollectionInStore', userSingleConceptCollection);
        }
      }).catch(function (err) {
        console.log('error in fetching user collection : ', err);
        reject();
      });
    });
  },
  getSingleConceptSearchResult: function getSingleConceptSearchResult(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      //   axios
      //   .post(/')
      //   .then()
      //   .catch()
      resolve();
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "eO6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoggedIn) ? _c('div', {
    staticClass: "container-fluid course-card-css"
  }, [(_vm.$store.getters.getRecommendedCoursesData.length > 0) ? _c('div', {
    staticClass: "pb-3 row justify-content-end"
  }, [_c('h6', {
    staticClass: "col-md-12 text-left main-title"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.Recommended_Courses')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getRecommendedCoursesData.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('swiper', {
    staticClass: "px-3",
    attrs: {
      "options": _vm.swiperOptionCourse
    }
  }, _vm._l((_vm.$store.getters.getRecommendedCoursesData), function(course, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "card-course",
      on: {
        "click": function($event) {
          _vm.ViewDetails(course.contentId)
        }
      }
    }, [_c('div', {
      staticClass: "card-content"
    }, [(_vm.checkValue(course.thumbnail)) ? _c('div', [_c('div', {
      staticClass: "img-fluid",
      style: (_vm.generatePath(course.thumbnail))
    })]) : _c('div', [_c('div', {
      staticClass: "img-fluid",
      staticStyle: {
        "background-image": "url('../../../static/assets/images/defaultCO.jpg')"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "link-css",
      attrs: {
        "to": "coursePage"
      }
    }, [_c('p', {
      staticClass: "course-name"
    }, [_vm._v(_vm._s(course.title))])]), _vm._v(" "), _c('p', {
      staticClass: "course-cost"
    }, [_vm._v("\n              POINTS " + _vm._s(course.price) + "\n            ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "course-text"
    }, [_vm._v(_vm._s(_vm.$t('course.numberOfStudentsEnrolled')) + "\n                "), _c('strong', {
      staticClass: "pl-2"
    }, [_vm._v(_vm._s(course.enrolledCount) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "rating-ptag"
    }, [_vm._v(" " + _vm._s(_vm.$t('course.ratings')) + " " + _vm._s(course.rating) + "\n            \n              \n"), _c('div', [_c('star-rating', {
      attrs: {
        "rating": course.rating,
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "pt-3"
    }, [(_vm.presentInWishListStore(course.contentId)) ? _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.removeFromWishList(course.contentId)
        }
      }
    })]) : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addToWishList(course.contentId)
        }
      }
    })]), _vm._v(" "), (!_vm.inCart(course.contentId)) ? _c('div', [_c('button', {
      staticClass: "btn  btn-blue-outline mb-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addToCart(course.contentId)
        }
      }
    }, [_vm._v("ADD TO CART")])]) : _c('div', [_c('button', {
      staticClass: "btn mb-2 btn-blue"
    }, [_vm._v("ADDED")])])])], 1)])])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "options": _vm.swiperOptionCourse
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev swiper-course-prev",
    slot: "button-prev"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-course-next",
    slot: "button-next"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.$store.getters.getRecommendedCoursesData.length > 0) ? _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('router-link', {
    staticClass: "link-css",
    attrs: {
      "to": "allCourses"
    }
  }, [_c('button', {
    staticClass: "btn btn-large btn-blue m-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('course.view_all_courses')) + " ")])])], 1) : _vm._e()])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eW+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loadercss',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "f5rE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  collectionList: []
};
var getters = {
  getCollectionList: function getCollectionList(state) {
    return state.collectionList;
  },

  getLOObjectByContentId: function getLOObjectByContentId(state, getters) {
    return function (contentId) {
      for (var i = 0; i < getters.getCollectionList.length; i++) {
        if (getters.getCollectionList[i].contentId === contentId) {
          return getters.getCollectionList[i];
        }
      }
    };
  }

};

var mutations = {
  setCollectionList: function setCollectionList(state, data) {
    if (data !== null) {
      state.collectionList = data;
    }
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "gIzc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileContent_vue__ = __webpack_require__("tbNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48835813_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_profileContent_vue__ = __webpack_require__("IfgM");
function injectStyle (ssrContext) {
  __webpack_require__("Voaj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48835813_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_profileContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gzcv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h9xL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hCol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hJMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('profileContent')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hL9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveDemyLogout_vue__ = __webpack_require__("8TUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540d878a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_liveDemyLogout_vue__ = __webpack_require__("h9xL");
function injectStyle (ssrContext) {
  __webpack_require__("cQNi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveDemyLogout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540d878a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_liveDemyLogout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ip3D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jayJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swfPlayer_vue__ = __webpack_require__("culI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a48230a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_swfPlayer_vue__ = __webpack_require__("Fu3j");
function injectStyle (ssrContext) {
  __webpack_require__("LCRK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swfPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a48230a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_swfPlayer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jeSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__ = __webpack_require__("P5xh");



var state = {
  token: null,
  isLoggedIn: false
};

var getters = {
  getToken: function getToken(state) {
    return state.token;
  },
  getIsLoggedIn: function getIsLoggedIn(state) {
    return state.isLoggedIn;
  }
};

var mutations = {
  setIsLoggedIn: function setIsLoggedIn(state, isLogged) {
    state.isLoggedIn = isLogged;
  },
  setToken: function setToken(state, data) {
    // console.log('setting token')
    state.token = data;
  },
  deleteToken: function deleteToken(state) {
    // console.log('deleting token')
    state.token = null;
  }
};

var actions = {
  // setUserStoreData - initializes store data for user
  // [5/6/18] currently called from headerLogin.vue to initialize third party user registered on liveDemy and logins through third party forms
  setUserStoreData: function setUserStoreData(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      context.commit('setCartData', data.cartDetails);
      context.commit('setProfileDetails', data.profileDetails);
      context.commit('setWishListStoreData', data.wishListItems);
      context.commit('setUserPlaylists', data.userPlaylists);
      context.commit('setItemsEnrolled', data.enrolledLearningObject); // storing all LOs and COs purchased by user
      context.commit('setIsLoggedIn', true);
      resolve(true);
    });
  },

  // userSignIn - gets token from SSO server and initialized thee store data for user
  // [5/6/18] currently called from headerLogin.vue to initialize liveDemy and third party
  userSignIn: function userSignIn(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.MKCLAPI.login(data.username, data.password).then(function (token) {
        context.commit('setToken', token);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/o/loginForSocialUser', { headers: { 'clientId': __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["a" /* SSO_CLIENT_ID */], 'Authorization': token, 'jvId': data.jvId, 'linkingPermission': data.linkingPermission } }).then(function (response) {
          if (response.status === 200) {
            var userData = response.data;
            // console.log(JSON.stringify(response.data))
            context.commit('setCartData', userData.cartDetails);
            context.commit('setProfileDetails', userData.profileDetails);
            context.commit('setWishListStoreData', userData.wishListItems);
            context.commit('setUserPlaylists', userData.userPlaylists);
            context.commit('setItemsEnrolled', userData.enrolledLearningObject); // storing all LOs and COs purchased by user
            context.commit('setIsLoggedIn', true);
            localStorage.setItem('isLoggedIn', true);
            localStorage.setItem('token', token);
            localStorage.setItem('ssoToken', true);
            resolve('success');
          }
        }).catch(function (e) {
          console.log('Failed to initialize user Profile' + e.response.data);
          reject(new Error('Failed to initialize user Profile' + e.response.data));
        });
      }).catch(function (e) {
        console.log('FAILED_TO_GET_TOKEN_FROM_SSO : ', e);
        reject(e);
      });
    });
  },

  // logoutThirdPartyUser - deletes the session from redux server
  // returns true if session is deleted successfully
  logoutThirdPartyUser: function logoutThirdPartyUser(context) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/logoutThirdPartyUser').then(function (res) {
        resolve(true);
      }).catch(function (err) {
        console.log('ERROR_IN_REMOVING_SESSION : ', err);
        reject(err);
      });
    });
  },

  // signInThirdPartyUser - initialize store data for third party user (token => data, isLoggedIn => true, ssoToken => false)
  signInThirdPartyUser: function signInThirdPartyUser(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/o/loginForSocialUser', null, { headers: { 'Authorization': data } }).then(function (response) {
        if (response.status === 200) {
          context.commit('setCartData', response.data.cartDetails);
          context.commit('setProfileDetails', response.data.profileDetails);
          context.commit('setWishListStoreData', response.data.wishListItems);
          context.commit('setUserPlaylists', response.data.userPlaylists);
          context.commit('setItemsEnrolled', response.data.enrolledLearningObject); // storing all LOs and COs purchased by user
          context.commit('setIsLoggedIn', true);
          resolve();
        }
      }).catch(function (e) {
        console.log('ERROR_IN_INTILIALIZING_THIRD_PARTY_PROFILE : ', e);
        reject(e);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "jxDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container frames-video"
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-4 text-left input-find"
  }, [(_vm.$store.getters.getIsplaylist) ? _c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchLOString),
      expression: "searchLOString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contentViewer.placeholder.searchContentHere')
    },
    domProps: {
      "value": (_vm.searchLOString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchLOString = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "frame-holder"
  }, [(_vm.$store.getters.getSearchPlaylistLO(_vm.searchLOString) !== null && _vm.$store.getters.getSearchPlaylistLO(_vm.searchLOString).length > 0) ? _c('div', {
    staticClass: "vbar-holder"
  }, _vm._l((_vm.$store.getters.getSearchPlaylistLO(_vm.searchLOString)), function(content, i) {
    return _c('div', {
      key: i,
      staticClass: "cards"
    }, [(content.type === 'LO') ? _c('div', {
      class: _vm.$store.getters.getcurrentPlayingContent.contentId === content.contentId ? 'card card-active' : 'card',
      on: {
        "click": function($event) {
          _vm.play(content)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 video-col"
    }, [(_vm.checkValue(content.thumbnail)) ? _c('div', {
      staticClass: "video-wraper"
    }, [_c('video', {
      staticClass: "video-css",
      attrs: {
        "width": "100%",
        "height": "240",
        "poster": _vm.makePath(content.thumbnail)
      }
    }, [_c('source', {
      attrs: {
        "src": __webpack_require__("n/uR"),
        "type": "video/mp4"
      }
    }), _vm._v("\n                                  " + _vm._s(_vm.$t('common.errors.videoTagError')) + "\n                              ")]), _vm._v(" "), _vm._m(1, true)]) : _c('div', {
      staticClass: "video-wraper"
    }, [_c('video', {
      staticClass: "video-css",
      attrs: {
        "width": "100%",
        "height": "240",
        "poster": "../../../static/assets/images/defaultLO.jpg"
      }
    }, [_c('source', {
      attrs: {
        "src": __webpack_require__("n/uR"),
        "type": "video/mp4"
      }
    }), _vm._v("\n                                  " + _vm._s(_vm.$t('common.errors.videoTagError')) + "\n                              ")]), _vm._v(" "), _vm._m(2, true)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 description align-middle"
    }, [_c('strong', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.labels.Duration')) + "   "), _c('span', [_vm._v(" " + _vm._s((content.duration / 60).toString().split('.')[0]) + " Mins " + _vm._s(parseInt((content.duration / 60).toFixed(1).split('.')[1]) * 6) + " sec")])]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      on: {
        "click": function($event) {
          _vm.showRating(content.contentId)
        }
      }
    }, [_c('span', {
      staticClass: "ratingText"
    }, [_vm._v("Your rating")]), _vm._v(" "), _c('span', [_c('star-rating', {
      attrs: {
        "rating": content.rating,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      },
      on: {
        "rating-selected": _vm.setRating
      }
    })], 1)]) : _vm._e()])])]) : _vm._e()])
  })) : _c('div', {
    staticClass: "watermark"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contentViewer.labels.noResultFoundError')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 video-gallery"
  }, [_c('div', {
    staticClass: "row gallery-head"
  }, [_c('div', {
    staticClass: "col-auto pr-0"
  }, [_c('b-dropdown', {
    attrs: {
      "id": "language-dd",
      "text": _vm.getLanguageNameById(_vm.language)
    },
    on: {
      "change": _vm.setContentPathByLanguage
    },
    model: {
      value: (_vm.language),
      callback: function($$v) {
        _vm.language = $$v
      },
      expression: "language"
    }
  }, _vm._l((_vm.getLanguages()), function(lang, index) {
    return _c('b-dropdown-item', {
      key: index,
      attrs: {
        "value": index + 1
      },
      on: {
        "click": function($event) {
          _vm.setContentPathByLanguage(lang)
        }
      }
    }, [_vm._v(_vm._s(lang))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col video-title"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$store.getters.getcurrentPlayingContent.title))])]), _vm._v(" "), (_vm.$store.getters.getEnrolledLODataByContentIdProfileId != null &&
    _vm.$store.getters.getEnrolledLODataByContentIdProfileId != undefined &&
    _vm.$store.getters.getEnrolledLODataByContentIdProfileId.expiryDate != undefined &&
    _vm.$store.getters.getEnrolledLODataByContentIdProfileId.expiryDate != null) ? _c('div', {
    staticClass: "col-auto wallet-amt"
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mdi mdi-desktop-mac view-icon",
    attrs: {
      "title": _vm.getRemainingDays(_vm.$store.getters.getEnrolledLODataByContentIdProfileId.expiryDate)
    }
  })]) : _c('div')]), _vm._v(" "), (_vm.isPurchase != null && _vm.isPurchase) ? _c('div', {
    staticClass: "container-player",
    attrs: {
      "id": "container-player"
    }
  }, [(_vm.isVideo) ? _c('div', {
    staticClass: "meadia-wraper"
  }, [_c('videoPlayer', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHTML) ? _c('div', {
    staticClass: "meadia-wraper"
  }, [_c('htmlViewer', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isImage) ? _c('div', {
    staticClass: "meadia-wraper"
  }, [_c('imageViewer', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isPDF) ? _c('div', {
    staticClass: "meadia-wraper"
  }, [_c('pdfViewer', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isYoutube) ? _c('div', {
    staticClass: "meadia-wraper"
  }, [_c('youtube-player', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSWF) ? _c('div', {
    staticClass: "meadia-wraper",
    attrs: {
      "controls": ""
    }
  }, [_c('swfPlayer', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAudio) ? _c('div', {
    staticClass: "meadia-wraper"
  }, [_c('audioPlayer', {
    attrs: {
      "path": _vm.getCdpCdnUrl
    }
  })], 1) : _vm._e()]) : (_vm.showViewCountExhaustedMsg != null) ? _c('div', {
    staticClass: "video-not-found text-center"
  }, [(_vm.showViewCountExhaustedMsg) ? _c('span', [_c('h5', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$t('contentViewer.labels.viewCountExhausted')))])]) : _c('span', [_c('h5', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$t('contentViewer.labels.itemNotPurchased')))])]), _vm._v(" "), (_vm.cartAdd(_vm.$store.getters.getcurrentPlayingContent.contentId)) ? _c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-green-outline"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))])]) : _c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-green-outline mt-3",
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.$store.getters.getcurrentPlayingContent.contentId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "play-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-play-circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "play-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-play-circle"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jzGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cart_vue__ = __webpack_require__("HReX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e91d623c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_cart_vue__ = __webpack_require__("ZNv8");
function injectStyle (ssrContext) {
  __webpack_require__("wrZK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e91d623c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_cart_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k1mU":
/***/ (function(module, exports) {

module.exports = {"common":{"labels":{"surf_library":"संग्रह पहा","check_courses":"यशोगाथा पाहा","log_in":"लॉगीन","sign_up":"साईन अप","logout":"लॉगआऊट","your_profile":"तुमची प्रोफाईल","now":"आता","PLAY_NOW":"बघा","ADDED":"समाविष्ट केले आहे","ADD_TO_CART":"ADD TO CART","PLAY":"प्ले करा","PLAY_ALL":" सर्व प्ले करा","your_Rating":"तुमचे रेटिंग","RATING_MSG":"तुमचे रेटिंग शेअर करा","ADD_MONEY":"Add Money","TRANSACTION_ID":"Transaction ID","GO_TO_COURSE":"यशोगाथा बघा","MyCourses":"माझ्या यशोगाथा / कौशल्ये","Courses":"यशोगाथा","Duration":"कालावधी","Courses_in":"Courses in","POINTS":"POINTS","Ratings":"रेटिंग","OVERALL_RATING":"सर्वसाधारण रेटिंग","Total_Points_Need_To_Purchase":"Total Points you need to purchase","Recommended_Courses":"तुम्हाला आवडतील असे व्हिडीओज्","Recently_added_Videos":"समाविष्ट केलेल्या यशोगाथा व कौशल्ये","CART_WISHLIST_WITHOUT_LOGIN":"Please login before adding it to cart / wishlist","shareOn":"शेअर करा","Back":"मागे","All":"यशोगाथा व कौशल्ये","SearchPlaceHolder":"यशोगाथा किंवा नवीन कौशल्य शोधा"},"alerts":{"DATA_NOT_VALID":"कृपया योग्य माहिती भरा","DATA_EMPTY":"कृपया संपूर्ण माहिती भरा","FIELD_EMPTY":"कृपया संपूर्ण माहिती भरा","ONLY_NUMERIC":"केवळ अंक भरा","ONLY_ALPHABETS":"केवळ अक्षर भरा","ONLY_ALPHANUMERIC":"केवळ अंक/अक्षर भरा","CART_ADDED_SUCCESS":"Added to cart successfully","RATING_ADDED":"रेटिंग यशस्वीरीत्या जमा केले","ALL_CART_ADDED_SUCCESS":"All items have been added to the cart successfully","POINTS_IN_WALLET":"Points in your wallet"},"errors":{"videoTagError":"तुमचा ब्राउझर हा व्हिडीओ सपोर्ट करत नाही","CartItemAddError":"कृपया थोड्यावेळाने प्रयत्न करा. गैरसोयीबद्दल क्षमस्व","audioTagError":"तुमचा ब्राउझर हा ऑडीओ सपोर्ट करत नाही"}},"login":{"alerts":{"logout_success":"तुम्ही लॉगआउट झालेले आहात, पुन्हा भेटू","logout_fail":""}},"profileDetails":{"labels":{"fullName":"संपूर्ण नाव","yourName":"आपले नाव","dob":"जन्मदिनांक","gender":"लिंग","gender_male":"पुरूष","gender_female":"स्त्री","email":"ईमेल आयडी","mobile":"मोबाईल नं.","aboutMe":"माझ्याविषयी","skills":"कौशल्ये","editButtonText":"प्रोफाईल एडीट करा","saveButtonText":"प्रोफाईल सेव्ह करा","watchButtonText":"पाहा","WatchCount":"संख्या पहा","TotalWatchedDuration":"एकूण पाहिलेला कालावधी","PurchasedOn":"Purchased On","ExpiresOn":"Expires On","noLO":"नवीन काय आले ते पहा","Playlist":"सूची","PurchasedVideos":"संग्रह","PurchasedCourses":"यशोगाथा / कौशल्ये","CourseCompletionStatus":"Course Completion Status","SolvedChallenges":"Solved Challenges","timeSpent":"व्यतीत केलेला वेळ","CompletedLectures":"Completed lectures","TotalLectures":"Total lectures","CourseStartDate":"Course Start Date:","CourseEndDate":"Course End Date:","PleaseWait":"कृपया प्रतीक्षा करा...","No. of Concepts":"यशोगाथांची संख्या","No.of Concept":" यशोगाथांची संख्या ","Hi_I_am":"Hi! I am","Course_starts_on":"Course starts on","and_expires_on":"and expires on","You've_solved":"You've solved","and_completed":"and completed","out_of":"out of","challenges":"challenges","lectures":"lectures","My_Rating":"तुमचे रेटिंग","Share_on":"शेअर करा","item_purchased_on":"You've purchased this content on","item_expires_on":"and it expires on","Watch_Count":"पाहिलेली संख्या"},"placeholder":{"fullname":"संपूर्ण नाव","email":"ईमेल आयडी","mobile":"मोबाईल नं.","YourFullName":"तुमचे संपूर्ण नाव","WriteAboutYourself":"Hi there ! Write about yourself here","contact":"संपर्क","AccountType":"खाते प्रकार","SeeMore":"अजून पहा"},"alerts":{"DATA_NOT_VALID":"कृपया सर्व माहिती व्यवस्थित भरा","FAILED_TO_UPDATE_PROFILE_DETAILS":"काहीतरी अडचण येतेय, कृपया सर्व माहिती भरणे चालूच ठेवा","FILE_UPLOADED_SUCCESS":"फाईल यशस्वीरित्या अपलोड झाली आहे ","FILE_DELETED_SUCCESS":"फाईल काढून टाकण्यात आली आहे","noVideosToDisplay":"तुमच्या सूचीमध्ये व्हिडियो टाकणे सुरु करा","File_replace_success":"फाईल यशस्वीरीत्या बदलली"},"errors":{"Name_cannot_empty":"कृपया आपले नाव एंटर करा ","Invalid_email_address":"ईमेल आयडी चुकीचा आहे","File_size_more_than_512":"फाईलची साईज 512kb पेक्षा जास्त आहे","Can_not_upload_multiple_files":"तुम्ही एकापेक्षा जास्त फाईल्स अपलोड करू शकत नाही"}},"cart":{"labels":{"cart":"cart","Cost":"Cost","ItemsInYourCart":"Items in your cart","ItemInYourCart":"Item in your cart","InWishlist":"In wishlist","MoveToWishlist":"पाहण्यासाठी सूचीमध्ये टाका","Points":"POINTS","Point":"POINT","RedeemedMsg":"Points will be automatically redeemed from wallet in case of sufficient balance.","NoCashTransactionMsg":"No cash transaction will be required.","TotalPointsReq":"Total Points Required","ProceedToRedem":"Proceed to redemption"},"placeholders":{},"alerts":{"DeletedFromCart":"Deleted from cart successfully","AddItemToCart":"Add item to your cart","RemovalConfirmation":"Are you sure, you want to remove item from Cart ?"}},"wallet":{"labels":{"WalletBalance":"Wallet Balance","YouHave":"You have","AddMoneyInWallet":"Add money in wallet","ContactUs":"Contact us for queries","WatchedFor":"Watched for","MinutesOn":"Minutes on","FailedToAddMsg":"Failed to add in wallet on","AddedToWalletOn":"Added to wallet on","PurchaseMadeOn":"Purchase made on","Activities":"Activities","Transactions":"Transactions","Points":"Points"},"placeholders":{"EnterAmount":"Enter amount"},"alerts":{"EnterValidAmount":"Kindly enter valid amount"}},"wishlist":{"labels":{"MyWishlist":"पाहण्यासाठी सूची","StudentRating":"Student rating","MoveToCart":"Move to cart","MoveAllToCart":"Move all to cart","AddCoursesInWishlist":"पाहण्यासाठीच्या सूचीमध्ये व्हिडियो टाका","RemoveFromWishlistMsg":"पाहण्यासाठीच्या सूचीमधून काढून टाका"},"placeholders":{},"alerts":{"RemoveItem":" पाहण्यासाठीच्या सूचीमधून व्हिडियो काढून टाकला","RemoveItemConfirm":"तुम्हाला खात्रीलायकरीत्या पाहण्यासाठीच्या सूचीमधून हा व्हिडियो काढायचा आहे का?","AddedToWishList":" पाहण्यासाठीच्या सूचीमध्ये व्हिडियो यशस्वीरीत्या टाकला"}},"course":{"numberOfStudentsEnrolled":"No. of students enrolled","courseDuration":"Course duration","lectures":"Lectures","noCourses":"टाकण्यास सुरवात करा","purchased":"Purchased","added":"जोडले","ratings":"रेटिंग","my_rating":"तुमचे रेटिंग","share_on":"शेअर करा","view_all_courses":"सर्व यशोगाथा पहा","students_review_about_course":"Students' Reviews About Course","course_description":"यशोगाथेचा तपशील","download_syllabus":"Download Syllabus","trending_courses":"लोकप्रिय यशोगाथा / कौशल्ये","GO_TO_COURSE":"यशोगाथा बघा"},"instructor_profile":{"course_taught_by":"This course is taught by","instructor_name":"Name of Instructor","designation":"हुद्दा / पद","view_profile":"प्रोफाईल पहा"},"playlist":{"numOfViews":"एकूण कितीवेळा पहिला गेला ती संख्या","duration":"कालावधी","noPlaylists":"तुमची यशोगाथा सूची बनवा","AddToPlaylist":"यशोगाथा सूचीमध्ये समाविष्ट करा","CreateNewPlaylist":"यशोगाथेची नवीन सूची तयार करा","VideoTagError":"तुमचा ब्राउझर हा व्हिडीओ सपोर्ट करत नाही","RemainingMsg":"उर्वरित","DeletePlaylist":"सूची काढून टाका","Create":"तयार करा","CreatePlaylist":"यशोगाथा सूची बनवा","ResumePlaying":"चालू ठेवा","HereLink":"इथे","Concept":"संकल्पना","Concepts":"संकल्पना","labels":{"MyCollection":"संकलन","MyPlaylist":"माझी  संग्रह सूची","RemoveFromThisPlaylist":"ह्या सूची मधून काढून टाका","PlaylistName":"यशोगाथा सूचीचे नाव","AddToExistingPlaylists":"उपलब्ध असलेल्या सूचीमध्ये समाविष्ट करा","CreateNewPlaylistMsg":"नवीन यशोगाथा सूची बनवा!","BlankPlaylistMsg":"सूचीमध्ये यशोगाथा समाविष्ट करा","AddFramesMsg":"You can add frames in this collection now! Start searching frames","ShowMsg":"संदेश दाखवा","OR":"किंवा","AND":"आणि","Show_more":"आणखी दाखवा ","My_rating":"Your Rating","share_on":"शेअर करा","Add_Item_To_Playlist":"You can add items from collection to this playlist"},"placeholders":{"TypePlaylistNameHere":"सूचीचे नाव येथे टाईप करा","NameYourPlaylist":"तुमच्या यशोगाथेच्या सूचीला नाव द्या","TypeNewPlaylistNameHere":"नवीन यशोगाथा सूचीचे नाव इथे टाईप करा "},"alerts":{"ENTER_PLAYLIST_NAME":"कृपया तुमच्या यशोगाथा सूचीला नाव द्या","PLAYLIST_ALREADY_PRESENT":"माफ करा. ही सूची आधीच अस्तित्वात आहे","ADDED_INTO_PLAYLIST":"सूचीमध्ये समाविष्ट करण्यात आले आहे","SELECT_PLAYLIST":"Please select any existing playlist or create a new one","PRESENT_IN_PLAYLIST":"ह्यामध्ये उपलब्ध आहे","PLAYLIST_CREATED":"सूची तयार करण्यात आली आहे, यशोगाथा टाका","DELETE_ITEM":"काढून टाकण्यात आले आहे","DELETE_PLAYLIST":"यशोगाथेची सूची काढून टाकण्यात आली आहे","REMOVAL_CONFIRMATION":"तुम्हाला सूचीमधून हा व्हिडीओ खरचं काढायचा आहे का?","PLAYLIST_DELETE_CONFIRMATION":"तुम्हाला सूची खरचं काढून टाकायची आहे का?"}},"recommendation":{"labels":{"you_may_like":"तुम्हाला आवडेल","lo_label":"SINGLE CONCEPT"}},"libraryCards":{"labels":{"most_watched_Videos":"सर्वाधिक पाहिलेल्या यशोगाथा व  ौशल्ये","lo_label":"एक यशोगाथा","share_on":"शेअर करा"}},"myCourses":{"labels":{"LearnAbout":"पुढच्या सत्रामध्ये तुम्ही शिकाल की...","RemainingMsg":"उर्वरित","NoCourses":"Start purchasing your courses now!"}},"searchPage":{"labels":{"multipleResults":"पर्याय","singleResults":"पर्याय","ChooseCategory":"संवर्ग निवडा","ShowMore":"आणखी दाखवा","ShowLess":"कमी दाखवा","Language":"पुढील भाषेमध्ये उपलब्ध आहे","Cost":"किंमत","Duration":"कालावधी","ClearAllFilters":"सर्व फिल्टर्स काढून टाका","loading":"लोड करीत आहे","showing":"च्या साठी दाखवत आहे","resultsOutOf":"च्या परिणाम","EnrolledCount":"Enrolled count","Lectures":"Lectures","Points":"POINTS","allResultsDisplayed":"सर्व परिणाम प्रदर्शित","noRecordsFound":"आपला शोध बदलण्याचा प्रयत्न करा","EnterTextToSearch":"आपण शिकू इच्छित कौशल्य शोधणे प्रारंभ करा"},"alerts":{"AddItemToWishlist":" पाहण्यासाठीच्या सूचीमध्ये टाकले","ItemRemovedFromWishlist":" पाहण्यासाठीच्या सूचीमधून काढून टाकले","AddItemToCart":"Item added to cart successfully","CartAddError":"क्षमा करा, जोडताना काहीतरी अडचण येतेय, पुन्हा प्रयत्न करा"}},"contentViewer":{"labels":{"noResultFoundError":"There are no results","viewCountExhausted":"You have exceeded no of views","itemNotPurchased":"Please purchase this item to view"},"placeholder":{"searchContentHere":"तुमचा कंटेंट येथे शोधा..."}},"footer":{"mahademy_title":"Powered by Maharashtra Knowledge Corporation Ltd. (MKCL) as Knowledge Partner and Solution Architect,","mkcl_title":"Maharashtra Knowledge Corporation Limited.","rights_reserved":"सर्व हक्क राखीव.","about":"MKCL विषयी","disclaimer":"सूचना व अटी","privacy_policy":"Privacy Policy","copyright":"Copyright"},"offers":{"new_offers_available_soon":"NEW OFFERS WILL BE AVAILABLE SOON !"},"era_redirect":{"show_era":"Show ERA","token_set":"Token Set"},"payment":{"labels":{"payment_receive":"Congrats! Your transaction has been processed. We have successfully received an amount of","credits_added":"Credits added to your wallet","transaction_failed":"Transaction failed for amount","go_to_profile":"प्रोफाईलकडे जा","go_to_home":"मुख्यपृष्ठाकडे जा","go_to_wallet":"Go To Wallet"}}}

/***/ }),

/***/ "lIyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mahademyHome_vue__ = __webpack_require__("aXMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2667fe16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_mahademyHome_vue__ = __webpack_require__("/6OH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mahademyHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2667fe16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_mahademyHome_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lKwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    attrs: {
      "id": "imgHolder",
      "src": _vm.mediaPath
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lMjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lcmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'htmlViewer',
  props: ['path'],
  data: function data() {
    return {
      mediaPath: this.path,
      media: '',
      htmlHolder: ''
    };
  },
  mounted: function mounted() {
    // console.log('html viewer path:' + this.mediaPath)
  },

  watch: {
    path: function path(newValue, oldValue) {
      // console.log('html:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue;
      this.htmlHolder = document.getElementById('htmlHolder');
      // this.clone = this.htmlHolder.cloneNode(true)
      // this.clone.setAttribute('src', newValue)
      // this.htmlHolder.parentNode.replaceChild(this.clone, this.htmlHolder)
      var innerHTMLObj = '<object  :data="' + newValue + '" ></object>';
      this.htmlHolder.innerHTML = '';
      this.htmlHolder.innerHTML = innerHTMLObj;
    }
  },
  created: function created() {
    this.$parent.$on('notifyHTMLViewer', this.notifyHTMLViewer);
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('html destroy called')
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', { 'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 });
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
          /* return new Promise((resolve, reject) => {
            axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
            .then(response => {
              this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject()
            })
          }) */
        }
    }
  }
});

/***/ }),

/***/ "mH3w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_coursePage_vue__ = __webpack_require__("dtsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a141991e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_coursePage_vue__ = __webpack_require__("vYOO");
function injectStyle (ssrContext) {
  __webpack_require__("+zfG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_coursePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a141991e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_coursePage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mOXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder",
    attrs: {
      "id": "library-cards"
    }
  }, [(_vm.$store.getters.getrecommendedItems !== undefined && _vm.$store.getters.getrecommendedItems !== null && _vm.$store.getters.getrecommendedItems.length > 0) ? _c('div', {
    staticClass: "pb-2 row justify-content-end"
  }, [_c('h6', {
    staticClass: "main-title col-12 text-left"
  }, [_vm._v(_vm._s(_vm.$t('recommendation.labels.you_may_like')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getrecommendedItems !== undefined && _vm.$store.getters.getrecommendedItems !== null && _vm.$store.getters.getrecommendedItems.length > 0) ? _c('div', {
    staticClass: "swiper-holder"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_vm._l((_vm.$store.getters.getrecommendedItems), function(item, i) {
    return (!_vm.$store.getters.getItemPurchasedStatus(item.contentId)) ? _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "card-design"
    }, [(item.thumbnail.length != 0) ? _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": _vm.makePath(item.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": "../../../static/assets/images/defaultLO.jpg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [(item.type == 'LO') ? _c('div', {
      staticClass: "lo-label"
    }, [_vm._v(_vm._s(_vm.$t('libraryCards.labels.lo_label')))]) : _vm._e(), _vm._v(" "), (item.type == 'LO') ? _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.type == 'CO') ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "tag": "h3",
        "title": item.title,
        "to": {
          name: 'coursePage',
          params: {
            contentId: item.contentId
          }
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(item.price) + " " + _vm._s(item.price > 1 ? 'Points' : 'Point '))]), _vm._v(" "), _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]), _vm._v(" "), (parseInt(item.rating) == 0) ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(item.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(item.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ratingText"
    }, [_vm._v("Share On ")]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": 'www.livedemy.mkcl.org/' + item.title,
        "title": item.title,
        "description": item.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "social-links"
            }, [_c('network', {
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "mdi mdi-email"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "mdi mdi-facebook"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "mdi mdi-twitter"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "linkedin"
              }
            }, [_c('i', {
              staticClass: "mdi mdi-linkedin"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "skype"
              }
            }, [_c('i', {
              staticClass: "mdi mdi-skype"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row mt-3"
    }, [(_vm.$store.getters.getItemSubscriptionStatus({
      'id': item.contentId,
      'type': item.type
    }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
      'id': item.contentId,
      'type': item.type
    }) != null && _vm.$store.getters.getItemSubscriptionStatus({
      'id': item.contentId,
      'type': item.type
    })) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.playLO(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_NOW')))])]) : _c('div', {
      staticClass: "col"
    }, [(_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(item.contentId)) ? _c('button', {
      staticClass: "btn btn-green-alt"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(item.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]), _vm._v(" "), (_vm.$store.getters.getItemPurchasedStatus(item.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(item.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(item.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(item.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(item.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(item.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(item.contentId) != undefined && $store.getters.itemPresentInCartStatus(item.contentId)!= null && !$store.getters.itemPresentInCartStatus(item.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(item.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(item.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(item.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })])])], 1)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  clearUserData: function clearUserData(context) {
    context.commit('deleteToken');
    context.commit('setIsLoggedIn', false);
    context.commit('clearWishListStoreData');
    context.commit('clearCartData');
    context.commit('clearProfileDetails');
    context.commit('clearPlaylistData');
    context.commit('resetSearchType');
    context.commit('clearSearchStoreData');
    context.commit('clearCategoryStoreData');
    context.commit('clearEnrolledItemsDetails');
    context.commit('resetMostSearchWordList');
    context.commit('setSearchType', 'all');
    var i = sessionStorage.length;
    while (i--) {
      var key = sessionStorage.key(i);
      sessionStorage.removeItem(key);
    }
    var j = localStorage.length;
    while (j--) {
      var _key = localStorage.key(j);
      localStorage.removeItem(_key);
    }
  }
});

/***/ }),

/***/ "mfkx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n/uR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/a.d55bddf.mp4";

/***/ }),

/***/ "nILK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadercss_vue__ = __webpack_require__("eW+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000ab1f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_loadercss_vue__ = __webpack_require__("8Wcx");
function injectStyle (ssrContext) {
  __webpack_require__("oW0j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadercss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000ab1f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_loadercss_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "npNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_bannerSearch_vue__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wishList_courseWishList__ = __webpack_require__("Bhfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mycourseCards__ = __webpack_require__("qjR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_footerArea__ = __webpack_require__("Yu1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_trendingCourses__ = __webpack_require__("8bW+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wishlist',
  components: {
    bannerSearch: __WEBPACK_IMPORTED_MODULE_2__home_bannerSearch_vue__["a" /* default */],
    mycourseCards: __WEBPACK_IMPORTED_MODULE_5__mycourseCards__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_4__home_courseCards__["a" /* default */],
    courseWishlist: __WEBPACK_IMPORTED_MODULE_3__components_wishList_courseWishList__["a" /* default */],
    footerArea: __WEBPACK_IMPORTED_MODULE_6__common_footerArea__["a" /* default */],
    trendingCourses: __WEBPACK_IMPORTED_MODULE_7__components_home_trendingCourses__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      showTrendingCard: false
    };
  },

  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.globalState = $state;
      setTimeout(function () {
        _this.showTrendingCard = true;
        // this.showLibraryCard = true
        $state.loaded();
      }, 2000);
    },

    // handleScroll - handles scrolling
    handleScroll: function handleScroll() {
      var _this2 = this;

      if (this.showTrendingCard) {
        setTimeout(function () {
          if (_this2.$refs.infiniteLoader !== undefined) {
            _this2.globalState.complete();
          }
        }, 2000);
      }
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$emit('showNav', true);
  }
});

/***/ }),

/***/ "nuTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myCourses"
  }, [_c('banner-search'), _vm._v(" "), _c('div', {
    staticClass: "content-holder"
  }, [_c('mycourseCards'), _vm._v(" "), (_vm.showTrendingCard && _vm.$store.getters.getItemsEnrolledByType('CO') != undefined && _vm.$store.getters.getItemsEnrolledByType('CO') != null && _vm.$store.getters.getItemsEnrolledByType('CO').length == 0) ? _c('trendingCourses') : _vm._e(), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oVvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'audioPlayer',
  loaded: true,
  props: ['path'],
  data: function data() {
    return {
      mediaPath: this.path
    };
  },
  mounted: function mounted() {
    // console.log('audio player path:' + this.mediaPath)
  },

  watch: {
    path: function path(newValue, oldValue) {
      // console.log('audio:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue;
      this.audioHolder = document.getElementById('audioHolder');
      this.clone = this.audioHolder.cloneNode(true);
      this.clone.setAttribute('src', newValue);
      this.audioHolder.parentNode.replaceChild(this.clone, this.audioHolder);
      this.clone.play();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', { 'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 });
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            response()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
          /* return new Promise((resolve, reject) => {
            axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
            .then(response => {
              this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject()
            })
          }) */
        }
    }
  }
});

/***/ }),

/***/ "oW0j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oey5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pA/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobileHome_vue__ = __webpack_require__("IvKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ebeefe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_mobileHome_vue__ = __webpack_require__("RLDc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobileHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ebeefe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_mobileHome_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pCe1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiselectMixin__ = __webpack_require__("C+QQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pointerMixin__ = __webpack_require__("DqTG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-multiselect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__multiselectMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__pointerMixin__["a" /* default */]],
  props: {

    /**
     * name attribute to match optional label element
     * @default ''
     * @type {String}
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * String to show when pointing to an option
     * @default 'Press enter to select'
     * @type {String}
     */
    selectLabel: {
      type: String,
      default: 'Press enter to select'
    },
    /**
     * String to show when pointing to an option
     * @default 'Press enter to select'
     * @type {String}
     */
    selectGroupLabel: {
      type: String,
      default: 'Press enter to select group'
    },
    /**
     * String to show next to selected option
     * @default 'Selected'
     * @type {String}
    */
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    /**
     * String to show when pointing to an alredy selected option
     * @default 'Press enter to remove'
     * @type {String}
    */
    deselectLabel: {
      type: String,
      default: 'Press enter to remove'
    },
    /**
     * String to show when pointing to an alredy selected option
     * @default 'Press enter to remove'
     * @type {String}
    */
    deselectGroupLabel: {
      type: String,
      default: 'Press enter to deselect group'
    },
    /**
     * Decide whether to show pointer labels
     * @default true
     * @type {Boolean}
    */
    showLabels: {
      type: Boolean,
      default: true
    },
    /**
     * Limit the display of selected options. The rest will be hidden within the limitText string.
     * @default 99999
     * @type {Integer}
     */
    limit: {
      type: Number,
      default: 99999
    },
    /**
     * Sets maxHeight style value of the dropdown
     * @default 300
     * @type {Integer}
     */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
     * Function that process the message shown when selected
     * elements pass the defined limit.
     * @default 'and * more'
     * @param {Int} count Number of elements more than limit
     * @type {Function}
     */
    limitText: {
      type: Function,
      default: function _default(count) {
        return 'and ' + count + ' more';
      }
    },
    /**
     * Set true to trigger the loading spinner.
     * @default False
     * @type {Boolean}
    */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Disables the multiselect if true.
     * @default false
     * @type {Boolean}
    */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Fixed opening direction
     * @default ''
     * @type {String}
    */
    openDirection: {
      type: String,
      default: ''
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isSingleLabelVisible: function isSingleLabelVisible() {
      return this.singleValue && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible: function isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues: function visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue: function singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : '';
    },
    deselectGroupLabelText: function deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : '';
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : '';
    },
    selectGroupLabelText: function selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : '';
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : '';
    },
    inputStyle: function inputStyle() {
      if (this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { 'width': 'auto' } : { 'width': '0', 'position': 'absolute', 'padding': '0' };
      }
    },
    contentStyle: function contentStyle() {
      return this.options.length ? { 'display': 'inline-block' } : { 'display': 'block' };
    },
    isAbove: function isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true;
      } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
        return false;
      } else {
        return this.prefferedOpenDirection === 'above';
      }
    },
    showSearchInput: function showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : true);
    }
  }
});

/***/ }),

/***/ "pUck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object', {
    attrs: {
      "id": "pdfHolder",
      "data": _vm.mediaPath
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_02815865_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("0AB+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_02815865_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "phBq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_shareOnMedia__ = __webpack_require__("HOUo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchCards',
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a,
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default.a,
    ShareOnMedia: __WEBPACK_IMPORTED_MODULE_6__common_shareOnMedia__["a" /* default */]
  },
  data: function data() {
    return {
      // multipleResults: $t('searchPage.labels.multipleResults'),
      // singleResults: $t('searchPage.labels.singleResults'),
      instanceName: __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */],
      userId: '',
      showLoader: true,
      moreCategory: '',
      showAllCategory: false,
      showAllLanguage: false,
      value: [],
      cost: [],
      tooltip: 'always',
      formatter: 'Rs {value}',
      dtoggle: false,
      ctoggle: false,
      etoggle: false,
      rtoggle: false,
      languageSelected: [],
      categoriesSelected: [],
      durationSelected: {},
      halfoptions: [{ text: 'English', value: '1' }, { text: 'हिन्दी', value: '2' }],
      options: [{ text: 'English', value: '1' }, { text: 'हिन्दी', value: '2' }, { text: 'मराठी', value: '3' }],
      categories: [],
      duration: { 'low': { text: 'Low to High', value: 0 }, 'high': { text: 'High to Low', value: 1 } },
      searchResult: [],
      searchClickStatus: false,
      Language: ''
    };
  },

  methods: {
    // checks whether rtl style is followed
    checkForRTL: function checkForRTL() {
      if (document.getElementsByTagName('body')[0].getAttribute('dir') !== undefined && document.getElementsByTagName('body')[0].getAttribute('dir') === 'rtl') {
        return true;
      }
      return false;
    },

    // makes URL for CDP path
    makePath: function makePath(path) {
      return __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },

    //  handles lazy loading
    infiniteHandler: function infiniteHandler($state) {
      if (this.$store.getters.getFilteredData({ 'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value }).length > 0) {
        // console.log(this.$store.getters.getFirstIndex + '<' + this.$store.getters.getTotalResultLength)
        // console.log(this.$store.getters.getTotalResultLength + '>' + this.$store.getters.getLastIndex)
        // if (this.$store.getters.getTotalResultLength > this.$store.getters.getLastIndex) {
        // console.log((this.$store.getters.getFirstIndex + '<' + this.$store.getters.getTotalResultLength))
        // console.log((this.$store.getters.getTotalResultLength + '<' + this.$store.getters.getLastIndex))
        if (this.$store.getters.getFirstIndex < this.$store.getters.getTotalResultLength && this.$store.getters.getTotalResultLength > this.$store.getters.getLastIndex) {
          if (this.isLoggedIn) {
            var profileDetails = this.$store.getters.getProfileDetails;
            if (profileDetails !== null && profileDetails.profileId != null) {
              this.userId = profileDetails.profileId;
            }
          }
          // old working
          // this.$store.dispatch('appendSearchResult', {'searchText': this.$store.getters.getSearchText, 'userId': this.userId, 'startIndex': this.$store.getters.getLastIndex + 1, 'lastIndex': this.$store.getters.getLastIndex + 6}).then(response => {
          this.$store.dispatch('appendSearchResult', { 'searchText': this.$store.getters.getSearchText, 'userId': this.userId, 'startIndex': this.$store.getters.getLastIndex, 'lastIndex': this.$store.getters.getLastIndex + 5, 'location': { 'coordinates': [0.0, 0.0] } }).then(function (response) {
            // to be called to finish current scroll event
            $state.loaded();
          }, function (error) {
            console.log('error in apending search result', error);
          });
        } else {
          // to be called when complete result displayed
          $state.complete();
        }
      }
    },
    displayLanguage: function displayLanguage(langArr) {
      // alert(JSON.stringify(langArr))
      // console.log(JSON.stringify(langArr))
      var language = '';
      for (var i = 0; i < langArr.length; i++) {
        // alert(langArr[i])
        if (langArr[i] === '1') {
          if (language.length !== 0) {
            language = language + ', English';
          } else {
            language = 'English';
          }
        } else if (langArr[i] === '2') {
          if (language.length !== 0) {
            language = language + ', Hindi';
          } else {
            language = 'Hindi';
          }
        } else if (langArr[i] === '3') {
          if (language.length !== 0) {
            language = language + ', Marathi';
          } else {
            language = 'Marathi';
          }
        }
      }
      return language;
    },
    getTagString: function getTagString(contentObj) {
      var tagsArray = [];
      if (contentObj.metadata.courseObj.Tags !== null && contentObj.metadata.courseObj.Tags !== undefined && contentObj.learningObjectTags !== null && contentObj.learningObjectTags !== undefined) {
        if (contentObj.metadata.courseObj.Tags.length > 0 && contentObj.learningObjectTags.length > 0) {
          tagsArray = contentObj.metadata.courseObj.Tags.concat(contentObj.learningObjectTags);
        } else if (contentObj.metadata.courseObj.Tags.length > 0 && contentObj.learningObjectTags.length === 0) {
          tagsArray = contentObj.metadata.courseObj.Tags;
        } else if (contentObj.metadata.courseObj.Tags.length === 0 && contentObj.learningObjectTags.length > 0) {
          tagsArray = contentObj.learningObjectTags;
        }
      }
      return tagsArray.join(', ');
    },
    showLanguage: function showLanguage() {
      this.showAllLanguage = true;
    },
    hideLanguage: function hideLanguage() {
      this.showAllLanguage = false;
    },
    showCategory: function showCategory() {
      this.showAllCategory = true;
    },
    hideCategory: function hideCategory() {
      this.showAllCategory = false;
    },
    goToLogin: function goToLogin() {
      this.$root.$emit('bv::show::modal', 'login');
    },

    // insert item in wishList
    addToWishList: function addToWishList(itemId) {
      var _this = this;

      // if user is loggedIn then call to insert api
      if (this.isLoggedIn) {
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
          _this.$toasted.success(_this.$t('searchPage.alerts.AddItemToWishlist'));
        }, function (error) {
          console.error('error in adding item to wishList', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },

    // remove item from wishList
    removeFromWishList: function removeFromWishList(itemId) {
      var _this2 = this;

      this.$swal({
        title: 'Are you sure, you want to remove item from WishList ?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this2.$store.dispatch('removeWishListFromDb', { profileId: _this2.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
            _this2.$toasted.success(_this2.$t('wishlist.alerts.RemoveItem'));
          }, function (error) {
            console.log('error in removing item from db', error);
          });
        }
      });
      // this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId }).then(
      //   response => {
      //     this.$toasted.success(this.$t('searchPage.alerts.ItemRemovedFromWishlist'))
      //   },
      //   error => {
      //     console.error('error in removing item from wishList', error)
      //   }
      // )
    },

    // checks whether is item is added in wishList
    presentInWishListStore: function presentInWishListStore(itemId) {
      if (this.$store.getters.getWishListStoreData !== undefined && this.$store.getters.getWishListStoreData !== null) {
        for (var i = 0; i < this.$store.getters.getWishListStoreData.length; i++) {
          if (this.$store.getters.getWishListStoreData[i].itemId === itemId) {
            return true;
          }
        }
      }
      return false;
    },

    // clears all filters applied by user
    clearFilters: function clearFilters() {
      // reset all values
      this.languageSelected = [];
      this.categoriesSelected = [];
      this.durationSelected = {};
      this.value = this.$store.getters.getSearchPrice;
      this.cost = this.$store.getters.getSearchPrice;
    },
    addToCart: function addToCart(id) {
      var _this3 = this;

      if (this.isLoggedIn) {
        // if (!this.presentInWishListStore(id)) {
        //   this.addToWishList(id)
        // }
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
          _this3.$toasted.success(_this3.$t('searchPage.alerts.AddItemToCart'));
        }, function (error) {
          _this3.$toasted.error(_this3.$t('searchPage.alerts.CartAddError'));
          console.log(error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    playLO: function playLO(val) {
      var playlist = [];
      // alert(val.type)
      // console.log(JSON.stringify(val))
      if (val.type === 'CO') {
        // redirect to era
        this.$store.dispatch('checkExpiryDateForCO', val);
      } else {
        playlist.push(val);
        this.$store.dispatch('setCurrentContentViewerPlaylist', playlist);
        this.$store.dispatch('setIsPlaylist', false);
        this.$router.push('/frames');
      }
    },
    viewCourse: function viewCourse(course) {
      var _this4 = this;

      if (course.type === 'CO') {
        if (this.isLoggedIn) {
          var tokenString = window.MKCLAPI.getToken();
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('r/viewEnrolledItem', { profileId: this.$store.getters.getProfileDetails.profileId, contentId: course.contentId }, { headers: { Authorization: tokenString } }).then(function (response) {
            _this4.$store.dispatch('setCurrentCourse', response.data);
            _this4.$store.dispatch('getCourseDetails', course.contentId);
          });
        } else {
          this.$store.dispatch('setCurrentCourse', course);
          this.$store.dispatch('getCourseDetails', course.contentId);
        }
        this.$router.push({ path: '/coursePage' });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // clear all store result and other details
    this.$store.dispatch('removePreviousSearchResult').then(function (response) {}, function (error) {
      console.log('error in clearing search store data from SEARCHCARDALT', error);
    });
  },
  mounted: function mounted() {
    var _this5 = this;

    // sets TimeOut for loader
    setTimeout(function () {
      _this5.showLoader = false;
    }, 1000);
    // fetched value for filter section
    this.cost = this.$store.getters.getSearchPrice;
    this.value = this.$store.getters.getSearchPrice;
    this.moreCategory = Math.floor(this.$store.getters.getCategoryStoreData.length / 2);
  },
  created: function created() {
    var _this6 = this;

    this.loList = this.$store.getters.getCourseEnrolled;
    // listens to searchEvent when user search new item
    __WEBPACK_IMPORTED_MODULE_2__main_js__["EventBus"].$on('searchEvent', function () {
      // this.showLoader = true
      // setTimeout(() => {
      //   this.showLoader = false
      // }, 1000)
      // clears previous filters
      _this6.clearFilters();
      // resets previous scroll
      if (_this6.$refs.infiniteLoader !== undefined) {
        _this6.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
      }
      // resets index
      _this6.$store.dispatch('setIndexesOnSearch').then({}, function (error) {
        console.log('error in setting index to (0,5)', error);
      });
    });
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "q9mY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newVideoCards_vue__ = __webpack_require__("3pqy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346b4bd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_newVideoCards_vue__ = __webpack_require__("Cn0U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newVideoCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346b4bd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_newVideoCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qELe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wishlistPage"
  }, [_c('banner-search'), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-gray"
  }, [_c('courseWishlist'), _vm._v(" "), (_vm.showTrendingCard && _vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('trendingCourses') : _vm._e(), _vm._v(" "), (_vm.showTrendingCard && _vm.showLibraryCard && _vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('libraryCards') : _vm._e(), _vm._v(" "), (_vm.showTrendingCard && _vm.showLibraryCard && _vm.showTrendingCard && _vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('newVideoCards') : _vm._e(), _vm._v(" "), (_vm.$store.getters.getWishListStoreData !== undefined && _vm.$store.getters.getWishListStoreData !== null && _vm.$store.getters.getWishListStoreData.length == 0) ? _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGEf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.redirection),
      expression: "redirection"
    }],
    attrs: {
      "id": "app"
    }
  }, [(_vm.isPaymentPage) ? _c('div', [_c('header-logged-in', {
    attrs: {
      "status": _vm.navStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footerArea')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qODG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__ = __webpack_require__("Yu1t");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import headerLoginNoMenu from './common/headerLoginNoMenu.vue'
// import courseWishlist from '@/components/wishList/courseWishList.vue'
// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'success',
  amount: 0,
  components: {
    footerArea: __WEBPACK_IMPORTED_MODULE_0__common_footerArea_vue__["a" /* default */]
  },
  data: function data() {
    return {
      profileId: this.$store.getters.getProfileDetails.profileId,
      isLoad: false,
      itemsPurchased: [],
      courseLength: 0,
      courseList: []
    };
  },
  created: function created() {
    var _this = this;

    // not needed
    /*  for (var i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
      if (this.$store.getters.getCourseEnrolled[i].courseType === 'CO') {
        this.courseList.push(this.$store.getters.getCourseEnrolled[i])
      }
    } */
    if (this.$route.params.payementMode === 'wallet') {
      // get Course data before purchase
      this.courseList = this.$store.getters.getItemsEnrolledByType('CO');
      /*
        steps:
        1.update cart
        2.fetch item purchased
        3.remove item from wishList those are purchased
      */
      // alert('here')
      this.$store.dispatch('viewCartData', this.$store.getters.getProfileDetails.profileId).then(function (response) {
        _this.$store.dispatch('fetchEnrolledItems', _this.$store.getters.getProfileDetails.profileId).then(function (response) {
          for (var i = 0; i < _this.$store.getters.getItemsEnrolledByType('ALL').length; i++) {
            for (var j = 0; j < _this.$store.getters.getWishListStoreData.length; j++) {
              if (_this.$store.getters.getWishListStoreData[j].itemId === _this.$store.getters.getItemsEnrolledByType('ALL')[i].contentId) {
                _this.$store.dispatch('removeWishListFromDb', { profileId: _this.$store.getters.getProfileDetails.profileId, itemId: _this.$store.getters.getItemsEnrolledByType('ALL')[i].contentId }).then(function (response) {
                  // console.log('removed')
                }, function (error) {
                  console.log('Error in removing wishList from Db', error);
                });
              }
            }
          }
          // if course purchase then send info to ERA
          /* if (this.courseList.length !== this.$store.getters.getItemsEnrolledByType('CO').length) {
            return new Promise((resolve, reject) => {
              axios
                .post('r/sendERA', {
                  profileId: this.$store.getters.getProfileDetails.profileId,
                  cartId: this.$route.params.transactionId
                })
                .then(res => {
                  // console.log(res.data)
                  resolve()
                })
                .catch(err => {
                  console.log('Error Inserting Course To ERA', err)
                  reject()
                })
            })
          } */
          /* if (this.courseList.length !== this.$store.getters.getCourseCOEnrolled.length) {
            axios
              .post('r/sendERA', {
                profileId: this.$store.getters.getProfileDetails.profileId,
                cartId: this.$route.params.transactionId
              })
              .then(res => {
                console.log(res.data)
              })
              .catch(err => {
                console.log('Error Inserting Course To ERA', err)
              })
          } */
        }, function (error) {
          console.log('error in fetching course data', error);
        });
        // bk 4 above
        /* this.$store.dispatch('fetchEnrolledCourses', this.$store.getters.getProfileDetails.profileId).then(
          response => {
            for (let i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
              for (let j = 0; j < this.$store.getters.getWishListStoreData.length; j++) {
                // console.log('cid', this.$store.getters.getCourseEnrolled[i].contentId)
                // console.log('iid', this.$store.getters.getWishListStoreData[j].itemId)
                if (this.$store.getters.getWishListStoreData[j].itemId === this.$store.getters.getCourseEnrolled[i].contentId) {
                  this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: this.$store.getters.getCourseEnrolled[i].contentId }).then(
                    response => {},
                    error => {
                      console.log('Error in removing wishList from Db', error)
                    }
                  )
                }
              }
            }
            if (this.courseList.length !== this.$store.getters.getCourseCOEnrolled.length) {
              axios
                .post('r/sendERA', {
                  profileId: this.$store.getters.getProfileDetails.profileId,
                  cartId: this.$route.params.transactionId
                })
                .then(res => {
                  console.log(res.data)
                })
                .catch(err => {
                  console.log('Error Inserting Course To ERA', err)
                })
            }
          },
          error => {
            console.log('error in fetching course data', error)
          }
        ) */
      }, function (error) {
        console.log('error in removing cart data', error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$store.getters.getCartData.items.length !== 0 && this.$route.params.payementMode !== 'wallet' && this.$route.params.status === 'success') {
      this.isLoad = true;
      setTimeout(function () {
        _this2.$Progress.start();
        _this2.isLoad = false;
        _this2.$router.push({ name: 'cart' });
      }, 5000);
    } else {
      if (this.$route.params.payementMode === 'wallet' && this.$route.params.status === 'success') {
        this.$store.dispatch('previousCartItems', { 'profileId': this.profileId, 'cartId': this.$route.params.transactionId }).then(function (res) {
          _this2.itemsPurchased = res;
        }, function (err) {
          console.log('ERROR_IN_DISPLAYING_ITEM_PURCHASED : ', err);
        });
      }
    }
  }
});

/***/ }),

/***/ "qUkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_bannerSearch_vue__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__framesVideo__ = __webpack_require__("cFcx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_footerArea__ = __webpack_require__("Yu1t");
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wishlist',
  components: {
    bannerSearch: __WEBPACK_IMPORTED_MODULE_0__home_bannerSearch_vue__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_3__home_courseCards__["a" /* default */],
    framesVideo: __WEBPACK_IMPORTED_MODULE_2__framesVideo__["a" /* default */],
    footerArea: __WEBPACK_IMPORTED_MODULE_4__common_footerArea__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$emit('showNav', false);
  }
});

/***/ }),

/***/ "qUpu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseCards',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a
  },
  data: function data() {
    return {
      isActive: false,
      notNextTick: true,
      coList: [],
      loList: [],
      add: '',
      swiperOptionCourse: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-course-next',
        prevButton: '.swiper-course-prev',
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      }
    };
  },
  created: function created() {
    var _this = this;

    this.loList = this.$store.getters.getCourseEnrolled;
    this.loList.forEach(function (element) {
      if (element.courseType === 'CO') {
        _this.coList.push(element.contentId);
      }
    });
    this.$store.commit('setCourseCOEnrolled', this.coList);
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  methods: {
    removeFromWishList: function removeFromWishList(itemId) {
      var profileId = this.$store.getters.getProfileDetails.profileId;
      this.$store.dispatch('removeWishListFromDb', { profileId: profileId, itemId: itemId });
    },
    addToWishList: function addToWishList(itemId) {
      if (this.isLoggedIn()) {
        var profileId = this.$store.getters.getProfileDetails.profileId;
        this.$store.dispatch('insertWishListInDb', { profileId: profileId, itemId: itemId });
      } else {
        window.MKCLAPI.login();
      }
    },
    presentInWishListStore: function presentInWishListStore(itemId) {
      this.wishListData = this.$store.getters.getWishListStoreData;
      for (var i = 0; i < this.wishListData.length; i++) {
        if (this.wishListData[i].itemId === itemId) {
          return true;
        }
      }
    },
    addToCart: function addToCart(id) {
      if (this.isLoggedIn()) {
        this.isActive = true;
        var obj = {
          itemId: id,
          profileId: this.$store.getters.getProfileDetails.profileId,
          cartId: this.$store.getters.getCartData.cartId
        };
        this.$store.dispatch('addCartData', obj);
      } else {
        window.MKCLAPI.login();
      }
    },
    inPurchase: function inPurchase(itemId) {
      this.courseData = this.coList;
      var result = false;
      for (var i = 0; i < this.courseData.length; i++) {
        if (this.courseData[i] === itemId) {
          result = true;
        }
      }
      return result;
    },
    isPresent: function isPresent(courseCategory, currentItemCategoryList) {
      if (currentItemCategoryList !== null) {
        if (currentItemCategoryList.includes(courseCategory)) {
          return true;
        } else {
          return false;
        }
      }
    },
    cartAdd: function cartAdd(itemId) {
      this.cartData = this.$store.getters.getCartData.items;
      for (var j = 0; j < this.cartData.length; j++) {
        if (this.cartData[j].itemId === itemId) {
          return true;
        }
      }
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchAllCOsFromDb');
    this.$store.dispatch('fetchSearchCategory');
  }
});

/***/ }),

/***/ "qjR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mycourseCards_vue__ = __webpack_require__("wXyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af21728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_mycourseCards_vue__ = __webpack_require__("s3SC");
function injectStyle (ssrContext) {
  __webpack_require__("9mgw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mycourseCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af21728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_mycourseCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r4Bi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rkxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);





// var axios = window.axios
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var state = {
  offers: []
};
var getters = {
  getOffers: function getOffers(state) {
    return state.offers;
  }
};
var actions = {
  fetchAllOffersFromDb: function fetchAllOffersFromDb(context) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('o/getOffers').then(function (response) {
        var offers = [];
        if (response.data !== null && response.data !== undefined) {
          for (var i = 0; i < response.data.length; i++) {
            var expiryDate = response.data[i].validTil;
            // console.log(expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.indexOf(expiryDate.length)).split(':'))
            var expiryDateList = expiryDate.substring(0, expiryDate.indexOf('T')).split('-');
            var newDate = {
              'year': expiryDateList[0],
              'month': expiryDateList[1],
              'day': expiryDateList[2]
            };
            expiryDateList = [];
            expiryDateList = expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.length).split(':');
            newDate['hour'] = expiryDateList[0];
            newDate['min'] = expiryDateList[1];
            newDate['sec'] = expiryDateList[2].substring(0, expiryDateList[2].indexOf('+'));
            expiryDate = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec']);
            var currentDate = new Date();
            // console.log('cd', currentDate)
            // console.log('ed', expiryDate)
            // console.log((currentDate >= expiryDate))
            if (currentDate < expiryDate) {
              offers.push(response.data[i]);
            }
          }
        }
        context.commit('setOffersStoreData', offers);
        resolve();
      }).catch(function (e) {
        console.log('Catch', e);
        reject(e);
      });
    });
  }
};
var mutations = {
  setOffersStoreData: function setOffersStoreData(state, data) {
    if (data === null) {
      state.offers = [];
    } else {
      state.offers = data;
    }
  },
  clearOffersStoreData: function clearOffersStoreData(state) {
    state.offers = [];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "s0Kx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contentHelper_htmlViewer__ = __webpack_require__("vWA7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contentHelper_swfPlayer__ = __webpack_require__("jayJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contentHelper_videoPlayer__ = __webpack_require__("dYQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contentHelper_audioPlayer__ = __webpack_require__("v+qr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contentHelper_imageViewer__ = __webpack_require__("2k/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__contentHelper_pdfViewer__ = __webpack_require__("dMGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contentHelper_youtube_player__ = __webpack_require__("67tN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_constants_js__ = __webpack_require__("P5xh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'framesVideo',
  components: { StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a, 'v-select': __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a, htmlViewer: __WEBPACK_IMPORTED_MODULE_4__contentHelper_htmlViewer__["a" /* default */], swfPlayer: __WEBPACK_IMPORTED_MODULE_5__contentHelper_swfPlayer__["a" /* default */], videoPlayer: __WEBPACK_IMPORTED_MODULE_6__contentHelper_videoPlayer__["a" /* default */], audioPlayer: __WEBPACK_IMPORTED_MODULE_7__contentHelper_audioPlayer__["a" /* default */], imageViewer: __WEBPACK_IMPORTED_MODULE_8__contentHelper_imageViewer__["a" /* default */], pdfViewer: __WEBPACK_IMPORTED_MODULE_9__contentHelper_pdfViewer__["a" /* default */], youtubePlayer: __WEBPACK_IMPORTED_MODULE_10__contentHelper_youtube_player__["a" /* default */] },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_12__components_common_constants_js__["e" /* INSTANCE_NAME */],
      contentPath: '',
      language: '1',
      selected: 'English',
      mediaPath: '',
      lang: 'en',
      media: '',
      videoHolder: '',
      swfHolder: '',
      pdfHolder: '',
      currentTime: '5',
      previousCalled: 0,
      isPurchase: null,
      showViewCountExhaustedMsg: null,
      cdpcdnurl: __WEBPACK_IMPORTED_MODULE_12__components_common_constants_js__["s" /* CDP_CDN_URL */],
      searchLOString: ''
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('setLoaderStatus', false);
    this.$store.dispatch('setCurrentLang', this.language);
    window.scrollTo(0, 0);
    this.$Progress.start();
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'static/js/contentHelper.js';
    document.body.appendChild(script);
  },

  methods: {
    isObjectEmpty: function isObjectEmpty(loObj) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(loObj).length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    getRemainingDays: function getRemainingDays(expiryDate) {
      if (expiryDate !== '') {
        var expiryDateTemp;
        var oneDay = 1000 * 60 * 60 * 24;
        var expiryDateList = expiryDate.substring(0, expiryDate.indexOf('T')).split('-');
        var newDate = {
          'year': expiryDateList[0],
          'month': parseInt(expiryDateList[1]) - 1,
          'day': expiryDateList[2]
        };
        expiryDateList = [];
        expiryDateList = expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.indexOf('.')).split(':');
        newDate['hour'] = expiryDateList[0];
        newDate['min'] = expiryDateList[1];
        newDate['sec'] = expiryDateList[2];
        // convert expiryDate & currentDate in mili seconds
        expiryDate = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec']).getTime();
        expiryDateTemp = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec']);
        var currentDate = new Date().getTime();
        var currentDateTemp = new Date();
        // calculate the difference in miliSeconds
        var differenceInMs = Math.abs(currentDate - expiryDate);
        // if difference  is more than 24 hr
        if (Math.round(differenceInMs / oneDay) !== 0) {
          if (Math.round(differenceInMs / oneDay) > 1) {
            return Math.round(differenceInMs / oneDay) + ' days remaining';
          } else {
            return Math.round(differenceInMs / oneDay) + ' day remaining';
          }
        } else {
          // if difference is less than 24 hr
          var date1Hr = expiryDateTemp.getHours();
          var date2Hr = currentDateTemp.getHours();
          var date1Min = expiryDateTemp.getMinutes();
          var date2Min = currentDateTemp.getMinutes();
          if (Math.abs(date1Hr - date2Hr) !== 0) {
            return Math.abs(date1Hr - date2Hr) + ' hr ' + Math.abs(date1Min - date2Min) + ' min remaing';
          } else {
            return Math.abs(date1Min - date2Min) + ' min remaing';
          }
        }
      }
    },
    cartAdd: function cartAdd(itemId) {
      if (this.$store.getters.getCartData.items !== undefined && this.$store.getters.getCartData.items !== null) {
        for (var j = 0; j < this.$store.getters.getCartData.items.length; j++) {
          if (this.$store.getters.getCartData.items[j].itemId === itemId) {
            return true;
          }
        }
      }
      return false;
    },

    setRating: function setRating(rating) {
      this.rating = rating;
    },
    showRating: function showRating(contentID) {
      var _this = this;

      this.$store.dispatch('showRating', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating }).then(function (response) {
        _this.$toasted.success(_this.$t('common.alerts.RATING_ADDED'));
      }, function (error) {
        _this.$toasted.error(error);
        console.log('error in adding rating', error);
      });
      /* axios.post('/r/rating/addratingdata', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating })
        .then(response => {
          this.$toasted.success(this.$t('common.alerts.RATING_ADDED'))
        })
        .catch(error => {
          this.$toasted.error(error)
        }) */
    },
    play: function play(content) {
      var _this2 = this;

      this.$store.dispatch('setPreviousContent', this.$store.getters.getcurrentPlayingContent).then(function (response) {
        if (_this2.$store.getters.getcurrentPlayingContent.contentId !== content.contentId) {
          _this2.showViewCountExhaustedMsg = false;
          _this2.getPurchaseStatus(content.contentId).then(function (response) {
            _this2.$store.dispatch('setCurrentPlayingContent', content).then(function (response) {
              if (_this2.isPurchase) {
                _this2.selected = 'English';
                _this2.language = '1';
                /* this.$store.dispatch('updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': content.contentId}).then(response => {
                  this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
                }, error => {
                  console.log('error in updating LO watch count', error)
                }) */
                __WEBPACK_IMPORTED_MODULE_11_axios___default.a.post('r/contentviewer/updatelowatchcount', { 'profileId': _this2.$store.getters.getProfileDetails.profileId, 'itemId': content.contentId }).then(function (response) {
                  _this2.$store.dispatch('fetchEnrolledItems', _this2.$store.getters.getProfileDetails.profileId);
                }).catch(function (err) {
                  console.log(err);
                });
              }
            });
          });
        }
      });
    },
    getLanguageIdByName: function getLanguageIdByName(languageId) {
      if (languageId === 'English') {
        return '1';
      } else if (languageId === 'Hindi') {
        return '2';
      } else if (languageId === 'Marathi') {
        return '3';
      }
    },
    setContentPathByLanguage: function setContentPathByLanguage(languageId) {
      if (languageId === 'English') {
        this.language = '1';
      } else if (languageId === 'Hindi') {
        this.language = '2';
      } else if (languageId === 'Marathi') {
        this.language = '3';
      }
      this.$store.dispatch('setCurrentLang', this.language);
    },

    playNext: function playNext(event) {
      if (this.$store.getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < this.$store.getters.getCurrentContentViewerPlaylist.length; i++) {
          if (this.$store.getters.getCurrentContentViewerPlaylist[i].contentId === this.$store.getters.getcurrentPlayingContent.contentId) {
            if (this.$store.getters.getCurrentContentViewerPlaylist.length > i + 1) {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[i + 1]);
              break;
            } else {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0]);
              break;
            }
          }
        }
      }
    },
    playPrevious: function playPrevious(event) {
      if (this.$store.getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < this.$store.getters.getCurrentContentViewerPlaylist.length; i++) {
          if (this.$store.getters.getCurrentContentViewerPlaylist[i].contentId === this.$store.getters.getcurrentPlayingContent.contentId) {
            if (i - 1 >= 0) {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[i - 1]);
              break;
            } else {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0]);
              break;
            }
          }
        }
      }
    },
    getFileExtension: function getFileExtension(aggregationPath) {
      return aggregationPath != null ? aggregationPath.substr(aggregationPath.lastIndexOf('.') + 1) : '';
    },
    getLanguages: function getLanguages() {
      var _this3 = this;

      var result = [];
      if (this.$store.getters.getcurrentPlayingContent.languageId !== undefined) {
        this.$store.getters.getcurrentPlayingContent.languageId.forEach(function (element) {
          result.push(_this3.getLanguageNameById(element));
        });
        return result;
      }
    },
    getLanguageNameById: function getLanguageNameById(languageId) {
      if (languageId === '1') {
        return 'English';
      } else if (languageId === '2') {
        return 'Hindi';
      } else if (languageId === '3') {
        return 'Marathi';
      }
    },
    getContentValidityStatus: function getContentValidityStatus(contentId) {
      var _this4 = this;

      /*
        check if item is in enrolled list => then call  viewItemValidityStatus
        else check if tag is not expired
      */
      if (this.$store.getters.getItemPurchasedStatus(contentId)) {
        // console.log('content purchased')
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_11_axios___default.a.post('r/viewItemValidityStatus', { 'profileId': _this4.$store.getters.getProfileDetails.profileId, 'contentId': contentId }).then(function (response) {
            if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
              _this4.isPurchase = false;
            }
            if (response.data === 'VIEW_LIMIT_CROSSED') {
              _this4.isPurchase = false;
              _this4.showViewCountExhaustedMsg = true;
            }
            if (response.data === 'ITEM_NOT_EXPIRED') {
              _this4.isPurchase = true;
            }
            resolve();
          }).catch(function (err) {
            console.log(err);
            reject(err);
          });
        });
      } else {
        // console.log('check if tag is allocated')
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_11_axios___default.a.post('o/getAllocatedTag', { 'profileId': _this4.$store.getters.getProfileDetails.profileId, 'contentId': contentId }).then(function (res) {
            _this4.isPurchase = true;
            resolve();
          }).catch(function (err) {
            console.log('error in getting getAllocateTag : ', err);
            reject();
          });
        });
      }
    },
    getPurchaseStatus: function getPurchaseStatus(contentId) {
      var _this5 = this;

      /* this.$store.dispatch('getPurchaseStatus', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentId}).then(response => {
        console.log(response.data)
        if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
          this.isPurchase = false
        }
        if (response.data === 'VIEW_LIMIT_CROSSED') {
          this.isPurchase = false
          this.showViewCountExhaustedMsg = true
        }
        if (response.data === 'ITEM_NOT_EXPIRED') {
          this.isPurchase = true
        }
      }, err => {
        console.log('error in getting item validity status : ', err)
      }) */
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_11_axios___default.a.post('r/viewItemValidityStatus', { 'profileId': _this5.$store.getters.getProfileDetails.profileId, 'contentId': contentId }).then(function (response) {
          if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
            _this5.isPurchase = false;
          }
          if (response.data === 'VIEW_LIMIT_CROSSED') {
            _this5.isPurchase = false;
            _this5.showViewCountExhaustedMsg = true;
          }
          if (response.data === 'ITEM_NOT_EXPIRED') {
            _this5.isPurchase = true;
          }
          resolve();
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    },
    addToCart: function addToCart(id) {
      var _this6 = this;

      this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
        _this6.$toasted.success(_this6.$t('common.alerts.CART_ADDED_SUCCESS'));
      }, function (error) {
        console.log('error in adding item to cart', error);
      });
    },
    checkValue: function checkValue(val) {
      if (val.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    makePath: function makePath(path) {
      return __WEBPACK_IMPORTED_MODULE_12__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    }
  },
  computed: {
    getCdpCdnUrl: function getCdpCdnUrl() {
      var rx = new RegExp('www.youtube.com');
      if (rx.test(this.$store.getters.getCurrentContentPath(this.language))) {
        return this.$store.getters.getCurrentContentPath(this.language) + '?controls=0';
      }
      return this.cdpcdnurl + this.$store.getters.getCurrentContentPath(this.language);
    },
    isEnded: function isEnded() {
      return this.$refs.player.ended();
    },
    isImage: function isImage() {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'jpg' || this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'jpeg' || this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'png') {
        this.media = 'image';
        return true;
      }
      return false;
    },
    isVideo: function isVideo() {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'mp4') {
        this.media = 'video';
        return true;
      }
      return false;
    },
    isYoutube: function isYoutube() {
      var rx = new RegExp('www.youtube.com');
      return this.$store.getters.getCurrentContentPath(this.language) !== '' && rx.test(this.$store.getters.getCurrentContentPath(this.language));
    },
    isAudio: function isAudio() {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'mp3') {
        this.media = 'audio';
        return true;
      }
      return false;
    },
    isSWF: function isSWF() {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'swf') {
        this.media = 'swf';
        // this.$refs.frame.src = this.$store.getters.getCurrentContentPath(this.language)
        return true;
      }
      return false;
    },
    isHTML: function isHTML() {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'html') {
        this.media = 'html';
        return true;
      }
      return false;
    },
    isPDF: function isPDF() {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'pdf') {
        this.media = 'pdf';
        return true;
      }
      return false;
    },
    isLO: function isLO() {
      return this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'lo';
    },
    getViewedCount: function getViewedCount() {
      if (this.$store.getters.getEnrolledLODataByContentIdProfileId.watchedOn !== undefined) {
        return this.$store.getters.getEnrolledLODataByContentIdProfileId.watchedOn !== null ? this.$store.getters.getEnrolledLODataByContentIdProfileId.watchedOn.length : 0;
      } else {
        return 0;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    var scripts = document.getElementsByTagName('script');
    var i = scripts.length;
    while (i--) {
      if (scripts[i].src.search('/static/assets/js/contentHelper.js') >= 0) {
        scripts[i].parentNode.removeChild(scripts[i]);
      }
    }
    this.isPurchase = false;
    this.showViewCountExhaustedMsg = false;
  },
  created: function created() {
    var _this7 = this;

    // this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0])
    if (this.$store.getters.getIsplaylist) {
      // playList
      if (this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId !== '') {
        this.getContentValidityStatus(this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId).then(function (response) {
          _this7.contentPath = _this7.$store.getters.getContentById(_this7.$store.getters.getcurrentPlaylist.lastItemViewed.itemId);
          if (_this7.isPurchase) {
            _this7.$store.dispatch('setCurrentPlayingContent', _this7.$store.getters.getContentById(_this7.$store.getters.getcurrentPlaylist.lastItemViewed.itemId)).then(function (response) {
              // axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId}).then(response => {
              //   this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              // }).catch(err => {
              //   console.log(err)
              // })
            });
          }
        });
      } else {
        this.getContentValidityStatus(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId).then(function (response) {
          _this7.$store.dispatch('setCurrentPlayingContent', _this7.$store.getters.getCurrentContentViewerPlaylist[0]);
          if (_this7.isPurchase) {
            _this7.$store.dispatch('setCurrentPlayingContent', _this7.$store.getters.getCurrentContentViewerPlaylist[0]).then(function (response) {
              _this7.contentPath = _this7.$store.getters.getContentById(_this7.$store.getters.getCurrentContentViewerPlaylist[0].contentId);
              // axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getCurrentContentViewerPlaylist[0].contentId}).then(response => {
              //   this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              // }).catch(err => {
              //   console.log(err)
              // })
            });
          }
        });
      }
    } else {
      this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0]);
      // this.getContentValidityStatus(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId)
      this.getContentValidityStatus(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId).then(function (response) {
        // console.log('check if purchase')
        // this.isPurchase = true
        if (_this7.isPurchase) {
          _this7.$store.dispatch('setCurrentPlayingContent', _this7.$store.getters.getCurrentContentViewerPlaylist[0]).then(function (response) {
            _this7.contentPath = _this7.$store.getters.getCurrentContentViewerPlaylist[0];
            // axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getCurrentContentViewerPlaylist[0].contentId}).then(response => {
            //   this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            // }).catch(err => {
            //   console.log(err)
            // })
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "s3SC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder mycourse-cards"
  }, [_c('div', {
    staticClass: "pb-3 row justify-content-end"
  }, [_c('h6', {
    staticClass: "col-md-12 main-title"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.Courses')))])]), _vm._v(" "), (_vm.$store.getters.getItemsEnrolledByType('CO') != undefined && _vm.$store.getters.getItemsEnrolledByType('CO') != null && _vm.$store.getters.getItemsEnrolledByType('CO').length != 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.$store.getters.getItemsEnrolledByType('CO')), function(course, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm-6 col-md-5 col-lg-4 col-xl-3"
    }, [_c('div', {
      staticClass: "card-design"
    }, [(course.thumbnail.length !== 0) ? _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(course.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__("9oHV"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "tag": "h3",
        "title": course.title,
        "to": {
          name: 'coursePage',
          params: {
            contentId: course.contentId
          }
        }
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'MAHADEMY') ? _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": course.title
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(course.price) + " " + _vm._s(course.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('course.my_rating')))]) : _vm._e(), _vm._v(" "), (parseInt(course.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": parseInt(course.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": course.rating,
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('share-on-media', {
      attrs: {
        "item": course,
        "labelOnTop": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row box-action"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToCourse(course)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.GO_TO_COURSE')))])])])], 1)])])
  })) : _c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('myCourses.labels.NoCourses')))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sBpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue__ = __webpack_require__("9CB+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65041b82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__ = __webpack_require__("GLDi");
function injectStyle (ssrContext) {
  __webpack_require__("gzcv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65041b82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sD0W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sRaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-pay"
  }, [_c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-left"
  }, [_c('span', {
    staticClass: "bal"
  }, [_vm._v("INVOICE")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("Dated - " + _vm._s(_vm._f("moment")(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('span', {
    staticClass: "transaction"
  }, [_vm._v(" Transaction ID: " + _vm._s(_vm.$route.params.transactionId))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.itemsPurchased), function(item, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(item.itemName) + "  " + _vm._s(item.amount) + " " + _vm._s(item.amount > 1 ? 'POINTS' : 'POINT'))])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [(this.$store.getters.getCartData.items.length !== 0 && this.$route.params.payementMode !== 'wallet' && this.$route.params.status === 'success') ? _c('div', [(_vm.isLoad) ? _c('img', {
    attrs: {
      "src": __webpack_require__("Pa+M"),
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.status === 'success' && _vm.$route.params.payementMode === 'wallet') ? _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.$t('payment.labels.payment_receive')) + "  \n              "), _c('span', {
    staticClass: "amt"
  }, [_c('i', {
    staticClass: "mdi mdi-currency-inr"
  }), _vm._v(_vm._s(_vm.$route.params.amount))]), _vm._v(".\n              ")]) : (_vm.$route.params.status === 'success') ? _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "amt"
  }, [_c('i', {
    staticClass: "mdi mdi-currency-inr"
  }), _vm._v(_vm._s(_vm.$route.params.amount))]), _vm._v("  " + _vm._s(_vm.$t('payment.labels.credits_added')) + "\n              ")]) : _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.$t('payment.labels.transaction_failed')) + "  \n              "), _c('span', {
    staticClass: "amt"
  }, [_c('i', {
    staticClass: "mdi mdi-currency-inr"
  }), _vm._v(_vm._s(_vm.$route.params.amount))]), _vm._v(".\n              ")])]), _vm._v(" "), ((_vm.$route.params.payementMode === 'wallet')) ? _c('div', {
    staticClass: "a-href"
  }, [_c('b-link', {
    staticClass: "btn btn-large btn-purple",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('payment.labels.go_to_profile')) + "\n            ")])], 1) : ((_vm.$route.params.payementMode !== 'wallet' && _vm.$route.params.status == 'Failed')) ? _c('div', {
    staticClass: "a-href"
  }, [_c('b-link', {
    staticClass: "btn btn-large btn-purple",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('payment.labels.go_to_home')) + "\n            ")])], 1) : ((_vm.$store.getters.getCartData.items.length == 0)) ? _c('div', {
    staticClass: "a-href"
  }, [_c('b-link', {
    staticClass: "btn btn-large btn-purple",
    attrs: {
      "to": {
        name: 'wallet'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('payment.labels.go_to_wallet')) + "\n            ")])], 1) : _vm._e()], 2)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tR9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_shareOnMedia__ = __webpack_require__("HOUo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import axios from 'axios'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'libraryCards',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a, ShareOnMedia: __WEBPACK_IMPORTED_MODULE_2__common_shareOnMedia__["a" /* default */]
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_1__common_constants_js__["e" /* INSTANCE_NAME */],
      isValidUser: false,
      isActive: false,
      notNextTick: true,
      obj: {},
      courses: [],
      coList: [],
      loList: [],
      add: 'Add to Cart',
      itemDescription: 'Coarse is to help you with some basics of HTML',
      itemName: 'HTML5 Demo',
      swiperOptionLib: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-lib-next',
        prevButton: '.swiper-lib-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 20,
        paginationClickable: true,
        loop: false
      },
      selected: [], // Must be an array reference!
      options: [{ text: 'Playlist 1', value: 'Playlist 1' }, { text: 'Playlist 2', value: 'Playlist 2' }, { text: 'Playlist 3', value: 'Playlist 3' }, { text: 'Playlist 4', value: 'Playlist 4' }, { text: 'Playlist 5', value: 'Playlist 5' }, { text: 'Playlist 6', value: 'Playlist 6' }]
    };
  },
  created: function created() {
    this.$store.dispatch('fetchAllCOsFromDb').then(function (response) {}, function (error) {
      console.log('error in fetchAllCOsFromDb', error);
    });
    //     if (this.$store.getters.getIsLoggedIn) {
    /* if (this.$store.getters.getIsLoggedIn || this.$store.getters.getAllCOs.length === 0) {
      // alert(123)
      this.$store.dispatch('fetchAllCOsFromDb').then(
        response => {},
        error => {
          console.log('error in fetchAllCOsFromDb', error)
        }
      )
    } */ /* else {
         // alert(this.$store.getters.getAllCOs.length)
         if (this.$store.getters.getAllCOs.length === 0) {
         this.$store.dispatch('fetchAllCOsFromDb').then(
         response => {},
         error => {
          console.log('error in fetchAllCOsFromDb', error)
         }
         )
         }
         } */
  },
  beforeDestroy: function beforeDestroy() {
    // clear store data
    if (this.$store.getters.getIsLoggedIn) {
      this.$store.dispatch('clearAllCosFromStore').then(function (response) {}, function (error) {
        console.log('error in clearAllCosFromStore', error);
      });
    }
  },

  methods: {
    goToCourse: function goToCourse(course) {
      this.$store.dispatch('checkExpiryDateForCO', course);
    },
    viewCourse: function viewCourse(course) {
      /* if (this.isLoggedIn) {
      // alert(JSON.stringify(this.$store.getters.getProfileDetails))
        axios.post('r/viewEnrolledItem', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': course.contentId })
        .then(response => {
          // alert('response:' + JSON.stringify(response.data))
          this.$store.dispatch('setCurrentCourse', response.data)
        })
      }
      this.$store.dispatch('getCourseDetails', course.contentId) */
      this.$router.push({ path: '/coursePage' });
    },
    makePath: function makePath(path) {
      // var url = constants.CDP_CDN_THUMBNAIL_URL
      return __WEBPACK_IMPORTED_MODULE_1__common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
      // return url + path
    },
    addToWishList: function addToWishList(itemId) {
      var _this = this;

      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
          _this.$toasted.success(_this.$t('wishlist.alerts.AddedToWishList'));
        }, function (error) {
          console.error('error in adding item to wishList', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    removeFromWishList: function removeFromWishList(itemId) {
      var _this2 = this;

      this.$swal({
        title: this.$t('wishlist.alerts.RemoveItemConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          _this2.$store.dispatch('removeWishListFromDb', { profileId: _this2.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(function (response) {
            _this2.$toasted.success(_this2.$t('wishlist.alerts.RemoveItem'));
          }, function (error) {
            console.log('error in removing item from db', error);
          });
        }
      });
    },
    goToLogin: function goToLogin() {
      this.$root.$emit('bv::show::modal', 'login');
      return;
      // window.MKCLAPI.login()
    },
    addToCart: function addToCart(id) {
      var _this3 = this;

      if (this.isLoggedIn) {
        // if (!this.presentInWishListStore(id)) {
        //   this.addToWishList(id)
        // }
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(function (response) {
          _this3.$toasted.success(_this3.$t('common.alerts.CART_ADDED_SUCCESS'));
        }, function (error) {
          console.log('error in adding item to cart', error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },
    ViewDetails: function ViewDetails(contentId) {
      var Data = this;
      Data.$store.dispatch('getCourseDetails', contentId).then(function (response) {}, function (error) {
        console.error('error in viewing details', error);
      });
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
});

/***/ }),

/***/ "tRWC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allCourseCards_vue__ = __webpack_require__("qUpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d7a864_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_allCourseCards_vue__ = __webpack_require__("HF4C");
function injectStyle (ssrContext) {
  __webpack_require__("lMjY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allCourseCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d7a864_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_allCourseCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tbNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vue2_dropzone_vue_dropzone_vue__ = __webpack_require__("LYxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_input_tag__ = __webpack_require__("28+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_picture_input__ = __webpack_require__("2f0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_shareOnMedia__ = __webpack_require__("HOUo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cropperjs__ = __webpack_require__("sRoY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_cropperjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import vue2Dropzone from 'vue2-dropzone'








// import * as constants from '../common/constants.js'
// import DropZone from 'vue-dropzone'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profileContent',
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_3__components_vue2_dropzone_vue_dropzone_vue__["a" /* default */],
    InputTag: __WEBPACK_IMPORTED_MODULE_4_vue_input_tag___default.a,
    StarRating: __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default.a,
    PictureInput: __WEBPACK_IMPORTED_MODULE_5_vue_picture_input__["a" /* default */],
    ShareOnMedia: __WEBPACK_IMPORTED_MODULE_8__common_shareOnMedia__["a" /* default */],
    VueCropper: __WEBPACK_IMPORTED_MODULE_9_vue_cropperjs___default.a
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["e" /* INSTANCE_NAME */],
      userSingleConceptCollection: [],
      userCategory: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["g" /* LIVEDEMY_DEFAULT_USER */],
      googleSignInParams: {
        client_id: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["u" /* GOOGLE_SIGN_IN_APP_ID */]
      },
      editDOB: true,
      monthList: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      config: {
        format: 'YYYY/MM/DD',
        useCurrent: false
      },
      dob: '',
      skills: [],
      rating: 0.0,
      loading: false,
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: '2456',
        thumbnailWidth: 150,
        thumbnailHeight: 100,
        maxFiles: 1,
        maxFilesize: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["v" /* IMAGE_UPLOAD_MAX_SIZE */],
        addRemoveLinks: true,
        dictDefaultMessage: 'Drop image here to upload maxsize:512kb',
        headers: { 'Bussiness-Code': 'ERA', 'Client-Code': 'LiveDemy' },
        autoProcessQueue: true,
        dictMaxFilesExceeded: 'Extra File',
        uploadMultiple: false
      },
      maxFilesize: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["v" /* IMAGE_UPLOAD_MAX_SIZE */],
      imgSrc: this.$store.getters.getProfileDetails.profileImg,
      cropImg: '',
      selectedFile: null,
      bussiness_header: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["w" /* CDN_BUSSINESSHEADER */],
      client_header: __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["x" /* CDN_CLIENTHEADER */],
      in_name: '',
      in_designation: '',
      in_email: '',
      in_aboutMe: '',
      in_skills: [],
      isEdit: false,
      in_profileImage: '',
      EnrolledCourseDetails: [],
      fileExceedLimit: false,
      mobile: '',
      isCropped: false
    };
  },

  computed: {
    basicProfile: function basicProfile() {
      return this.$store.getters.getProfileDetails;
    },
    playLists: function playLists() {
      return this.$store.getters.getUserPlaylists;
    },
    enrolledCourses: function enrolledCourses() {
      return this.$store.getters.getItemsEnrolledByType('CO');
    },
    enrolledLOs: function enrolledLOs() {
      return this.$store.getters.getItemsEnrolledByType('LO');
    }
  },
  methods: {
    getImageSrc: function getImageSrc() {
      if (this.imgSrc.length === 0) {
        this.imgSrc = '../../../static/assets/images/user.png';
        return '../../../static/assets/images/user.png';
      } else {
        return this.imgSrc;
      }
    },
    linkNewAccountDetails: function linkNewAccountDetails(profileId, thirdParty, email, identificationNo) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/linkSocialAccount', { 'profileId': _this.$store.getters.getProfileDetails.profileId, 'accountDetails': [{ 'jvId': thirdParty, 'identificationNumber': identificationNo, 'portedUserName': email }] }).then(function (res) {
          _this.$toasted.success(thirdParty + ' account linked successfully');
          _this.$store.dispatch('addLinkedAccountsDetailsInStore', { 'jvId': thirdParty, 'identificationNumber': identificationNo, 'portedUserName': email, 'isActive': true, 'isOnline': false }).then(function (res) {
            resolve(true);
          }, function (err) {
            console.log('ERROR_IN_ADDING_ACCOUNT_DETAILS_IN_STORE : ', err);
            reject(err);
          });
        }).catch(function (err) {
          console.log('ERROR_IN_ADDING_CONTACT_DETAILS : ', err);
          reject(false);
        });
      });
    },
    isAccountLinked: function isAccountLinked(thirdParty) {
      for (var i = 0; i < this.$store.getters.getProfileDetails.accountDetails.length; i++) {
        if (this.$store.getters.getProfileDetails.accountDetails[i].jvId === thirdParty) {
          return true;
        } else {
          if (i + 1 === this.$store.getters.getProfileDetails.accountDetails.length) {
            return false;
          }
        }
      }
    },
    onSignInSuccess: function onSignInSuccess(googleUser) {
      /*
        googleUser.w3.U3 // email
        googleUser.w3.Eea // identification number
      */
      // console.log(JSON.stringify(googleUser))
      this.linkNewAccountDetails(this.$store.getters.getProfileDetails.profileId, __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["i" /* THIRDPARTY_GOOGLE_USER */], googleUser.w3.U3, googleUser.w3.Eea);
    },
    onSignInError: function onSignInError(error) {
      this.$toasted.error('Something went wrong... please try again');
      // `error` contains any error occurred.
      console.log('ERROR_WHILE_THIRD_PARTY_SIGN_IN : ', error);
    },
    showRating: function showRating(contentID) {
      var _this2 = this;

      this.$store.dispatch('showRating', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating }).then(function (response) {
        _this2.$toasted.success(_this2.$t('common.alerts.RATING_ADDED'));
      }, function (error) {
        _this2.$toasted.error(error);
        console.log('error in adding rating', error);
      });
    },
    checkValue: function checkValue(val) {
      if (val === '') {
        return false;
      } else {
        return true;
      }
    },

    // makes URL for CDP path
    makePath: function makePath(path) {
      return __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },

    goToPlaylist: function goToPlaylist() {
      var _this3 = this;

      this.$toasted.info(this.$t('profileDetails.alerts.noVideosToDisplay'), { theme: 'primary', duration: 3000 });
      setTimeout(function () {
        return _this3.$router.push('playlist');
      }, 2000);
    },
    setRating: function setRating(rating) {
      this.rating = rating;
    },
    learnCourse: function learnCourse(course) {
      if (course.courseType === 'CO') {
        this.$store.dispatch('checkExpiryDateForCO', course);
      } else {
        var playlist = [];
        playlist.push(this.$store.getters.getLOObjectByContentId(course.contentId));
        this.$store.dispatch('setCurrentContentViewerPlaylist', playlist);
        this.$store.dispatch('setIsPlaylist', false);
        this.$router.push('/frames');
      }
    },

    // checks whether user has not entered DOB greater than current date
    checkDob: function checkDob(dob) {
      if (dob !== null) {
        var dobDate = new Date(parseInt(dob.split('/')[0]), parseInt(dob.split('/')[1]) - 1, parseInt(dob.split('/')[2]));
        if (dobDate > new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    // returns string in proper format required for correct ISO conversion
    getDOB: function getDOB(dob) {
      return dob.split('/')[2] + ' ' + this.monthList[dob.split('/')[1] - 1] + ' ' + dob.split('/')[0] + ' 00:00 UTC';
    },
    saveBasicProfile: function saveBasicProfile() {
      var b = this;
      if (b.in_name.length !== 0) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (b.in_profileImage.length === 0) {
            // profilePicNotUpdated
            b.in_profileImage = b.$store.getters.getProfileDetails.profileImg;
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/updateUserData', { 'profileId': b.$store.getters.getProfileDetails.profileId, 'fullName': b.in_name, 'profileImg': b.in_profileImage, 'aboutMe': b.in_aboutMe }).then(function (res) {
              b.in_profileImage = '';
              b.$store.dispatch('fetchProfile', b.$store.getters.getProfileDetails.profileId).then(function () {
                b.isEdit = false;
                resolve();
              }).catch(function (err) {
                console.log('err profile fetched : ', err);
                reject();
              });
              resolve();
            }).catch(function (err) {
              console.log('ERROR_IN_UPDATING_PROFILE : ', err);
              reject(err);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/updateUserData', { 'profileId': b.$store.getters.getProfileDetails.profileId, 'fullName': b.in_name, 'profileImg': b.in_profileImage, 'aboutMe': b.in_aboutMe }).then(function (res) {
              b.in_profileImage = '';
              b.$store.dispatch('fetchProfile', b.$store.getters.getProfileDetails.profileId).then(function () {
                b.isEdit = false;
                resolve();
              }).catch(function (err) {
                console.log('err profile fetched : ', err);
                reject();
              });
            }).catch(function (err) {
              console.log('ERROR_IN_UPDATING_PROFILE : ', err);
              reject(err);
            });
          }
        });
      } else {
        b.$toasted.error('Name Field cannot be empty');
      }
    },
    editBasicProfile: function editBasicProfile() {
      this.editDOB = true;
      this.isEdit = true;
      this.in_name = this.$store.getters.getProfileDetails.fullName;
      this.in_designation = this.$store.getters.getProfileDetails.designation;
      this.in_email = this.$store.getters.getProfileDetails.email;
      this.in_aboutMe = this.$store.getters.getProfileDetails.aboutMe;
      this.in_skills = this.$store.getters.getProfileDetails.skills;
      // this.in_profileImage = this.$store.getters.getProfileDetails.profileImg
      // alert('end')
    },
    fetchPlayList: function fetchPlayList() {
      var playlistView = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('o/getAllPlaylists', {
          profileId: playlistView.$store.getters.getProfileDetails.profileId
        }).then(function (response) {
          // console.log('getAllPlaylists')
          // console.log(response.data)
          playlistView.$store.commit('setUserPlaylists', response.data);
          // console.log(JSON.stringify(this.$store.getters.getcurrentPlaylist));
          resolve();
        }).catch(function (err) {
          console.log(err);
          reject();
        });
      });
    },
    goToContentViewer: function goToContentViewer(playlist) {
      var _this4 = this;

      playlist.lastItemViewed.itemViewedDuration = parseInt(playlist.lastItemViewed.itemViewedDuration);
      var playlists = [];
      playlists.push(playlist);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/learningobject/getlodatabyplaylist', playlists).then(function (response) {
          _this4.$store.dispatch('setCurrentContentViewerPlaylist', response.data);
          if (response.data.length > 0) {
            _this4.contentPath = response.data[0].path[0].filePath;
            _this4.$store.dispatch('setCurrentPlayingContent', response.data[0]);
            _this4.$store.dispatch('setCurrentPlaylist', playlist);
            _this4.$store.dispatch('setIsPlaylist', true);
            _this4.$router.push('/frames');
          }
          resolve();
        }).catch(function (err) {
          console.log(err);
          reject();
        });
      });
    },
    learnLO: function learnLO(LO) {
      var _this5 = this;

      var LOObj = [];
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/learningobject/getlodatabyitemid', { itemId: LO.contentId }).then(function (Response) {
          if (Response.status === 200) {
            LOObj = Response.data;
            _this5.$store.dispatch('setCurrentContentViewerPlaylist', LOObj).then(function (response) {
              resolve();
              _this5.$store.dispatch('setIsPlaylist', false).then(function (response) {
                _this5.$router.push('/frames');
              });
            });
          }
        });
      });
    },
    setImage: function setImage(e) {
      var _this6 = this;

      var file = e.target.files[0];
      if (file !== undefined && file !== null && file.size !== undefined) {
        if (file.size / 1048576 > this.dropzoneOptions.maxFilesize) {
          this.loading = false;
          this.fileExceedLimit = true;
          return;
        } else {
          this.fileExceedLimit = false;
        }
        if (!file.type.includes('image/')) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          var reader = new FileReader();
          reader.onload = function (event) {
            _this6.imgSrc = event.target.result;
            // rebuild cropperjs with the updated source
            _this6.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
          // console.log(reader.readAsDataURL(file))
        }
      }
    },
    cropImage: function cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$refs.cropper.replace(this.cropImg);
      this.isCropped = true;
    },
    rotate: function rotate() {
      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
    uploadImage: function uploadImage() {
      // console.log(this.$refs.cropper.getCroppedCanvas())
      // console.log(this.cropImg)
      var blob;
      if (this.isCropped) {
        blob = this.dataURItoBlob(this.cropImg);
      } else {
        blob = this.dataURItoBlob(this.imgSrc);
      }
      var fileToUpload = new File([blob], '', { type: 'image/jpeg', lastModified: Date.now() });
      this.selectedFile = fileToUpload;
      this.loading = true;
      this.ChangeProfilePic();
    },

    // convert base64/URLEncoded data component to raw binary data held in a string
    dataURItoBlob: function dataURItoBlob(dataURI) {
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    ErrorUploading: function ErrorUploading(file, error) {
      if (error.includes('File is too big')) {
        this.$toasted.error(this.$t('profileDetails.errors.File_size_more_than_512'));
      } else if (error.includes('Extra File')) {
        this.$toasted.error(this.$t('profileDetails.errors.Can_not_upload_multiple_files'));
      }
      this.loading = false;
      console.log(error);
    },

    ReplaceFile: function ReplaceFile() {
      var _this7 = this;

      var uploadForm = this;
      var replaceurl = this.basicProfile.profileImg.split(uploadForm.bussiness_header);
      var path = this.basicProfile.profileImg.split('/');
      var CDN_REPLACEURL = replaceurl[0] + 'o/FileUploadWithReplace';
      var filePath = 'ProfilePics/' + uploadForm.$store.getters.getProfileDetails.profileId;
      // var filename = 'Profile_Img_' + uploadForm.$store.getters.getProfileDetails.profileId
      var filename = path[path.length - 1].split('#');
      var formData = new FormData();
      // console.log(path)
      formData.append('path', filePath);
      formData.append('fileName', filename[0]);
      formData.append('file', uploadForm.selectedFile);
      var url = CDN_REPLACEURL;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, formData, { headers: { 'Bussiness-Code': uploadForm.bussiness_header, 'Client-Code': uploadForm.client_header } }).then(function (Response) {
          if (Response.status === 202) {
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/updateUserData', { 'profileId': uploadForm.$store.getters.getProfileDetails.profileId, 'fullName': uploadForm.in_name, 'profileImg': Response.data.filepath, 'aboutMe': uploadForm.in_aboutMe }).then(function (res) {
              uploadForm.in_profileImage = '';
              resolve();
            }).catch(function (err) {
              console.log('err profile fetched : ', err);
              reject(err);
            });
            uploadForm.in_profileImage = Response.data.filepath;
            uploadForm.loading = false;
            uploadForm.$store.commit('setProfileImg', Response.data.filepath);
            uploadForm.$toasted.success(_this7.$t('profileDetails.alerts.File_replace_success'));
            uploadForm.isCropped = false;
          }
        }).catch(function (error) {
          console.log('err', error);
        });
      });
    },
    UploadFile: function UploadFile() {
      var uploadForm = this;
      if (!this.fileExceedLimit) {
        // this.DeleteFile(this.basicProfile.profileImg).then(function () {
        var filePath = 'ProfilePics/' + uploadForm.$store.getters.getProfileDetails.profileId;
        var filename = 'ProfileImg_' + uploadForm.$store.getters.getProfileDetails.profileId;
        // console.log(uploadForm.selectedFile)
        var formData = new FormData();
        formData.append('path', filePath);
        formData.append('fileName', filename);
        formData.append('file', uploadForm.selectedFile);
        // var url = 'http://10.2.10.42:9091/' + '?' + 's-o'
        var url = __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["y" /* CDN_UPLOAD_URL */];
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, formData, { headers: { 'Bussiness-Code': uploadForm.bussiness_header, 'Client-Code': uploadForm.client_header } }).then(function (Response) {
            // console.log(Response)
            if (Response.status === 201) {
              // console.log(Response.data.filepath)
              __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/updateUserData', { 'profileId': uploadForm.$store.getters.getProfileDetails.profileId, 'fullName': uploadForm.in_name, 'profileImg': Response.data.filepath, 'aboutMe': uploadForm.in_aboutMe }).then(function (res) {
                uploadForm.in_profileImage = '';
                resolve();
              }).catch(function (err) {
                console.log('err profile fetched : ', err);
                reject(err);
              });
              uploadForm.$store.commit('setProfileImg', Response.data.filepath);
              uploadForm.in_profileImage = Response.data.filepath;
              uploadForm.loading = false;
              uploadForm.isCropped = false;
              uploadForm.$toasted.success(uploadForm.$t('profileDetails.alerts.FILE_UPLOADED_SUCCESS'));
            }
          }).catch(function (error) {
            console.log('err', error);
          });
        });
        // }).catch(function (error) {
        //   console.error('Error in DeleteFileFromCDN : ' + error)
        // })
      } else {
        this.loading = false;
        return;
      }
    },
    /* fileAdded (file) {
      if (((file.size) / 1048576 > (this.dropzoneOptions.maxFilesize))) {
        this.loading = false
        this.fileExceedLimit = true
        return
      } else {
        // console.log('inside else')
        this.loading = true
        this.selectedFile = file
        this.ChangeProfilePic()
      }
      // console.log((file.size) / 1048576)
      // console.log(this.dropzoneOptions.maxFilesize)
    }, */
    ChangeProfilePic: function ChangeProfilePic() {
      if (this.basicProfile.profileImg === '') {
        this.UploadFile();
      } else {
        this.ReplaceFile();
      }
    },

    /*  clearFiles () {
       if (this.$refs.myVueDropzone.getAcceptedFiles().length) {
       } else {
         this.selectedFile = ''
       }
     }, */
    DeleteFile: function DeleteFile(filePath) {
      var uploadForm = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["z" /* CDN_DELETE_URL */];
        var obj = {};
        obj.url = filePath;
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, obj, { headers: { 'Bussiness-Code': __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["w" /* CDN_BUSSINESSHEADER */], 'Client-Code': __WEBPACK_IMPORTED_MODULE_1__components_common_constants_js__["x" /* CDN_CLIENTHEADER */] } }).then(function (Response) {
          if (Response.status === 200) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('r/removeDisplayPicture', { 'profileId': uploadForm.$store.getters.getProfileDetails.profileId }).then(function (res) {
                if (res.status === 200) {
                  uploadForm.$store.dispatch('removeDiplayPictureFromStore').then(function (res) {
                    uploadForm.imgSrc = '';
                    resolve();
                  });
                }
              }).catch(function (err) {
                console.log('ERROR_IN_UPDATING_THE_VALUE_PROFILE_PIC_PATH : ', err);
                reject(err);
              });
            });
          }
        }).catch(function (error) {
          console.log('err', error);
          reject(error);
        });
      });
    },
    GetAllocatedVideosDetails: function GetAllocatedVideosDetails() {
      this.$store.dispatch('fetchUserSingleConceptCollection', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': 1 });
    }
  },
  created: function created() {
    var _this8 = this;

    // this.$store.dispatch('fetchProfile', this.$store.getters.getProfileDetails.profileId)
    // this.fetchPlayList()
    // alert(this.$store.getters.getProfileDetails.profileId)
    this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId).then(function (res) {
      var itemIdList = [];
      // alert(JSON.stringify(this.$store.getters.getItemsEnrolledByType('CO')))
      for (var i = 0; i < _this8.$store.getters.getItemsEnrolledByType('CO').length; i++) {
        if (_this8.$store.getters.getItemsEnrolledByType('CO')[i].allocationDetails.completionPercentage === 100) {
          itemIdList.push({ 'contentId': _this8.$store.getters.getItemsEnrolledByType('CO')[i].contentId });
        }
      }
      _this8.$store.dispatch('getUserSkillsFromDB', itemIdList).then(function (res) {
        _this8.skills = res;
      }, function (err) {
        console.log('ERROR_IN_FETCHING_USER_SKILLS : ', err);
      });
    }, function (err) {
      console.log('error in fetching enrolled item :', err);
    });
  },
  mounted: function mounted() {
    this.GetAllocatedVideosDetails();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.in_profileImage !== '') {
      // alert('final delete')
      // this.DeleteFile(this.in_profileImage)
    }
  }
});

/***/ }),

/***/ "tfJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bannerVideo_vue__ = __webpack_require__("z5Hk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44cc9118_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_bannerVideo_vue__ = __webpack_require__("8Fcd");
function injectStyle (ssrContext) {
  __webpack_require__("oey5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bannerVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44cc9118_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_bannerVideo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u3Ct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__("424j");

// import axios from 'axios'



// import * as types from '../mutation-types'
// import router from '../../router'

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var state = {
  cart: {
    cartId: '',
    items: []
  }
};
var getters = {
  // returns the filltered wishList content
  getCartDataMatchingKeyWord: function getCartDataMatchingKeyWord(state, getters) {
    return function (keyWord) {
      var result = [];
      if (keyWord.length === 0) {
        result = state.cart.items;
        // result = getters.getCartData.items
      } else {
        // console.log(123)
        result = getters.getCartData.items.filter(function (obj) {
          // console.log(JSON.stringify(obj.itemName), obj.itemName.toLowerCase().includes(keyWord.toLowerCase()))
          return obj.itemName.toLowerCase().includes(keyWord.toLowerCase());
        });
      }
      return result;
    };
  },
  // return true if item present in cart else false if not present
  itemPresentInCartStatus: function itemPresentInCartStatus(state, getters) {
    return function (itemId) {
      for (var j = 0; j < getters.getCartData.items.length; j++) {
        if (getters.getCartData.items[j].itemId === itemId) {
          return true;
        }
      }
      return false;
    };
  },
  getCartData: function getCartData(state) {
    // swal('hello there')
    return state.cart;
  }
};
var mutations = {
  setCartData: function setCartData(state, data) {
    // data.items.forEach(element => {
    //   var isExist = false
    //   state.cart.items.forEach(element1 => {
    //     if (element1.itemId === element.itemId) {
    //       console.log(element1.itemId)
    //       isExist = true
    //     }
    //   })
    //   if (!isExist) {
    //     console.log('n h')
    //     state.cart.items.push(element)
    //   } else {
    //     console.log('here')
    //     state.cart.items.forEach(ele => {
    //       if (ele.itemId === element.itemId) {
    //         console.log('s', ele.itemId, '===', element.itemId)
    //         ele.amount = element.amount
    //       }
    //     })
    //   }
    // })
    state.cart.items = data.items;
    state.cart.cartId = data.cartId;
  },
  addTocart: function addTocart(state, data) {
    var isExist = false;
    if (state.cart.items.length !== 0) {
      state.cart.items.forEach(function (element1) {
        if (element1.itemId === data.itemId) {
          isExist = true;
        }
      });
    }
    if (!isExist) {
      state.cart.push(data);
    }
  },
  deleteFromCart: function deleteFromCart(state, data) {
    var temp = state.cart.items;
    state.cart.items = [];
    if (temp.length !== 0) {
      temp.forEach(function (element) {
        if (element.itemId !== data.itemId) {
          state.cart.items.push(element);
        }
      });
    }
  },
  clearCartData: function clearCartData(state) {
    state.cart = {
      cartId: null,
      items: []
    };
  },
  resetCartItems: function resetCartItems(state) {
    state.cart.items = [];
  }
};
var actions = {
  previousCartItems: function previousCartItems(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/r/getCartItems', data).then(function (res) {
        if (res.data !== null) {
          resolve(res.data);
        }
      }).catch(function (err) {
        console.log('error viewing::', err);
        reject(err);
      });
    });
  },
  viewCartData: function viewCartData(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/r/cartView', {
        'profileId': data
      }).then(function (res) {
        if (res.data !== null) {
          context.commit('setCartData', res.data);
          resolve();
        }
      }).catch(function (err) {
        console.log('error viewing::', err);
        reject(err);
      });
    });
  },
  deleteData: function deleteData(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/r/cartDelete', {
        'profileId': data.profileId,
        'itemId': data.itemId,
        'cartId': data.cartId
      }).then(function (res) {
        context.commit('deleteFromCart', data);
        resolve();
      }).catch(function (err) {
        console.log('error deleting', err);
        reject(err);
      });
    });
  },
  addCartData: function addCartData(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/r/cartAdd', {
        'profileId': data.profileId,
        'itemId': data.itemId,
        'cartId': data.cartId
      }).then(function (res) {
        context.commit('setCartData', res.data);
        // context.dispatch('viewCartData', data.profileId)
        resolve();
      }).catch(function (err) {
        console.log('error Inserting', err);
        reject(err);
      });
    });
  },
  clearCartItemsInStore: function clearCartItemsInStore(context) {
    context.commit('resetCartItems');
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "uvl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__ = __webpack_require__("EOnD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_674c3c00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__ = __webpack_require__("WE48");
function injectStyle (ssrContext) {
  __webpack_require__("+Gh5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_674c3c00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v+qr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audioPlayer_vue__ = __webpack_require__("oVvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dab0c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_audioPlayer_vue__ = __webpack_require__("3nNa");
function injectStyle (ssrContext) {
  __webpack_require__("V2Ez")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audioPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dab0c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_audioPlayer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vWA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_htmlViewer_vue__ = __webpack_require__("lcmo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_196585a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_htmlViewer_vue__ = __webpack_require__("y7F+");
function injectStyle (ssrContext) {
  __webpack_require__("2sew")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_htmlViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_196585a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_htmlViewer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vY0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiselect",
    class: {
      'multiselect--active': _vm.isOpen, 'multiselect--disabled': _vm.disabled, 'multiselect--above': _vm.isAbove
    },
    attrs: {
      "tabindex": _vm.searchable ? -1 : _vm.tabindex
    },
    on: {
      "focus": function($event) {
        _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.deactivate()
      }
    }
  }, [_vm._t("caret", [_c('div', {
    staticClass: "multiselect__select",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle()
      },
      "click": function($event) {
        _vm.addPointerElement($event)
      }
    }
  })], {
    toggle: _vm.toggle
  }), _vm._v(" "), _vm._t("clear", null, {
    search: _vm.search
  }), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "multiselect__tags"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleValues.length > 0),
      expression: "visibleValues.length > 0"
    }],
    staticClass: "multiselect__tags-wrap"
  }, [_vm._l((_vm.visibleValues), function(option) {
    return [_vm._t("tag", [_c('span', {
      staticClass: "multiselect__tag"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getOptionLabel(option))
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "multiselect__tag-icon",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.preventDefault();
          _vm.removeElement(option)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.removeElement(option)
        }
      }
    })])], {
      option: option,
      search: _vm.search,
      remove: _vm.removeElement
    })]
  })], 2), _vm._v(" "), (_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_vm._t("limit", [_c('strong', {
    staticClass: "multiselect__strong",
    domProps: {
      "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
    }
  })])] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect__loading"
    }
  }, [_vm._t("loading", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "multiselect__spinner"
  })])], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen && _vm.searchable),
      expression: "isOpen && searchable"
    }],
    ref: "search",
    staticClass: "multiselect__input",
    style: (_vm.inputStyle),
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function($event) {
        _vm.updateSearch($event.target.value)
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.activate()
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.deactivate()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        $event.stopPropagation();
        _vm.removeLastElement()
      }]
    }
  }), _vm._v(" "), (_vm.isSingleLabelVisible) ? _c('span', {
    staticClass: "multiselect__single",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [_vm._t("singleLabel", [
    [_vm._v(_vm._s(_vm.currentOptionLabel))]
  ], {
    option: _vm.singleValue
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isPlaceholderVisible) ? _c('span', {
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [_vm._t("placeholder", [_c('span', {
    staticClass: "multiselect__single"
  }, [_vm._v("\n            " + _vm._s(_vm.placeholder) + "\n          ")])])], 2) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "multiselect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    }),
    on: {
      "focus": _vm.activate,
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "multiselect__content",
    style: (_vm.contentStyle)
  }, [_vm._t("beforeList"), _vm._v(" "), (_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("maxElements", [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected option to select another.")])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "multiselect__element"
    }, [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e(), _vm._v(" "), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.groupHighlight(index, option),
      attrs: {
        "data-select": _vm.groupSelect && _vm.selectGroupLabelText,
        "data-deselect": _vm.groupSelect && _vm.deselectGroupLabelText
      },
      on: {
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.groupSelect && _vm.pointerSet(index)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.selectGroup(option)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),
      expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)"
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noResult", [_vm._v("No elements found. Consider changing the search query.")])], 2)]), _vm._v(" "), _vm._t("afterList")], 2)])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vYOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-gradient-gray"
  }, [_c('bannerVideo', {
    attrs: {
      "contentId": _vm.courseId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-holder"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-holder"
  }, [_c('libraryCards')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vcyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseObjectives',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "vuv6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

// The Emitter class provides the ability to call `.on()` on Dropzone to listen
// to events.
// It is strongly based on component's emitter class, and I removed the
// functionality because of the dependency hell with different frameworks.
var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: "on",

    // Add an event listener for given event
    value: function on(event, fn) {
      this._callbacks = this._callbacks || {};
      // Create namespace for this event
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      this._callbacks = this._callbacks || {};
      var callbacks = this._callbacks[event];

      if (callbacks) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        for (var _iterator = callbacks, _isArray = true, _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var callback = _ref;

          callback.apply(this, args);
        }
      }

      return this;
    }

    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.

  }, {
    key: "off",
    value: function off(event, fn) {
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }

      // specific event
      var callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }

      // remove all handlers
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }

      // remove specific handler
      for (var i = 0; i < callbacks.length; i++) {
        var callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }

      return this;
    }
  }]);

  return Emitter;
}();

var Dropzone = function (_Emitter) {
  _inherits(Dropzone, _Emitter);

  _createClass(Dropzone, null, [{
    key: "initClass",
    value: function initClass() {

      // Exposing the emitter class, mainly for tests
      this.prototype.Emitter = Emitter;

      /*
       This is a list of all available events you can register on a dropzone object.
        You can register an event handler like this:
        dropzone.on("dragEnter", function() { });
        */
      this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

      this.prototype.defaultOptions = {
        /**
         * Has to be specified on elements other than form (or when the form
         * doesn't have an `action` attribute). You can also
         * provide a function that will be called with `files` and
         * must return the url (since `v3.12.0`)
         */
        url: null,

        /**
         * Can be changed to `"put"` if necessary. You can also provide a function
         * that will be called with `files` and must return the method (since `v3.12.0`).
         */
        method: "post",

        /**
         * Will be set on the XHRequest.
         */
        withCredentials: false,

        /**
         * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
         */
        timeout: 30000,

        /**
         * How many file uploads to process in parallel (See the
         * Enqueuing file uploads* documentation section for more info)
         */
        parallelUploads: 2,

        /**
         * Whether to send multiple files in one request. If
         * this it set to true, then the fallback file input element will
         * have the `multiple` attribute as well. This option will
         * also trigger additional events (like `processingmultiple`). See the events
         * documentation section for more information.
         */
        uploadMultiple: false,

        /**
         * Whether you want files to be uploaded in chunks to your server. This can't be
         * used in combination with `uploadMultiple`.
         *
         * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
         */
        chunking: false,

        /**
         * If `chunking` is enabled, this defines whether **every** file should be chunked,
         * even if the file size is below chunkSize. This means, that the additional chunk
         * form data will be submitted and the `chunksUploaded` callback will be invoked.
         */
        forceChunking: false,

        /**
         * If `chunking` is `true`, then this defines the chunk size in bytes.
         */
        chunkSize: 2000000,

        /**
         * If `true`, the individual chunks of a file are being uploaded simultaneously.
         */
        parallelChunkUploads: false,

        /**
         * Whether a chunk should be retried if it fails.
         */
        retryChunks: false,

        /**
         * If `retryChunks` is true, how many times should it be retried.
         */
        retryChunksLimit: 3,

        /**
         * If not `null` defines how many files this Dropzone handles. If it exceeds,
         * the event `maxfilesexceeded` will be called. The dropzone element gets the
         * class `dz-max-files-reached` accordingly so you can provide visual feedback.
         */
        maxFilesize: 256,

        /**
         * The name of the file param that gets transferred.
         * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
         * Dropzone will append `[]` to the name.
         */
        paramName: "file",

        /**
         * Whether thumbnails for images should be generated
         */
        createImageThumbnails: true,

        /**
         * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
         */
        maxThumbnailFilesize: 10,

        /**
         * If `null`, the ratio of the image will be used to calculate it.
         */
        thumbnailWidth: 120,

        /**
         * The same as `thumbnailWidth`. If both are null, images will not be resized.
         */
        thumbnailHeight: 120,

        /**
         * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
         * Can be either `contain` or `crop`.
         */
        thumbnailMethod: 'crop',

        /**
         * If set, images will be resized to these dimensions before being **uploaded**.
         * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
         * ratio of the file will be preserved.
         *
         * The `options.transformFile` function uses these options, so if the `transformFile` function
         * is overridden, these options don't do anything.
         */
        resizeWidth: null,

        /**
         * See `resizeWidth`.
         */
        resizeHeight: null,

        /**
         * The mime type of the resized image (before it gets uploaded to the server).
         * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
         * See `resizeWidth` for more information.
         */
        resizeMimeType: null,

        /**
         * The quality of the resized images. See `resizeWidth`.
         */
        resizeQuality: 0.8,

        /**
         * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
         * Can be either `contain` or `crop`.
         */
        resizeMethod: 'contain',

        /**
         * The base that is used to calculate the filesize. You can change this to
         * 1024 if you would rather display kibibytes, mebibytes, etc...
         * 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte` not `1 kilobyte`.
         * You can change this to `1024` if you don't care about validity.
         */
        filesizeBase: 1000,

        /**
         * Can be used to limit the maximum number of files that will be handled by this Dropzone
         */
        maxFiles: null,

        /**
         * An optional object to send additional headers to the server. Eg:
         * `{ "My-Awesome-Header": "header value" }`
         */
        headers: null,

        /**
         * If `true`, the dropzone element itself will be clickable, if `false`
         * nothing will be clickable.
         *
         * You can also pass an HTML element, a CSS selector (for multiple elements)
         * or an array of those. In that case, all of those elements will trigger an
         * upload when clicked.
         */
        clickable: true,

        /**
         * Whether hidden files in directories should be ignored.
         */
        ignoreHiddenFiles: true,

        /**
         * The default implementation of `accept` checks the file's mime type or
         * extension against this list. This is a comma separated list of mime
         * types or file extensions.
         *
         * Eg.: `image/*,application/pdf,.psd`
         *
         * If the Dropzone is `clickable` this option will also be used as
         * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
         * parameter on the hidden file input as well.
         */
        acceptedFiles: null,

        /**
         * **Deprecated!**
         * Use acceptedFiles instead.
         */
        acceptedMimeTypes: null,

        /**
         * If false, files will be added to the queue but the queue will not be
         * processed automatically.
         * This can be useful if you need some additional user input before sending
         * files (or if you want want all files sent at once).
         * If you're ready to send the file simply call `myDropzone.processQueue()`.
         *
         * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
         * section for more information.
         */
        autoProcessQueue: true,

        /**
         * If false, files added to the dropzone will not be queued by default.
         * You'll have to call `enqueueFile(file)` manually.
         */
        autoQueue: true,

        /**
         * If `true`, this will add a link to every file preview to remove or cancel (if
         * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
         * and `dictRemoveFile` options are used for the wording.
         */
        addRemoveLinks: false,

        /**
         * Defines where to display the file previews – if `null` the
         * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
         * selector. The element should have the `dropzone-previews` class so
         * the previews are displayed properly.
         */
        previewsContainer: null,

        /**
         * This is the element the hidden input field (which is used when clicking on the
         * dropzone to trigger file selection) will be appended to. This might
         * be important in case you use frameworks to switch the content of your page.
         */
        hiddenInputContainer: "body",

        /**
         * If null, no capture type will be specified
         * If camera, mobile devices will skip the file selection and choose camera
         * If microphone, mobile devices will skip the file selection and choose the microphone
         * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
         * On apple devices multiple must be set to false.  AcceptedFiles may need to
         * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
         */
        capture: null,

        /**
         * **Deprecated**. Use `renameFile` instead.
         */
        renameFilename: null,

        /**
         * A function that is invoked before the file is uploaded to the server and renames the file.
         * This function gets the `File` as argument and can use the `file.name`. The actual name of the
         * file that gets used during the upload can be accessed through `file.upload.filename`.
         */
        renameFile: null,

        /**
         * If `true` the fallback will be forced. This is very useful to test your server
         * implementations first and make sure that everything works as
         * expected without dropzone if you experience problems, and to test
         * how your fallbacks will look.
         */
        forceFallback: false,

        /**
         * The text used before any files are dropped.
         */
        dictDefaultMessage: "Drop files here to upload",

        /**
         * The text that replaces the default message text it the browser is not supported.
         */
        dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",

        /**
         * The text that will be added before the fallback form.
         * If you provide a  fallback element yourself, or if this option is `null` this will
         * be ignored.
         */
        dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",

        /**
         * If the filesize is too big.
         * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
         */
        dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",

        /**
         * If the file doesn't match the file type.
         */
        dictInvalidFileType: "You can't upload files of this type.",

        /**
         * If the server response was invalid.
         * `{{statusCode}}` will be replaced with the servers status code.
         */
        dictResponseError: "Server responded with {{statusCode}} code.",

        /**
         * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
         */
        dictCancelUpload: "Cancel upload",

        /**
         * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
         */
        dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",

        /**
         * If `addRemoveLinks` is true, the text to be used to remove a file.
         */
        dictRemoveFile: "Remove file",

        /**
         * If this is not null, then the user will be prompted before removing a file.
         */
        dictRemoveFileConfirmation: null,

        /**
         * Displayed if `maxFiles` is st and exceeded.
         * The string `{{maxFiles}}` will be replaced by the configuration value.
         */
        dictMaxFilesExceeded: "You can not upload any more files.",

        /**
         * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
         * `b` for bytes.
         */
        dictFileSizeUnits: { tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b" },

        /**
         * Called when dropzone initialized
         * You can add event listeners here
         */
        init: function init() {},


        /**
         * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
         * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
         * of a function, this needs to return a map.
         *
         * The default implementation does nothing for normal uploads, but adds relevant information for
         * chunked uploads.
         *
         * This is the same as adding hidden input fields in the form element.
         */
        params: function params(files, xhr, chunk) {
          if (chunk) {
            return {
              dzuuid: chunk.file.upload.uuid,
              dzchunkindex: chunk.index,
              dztotalfilesize: chunk.file.size,
              dzchunksize: this.options.chunkSize,
              dztotalchunkcount: chunk.file.upload.totalChunkCount,
              dzchunkbyteoffset: chunk.index * this.options.chunkSize
            };
          }
        },


        /**
         * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
         * and a `done` function as parameters.
         *
         * If the done function is invoked without arguments, the file is "accepted" and will
         * be processed. If you pass an error message, the file is rejected, and the error
         * message will be displayed.
         * This function will not be called if the file is too big or doesn't match the mime types.
         */
        accept: function accept(file, done) {
          return done();
        },


        /**
         * The callback that will be invoked when all chunks have been uploaded for a file.
         * It gets the file for which the chunks have been uploaded as the first parameter,
         * and the `done` function as second. `done()` needs to be invoked when everything
         * needed to finish the upload process is done.
         */
        chunksUploaded: function chunksUploaded(file, done) {
          done();
        },

        /**
         * Gets called when the browser is not supported.
         * The default implementation shows the fallback input field and adds
         * a text.
         */
        fallback: function fallback() {
          // This code should pass in IE7... :(
          var messageElement = void 0;
          this.element.className = this.element.className + " dz-browser-not-supported";

          for (var _iterator2 = this.element.getElementsByTagName("div"), _isArray2 = true, _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var child = _ref2;

            if (/(^| )dz-message($| )/.test(child.className)) {
              messageElement = child;
              child.className = "dz-message"; // Removes the 'dz-default' class
              break;
            }
          }
          if (!messageElement) {
            messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
            this.element.appendChild(messageElement);
          }

          var span = messageElement.getElementsByTagName("span")[0];
          if (span) {
            if (span.textContent != null) {
              span.textContent = this.options.dictFallbackMessage;
            } else if (span.innerText != null) {
              span.innerText = this.options.dictFallbackMessage;
            }
          }

          return this.element.appendChild(this.getFallbackForm());
        },


        /**
         * Gets called to calculate the thumbnail dimensions.
         *
         * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
         *
         *  - `srcWidth` & `srcHeight` (required)
         *  - `trgWidth` & `trgHeight` (required)
         *  - `srcX` & `srcY` (optional, default `0`)
         *  - `trgX` & `trgY` (optional, default `0`)
         *
         * Those values are going to be used by `ctx.drawImage()`.
         */
        resize: function resize(file, width, height, resizeMethod) {
          var info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
          };

          var srcRatio = file.width / file.height;

          // Automatically calculate dimensions if not specified
          if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
          } else if (width == null) {
            width = height * srcRatio;
          } else if (height == null) {
            height = width / srcRatio;
          }

          // Make sure images aren't upscaled
          width = Math.min(width, info.srcWidth);
          height = Math.min(height, info.srcHeight);

          var trgRatio = width / height;

          if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === 'crop') {
              if (srcRatio > trgRatio) {
                info.srcHeight = file.height;
                info.srcWidth = info.srcHeight * trgRatio;
              } else {
                info.srcWidth = file.width;
                info.srcHeight = info.srcWidth / trgRatio;
              }
            } else if (resizeMethod === 'contain') {
              // Method 'contain'
              if (srcRatio > trgRatio) {
                height = width / srcRatio;
              } else {
                width = height * srcRatio;
              }
            } else {
              throw new Error("Unknown resizeMethod '" + resizeMethod + "'");
            }
          }

          info.srcX = (file.width - info.srcWidth) / 2;
          info.srcY = (file.height - info.srcHeight) / 2;

          info.trgWidth = width;
          info.trgHeight = height;

          return info;
        },


        /**
         * Can be used to transform the file (for example, resize an image if necessary).
         *
         * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
         * images according to those dimensions.
         *
         * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
         * to be invoked with the file when the transformation is done.
         */
        transformFile: function transformFile(file, done) {
          if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) {
            return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
          } else {
            return done(file);
          }
        },


        /**
         * A string that contains the template used for each dropped
         * file. Change it to fulfill your needs but make sure to properly
         * provide all elements.
         *
         * If you want to use an actual HTML element instead of providing a String
         * as a config option, you could create a div with the id `tpl`,
         * put the template inside it and provide the element like this:
         *
         *     document
         *       .querySelector('#tpl')
         *       .innerHTML
         *
         */
        previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>",

        // END OPTIONS
        // (Required by the dropzone documentation parser)


        /*
         Those functions register themselves to the events on init and handle all
         the user interface specific stuff. Overwriting them won't break the upload
         but can break the way it's displayed.
         You can overwrite them if you don't like the default behavior. If you just
         want to add an additional event handler, register it on the dropzone object
         and don't overwrite those options.
         */

        // Those are self explanatory and simply concern the DragnDrop.
        drop: function drop(e) {
          return this.element.classList.remove("dz-drag-hover");
        },
        dragstart: function dragstart(e) {},
        dragend: function dragend(e) {
          return this.element.classList.remove("dz-drag-hover");
        },
        dragenter: function dragenter(e) {
          return this.element.classList.add("dz-drag-hover");
        },
        dragover: function dragover(e) {
          return this.element.classList.add("dz-drag-hover");
        },
        dragleave: function dragleave(e) {
          return this.element.classList.remove("dz-drag-hover");
        },
        paste: function paste(e) {},


        // Called whenever there are no files left in the dropzone anymore, and the
        // dropzone should be displayed as if in the initial state.
        reset: function reset() {
          return this.element.classList.remove("dz-started");
        },


        // Called when a file is added to the queue
        // Receives `file`
        addedfile: function addedfile(file) {
          var _this2 = this;
          window.dropZone = this
          if (this.element === this.previewsContainer) {
            this.element.classList.add("dz-started");
          }

          if (this.previewsContainer) {
            file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility

            this.previewsContainer.appendChild(file.previewElement);
            for (var _iterator3 = file.previewElement.querySelectorAll("[data-dz-name]"), _isArray3 = true, _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
              var _ref3;

              if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
              } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
              }

              var node = _ref3;

              node.textContent = file.name;
            }
            for (var _iterator4 = file.previewElement.querySelectorAll("[data-dz-size]"), _isArray4 = true, _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
              if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                node = _iterator4[_i4++];
              } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                node = _i4.value;
              }

              node.innerHTML = this.filesize(file.size);
            }

            if (this.options.addRemoveLinks) {
              file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
              file.previewElement.appendChild(file._removeLink);
            }

            var removeFileEvent = function removeFileEvent(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                //return Dropzone.confirm(_this2.options.dictCancelUploadConfirmation, function () {
                  return _this2.removeFile(file);
                //});
              } else {
                if (_this2.options.dictRemoveFileConfirmation) {
                  //return Dropzone.confirm(_this2.options.dictRemoveFileConfirmation, function () {
                    return _this2.removeFile(file);
                  // });
                } else {
                  return _this2.removeFile(file);
                }
              }
            };

            for (var _iterator5 = file.previewElement.querySelectorAll("[data-dz-remove]"), _isArray5 = true, _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
              var _ref4;

              if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref4 = _iterator5[_i5++];
              } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref4 = _i5.value;
              }

              var removeLink = _ref4;

              removeLink.addEventListener("click", removeFileEvent);
            }
          }
        },


        // Called whenever a file is removed.
        removedfile: function removedfile(file) {
          if (file.previewElement != null && file.previewElement.parentNode != null) {
            file.previewElement.parentNode.removeChild(file.previewElement);
          }
          return this._updateMaxFilesReachedClass();
        },


        // Called when a thumbnail has been generated
        // Receives `file` and `dataUrl`
        thumbnail: function thumbnail(file, dataUrl) {
          if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (var _iterator6 = file.previewElement.querySelectorAll("[data-dz-thumbnail]"), _isArray6 = true, _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
              var _ref5;

              if (_isArray6) {
                if (_i6 >= _iterator6.length) break;
                _ref5 = _iterator6[_i6++];
              } else {
                _i6 = _iterator6.next();
                if (_i6.done) break;
                _ref5 = _i6.value;
              }

              var thumbnailElement = _ref5;

              thumbnailElement.alt = file.name;
              thumbnailElement.src = dataUrl;
            }

            return setTimeout(function () {
              return file.previewElement.classList.add("dz-image-preview");
            }, 1);
          }
        },


        // Called whenever an error occurs
        // Receives `file` and `message`
        error: function error(file, message) {
          if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "String" && message.error) {
              message = message.error;
            }
            for (var _iterator7 = file.previewElement.querySelectorAll("[data-dz-errormessage]"), _isArray7 = true, _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
              var _ref6;

              if (_isArray7) {
                if (_i7 >= _iterator7.length) break;
                _ref6 = _iterator7[_i7++];
              } else {
                _i7 = _iterator7.next();
                if (_i7.done) break;
                _ref6 = _i7.value;
              }

              var node = _ref6;

              node.textContent = message;
            }
          }
        },
        errormultiple: function errormultiple() {},


        // Called when a file gets processed. Since there is a cue, not all added
        // files are processed immediately.
        // Receives `file`
        processing: function processing(file) {
          if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) {
              return file._removeLink.textContent = this.options.dictCancelUpload;
            }
          }
        },
        processingmultiple: function processingmultiple() {},


        // Called whenever the upload progress gets updated.
        // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
        // To get the total number of bytes of the file, use `file.size`
        uploadprogress: function uploadprogress(file, progress, bytesSent) {
          if (file.previewElement) {
            for (var _iterator8 = file.previewElement.querySelectorAll("[data-dz-uploadprogress]"), _isArray8 = true, _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
              var _ref7;

              if (_isArray8) {
                if (_i8 >= _iterator8.length) break;
                _ref7 = _iterator8[_i8++];
              } else {
                _i8 = _iterator8.next();
                if (_i8.done) break;
                _ref7 = _i8.value;
              }

              var node = _ref7;

              node.nodeName === 'PROGRESS' ? node.value = progress : node.style.width = progress + "%";
            }
          }
        },


        // Called whenever the total upload progress gets updated.
        // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
        totaluploadprogress: function totaluploadprogress() {},


        // Called just before the file is sent. Gets the `xhr` object as second
        // parameter, so you can modify it (for example to add a CSRF token) and a
        // `formData` object to add additional information.
        sending: function sending() {},
        sendingmultiple: function sendingmultiple() {},


        // When the complete upload is finished and successful
        // Receives `file`
        success: function success(file) {
          if (file.previewElement) {
            return file.previewElement.classList.add("dz-success");
          }
        },
        successmultiple: function successmultiple() {},


        // When the upload is canceled.
        canceled: function canceled(file) {
          return this.emit("error", file, "Upload canceled.");
        },
        canceledmultiple: function canceledmultiple() {},


        // When the upload is finished, either with success or an error.
        // Receives `file`
        complete: function complete(file) {
          if (file._removeLink) {
            file._removeLink.textContent = this.options.dictRemoveFile;
          }
          if (file.previewElement) {
            return file.previewElement.classList.add("dz-complete");
          }
        },
        completemultiple: function completemultiple() {},
        maxfilesexceeded: function maxfilesexceeded() {},
        maxfilesreached: function maxfilesreached() {},
        queuecomplete: function queuecomplete() {},
        addedfiles: function addedfiles() {}
      };

      this.prototype._thumbnailQueue = [];
      this.prototype._processingThumbnail = false;
    }

    // global utility

  }, {
    key: "extend",
    value: function extend(target) {
      for (var _len2 = arguments.length, objects = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        objects[_key2 - 1] = arguments[_key2];
      }

      for (var _iterator9 = objects, _isArray9 = true, _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray9) {
          if (_i9 >= _iterator9.length) break;
          _ref8 = _iterator9[_i9++];
        } else {
          _i9 = _iterator9.next();
          if (_i9.done) break;
          _ref8 = _i9.value;
        }

        var object = _ref8;

        for (var key in object) {
          var val = object[key];
          target[key] = val;
        }
      }
      return target;
    }
  }]);

  function Dropzone(el, options) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this));

    var fallback = void 0,
        left = void 0;
    _this.element = el;
    // For backwards compatibility since the version was in the prototype previously
    _this.version = Dropzone.version;

    _this.defaultOptions.previewTemplate = _this.defaultOptions.previewTemplate.replace(/\n*/g, "");

    _this.clickableElements = [];
    _this.listeners = [];
    _this.files = []; // All files

    if (typeof _this.element === "string") {
      _this.element = document.querySelector(_this.element);
    }

    // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
    if (!_this.element || _this.element.nodeType == null) {
      throw new Error("Invalid dropzone element.");
    }

    if (_this.element.dropzone) {
      throw new Error("Dropzone already attached.");
    }

    // Now add this dropzone to the instances.
    Dropzone.instances.push(_this);

    // Put the dropzone inside the element itself.
    _this.element.dropzone = _this;

    var elementOptions = (left = Dropzone.optionsForElement(_this.element)) != null ? left : {};

    _this.options = Dropzone.extend({}, _this.defaultOptions, elementOptions, options != null ? options : {});

    // If the browser failed, just call the fallback and leave
    if (_this.options.forceFallback || !Dropzone.isBrowserSupported()) {
      var _ret;

      return _ret = _this.options.fallback.call(_this), _possibleConstructorReturn(_this, _ret);
    }

    // @options.url = @element.getAttribute "action" unless @options.url?
    if (_this.options.url == null) {
      _this.options.url = _this.element.getAttribute("action");
    }

    if (!_this.options.url) {
      throw new Error("No URL provided.");
    }

    if (_this.options.acceptedFiles && _this.options.acceptedMimeTypes) {
      throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
    }

    if (_this.options.uploadMultiple && _this.options.chunking) {
      throw new Error('You cannot set both: uploadMultiple and chunking.');
    }

    // Backwards compatibility
    if (_this.options.acceptedMimeTypes) {
      _this.options.acceptedFiles = _this.options.acceptedMimeTypes;
      delete _this.options.acceptedMimeTypes;
    }

    // Backwards compatibility
    if (_this.options.renameFilename != null) {
      _this.options.renameFile = function (file) {
        return _this.options.renameFilename.call(_this, file.name, file);
      };
    }

    _this.options.method = _this.options.method.toUpperCase();

    if ((fallback = _this.getExistingFallback()) && fallback.parentNode) {
      // Remove the fallback
      fallback.parentNode.removeChild(fallback);
    }

    // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
    if (_this.options.previewsContainer !== false) {
      if (_this.options.previewsContainer) {
        _this.previewsContainer = Dropzone.getElement(_this.options.previewsContainer, "previewsContainer");
      } else {
        _this.previewsContainer = _this.element;
      }
    }

    if (_this.options.clickable) {
      if (_this.options.clickable === true) {
        _this.clickableElements = [_this.element];
      } else {
        _this.clickableElements = Dropzone.getElements(_this.options.clickable, "clickable");
      }
    }

    _this.init();
    return _this;
  }

  // Returns all files that have been accepted


  _createClass(Dropzone, [{
    key: "getAcceptedFiles",
    value: function getAcceptedFiles() {
      return this.files.filter(function (file) {
        return file.accepted;
      }).map(function (file) {
        return file;
      });
    }

    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.

  }, {
    key: "getRejectedFiles",
    value: function getRejectedFiles() {
      return this.files.filter(function (file) {
        return !file.accepted;
      }).map(function (file) {
        return file;
      });
    }
  }, {
    key: "getFilesWithStatus",
    value: function getFilesWithStatus(status) {
      return this.files.filter(function (file) {
        return file.status === status;
      }).map(function (file) {
        return file;
      });
    }

    // Returns all files that are in the queue

  }, {
    key: "getQueuedFiles",
    value: function getQueuedFiles() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    }
  }, {
    key: "getUploadingFiles",
    value: function getUploadingFiles() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    }
  }, {
    key: "getAddedFiles",
    value: function getAddedFiles() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    }

    // Files that are either queued or uploading

  }, {
    key: "getActiveFiles",
    value: function getActiveFiles() {
      return this.files.filter(function (file) {
        return file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED;
      }).map(function (file) {
        return file;
      });
    }

    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.

  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      // In case it isn't set already
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }

      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }

      if (this.clickableElements.length) {
        var setupHiddenFileInput = function setupHiddenFileInput() {
          if (_this3.hiddenFileInput) {
            _this3.hiddenFileInput.parentNode.removeChild(_this3.hiddenFileInput);
          }
          _this3.hiddenFileInput = document.createElement("input");
          _this3.hiddenFileInput.setAttribute("type", "file");
          if (_this3.options.maxFiles === null || _this3.options.maxFiles > 1) {
            _this3.hiddenFileInput.setAttribute("multiple", "multiple");
          }
          _this3.hiddenFileInput.className = "dz-hidden-input";

          if (_this3.options.acceptedFiles !== null) {
            _this3.hiddenFileInput.setAttribute("accept", _this3.options.acceptedFiles);
          }
          if (_this3.options.capture !== null) {
            _this3.hiddenFileInput.setAttribute("capture", _this3.options.capture);
          }

          // Not setting `display="none"` because some browsers don't accept clicks
          // on elements that aren't displayed.
          _this3.hiddenFileInput.style.visibility = "hidden";
          _this3.hiddenFileInput.style.position = "absolute";
          _this3.hiddenFileInput.style.top = "0";
          _this3.hiddenFileInput.style.left = "0";
          _this3.hiddenFileInput.style.height = "0";
          _this3.hiddenFileInput.style.width = "0";
          document.querySelector(_this3.options.hiddenInputContainer).appendChild(_this3.hiddenFileInput);
          return _this3.hiddenFileInput.addEventListener("change", function () {
            var files = _this3.hiddenFileInput.files;

            if (files.length) {
              for (var _iterator10 = files, _isArray10 = true, _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
                var _ref9;

                if (_isArray10) {
                  if (_i10 >= _iterator10.length) break;
                  _ref9 = _iterator10[_i10++];
                } else {
                  _i10 = _iterator10.next();
                  if (_i10.done) break;
                  _ref9 = _i10.value;
                }

                var file = _ref9;

                _this3.addFile(file);
              }
            }
            _this3.emit("addedfiles", files);
            return setupHiddenFileInput();
          });
        };
        setupHiddenFileInput();
      }

      this.URL = window.URL !== null ? window.URL : window.webkitURL;

      // Setup all event listeners on the Dropzone object itself.
      // They're not in @setupEventListeners() because they shouldn't be removed
      // again when the dropzone gets disabled.
      for (var _iterator11 = this.events, _isArray11 = true, _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray11) {
          if (_i11 >= _iterator11.length) break;
          _ref10 = _iterator11[_i11++];
        } else {
          _i11 = _iterator11.next();
          if (_i11.done) break;
          _ref10 = _i11.value;
        }

        var eventName = _ref10;

        this.on(eventName, this.options[eventName]);
      }

      this.on("uploadprogress", function () {
        return _this3.updateTotalUploadProgress();
      });

      this.on("removedfile", function () {
        return _this3.updateTotalUploadProgress();
      });

      this.on("canceled", function (file) {
        return _this3.emit("complete", file);
      });

      // Emit a `queuecomplete` event if all files finished uploading.
      this.on("complete", function (file) {
        if (_this3.getAddedFiles().length === 0 && _this3.getUploadingFiles().length === 0 && _this3.getQueuedFiles().length === 0) {
          // This needs to be deferred so that `queuecomplete` really triggers after `complete`
          return setTimeout(function () {
            return _this3.emit("queuecomplete");
          }, 0);
        }
      });

      var noPropagation = function noPropagation(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };

      // Create the listeners
      this.listeners = [{
        element: this.element,
        events: {
          "dragstart": function dragstart(e) {
            return _this3.emit("dragstart", e);
          },
          "dragenter": function dragenter(e) {
            noPropagation(e);
            return _this3.emit("dragenter", e);
          },
          "dragover": function dragover(e) {
            // Makes it possible to drag files from chrome's download bar
            // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
            // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
            var efct = void 0;
            try {
              efct = e.dataTransfer.effectAllowed;
            } catch (error) {}
            e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';

            noPropagation(e);
            return _this3.emit("dragover", e);
          },
          "dragleave": function dragleave(e) {
            return _this3.emit("dragleave", e);
          },
          "drop": function drop(e) {
            noPropagation(e);
            return _this3.drop(e);
          },
          "dragend": function dragend(e) {
            return _this3.emit("dragend", e);
          }

          // This is disabled right now, because the browsers don't implement it properly.
          // "paste": (e) =>
          //   noPropagation e
          //   @paste e
        } }];

      this.clickableElements.forEach(function (clickableElement) {
        return _this3.listeners.push({
          element: clickableElement,
          events: {
            "click": function click(evt) {
              // Only the actual dropzone or the message element should trigger file selection
              if (clickableElement !== _this3.element || evt.target === _this3.element || Dropzone.elementInside(evt.target, _this3.element.querySelector(".dz-message"))) {
                _this3.hiddenFileInput.click(); // Forward the click
              }
              return true;
            }
          }
        });
      });

      this.enable();

      return this.options.init.call(this);
    }

    // Not fully tested yet

  }, {
    key: "destroy",
    value: function destroy() {
      this.disable();
      this.removeAllFiles(true);
      if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    }
  }, {
    key: "updateTotalUploadProgress",
    value: function updateTotalUploadProgress() {
      var totalUploadProgress = void 0;
      var totalBytesSent = 0;
      var totalBytes = 0;

      var activeFiles = this.getActiveFiles();

      if (activeFiles.length) {
        for (var _iterator12 = this.getActiveFiles(), _isArray12 = true, _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
          var _ref11;

          if (_isArray12) {
            if (_i12 >= _iterator12.length) break;
            _ref11 = _iterator12[_i12++];
          } else {
            _i12 = _iterator12.next();
            if (_i12.done) break;
            _ref11 = _i12.value;
          }

          var file = _ref11;

          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }

      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }

    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.

  }, {
    key: "_getParamName",
    value: function _getParamName(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    }

    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData

  }, {
    key: "_renameFile",
    value: function _renameFile(file) {
      if (typeof this.options.renameFile !== "function") {
        return file.name;
      }
      return this.options.renameFile(file);
    }

    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(

  }, {
    key: "getFallbackForm",
    value: function getFallbackForm() {
      var existingFallback = void 0,
          form = void 0;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }

      var fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + this._getParamName(0) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : undefined) + " /><input type=\"submit\" value=\"Upload!\"></div>";

      var fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        // Make sure that the enctype and method attributes are set properly
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    }

    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(

  }, {
    key: "getExistingFallback",
    value: function getExistingFallback() {
      var getFallback = function getFallback(elements) {
        for (var _iterator13 = elements, _isArray13 = true, _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
          var _ref12;

          if (_isArray13) {
            if (_i13 >= _iterator13.length) break;
            _ref12 = _iterator13[_i13++];
          } else {
            _i13 = _iterator13.next();
            if (_i13.done) break;
            _ref12 = _i13.value;
          }

          var el = _ref12;

          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };

      var _arr = ["div", "form"];
      for (var _i14 = 0; _i14 < _arr.length; _i14++) {
        var tagName = _arr[_i14];
        var fallback;
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    }

    // Activates all listeners stored in @listeners

  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      return this.listeners.map(function (elementListeners) {
        return function () {
          var result = [];
          for (var event in elementListeners.events) {
            var listener = elementListeners.events[event];
            result.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return result;
        }();
      });
    }

    // Deactivates all listeners stored in @listeners

  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      return this.listeners.map(function (elementListeners) {
        return function () {
          var result = [];
          for (var event in elementListeners.events) {
            var listener = elementListeners.events[event];
            result.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return result;
        }();
      });
    }

    // Removes all event listeners and cancels all files in the queue or being processed.

  }, {
    key: "disable",
    value: function disable() {
      var _this4 = this;

      this.clickableElements.forEach(function (element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();

      return this.files.map(function (file) {
        return _this4.cancelUpload(file);
      });
    }
  }, {
    key: "enable",
    value: function enable() {
      this.clickableElements.forEach(function (element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    }

    // Returns a nicely formatted filesize

  }, {
    key: "filesize",
    value: function filesize(size) {
      var selectedSize = 0;
      var selectedUnit = "b";

      if (size > 0) {
        var units = ['tb', 'gb', 'mb', 'kb', 'b'];

        for (var i = 0; i < units.length; i++) {
          var unit = units[i];
          var cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;

          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }

        selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
      }

      return "<strong>" + selectedSize + "</strong> " + this.options.dictFileSizeUnits[selectedUnit];
    }

    // Adds or removes the `dz-max-files-reached` class from the form.

  }, {
    key: "_updateMaxFilesReachedClass",
    value: function _updateMaxFilesReachedClass() {
      if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    }
  }, {
    key: "drop",
    value: function drop(e) {
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);

      var files = e.dataTransfer.files;

      this.emit("addedfiles", files);

      // Even if it's a folder, files.length will contain the folders.
      if (files.length) {
        var items = e.dataTransfer.items;

        if (items && items.length && items[0].webkitGetAsEntry != null) {
          // The browser supports dropping of folders, so handle items instead of files
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    }
  }, {
    key: "paste",
    value: function paste(e) {
      if (__guard__(e != null ? e.clipboardData : undefined, function (x) {
        return x.items;
      }) == null) {
        return;
      }

      this.emit("paste", e);
      var items = e.clipboardData.items;


      if (items.length) {
        return this._addFilesFromItems(items);
      }
    }
  }, {
    key: "handleFiles",
    value: function handleFiles(files) {
      var _this5 = this;

      return files.map(function (file) {
        return _this5.addFile(file);
      });
    }

    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.

  }, {
    key: "_addFilesFromItems",
    value: function _addFilesFromItems(items) {
      var _this6 = this;

      return function () {
        var result = [];
        for (var _iterator14 = items, _isArray14 = true, _i15 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
          var _ref13;

          if (_isArray14) {
            if (_i15 >= _iterator14.length) break;
            _ref13 = _iterator14[_i15++];
          } else {
            _i15 = _iterator14.next();
            if (_i15.done) break;
            _ref13 = _i15.value;
          }

          var item = _ref13;

          var entry;
          if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
            if (entry.isFile) {
              result.push(_this6.addFile(item.getAsFile()));
            } else if (entry.isDirectory) {
              // Append all files from that directory to files
              result.push(_this6._addFilesFromDirectory(entry, entry.name));
            } else {
              result.push(undefined);
            }
          } else if (item.getAsFile != null) {
            if (item.kind == null || item.kind === "file") {
              result.push(_this6.addFile(item.getAsFile()));
            } else {
              result.push(undefined);
            }
          } else {
            result.push(undefined);
          }
        }
        return result;
      }();
    }

    // Goes through the directory, and adds each file it finds recursively

  }, {
    key: "_addFilesFromDirectory",
    value: function _addFilesFromDirectory(directory, path) {
      var _this7 = this;

      var dirReader = directory.createReader();

      var errorHandler = function errorHandler(error) {
        return __guardMethod__(console, 'log', function (o) {
          return o.log(error);
        });
      };

      var readEntries = function readEntries() {
        return dirReader.readEntries(function (entries) {
          if (entries.length > 0) {
            for (var _iterator15 = entries, _isArray15 = true, _i16 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
              var _ref14;

              if (_isArray15) {
                if (_i16 >= _iterator15.length) break;
                _ref14 = _iterator15[_i16++];
              } else {
                _i16 = _iterator15.next();
                if (_i16.done) break;
                _ref14 = _i16.value;
              }

              var entry = _ref14;

              if (entry.isFile) {
                entry.file(function (file) {
                  if (_this7.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                    return;
                  }
                  file.fullPath = path + "/" + file.name;
                  return _this7.addFile(file);
                });
              } else if (entry.isDirectory) {
                _this7._addFilesFromDirectory(entry, path + "/" + entry.name);
              }
            }

            // Recursively call readEntries() again, since browser only handle
            // the first 100 entries.
            // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
            readEntries();
          }
          return null;
        }, errorHandler);
      };

      return readEntries();
    }

    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.

  }, {
    key: "accept",
    value: function accept(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      var _this8 = this;
      if (this.files.length >= this.options.maxFiles) {
        return
      }
      file.upload = {
        uuid: Dropzone.uuidv4(),
        progress: 0,
        // Setting the total upload size to file.size for the beginning
        // It's actual different than the size to be transmitted.
        total: file.size,
        bytesSent: 0,
        filename: this._renameFile(file),
        chunked: this.options.chunking && (this.options.forceChunking || file.size > this.options.chunkSize),
        totalChunkCount: Math.ceil(file.size / this.options.chunkSize)
      };
      this.files.push(file);

      file.status = Dropzone.ADDED;

      this.emit("addedfile", file);

      this._enqueueThumbnail(file);

      return this.accept(file, function (error) {
        if (error) {
          file.accepted = false;
          _this8._errorProcessing([file], error); // Will set the file.status
        } else {
          file.accepted = true;
          if (_this8.options.autoQueue) {
            _this8.enqueueFile(file);
          } // Will set .accepted = true
        }
        return _this8._updateMaxFilesReachedClass();
      });
    }

    // Wrapper for enqueueFile

  }, {
    key: "enqueueFiles",
    value: function enqueueFiles(files) {
      for (var _iterator16 = files, _isArray16 = true, _i17 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
        var _ref15;

        if (_isArray16) {
          if (_i17 >= _iterator16.length) break;
          _ref15 = _iterator16[_i17++];
        } else {
          _i17 = _iterator16.next();
          if (_i17.done) break;
          _ref15 = _i17.value;
        }

        var file = _ref15;

        this.enqueueFile(file);
      }
      return null;
    }
  }, {
    key: "enqueueFile",
    value: function enqueueFile(file) {
      var _this9 = this;

      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(function () {
            return _this9.processQueue();
          }, 0); // Deferring the call
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    }
  }, {
    key: "_enqueueThumbnail",
    value: function _enqueueThumbnail(file) {
      var _this10 = this;

      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(function () {
          return _this10._processThumbnailQueue();
        }, 0); // Deferring the call
      }
    }
  }, {
    key: "_processThumbnailQueue",
    value: function _processThumbnailQueue() {
      var _this11 = this;

      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }

      this._processingThumbnail = true;
      var file = this._thumbnailQueue.shift();
      return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, function (dataUrl) {
        _this11.emit("thumbnail", file, dataUrl);
        _this11._processingThumbnail = false;
        return _this11._processThumbnailQueue();
      });
    }

    // Can be called by the user to remove a file

  }, {
    key: "removeFile",
    value: function removeFile(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);

      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    }

    // Removes all files that aren't currently processed from the list

  }, {
    key: "removeAllFiles",
    value: function removeAllFiles(cancelIfNecessary) {
      // Create a copy of files since removeFile() changes the @files array.
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      for (var _iterator17 = this.files.slice(), _isArray17 = true, _i18 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
        var _ref16;

        if (_isArray17) {
          if (_i18 >= _iterator17.length) break;
          _ref16 = _iterator17[_i18++];
        } else {
          _i18 = _iterator17.next();
          if (_i18.done) break;
          _ref16 = _i18.value;
        }

        var file = _ref16;

        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    }

    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.

  }, {
    key: "resizeImage",
    value: function resizeImage(file, width, height, resizeMethod, callback) {
      var _this12 = this;

      return this.createThumbnail(file, width, height, resizeMethod, false, function (dataUrl, canvas) {
        if (canvas === null) {
          // The image has not been resized
          return callback(file);
        } else {
          var resizeMimeType = _this12.options.resizeMimeType;

          if (resizeMimeType == null) {
            resizeMimeType = file.type;
          }
          var resizedDataURL = canvas.toDataURL(resizeMimeType, _this12.options.resizeQuality);
          if (resizeMimeType === 'image/jpeg' || resizeMimeType === 'image/jpg') {
            // Now add the original EXIF information
            resizedDataURL = ExifRestore.restore(file.dataURL, resizedDataURL);
          }
          return callback(Dropzone.dataURItoBlob(resizedDataURL));
        }
      });
    }
  }, {
    key: "createThumbnail",
    value: function createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
      var _this13 = this;

      var fileReader = new FileReader();

      fileReader.onload = function () {

        file.dataURL = fileReader.result;

        // Don't bother creating a thumbnail for SVG images since they're vector
        if (file.type === "image/svg+xml") {
          if (callback != null) {
            callback(fileReader.result);
          }
          return;
        }

        return _this13.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
      };

      return fileReader.readAsDataURL(file);
    }
  }, {
    key: "createThumbnailFromUrl",
    value: function createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
      var _this14 = this;

      // Not using `new Image` here because of a bug in latest Chrome versions.
      // See https://github.com/enyo/dropzone/pull/226
      var img = document.createElement("img");

      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }

      img.onload = function () {
        var loadExif = function loadExif(callback) {
          return callback(1);
        };
        if (typeof EXIF !== 'undefined' && EXIF !== null && fixOrientation) {
          loadExif = function loadExif(callback) {
            return EXIF.getData(img, function () {
              return callback(EXIF.getTag(this, 'Orientation'));
            });
          };
        }

        return loadExif(function (orientation) {
          file.width = img.width;
          file.height = img.height;

          var resizeInfo = _this14.options.resize.call(_this14, file, width, height, resizeMethod);

          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");

          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;

          if (orientation > 4) {
            canvas.width = resizeInfo.trgHeight;
            canvas.height = resizeInfo.trgWidth;
          }

          switch (orientation) {
            case 2:
              // horizontal flip
              ctx.translate(canvas.width, 0);
              ctx.scale(-1, 1);
              break;
            case 3:
              // 180° rotate left
              ctx.translate(canvas.width, canvas.height);
              ctx.rotate(Math.PI);
              break;
            case 4:
              // vertical flip
              ctx.translate(0, canvas.height);
              ctx.scale(1, -1);
              break;
            case 5:
              // vertical flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.scale(1, -1);
              break;
            case 6:
              // 90° rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.translate(0, -canvas.height);
              break;
            case 7:
              // horizontal flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.translate(canvas.width, -canvas.height);
              ctx.scale(-1, 1);
              break;
            case 8:
              // 90° rotate left
              ctx.rotate(-0.5 * Math.PI);
              ctx.translate(-canvas.width, 0);
              break;
          }

          // This is a bugfix for iOS' scaling bug.
          drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);

          var thumbnail = canvas.toDataURL("image/png");

          if (callback != null) {
            return callback(thumbnail, canvas);
          }
        });
      };

      if (callback != null) {
        img.onerror = callback;
      }

      return img.src = file.dataURL;
    }

    // Goes through the queue and processes files if there aren't too many already.

  }, {
    key: "processQueue",
    value: function processQueue() {
      var parallelUploads = this.options.parallelUploads;

      var processingLength = this.getUploadingFiles().length;
      var i = processingLength;

      // There are already at least as many files uploading than should be
      if (processingLength >= parallelUploads) {
        return;
      }

      var queuedFiles = this.getQueuedFiles();

      if (!(queuedFiles.length > 0)) {
        return;
      }

      if (this.options.uploadMultiple) {
        // The files should be uploaded in one request
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          } // Nothing left to process
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    }

    // Wrapper for `processFiles`

  }, {
    key: "processFile",
    value: function processFile(file) {
      return this.processFiles([file]);
    }

    // Loads the file, then calls finishedLoading()

  }, {
    key: "processFiles",
    value: function processFiles(files) {
      for (var _iterator18 = files, _isArray18 = true, _i19 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
        var _ref17;

        if (_isArray18) {
          if (_i19 >= _iterator18.length) break;
          _ref17 = _iterator18[_i19++];
        } else {
          _i19 = _iterator18.next();
          if (_i19.done) break;
          _ref17 = _i19.value;
        }

        var file = _ref17;

        file.processing = true; // Backwards compatibility
        file.status = Dropzone.UPLOADING;

        //this.emit("processing", file);
      }

      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
		
       return this.uploadFiles(files);
    }
  }, {
    key: "_getFilesWithXhr",
    value: function _getFilesWithXhr(xhr) {
      var files = void 0;
      return files = this.files.filter(function (file) {
        return file.xhr === xhr;
      }).map(function (file) {
        return file;
      });
    }

    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.

  }, {
    key: "cancelUpload",
    value: function cancelUpload(file) {
      if (file.status === Dropzone.UPLOADING) {
        var groupedFiles = this._getFilesWithXhr(file.xhr);
        for (var _iterator19 = groupedFiles, _isArray19 = true, _i20 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
          var _ref18;

          if (_isArray19) {
            if (_i20 >= _iterator19.length) break;
            _ref18 = _iterator19[_i20++];
          } else {
            _i20 = _iterator19.next();
            if (_i20.done) break;
            _ref18 = _i20.value;
          }

          var groupedFile = _ref18;

          groupedFile.status = Dropzone.CANCELED;
        }
        if (typeof file.xhr !== 'undefined') {
          file.xhr.abort();
        }
        for (var _iterator20 = groupedFiles, _isArray20 = true, _i21 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
          var _ref19;

          if (_isArray20) {
            if (_i21 >= _iterator20.length) break;
            _ref19 = _iterator20[_i21++];
          } else {
            _i21 = _iterator20.next();
            if (_i21.done) break;
            _ref19 = _i21.value;
          }

          var _groupedFile = _ref19;

          this.emit("canceled", _groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if (file.status === Dropzone.ADDED || file.status === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }

      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    }
  }, {
    key: "resolveOption",
    value: function resolveOption(option) {
      if (typeof option === 'function') {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        return option.apply(this, args);
      }
      return option;
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      return this.uploadFiles([file]);
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this15 = this;

      this._transformFiles(files, function (transformedFiles) {
        if (files[0].upload.chunked) {
          // This file should be sent in chunks!

          // If the chunking option is set, we **know** that there can only be **one** file, since
          // uploadMultiple is not allowed with this option.
          var file = files[0];
          var transformedFile = transformedFiles[0];
          var startedChunkCount = 0;

          file.upload.chunks = [];

          var handleNextChunk = function handleNextChunk() {
            var chunkIndex = 0;

            // Find the next item in file.upload.chunks that is not defined yet.
            while (file.upload.chunks[chunkIndex] !== undefined) {
              chunkIndex++;
            }

            // This means, that all chunks have already been started.
            if (chunkIndex >= file.upload.totalChunkCount) return;

            startedChunkCount++;

            var start = chunkIndex * _this15.options.chunkSize;
            var end = Math.min(start + _this15.options.chunkSize, file.size);

            var dataBlock = {
              name: _this15._getParamName(0),
              data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
              filename: file.upload.filename,
              chunkIndex: chunkIndex
            };

            file.upload.chunks[chunkIndex] = {
              file: file,
              index: chunkIndex,
              dataBlock: dataBlock, // In case we want to retry.
              status: Dropzone.UPLOADING,
              progress: 0,
              retries: 0 // The number of times this block has been retried.
            };

            //_this15._uploadData(files, [dataBlock]);
          };

          file.upload.finishedChunkUpload = function (chunk) {
            var allFinished = true;
            chunk.status = Dropzone.SUCCESS;

            // Clear the data from the chunk
            chunk.dataBlock = null;

            for (var i = 0; i < file.upload.totalChunkCount; i++) {
              if (file.upload.chunks[i] === undefined) {
                return handleNextChunk();
              }
              if (file.upload.chunks[i].status !== Dropzone.SUCCESS) {
                allFinished = false;
              }
            }

            if (allFinished) {
              _this15.options.chunksUploaded(file, function () {
                _this15._finished(files, '', null);
              });
            }
          };

          if (_this15.options.parallelChunkUploads) {
            for (var i = 0; i < file.upload.totalChunkCount; i++) {
              handleNextChunk();
            }
          } else {
            handleNextChunk();
          }
        } else {
          var dataBlocks = [];
          for (var _i22 = 0; _i22 < files.length; _i22++) {
            dataBlocks[_i22] = {
              name: _this15._getParamName(_i22),
              data: transformedFiles[_i22],
              filename: files[_i22].upload.filename
            };
          }
          _this15._uploadData(files, dataBlocks);
        }
      });
    }

    /// Returns the right chunk for given file and xhr

  }, {
    key: "_getChunk",
    value: function _getChunk(file, xhr) {
      for (var i = 0; i < file.upload.totalChunkCount; i++) {
        if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) {
          return file.upload.chunks[i];
        }
      }
    }

    // This function actually uploads the file(s) to the server.
    // If dataBlocks contains the actual data to upload (meaning, that this could either be transformed
    // files, or individual chunks for chunked upload).

  }, {
    key: "_uploadData",
    value: function _uploadData(files, dataBlocks) {
      var _this16 = this;

     /* var xhr = new XMLHttpRequest();

      // Put the xhr object in the file objects to be able to reference it later.
      for (var _iterator21 = files, _isArray21 = true, _i23 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
        var _ref20;

        if (_isArray21) {
          if (_i23 >= _iterator21.length) break;
          _ref20 = _iterator21[_i23++];
        } else {
          _i23 = _iterator21.next();
          if (_i23.done) break;
          _ref20 = _i23.value;
        }

        var file = _ref20;

        file.xhr = xhr;
      }
      if (files[0].upload.chunked) {
        // Put the xhr object in the right chunk object, so it can be associated later, and found with _getChunk
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
      }

      var method = this.resolveOption(this.options.method, files);
      var url = this.resolveOption(this.options.url, files);
      xhr.open(method, url, true);

      // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
      xhr.timeout = this.resolveOption(this.options.timeout, files);

      // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
      xhr.withCredentials = !!this.options.withCredentials;

      xhr.onload = function (e) {
        _this16._finishedUploading(files, xhr, e);
      };

      xhr.onerror = function () {
        _this16._handleUploadError(files, xhr);
      };

      // Some browsers do not have the .upload property
      var progressObj = xhr.upload != null ? xhr.upload : xhr;
      progressObj.onprogress = function (e) {
        return _this16._updateFilesUploadProgress(files, xhr, e);
      };

      var headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };

      if (this.options.headers) {
        Dropzone.extend(headers, this.options.headers);
      }

      for (var headerName in headers) {
        var headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }

      var formData = new FormData();

      // Adding all @options parameters
      if (this.options.params) {
        var additionalParams = this.options.params;
        if (typeof additionalParams === 'function') {
          additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
        }

        for (var key in additionalParams) {
          var value = additionalParams[key];
          formData.append(key, value);
        }
      }

      // Let the user add additional data if necessary
      for (var _iterator22 = files, _isArray22 = true, _i24 = 0, _iterator22 = _isArray22 ? _iterator22 : _iterator22[Symbol.iterator]();;) {
        var _ref21;

        if (_isArray22) {
          if (_i24 >= _iterator22.length) break;
          _ref21 = _iterator22[_i24++];
        } else {
          _i24 = _iterator22.next();
          if (_i24.done) break;
          _ref21 = _i24.value;
        }

        var _file = _ref21;

        this.emit("sending", _file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }

      this._addFormElementData(formData);

      // Finally add the files
      // Has to be last because some servers (eg: S3) expect the file to be the last parameter
      for (var i = 0; i < dataBlocks.length; i++) {
        var dataBlock = dataBlocks[i];
        formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
      }
	
      this.submitRequest(xhr, formData, files);
	  */
    }

    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.

  }, {
    key: "_transformFiles",
    value: function _transformFiles(files, done) {
      var _this17 = this;

      var transformedFiles = [];
      // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
      var doneCounter = 0;

      var _loop = function _loop(i) {
        _this17.options.transformFile.call(_this17, files[i], function (transformedFile) {
          transformedFiles[i] = transformedFile;
          if (++doneCounter === files.length) {
            done(transformedFiles);
          }
        });
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
    }

    // Takes care of adding other input elements of the form to the AJAX request

  }, {
    key: "_addFormElementData",
    value: function _addFormElementData(formData) {
      // Take care of other input elements
      if (this.element.tagName === "FORM") {
        for (var _iterator23 = this.element.querySelectorAll("input, textarea, select, button"), _isArray23 = true, _i25 = 0, _iterator23 = _isArray23 ? _iterator23 : _iterator23[Symbol.iterator]();;) {
          var _ref22;

          if (_isArray23) {
            if (_i25 >= _iterator23.length) break;
            _ref22 = _iterator23[_i25++];
          } else {
            _i25 = _iterator23.next();
            if (_i25.done) break;
            _ref22 = _i25.value;
          }

          var input = _ref22;

          var inputName = input.getAttribute("name");
          var inputType = input.getAttribute("type");
          if (inputType) inputType = inputType.toLowerCase();

          // If the input doesn't have a name, we can't use it.
          if (typeof inputName === 'undefined' || inputName === null) continue;

          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            // Possibly multiple values
            for (var _iterator24 = input.options, _isArray24 = true, _i26 = 0, _iterator24 = _isArray24 ? _iterator24 : _iterator24[Symbol.iterator]();;) {
              var _ref23;

              if (_isArray24) {
                if (_i26 >= _iterator24.length) break;
                _ref23 = _iterator24[_i26++];
              } else {
                _i26 = _iterator24.next();
                if (_i26.done) break;
                _ref23 = _i26.value;
              }

              var option = _ref23;

              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
    }

    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.

  }, {
    key: "_updateFilesUploadProgress",
    value: function _updateFilesUploadProgress(files, xhr, e) {
      var progress = void 0;
      if (typeof e !== 'undefined') {
        progress = 100 * e.loaded / e.total;

        if (files[0].upload.chunked) {
          var file = files[0];
          // Since this is a chunked upload, we need to update the appropriate chunk progress.
          var chunk = this._getChunk(file, xhr);
          chunk.progress = progress;
          chunk.total = e.total;
          chunk.bytesSent = e.loaded;
          var fileProgress = 0,
              fileTotal = void 0,
              fileBytesSent = void 0;
          file.upload.progress = 0;
          file.upload.total = 0;
          file.upload.bytesSent = 0;
          for (var i = 0; i < file.upload.totalChunkCount; i++) {
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].progress !== undefined) {
              file.upload.progress += file.upload.chunks[i].progress;
              file.upload.total += file.upload.chunks[i].total;
              file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
          }
          file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
        } else {
          for (var _iterator25 = files, _isArray25 = true, _i27 = 0, _iterator25 = _isArray25 ? _iterator25 : _iterator25[Symbol.iterator]();;) {
            var _ref24;

            if (_isArray25) {
              if (_i27 >= _iterator25.length) break;
              _ref24 = _iterator25[_i27++];
            } else {
              _i27 = _iterator25.next();
              if (_i27.done) break;
              _ref24 = _i27.value;
            }

            var _file2 = _ref24;

            _file2.upload.progress = progress;
            _file2.upload.total = e.total;
            _file2.upload.bytesSent = e.loaded;
          }
        }
        for (var _iterator26 = files, _isArray26 = true, _i28 = 0, _iterator26 = _isArray26 ? _iterator26 : _iterator26[Symbol.iterator]();;) {
          var _ref25;

          if (_isArray26) {
            if (_i28 >= _iterator26.length) break;
            _ref25 = _iterator26[_i28++];
          } else {
            _i28 = _iterator26.next();
            if (_i28.done) break;
            _ref25 = _i28.value;
          }

          var _file3 = _ref25;

          this.emit("uploadprogress", _file3, _file3.upload.progress, _file3.upload.bytesSent);
        }
      } else {
        // Called when the file finished uploading

        var allFilesFinished = true;

        progress = 100;

        for (var _iterator27 = files, _isArray27 = true, _i29 = 0, _iterator27 = _isArray27 ? _iterator27 : _iterator27[Symbol.iterator]();;) {
          var _ref26;

          if (_isArray27) {
            if (_i29 >= _iterator27.length) break;
            _ref26 = _iterator27[_i29++];
          } else {
            _i29 = _iterator27.next();
            if (_i29.done) break;
            _ref26 = _i29.value;
          }

          var _file4 = _ref26;

          if (_file4.upload.progress !== 100 || _file4.upload.bytesSent !== _file4.upload.total) {
            allFilesFinished = false;
          }
          _file4.upload.progress = progress;
          _file4.upload.bytesSent = _file4.upload.total;
        }

        // Nothing to do, all files already at 100%
        if (allFilesFinished) {
          return;
        }

        for (var _iterator28 = files, _isArray28 = true, _i30 = 0, _iterator28 = _isArray28 ? _iterator28 : _iterator28[Symbol.iterator]();;) {
          var _ref27;

          if (_isArray28) {
            if (_i30 >= _iterator28.length) break;
            _ref27 = _iterator28[_i30++];
          } else {
            _i30 = _iterator28.next();
            if (_i30.done) break;
            _ref27 = _i30.value;
          }

          var _file5 = _ref27;

          this.emit("uploadprogress", _file5, progress, _file5.upload.bytesSent);
        }
      }
    }
  }, {
    key: "_finishedUploading",
    value: function _finishedUploading(files, xhr, e) {
      var response = void 0;

      if (files[0].status === Dropzone.CANCELED) {
        return;
      }

      if (xhr.readyState !== 4) {
        return;
      }

      if (xhr.responseType !== 'arraybuffer' && xhr.responseType !== 'blob') {
        response = xhr.responseText;

        if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
          try {
            response = JSON.parse(response);
          } catch (error) {
            e = error;
            response = "Invalid JSON response from server.";
          }
        }
      }

      this._updateFilesUploadProgress(files);

      if (!(200 <= xhr.status && xhr.status < 300)) {
        this._handleUploadError(files, xhr, response);
      } else {
        if (files[0].upload.chunked) {
          files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr));
        } else {
          this._finished(files, response, e);
        }
      }
    }
  }, {
    key: "_handleUploadError",
    value: function _handleUploadError(files, xhr, response) {
      if (files[0].status === Dropzone.CANCELED) {
        return;
      }

      if (files[0].upload.chunked && this.options.retryChunks) {
        var chunk = this._getChunk(files[0], xhr);
        if (chunk.retries++ < this.options.retryChunksLimit) {
          // this._uploadData(files, [chunk.dataBlock]);
          return;
        } else {
          console.warn('Retried this chunk too often. Giving up.');
        }
      }

      for (var _iterator29 = files, _isArray29 = true, _i31 = 0, _iterator29 = _isArray29 ? _iterator29 : _iterator29[Symbol.iterator]();;) {
        var _ref28;

        if (_isArray29) {
          if (_i31 >= _iterator29.length) break;
          _ref28 = _iterator29[_i31++];
        } else {
          _i31 = _iterator29.next();
          if (_i31.done) break;
          _ref28 = _i31.value;
        }

        var file = _ref28;

        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
      }
    }
  }, {
    key: "submitRequest",
    value: function submitRequest(xhr, formData, files) {
      xhr.send(formData);
    }

    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.

  }, {
    key: "_finished",
    value: function _finished(files, responseText, e) {
      for (var _iterator30 = files, _isArray30 = true, _i32 = 0, _iterator30 = _isArray30 ? _iterator30 : _iterator30[Symbol.iterator]();;) {
        var _ref29;

        if (_isArray30) {
          if (_i32 >= _iterator30.length) break;
          _ref29 = _iterator30[_i32++];
        } else {
          _i32 = _iterator30.next();
          if (_i32.done) break;
          _ref29 = _i32.value;
        }

        var file = _ref29;

        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }

      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    }

    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.

  }, {
    key: "_errorProcessing",
    value: function _errorProcessing(files, message, xhr) {
      for (var _iterator31 = files, _isArray31 = true, _i33 = 0, _iterator31 = _isArray31 ? _iterator31 : _iterator31[Symbol.iterator]();;) {
        var _ref30;

        if (_isArray31) {
          if (_i33 >= _iterator31.length) break;
          _ref30 = _iterator31[_i33++];
        } else {
          _i33 = _iterator31.next();
          if (_i33.done) break;
          _ref30 = _i33.value;
        }

        var file = _ref30;

        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }

      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    }
  }], [{
    key: "uuidv4",
    value: function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);

  return Dropzone;
}(Emitter);

Dropzone.initClass();

Dropzone.version = "5.3.0";

// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// To disable autoDiscover for a specific element, you can set `false` as an option:
//
//     Dropzone.options.myDisabledElementId = false;
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
Dropzone.options = {};

// Returns the options for an element or undefined if none available.
Dropzone.optionsForElement = function (element) {
  // Get the `Dropzone.options.elementId` for this element if it exists
  if (element.getAttribute("id")) {
    return Dropzone.options[camelize(element.getAttribute("id"))];
  } else {
    return undefined;
  }
};

// Holds a list of all dropzone instances
Dropzone.instances = [];

// Returns the dropzone for given element if any
Dropzone.forElement = function (element) {
  if (typeof element === "string") {
    element = document.querySelector(element);
  }
  if ((element != null ? element.dropzone : undefined) == null) {
    throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
  }
  return element.dropzone;
};

// Set to false if you don't want Dropzone to automatically find and attach to .dropzone elements.
Dropzone.autoDiscover = true;

// Looks for all .dropzone elements and creates a dropzone for them
Dropzone.discover = function () {
  var dropzones = void 0;
  if (document.querySelectorAll) {
    dropzones = document.querySelectorAll(".dropzone");
  } else {
    dropzones = [];
    // IE :(
    var checkElements = function checkElements(elements) {
      return function () {
        var result = [];
        for (var _iterator32 = elements, _isArray32 = true, _i34 = 0, _iterator32 = _isArray32 ? _iterator32 : _iterator32[Symbol.iterator]();;) {
          var _ref31;

          if (_isArray32) {
            if (_i34 >= _iterator32.length) break;
            _ref31 = _iterator32[_i34++];
          } else {
            _i34 = _iterator32.next();
            if (_i34.done) break;
            _ref31 = _i34.value;
          }

          var el = _ref31;

          if (/(^| )dropzone($| )/.test(el.className)) {
            result.push(dropzones.push(el));
          } else {
            result.push(undefined);
          }
        }
        return result;
      }();
    };
    checkElements(document.getElementsByTagName("div"));
    checkElements(document.getElementsByTagName("form"));
  }

  return function () {
    var result = [];
    for (var _iterator33 = dropzones, _isArray33 = true, _i35 = 0, _iterator33 = _isArray33 ? _iterator33 : _iterator33[Symbol.iterator]();;) {
      var _ref32;

      if (_isArray33) {
        if (_i35 >= _iterator33.length) break;
        _ref32 = _iterator33[_i35++];
      } else {
        _i35 = _iterator33.next();
        if (_i35.done) break;
        _ref32 = _i35.value;
      }

      var dropzone = _ref32;

      // Create a dropzone unless auto discover has been disabled for specific element
      if (Dropzone.optionsForElement(dropzone) !== false) {
        result.push(new Dropzone(dropzone));
      } else {
        result.push(undefined);
      }
    }
    return result;
  }();
};

// Since the whole Drag'n'Drop API is pretty new, some browsers implement it,
// but not correctly.
// So I created a blacklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
//
Dropzone.blacklistedBrowsers = [
// The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
/opera.*(Macintosh|Windows Phone).*version\/12/i];

// Checks if the browser is supported
Dropzone.isBrowserSupported = function () {
  var capableBrowser = true;

  if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
    if (!("classList" in document.createElement("a"))) {
      capableBrowser = false;
    } else {
      // The browser supports the API, but may be blacklisted.
      for (var _iterator34 = Dropzone.blacklistedBrowsers, _isArray34 = true, _i36 = 0, _iterator34 = _isArray34 ? _iterator34 : _iterator34[Symbol.iterator]();;) {
        var _ref33;

        if (_isArray34) {
          if (_i36 >= _iterator34.length) break;
          _ref33 = _iterator34[_i36++];
        } else {
          _i36 = _iterator34.next();
          if (_i36.done) break;
          _ref33 = _i36.value;
        }

        var regex = _ref33;

        if (regex.test(navigator.userAgent)) {
          capableBrowser = false;
          continue;
        }
      }
    }
  } else {
    capableBrowser = false;
  }

  return capableBrowser;
};

Dropzone.dataURItoBlob = function (dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob
  return new Blob([ab], { type: mimeString });
};

// Returns an array without the rejected item
var without = function without(list, rejectedItem) {
  return list.filter(function (item) {
    return item !== rejectedItem;
  }).map(function (item) {
    return item;
  });
};

// abc-def_ghi -> abcDefGhi
var camelize = function camelize(str) {
  return str.replace(/[\-_](\w)/g, function (match) {
    return match.charAt(1).toUpperCase();
  });
};

// Creates an element from string
Dropzone.createElement = function (string) {
  var div = document.createElement("div");
  div.innerHTML = string;
  return div.childNodes[0];
};

// Tests if given element is inside (or simply is) the container
Dropzone.elementInside = function (element, container) {
  if (element === container) {
    return true;
  } // Coffeescript doesn't support do/while loops
  while (element = element.parentNode) {
    if (element === container) {
      return true;
    }
  }
  return false;
};

Dropzone.getElement = function (el, name) {
  var element = void 0;
  if (typeof el === "string") {
    element = document.querySelector(el);
  } else if (el.nodeType != null) {
    element = el;
  }
  if (element == null) {
    throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
  }
  return element;
};

Dropzone.getElements = function (els, name) {
  var el = void 0,
      elements = void 0;
  if (els instanceof Array) {
    elements = [];
    try {
      for (var _iterator35 = els, _isArray35 = true, _i37 = 0, _iterator35 = _isArray35 ? _iterator35 : _iterator35[Symbol.iterator]();;) {
        if (_isArray35) {
          if (_i37 >= _iterator35.length) break;
          el = _iterator35[_i37++];
        } else {
          _i37 = _iterator35.next();
          if (_i37.done) break;
          el = _i37.value;
        }

        elements.push(this.getElement(el, name));
      }
    } catch (e) {
      elements = null;
    }
  } else if (typeof els === "string") {
    elements = [];
    for (var _iterator36 = document.querySelectorAll(els), _isArray36 = true, _i38 = 0, _iterator36 = _isArray36 ? _iterator36 : _iterator36[Symbol.iterator]();;) {
      if (_isArray36) {
        if (_i38 >= _iterator36.length) break;
        el = _iterator36[_i38++];
      } else {
        _i38 = _iterator36.next();
        if (_i38.done) break;
        el = _i38.value;
      }

      elements.push(el);
    }
  } else if (els.nodeType != null) {
    elements = [els];
  }

  if (elements == null || !elements.length) {
    throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
  }

  return elements;
};

// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
Dropzone.confirm = function (question, accepted, rejected) {
  if (window.confirm(question)) {
    return accepted();
  } else if (rejected != null) {
    return rejected();
  }
};

// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
Dropzone.isValidFile = function (file, acceptedFiles) {
  if (!acceptedFiles) {
    return true;
  } // If there are no accepted mime types, it's OK
  acceptedFiles = acceptedFiles.split(",");

  var mimeType = file.type;
  var baseMimeType = mimeType.replace(/\/.*$/, "");

  for (var _iterator37 = acceptedFiles, _isArray37 = true, _i39 = 0, _iterator37 = _isArray37 ? _iterator37 : _iterator37[Symbol.iterator]();;) {
    var _ref34;

    if (_isArray37) {
      if (_i39 >= _iterator37.length) break;
      _ref34 = _iterator37[_i39++];
    } else {
      _i39 = _iterator37.next();
      if (_i39.done) break;
      _ref34 = _i39.value;
    }

    var validType = _ref34;

    validType = validType.trim();
    if (validType.charAt(0) === ".") {
      if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
        return true;
      }
    } else if (/\/\*$/.test(validType)) {
      // This is something like a image/* mime type
      if (baseMimeType === validType.replace(/\/.*$/, "")) {
        return true;
      }
    } else {
      if (mimeType === validType) {
        return true;
      }
    }
  }

  return false;
};

// Augment jQuery
if (typeof jQuery !== 'undefined' && jQuery !== null) {
  jQuery.fn.dropzone = function (options) {
    return this.each(function () {
      return new Dropzone(this, options);
    });
  };
}

if (typeof module !== 'undefined' && module !== null) {
  module.exports = Dropzone;
} else {
  window.Dropzone = Dropzone;
}

// Dropzone file status codes
Dropzone.ADDED = "added";

Dropzone.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
Dropzone.ACCEPTED = Dropzone.QUEUED;

Dropzone.UPLOADING = "uploading";
Dropzone.PROCESSING = Dropzone.UPLOADING; // alias

Dropzone.CANCELED = "canceled";
Dropzone.ERROR = "error";
Dropzone.SUCCESS = "success";

/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */

// Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
var detectVerticalSquash = function detectVerticalSquash(img) {
  var iw = img.naturalWidth;
  var ih = img.naturalHeight;
  var canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = ih;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  var _ctx$getImageData = ctx.getImageData(1, 0, 1, ih),
      data = _ctx$getImageData.data;

  // search image edge pixel position in case it is squashed vertically.


  var sy = 0;
  var ey = ih;
  var py = ih;
  while (py > sy) {
    var alpha = data[(py - 1) * 4 + 3];

    if (alpha === 0) {
      ey = py;
    } else {
      sy = py;
    }

    py = ey + sy >> 1;
  }
  var ratio = py / ih;

  if (ratio === 0) {
    return 1;
  } else {
    return ratio;
  }
};

// A replacement for context.drawImage
// (args are for source and destination).
var drawImageIOSFix = function drawImageIOSFix(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
  var vertSquashRatio = detectVerticalSquash(img);
  return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};

// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html

var ExifRestore = function () {
  function ExifRestore() {
    _classCallCheck(this, ExifRestore);
  }

  _createClass(ExifRestore, null, [{
    key: "initClass",
    value: function initClass() {
      this.KEY_STR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    }
  }, {
    key: "encode64",
    value: function encode64(input) {
      var output = '';
      var chr1 = undefined;
      var chr2 = undefined;
      var chr3 = '';
      var enc1 = undefined;
      var enc2 = undefined;
      var enc3 = undefined;
      var enc4 = '';
      var i = 0;
      while (true) {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
        if (!(i < input.length)) {
          break;
        }
      }
      return output;
    }
  }, {
    key: "restore",
    value: function restore(origFileBase64, resizedFileBase64) {
      if (!origFileBase64.match('data:image/jpeg;base64,')) {
        return resizedFileBase64;
      }
      var rawImage = this.decode64(origFileBase64.replace('data:image/jpeg;base64,', ''));
      var segments = this.slice2Segments(rawImage);
      var image = this.exifManipulation(resizedFileBase64, segments);
      return "data:image/jpeg;base64," + this.encode64(image);
    }
  }, {
    key: "exifManipulation",
    value: function exifManipulation(resizedFileBase64, segments) {
      var exifArray = this.getExifArray(segments);
      var newImageArray = this.insertExif(resizedFileBase64, exifArray);
      var aBuffer = new Uint8Array(newImageArray);
      return aBuffer;
    }
  }, {
    key: "getExifArray",
    value: function getExifArray(segments) {
      var seg = undefined;
      var x = 0;
      while (x < segments.length) {
        seg = segments[x];
        if (seg[0] === 255 & seg[1] === 225) {
          return seg;
        }
        x++;
      }
      return [];
    }
  }, {
    key: "insertExif",
    value: function insertExif(resizedFileBase64, exifArray) {
      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', '');
      var buf = this.decode64(imageData);
      var separatePoint = buf.indexOf(255, 3);
      var mae = buf.slice(0, separatePoint);
      var ato = buf.slice(separatePoint);
      var array = mae;
      array = array.concat(exifArray);
      array = array.concat(ato);
      return array;
    }
  }, {
    key: "slice2Segments",
    value: function slice2Segments(rawImageArray) {
      var head = 0;
      var segments = [];
      while (true) {
        var length;
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
          break;
        }
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
          head += 2;
        } else {
          length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
          var endPoint = head + length + 2;
          var seg = rawImageArray.slice(head, endPoint);
          segments.push(seg);
          head = endPoint;
        }
        if (head > rawImageArray.length) {
          break;
        }
      }
      return segments;
    }
  }, {
    key: "decode64",
    value: function decode64(input) {
      var output = '';
      var chr1 = undefined;
      var chr2 = undefined;
      var chr3 = '';
      var enc1 = undefined;
      var enc2 = undefined;
      var enc3 = undefined;
      var enc4 = '';
      var i = 0;
      var buf = [];
      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        console.warn('There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, \'+\', \'/\',and \'=\'\nExpect errors in decoding.');
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      while (true) {
        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        buf.push(chr1);
        if (enc3 !== 64) {
          buf.push(chr2);
        }
        if (enc4 !== 64) {
          buf.push(chr3);
        }
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
        if (!(i < input.length)) {
          break;
        }
      }
      return buf;
    }
  }]);

  return ExifRestore;
}();

ExifRestore.initClass();

/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */

// @win window reference
// @fn function reference
var contentLoaded = function contentLoaded(win, fn) {
  var done = false;
  var top = true;
  var doc = win.document;
  var root = doc.documentElement;
  var add = doc.addEventListener ? "addEventListener" : "attachEvent";
  var rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
  var pre = doc.addEventListener ? "" : "on";
  var init = function init(e) {
    if (e.type === "readystatechange" && doc.readyState !== "complete") {
      return;
    }
    (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
    if (!done && (done = true)) {
      return fn.call(win, e.type || e);
    }
  };

  var poll = function poll() {
    try {
      root.doScroll("left");
    } catch (e) {
      setTimeout(poll, 50);
      return;
    }
    return init("poll");
  };

  if (doc.readyState !== "complete") {
    if (doc.createEventObject && root.doScroll) {
      try {
        top = !win.frameElement;
      } catch (error) {}
      if (top) {
        poll();
      }
    }
    doc[add](pre + "DOMContentLoaded", init, false);
    doc[add](pre + "readystatechange", init, false);
    return win[add](pre + "load", init, false);
  }
};

// As a single function to be able to write tests.
Dropzone._autoDiscoverFunction = function () {
  if (Dropzone.autoDiscover) {
    return Dropzone.discover();
  }
};
contentLoaded(window, Dropzone._autoDiscoverFunction);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "vzA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchPageAlt"
  }, [_c('banner-search', {
    attrs: {
      "oldSearchText": this.textPreviouslySearched
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-holder bg-gradient-gray"
  }, [_c('div', {}, [_c('searchCardsAlt')], 1), _vm._v(" "), _c('section'), _vm._v(" "), _c('section', [(_vm.showTrendingCards && (_vm.$store.getters.getSearchType == 'all' || _vm.$store.getters.getSearchType == 'CO')) ? _c('trendingCourses') : _vm._e(), _vm._v(" "), (_vm.showTrendingCards && _vm.showLibraryCards && (_vm.$store.getters.getSearchType == 'all' || _vm.$store.getters.getSearchType == 'LO')) ? _c('libraryCards') : _vm._e(), _vm._v(" "), (_vm.showTrendingCards && _vm.showLibraryCards && _vm.showNewVideoCards && (_vm.$store.getters.getSearchType == 'all' || _vm.$store.getters.getSearchType == 'LO')) ? _c('newVideoCards') : _vm._e()], 1), _vm._v(" "), (_vm.continueScrolling) ? _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler1
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wGr/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wXyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_shareOnMedia__ = __webpack_require__("HOUo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'courseCards',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a, ShareOnMedia: __WEBPACK_IMPORTED_MODULE_3__common_shareOnMedia__["a" /* default */]
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["e" /* INSTANCE_NAME */],
      profileId: this.$store.getters.getProfileDetails.profileId,
      coList: [],
      loList: []
    };
  },

  methods: {
    viewCourse: function viewCourse(course) {
      var _this = this;

      if (this.isLoggedIn) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('r/viewEnrolledItem', { 'profileId': _this.$store.getters.getProfileDetails.profileId, 'contentId': course.contentId }).then(function (response) {
            // alert('response:' + JSON.stringify(response.data))
            _this.$store.dispatch('setCurrentCourse', response.data);
            resolve();
          }).catch(function (err) {
            console.log('ERROR_IN_myCourseCard : ', err);
            reject();
          });
        });
      }
      this.$store.dispatch('getCourseDetails', course.contentId);
      this.$router.push({ path: '/coursePage' });
    },

    // checkValue (val) {
    //   if (val.length === 0) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    makePath: function makePath(path) {
      // var url = constants.CDP_CDN_THUMBNAIL_URL
      return __WEBPACK_IMPORTED_MODULE_2__components_common_constants_js__["r" /* CDP_CDN_THUMBNAIL_URL */] + '/' + path;
      // return url + path
    },
    goToCourse: function goToCourse(course) {
      this.$store.dispatch('checkExpiryDateForCO', course);
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId).then(function (res) {}, function (err) {
      console.log('ERROR_IN_FETCHING_ENROLLING_ITEM : ', err);
    });
  }
  // created () {
  //   this.$store.dispatch('fetchEnrolledCourses', this.profileId)
  //   this.loList = this.$store.getters.getCourseEnrolled
  //   this.loList.forEach(element => {
  //     if (element.courseType === 'CO') {
  //       this.coList.push(element)
  //     }
  //   })
  //   this.$store.commit('setCourseCOEnrolled', this.coList)
  // }

});

/***/ }),

/***/ "wrZK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x4Sc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_autocomplete__ = __webpack_require__("Yv+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_constants_js__ = __webpack_require__("P5xh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bannerSearch',
  props: ['oldSearchText'],
  components: { Autocomplete: __WEBPACK_IMPORTED_MODULE_2__components_autocomplete__["a" /* default */] },
  data: function data() {
    return {
      searchPlaceholder: 'aaa',
      suggestions: [],
      wordlist: [],
      userId: '',
      searchText: '',
      receivedValue: '',
      latitude: 0,
      longitude: 0,
      caseFalse: false,
      defaultOptions: { maximumAge: 0, timeout: 2000, enableHighAccuracy: false }
    };
  },

  methods: {
    isPresentInSuggestions: function isPresentInSuggestions(elementToSearch) {
      var isPresent = false;
      // console.log(this.suggestions)
      this.suggestions.forEach(function (element) {
        if (element === elementToSearch) {
          isPresent = true;
        }
      });
      return isPresent;
    },
    addTag: function addTag(newTag) {
      if (!this.isPresentInSuggestions(newTag)) {
        this.suggestions.unshift(newTag);
      }
      this.searchText = newTag;
      this.onSearch(newTag);
    },
    errorQuery: function errorQuery() {
      var _this = this;

      // alert(this.searchText)
      if (this.searchText !== undefined && this.searchText !== null && this.searchText.length !== 0) {
        this.$store.dispatch('getSearchResult', { 'searchText': this.searchText, 'location': { 'coordinates': [0, 0] }, 'userId': this.userId }).then(function (response) {
          _this.$store.dispatch('fetchSearchCategory').then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__main_js__["EventBus"].$emit('searchEvent', _this.searchText);
            _this.$router.push({
              name: 'searchPageAlt',
              params: {
                search: _this.searchText
              }
            });
          }, function (error) {
            console.log('error in fetching category', error);
          });
        }, function (error) {
          console.log('error in setting search data:', error);
        });
      }
    },
    sendQuery: function sendQuery() {
      var _this2 = this;

      // alert(this.searchText)
      // console.log('in sendQuery')
      if (this.searchText !== undefined && this.searchText !== null && this.searchText.length !== 0) {
        this.$store.dispatch('getSearchResult', { 'searchText': this.searchText, 'location': { 'coordinates': [this.longitude, this.latitude] }, 'userId': this.userId }).then(function (response) {
          _this2.$store.dispatch('fetchSearchCategory').then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__main_js__["EventBus"].$emit('searchEvent', _this2.searchText);
            _this2.$router.push({
              name: 'searchPageAlt',
              params: {
                search: _this2.searchText
              }
            });
          }, function (error) {
            console.log('error in fetching category', error);
          });
        }, function (error) {
          console.log('error in setting search data:', error);
        });
      }
    },
    sendSearchQuery: function sendSearchQuery(position) {
      // console.log('in sendSearchQuery')
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      // alert('sendSearchQuery')
      this.sendQuery();
    },
    handleRejection: function handleRejection(error) {
      // console.log('in handleRejection')
      switch (error.code) {
        case error.PERMISSION_DENIED:
          // console.log('User denied the request for Geolocation.')
          this.errorQuery();
          break;
        case error.POSITION_UNAVAILABLE:
          // console.log('Location information is unavailable.')
          this.errorQuery();
          break;
        case error.TIMEOUT:
          // console.log('The request to get user location timed out.')
          this.errorQuery();
          break;
        case error.UNKNOWN_ERROR:
          // console.log('An unknown error occurred.')
          this.errorQuery();
          break;
      }
    },
    onSearch: function onSearch(val) {
      // console.log('in onSearch')
      // storing search text
      this.searchText = val;
      // storing profileId
      if (this.isLoggedIn) {
        var profileDetails = this.$store.getters.getProfileDetails;
        if (profileDetails !== null && profileDetails.profileId != null) {
          this.userId = profileDetails.profileId;
        }
      }
      // asking permission to get Location
      if (this.caseFalse) {
        // if (navigator.geolocation) {
        // console.log('in permission')
        navigator.geolocation.getCurrentPosition(this.sendSearchQuery, this.handleRejection, this.defaultOptions);
      } else {
        // console.log('Your browser doesn\'t support')
        this.errorQuery();
      }
    },
    getMostSearchedWordList: function getMostSearchedWordList() {
      if (this.$store.getters.getProfileDetails === undefined || this.$store.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.getProfileDetails).length === 0 && this.$store.getters.getProfileDetails.constructor === Object) {
        this.wordlist = [];
      } else {
        var bannerSearch = this;
        this.$store.dispatch('getMostSearchedWordList').then(function (wordlist) {
          bannerSearch.wordlist = wordlist;
        });
      }
    },
    getSuggestions: function getSuggestions(searchText) {
      var banner = this;
      if (searchText.length === 0) {
        this.suggestions = [];
        // this.searchText = ''
        return;
      } else if (searchText.length >= 2) {
        this.previousSuggestionsForSearchText = searchText;
        var contentCategory = '';
        if (this.$store.getters.getProfileDetails === undefined || this.$store.getters.getProfileDetails === null || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.getProfileDetails).length === 0 && this.$store.getters.getProfileDetails.constructor === Object) {
          contentCategory = __WEBPACK_IMPORTED_MODULE_4__components_common_constants_js__["m" /* DEFAULT_OBJECT_CATEGORY */];
        } else {
          contentCategory = this.$store.getters.getUserJvID(this.$store.getters.getProfileDetails.accountDetails);
        }
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('o/getSuggestionBasedOnKeyword', { 'searchText': searchText }, { headers: { 'contentCategory': contentCategory } }).then(function (res) {
          if (res.status === 200) {
            // alert(res.data.length)
            banner.suggestions = res.data;
            // banner.suggestions.unshift(banner.searchText)
          }
        });
      }
    }
  },
  mounted: function mounted() {
    // autofocus on search box
    // this.$refs.txt_search.$el.focus()
    // alert(this.oldSearchText)
    if (this.oldSearchText !== undefined && this.oldSearchText.length !== 0 && this.oldSearchText !== null) {
      this.searchText = this.oldSearchText;
    }
    this.getMostSearchedWordList();
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    },

    randomList: function randomList() {
      return this.$store.getters.getMostSearchedWordList.sort(function () {
        return 0.5 - Math.random();
      });
    }
    // suggestions () {
    //   var suggestionsList = []
    //   // alert(this.searchText)
    //   // var text = this.searchText
    //   // alert(this.wordlist)
    //   this.wordlist.forEach(word => {
    //     // alert(word)
    //     if (word.indexOf(this.searchText) !== -1) {
    //       suggestionsList.push(word)
    //     }
    //   })
    //   return suggestionsList
    // }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__ = __webpack_require__("P5xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_headerLogin__ = __webpack_require__("3656");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_footerArea__ = __webpack_require__("Yu1t");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    headerLoggedIn: __WEBPACK_IMPORTED_MODULE_2__components_common_headerLogin__["a" /* default */],
    footerArea: __WEBPACK_IMPORTED_MODULE_3__components_common_footerArea__["a" /* default */]
  },
  data: function data() {
    return {
      instanceName: __WEBPACK_IMPORTED_MODULE_0__components_common_constants_js__["e" /* INSTANCE_NAME */],
      navStatus: ''
    };
  },

  computed: {
    isPaymentPage: function isPaymentPage() {
      if (this.$route.name === 'success') {
        return false;
      }
      return true;
    },
    redirection: function redirection() {
      window.scrollTo(0, 0);
      this.start();
      var form = this;
      if (this.$route.path !== 'This/Is/Never/Gonna/Match') {
        // alert(JSON.stringify(this.$route.path.split('/')))
        if (!(this.$route.path === '/' || this.$route.path === '/home' || this.$route.path === '/advertisement' || this.$route.path === '/searchPageAlt' || this.$route.path.split('/')[1] === 'coursePage')) {
          var token = window.MKCLAPI.getToken();
          // var token = form.$store.getters.getToken
          window.MKCLAPI.isTokenValid(token).then(function () {}).catch(function () {
            form.$router.push({ path: '/home' });
            // form.$toasted.info('Session Expired. Please login again.')
            window.MKCLAPI.login();
          });
        }
      }
      return true;
    }
  },
  methods: {
    start: function start() {
      this.$Progress.start();
    },
    set: function set(num) {
      this.$Progress.set(num);
    },
    increase: function increase(num) {
      this.$Progress.increase(num);
    },
    decrease: function decrease(num) {
      this.$Progress.decrease(num);
    },
    finish: function finish() {
      this.$Progress.finish();
    },
    fail: function fail() {
      this.$Progress.fail();
    }
    // test () {
    //   this.$Progress.start()
    //   this.$http.jsonp('http://api.rottentomatoes.com/api/public/v1.0/lists/movies/in_theaters.json?apikey=7waqfqbprs7pajbz28mqf6vz')
    //   .then((response) => {
    //     this.$Progress.finish()
    //   }, (response) => {
    //     this.$Progress.fail()
    //   })
    // }

  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$on('showNav', function (data) {
      _this.navStatus = data;
    });
  },
  mounted: function mounted() {
    document.getElementsByTagName('title')[0].innerHTML = this.instanceName;
    if (this.instanceName === 'MAHADEMY') {
      document.getElementById('favIcon').href = 'static/assets/images/mahademyFavIcon.ico';
    } else {
      document.getElementById('favIcon').href = 'static/assets/images/favicon.ico';
    }
  }
});

/***/ }),

/***/ "xQzG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xRXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-obj section-holder"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center card-icon"
  }, [_vm._v("?")]), _vm._v(" "), _c('h6', {
    staticClass: "pb-2"
  }, [_vm._v("Why should I take up this course?")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center card-icon"
  }, [_vm._v(":O")]), _vm._v(" "), _c('h6', {
    staticClass: "pb-2"
  }, [_vm._v("What will I learn?")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center card-icon"
  }, [_vm._v("!")]), _vm._v(" "), _c('h6', {
    staticClass: "pb-2"
  }, [_vm._v("How will this course benefit me?")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xm+/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y7F+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object', {
    attrs: {
      "id": "htmlHolder",
      "data": _vm.mediaPath
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yUvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bannerSearch__ = __webpack_require__("IKiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__courseCards__ = __webpack_require__("4S4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libraryCards__ = __webpack_require__("15GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recommendation__ = __webpack_require__("/eNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__newVideoCards__ = __webpack_require__("q9mY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__trendingCourses__ = __webpack_require__("8bW+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    recommendation: __WEBPACK_IMPORTED_MODULE_5__recommendation__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default.a,
    bannerSearch: __WEBPACK_IMPORTED_MODULE_2__bannerSearch__["a" /* default */],
    newVideoCards: __WEBPACK_IMPORTED_MODULE_6__newVideoCards__["a" /* default */],
    courseCards: __WEBPACK_IMPORTED_MODULE_3__courseCards__["a" /* default */],
    libraryCards: __WEBPACK_IMPORTED_MODULE_4__libraryCards__["a" /* default */],
    trendingCourses: __WEBPACK_IMPORTED_MODULE_7__trendingCourses__["a" /* default */]
  },
  data: function data() {
    return {
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    };
  },

  methods: {
    handleScroll: function handleScroll() {
      var _this = this;

      if (this.showTrendingCard && !this.showLibraryCard) {
        setTimeout(function () {
          _this.showLibraryCard = true;
          if (_this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this.globalState.complete();
          }
        }, 100);
      } else if (this.showTrendingCard && this.showLibraryCard) {
        setTimeout(function () {
          _this.showNewVideoCard = true;
          if (_this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            _this.globalState.complete();
          }
        }, 100);
      }
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this2 = this;

      this.globalState = $state;
      setTimeout(function () {
        _this2.showTrendingCard = true;
        // this.showLibraryCard = true
        $state.loaded();
      }, 100);
    },
    checkTokenValidity: function checkTokenValidity() {
      var home = this;
      var token = window.MKCLAPI.getToken();
      if (token !== undefined && token !== null) {
        window.MKCLAPI.isTokenValid(token).then(function () {
          // token is valid
        }).catch(function () {
          home.$store.dispatch('clearUserData');
          window.MKCLAPI.removeToken();
        });
      }
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__main_js__["gAnalysis"])();
    this.checkTokenValidity();
    __WEBPACK_IMPORTED_MODULE_1__main_js__["EventBus"].$emit('showNav', true);
    this.$store.dispatch('changeSearchType', 'all').then(function (response) {}, function (error) {
      console.log('error in changing search type', error);
    });
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "z4IK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__("424j");





var categoryList = [];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var state = {
  category: []
};
var getters = {
  getNCategoryStoreData: function getNCategoryStoreData(state, getters) {
    return function (searchParameters) {
      categoryList = [];
      // console.log(searchParameters)
      for (var i = 0; i < searchParameters; i++) {
        categoryList.push(getters.getCategoryStoreData[i]);
      }
      // alert(JSON.stringify(categoryList))
      return categoryList;
    };
  },
  getCategoryStoreData: function getCategoryStoreData(state) {
    return state.category;
  }
};
var actions = {
  fetchSearchCategory: function fetchSearchCategory(context) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('o/getcategorymaster').then(function (response) {
        context.commit('setCategoryStoreData', response.data);
        resolve();
      }).catch(function (e) {
        console.log('err:', e);
        reject(e);
      });
    });
  }
};
var mutations = {
  setCategoryStoreData: function setCategoryStoreData(state, data) {
    if (data === null) {
      state.category = [];
    } else {
      state.category = data;
    }
  },
  clearCategoryStoreData: function clearCategoryStoreData(state) {
    state.category = [];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */])({ storage: window.localStorage })]
});

/***/ }),

/***/ "z5Hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_videojs_resolution_switcher__ = __webpack_require__("3FD3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_videojs_resolution_switcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_videojs_resolution_switcher__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import videojs from 'video.js'

// vue.require(StarRating)
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bannerVideo",
  components: { StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a },
  props: ["contentId"],
  data: function data() {
    return {
      courseDetails: {},
      // show: false,
      rating: 0,
      purchaseDate: null,
      expiryDate: null
    };
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  methods: {
    goToLogin: function goToLogin() {
      // window.MKCLAPI.login()
      this.$root.$emit("bv::show::modal", "login");
    },
    displayLanguage: function displayLanguage(langArr) {
      // alert(JSON.stringify(langArr))
      // console.log(JSON.stringify(langArr))
      var language = "";
      for (var i = 0; i < langArr.length; i++) {
        // alert(langArr[i])
        if (langArr[i] === "1") {
          if (language.length !== 0) {
            language = language + ", English";
          } else {
            language = "English";
          }
        } else if (langArr[i] === "2") {
          if (language.length !== 0) {
            language = language + ", Hindi";
          } else {
            language = "Hindi";
          }
        } else if (langArr[i] === "3") {
          if (language.length !== 0) {
            language = language + ", Marathi";
          } else {
            language = "Marathi";
          }
        }
      }
      return language;
    },
    goToCourse: function goToCourse(course) {
      this.$store.dispatch("checkExpiryDateForCO", course);
    },
    showRating: function showRating(contentID) {
      var _this = this;

      if (this.isLoggedIn) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/r/rating/addratingdata", {
          profileId: this.$store.getters.getProfileDetails.profileId,
          contentId: contentID,
          rating: this.rating
        }).then(function (response) {
          _this.$toasted.success("Rating added successfully");
          _this.$store.dispatch("setCurrentCourse", response.data);
        }).catch(function (error) {
          alert(error);
        });
      }
    },
    addToCart: function addToCart(id) {
      var _this2 = this;

      if (this.isLoggedIn) {
        this.$store.dispatch("addCartData", {
          itemId: id,
          profileId: this.$store.getters.getProfileDetails.profileId,
          cartId: this.$store.getters.getCartData.cartId
        }).then(function (response) {
          _this2.$toasted.success(_this2.$t("common.alerts.CART_ADDED_SUCCESS"));
        }, function (error) {
          console.log("error in adding item to cart", error);
        });
      } else {
        window.MKCLAPI.login();
      }
    },

    setRating: function setRating(rating) {
      this.rating = rating;
    },
    cartAdd: function cartAdd(itemId) {
      for (var j = 0; j < this.$store.getters.getCartData.items.length; j++) {
        if (this.$store.getters.getCartData.items[j].itemId === itemId) {
          return true;
        }
      }
      return false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // alert(this.contentId)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("o/getlodetails", { contentId: _this3.contentId }).then(function (response) {
        _this3.courseDetails = response.data;
        // this.show = true
        // console.log(JSON.stringify(this.courseDetails))
        /*   var player = videojs('player', {
            plugins: {
              videoJsResolutionSwitcher: {
                default: 'low',
                dynamicLabel: true
              }
            }
          })
          // console.log('=======================>', document.getElementById('test'))
          if (player != null) {
            resolve()
          } */
      }).catch(function (err) {
        console.log("error in fetching course details : ", err);
        reject();
      });
    });
  }
});

/***/ }),

/***/ "zFIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zK0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Multiselect_vue__ = __webpack_require__("pCe1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_562a3ecb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Multiselect_vue__ = __webpack_require__("vY0y");
function injectStyle (ssrContext) {
  __webpack_require__("KUKW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Multiselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_562a3ecb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Multiselect_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zM7h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zSpc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zcfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-help-wrapper",
    attrs: {
      "id": "youtube"
    }
  }, [_c('embed', {
    staticClass: "player",
    attrs: {
      "height": "400px",
      "src": _vm.path,
      "width": "100%"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zsv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseObjectives_vue__ = __webpack_require__("vcyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed193b88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseObjectives_vue__ = __webpack_require__("xRXm");
function injectStyle (ssrContext) {
  __webpack_require__("dnSH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseObjectives_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed193b88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_courseObjectives_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3382dcf723e0ef5f09da.js